//src/command/utils/sembols.js
import { Rectangle, Line, Text } from "./utils";


const layers = {
  0: { name: '0', frozen: false, visible: true, colorIndex: 7, color: 16777215 },
  kirmizi: { name: '18', frozen: false, visible: true, colorIndex: 1, color: 16711680 },
  yesil: { name: 'test', frozen: false, visible: true, colorIndex: 1, color: 65280 },
  mavi: { name: 'test', frozen: false, visible: true, colorIndex: 1, color: 255 },
  sari: { name: 'test', frozen: false, visible: true, colorIndex: 1, color: 16776960 },
  magenta: { name: 'test', frozen: false, visible: true, colorIndex: 1, color: 16711935 },
  cyan: { name: 'test', frozen: false, visible: true, colorIndex: 1, color: 65535 },
  gray: { name: 'test', frozen: false, visible: true, colorIndex: 8, color: 12632256 },
  AKSYAZI: { name: 'AKSYAZI', frozen: false, visible: true, colorIndex: 9, color: 12632256 }
};
const kirmizi = layers.kirmizi
const mavi = layers.mavi
const yesil = layers.yesil
const gray = layers.gray

const op_gray = {
  color: gray.color,
  colorIndex: gray.colorIndex,
  layer: gray.name,
  // lineType:layer.lineType,
  shape: true,
  hasContinuousLinetypePattern: false
}
const op_yesil = {
  color: yesil.color,
  colorIndex: yesil.colorIndex,
  layer: gray.name,
  // lineType:layer.lineType,
  shape: true,
  hasContinuousLinetypePattern: false
}
const Scl = 1// 0.75
const rowHeight = 50 * Scl
 

export const createToprakalamaDetay= ( ) => {

 
  const result= 
   [
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 380.1550434749811,
        "y": 503.7130949925585,
        "z": 0
      },
      {
        "x": 381.3838434535428,
        "y": 503.7133094612508,
        "z": 0
      }
    ],
    "handle": "228A",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 378.9259983869257,
        "y": 505.1172233633578,
        "z": 0
      },
      {
        "x": 382.6123983307038,
        "y": 505.1178667619823,
        "z": 0
      }
    ],
    "handle": "228B",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 377.6969533014348,
        "y": 506.5213517546578,
        "z": 0
      },
      {
        "x": 383.840953210776,
        "y": 506.5224240850593,
        "z": 0
      }
    ],
    "handle": "228C",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 388.2376033429758,
        "y": 509.3771514678327,
        "z": 0
      },
      {
        "x": 397.1363181961931,
        "y": 509.3787045860588,
        "z": 0
      }
    ],
    "handle": "228D",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "SOLID",
    "points": [
      {
        "x": 395.6707866876378,
        "y": 509.3238495150506,
        "z": 0
      },
      {
        "x": 396.4353424949227,
        "y": 505.9658571453736,
        "z": 0
      },
      {
        "x": 394.8956852272961,
        "y": 505.9682756355031,
        "z": 0
      },
      {
        "x": 394.8956852272961,
        "y": 505.9682756355031,
        "z": 0
      }
    ],
    "handle": "228E",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 388.220851922001,
        "y": 443.3729111095827,
        "z": 0
      },
      {
        "x": 397.1195667753938,
        "y": 443.3744642296842,
        "z": 0
      }
    ],
    "handle": "228F",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "SOLID",
    "points": [
      {
        "x": 395.713383846625,
        "y": 443.3197416597903,
        "z": 0
      },
      {
        "x": 394.9488280393422,
        "y": 446.677733962424,
        "z": 0
      },
      {
        "x": 396.4884853041727,
        "y": 446.6753154508705,
        "z": 0
      },
      {
        "x": 396.4884853041727,
        "y": 446.6753154508705,
        "z": 0
      }
    ],
    "handle": "2290",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 395.7105779333499,
        "y": 443.3196190278904,
        "z": 0
      },
      {
        "x": 395.698971398291,
        "y": 509.3431112430916,
        "z": 0
      }
    ],
    "handle": "2291",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "TEXT",
    "handle": "2292",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "startPoint": {
      "x": 393.3609056568238,
      "y": 471.8532379381321,
      "z": 0
    },
    "textHeight": 3.949714285714286,
    "text": "100cm",
    "rotation": 90.00999999975443
  },
  {
    "type": "ARC",
    "handle": "2293",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 583.5321388104342,
      "y": 679.1291768420531,
      "z": 0
    },
    "radius": 1.745961035494238,
    "startAngle": 3.778002994157258,
    "endAngle": 5.647124033304385,
    "angleLength": 1.8691210391471267
  },
  {
    "type": "ARC",
    "handle": "2294",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 586.3411866003883,
      "y": 677.054864826612,
      "z": 0
    },
    "radius": 1.745961035494238,
    "startAngle": 0.6364103405674665,
    "endAngle": 2.5055313797145935,
    "angleLength": 1.8691210391471271
  },
  {
    "type": "ARC",
    "handle": "2295",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 586.3408244791212,
      "y": 679.1296670492702,
      "z": 0
    },
    "radius": 1.745961035494238,
    "startAngle": 3.778002994157258,
    "endAngle": 5.647124033304385,
    "angleLength": 1.8691210391471267
  },
  {
    "type": "ARC",
    "handle": "2296",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 567.4838890751694,
      "y": 677.0515736080632,
      "z": 0
    },
    "radius": 1.745961035494238,
    "startAngle": 0.6364103405674665,
    "endAngle": 2.5055313797145935,
    "angleLength": 1.8691210391471271
  },
  {
    "type": "ARC",
    "handle": "2297",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 567.4835269538455,
      "y": 679.1263758307324,
      "z": 0
    },
    "radius": 1.745961035494238,
    "startAngle": 3.778002994157258,
    "endAngle": 5.647124033304385,
    "angleLength": 1.8691210391471267
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 346.4057388048959,
        "y": 503.707204627805,
        "z": 0
      },
      {
        "x": 347.6345387889308,
        "y": 503.7074190955608,
        "z": 0
      }
    ],
    "handle": "2298",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 345.1766937194632,
        "y": 505.1113329976833,
        "z": 0
      },
      {
        "x": 348.8630936633561,
        "y": 505.1119763972236,
        "z": 0
      }
    ],
    "handle": "2299",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 343.9476486340848,
        "y": 506.5154613908307,
        "z": 0
      },
      {
        "x": 350.0916485405761,
        "y": 506.5165337212309,
        "z": 0
      }
    ],
    "handle": "229A",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 342.718603551622,
        "y": 507.9195897374328,
        "z": 0
      },
      {
        "x": 351.3202034206468,
        "y": 507.9210910005421,
        "z": 0
      }
    ],
    "handle": "229B",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 357.781904496484,
        "y": 503.7091901451303,
        "z": 0
      },
      {
        "x": 359.0107044750466,
        "y": 503.7094046100945,
        "z": 0
      }
    ],
    "handle": "229C",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 356.5528594084319,
        "y": 505.1133185150018,
        "z": 0
      },
      {
        "x": 360.239259352324,
        "y": 505.1139619108216,
        "z": 0
      }
    ],
    "handle": "229D",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 355.3238143258496,
        "y": 506.5174469062975,
        "z": 0
      },
      {
        "x": 361.4678142294871,
        "y": 506.5185192366988,
        "z": 0
      }
    ],
    "handle": "229E",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 354.0947692376799,
        "y": 507.9215752547533,
        "z": 0
      },
      {
        "x": 362.696369106765,
        "y": 507.923076515082,
        "z": 0
      }
    ],
    "handle": "229F",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 369.1580782184033,
        "y": 503.7111756615338,
        "z": 0
      },
      {
        "x": 370.3868781996441,
        "y": 503.7113901283526,
        "z": 0
      }
    ],
    "handle": "22A0",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 367.9290331329688,
        "y": 505.1153040314019,
        "z": 0
      },
      {
        "x": 371.6154330768639,
        "y": 505.1159474290943,
        "z": 0
      }
    ],
    "handle": "22A1",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 366.6999880477099,
        "y": 506.5194324236333,
        "z": 0
      },
      {
        "x": 372.8439879540812,
        "y": 506.5205047540318,
        "z": 0
      }
    ],
    "handle": "22A2",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 365.470942962391,
        "y": 507.9235607692925,
        "z": 0
      },
      {
        "x": 374.072542828507,
        "y": 507.9250620333404,
        "z": 0
      }
    ],
    "handle": "22A3",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 323.711958239786,
        "y": 502.2895758943631,
        "z": 0
      },
      {
        "x": 327.2215898088179,
        "y": 509.3119028760108,
        "z": 0
      }
    ],
    "handle": "22A4",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 324.0631665007667,
        "y": 501.5874657752028,
        "z": 0
      },
      {
        "x": 327.9237612267027,
        "y": 509.3120254296845,
        "z": 0
      }
    ],
    "handle": "22A5",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 324.0631665007667,
        "y": 501.5874657752028,
        "z": 0
      },
      {
        "x": 321.6055665382297,
        "y": 501.5870368406102,
        "z": 0
      }
    ],
    "handle": "22A6",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 330.0302754803569,
        "y": 509.312393086031,
        "z": 0
      },
      {
        "x": 327.9237612267027,
        "y": 509.3120254296845,
        "z": 0
      }
    ],
    "handle": "22A7",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 327.9237612267027,
        "y": 509.3120254296845,
        "z": 0
      },
      {
        "x": 330.0302754803569,
        "y": 509.312393086031,
        "z": 0
      }
    ],
    "handle": "22A8",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 335.0295650829801,
        "y": 503.7052191132643,
        "z": 0
      },
      {
        "x": 336.2583650642769,
        "y": 503.7054335772908,
        "z": 0
      }
    ],
    "handle": "22A9",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 321.658182505053,
        "y": 512.9507654393127,
        "z": 0
      },
      {
        "x": 321.6566293863,
        "y": 521.849480280649,
        "z": 0
      }
    ],
    "handle": "22AA",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "SOLID",
    "points": [
      {
        "x": 321.6022858615608,
        "y": 520.3839296801052,
        "z": 0
      },
      {
        "x": 318.2442935251171,
        "y": 519.6193738803192,
        "z": 0
      },
      {
        "x": 318.2467120140787,
        "y": 521.159031155519,
        "z": 0
      },
      {
        "x": 318.2467120140787,
        "y": 521.159031155519,
        "z": 0
      }
    ],
    "handle": "22AB",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 333.8005199976618,
        "y": 505.1093474812841,
        "z": 0
      },
      {
        "x": 337.4869199415551,
        "y": 505.109990878962,
        "z": 0
      }
    ],
    "handle": "22AC",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 332.5714749095489,
        "y": 506.5134758735047,
        "z": 0
      },
      {
        "x": 338.7154748187161,
        "y": 506.5145482048347,
        "z": 0
      }
    ],
    "handle": "22AD",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 331.3424298241741,
        "y": 507.9176042200914,
        "z": 0
      },
      {
        "x": 339.9440296959358,
        "y": 507.919105484142,
        "z": 0
      }
    ],
    "handle": "22AE",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "TEXT",
    "handle": "22AF",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "startPoint": {
      "x": 281.8283761515051,
      "y": 522.6934087295058,
      "z": 0
    },
    "textHeight": 3.949714285714286,
    "text": "60cm",
    "rotation": 0.0100000010572011
  },
  {
    "type": "TEXT",
    "handle": "22B0",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "startPoint": {
      "x": 595.0898088958332,
      "y": 658.8806255804311,
      "z": 0
    },
    "textHeight": 3.949714285714286,
    "text": "TOPRAKLAMA ILETKENI",
    "rotation": 0.0100000010572011
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 585.1272778762512,
        "y": 660.6694881114997,
        "z": 0
      },
      {
        "x": 585.1234313645392,
        "y": 682.7083771303185,
        "z": 0
      }
    ],
    "handle": "22B1",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 565.2135643013752,
        "y": 660.6660125143815,
        "z": 0
      },
      {
        "x": 565.2097177895475,
        "y": 682.7049015304002,
        "z": 0
      }
    ],
    "handle": "22B2",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 581.2450143925963,
        "y": 609.7431542863922,
        "z": 0
      },
      {
        "x": 581.2482322733265,
        "y": 591.306055973262,
        "z": 0
      }
    ],
    "handle": "22B4",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "DASHDOT",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 600.0718459428155,
        "y": 612.7901285141533,
        "z": 0
      },
      {
        "x": 600.0744595354174,
        "y": 597.8153463089617,
        "z": 0
      }
    ],
    "handle": "22B5",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "DASHDOT",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 598.9280390958295,
        "y": 599.9531834199815,
        "z": 0
      },
      {
        "x": 598.9279752701412,
        "y": 600.31887778917,
        "z": 0
      }
    ],
    "handle": "22B6",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 598.5769533870044,
        "y": 599.9531221445512,
        "z": 0
      },
      {
        "x": 598.5768895611975,
        "y": 600.3188165137335,
        "z": 0
      }
    ],
    "handle": "22B7",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 601.3856390584252,
        "y": 599.9536123517692,
        "z": 0
      },
      {
        "x": 601.3855752326774,
        "y": 600.3193067209612,
        "z": 0
      }
    ],
    "handle": "22B8",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 601.0345533466892,
        "y": 599.9535510763341,
        "z": 0
      },
      {
        "x": 601.0344895209414,
        "y": 600.3192454445922,
        "z": 0
      }
    ],
    "handle": "22B9",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 584.5736290015045,
        "y": 599.2246676450412,
        "z": 0
      },
      {
        "x": 577.9030005317172,
        "y": 599.2235034005532,
        "z": 0
      }
    ],
    "handle": "22BC",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 584.5735064495223,
        "y": 599.9268390396497,
        "z": 0
      },
      {
        "x": 577.9028779796782,
        "y": 599.9256747960925,
        "z": 0
      }
    ],
    "handle": "22BD",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 577.9028779796782,
        "y": 599.9256747960925,
        "z": 0
      },
      {
        "x": 577.9030005317172,
        "y": 599.2235034005532,
        "z": 0
      }
    ],
    "handle": "22BE",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 579.3159862640322,
        "y": 598.6086971470902,
        "z": 0
      },
      {
        "x": 578.9649005550312,
        "y": 598.6086358707176,
        "z": 0
      }
    ],
    "handle": "22BF",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 583.5290147738993,
        "y": 598.6094324588627,
        "z": 0
      },
      {
        "x": 583.1779290623374,
        "y": 598.6093711824914,
        "z": 0
      }
    ],
    "handle": "22C1",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 583.1779290623374,
        "y": 598.6093711824914,
        "z": 0
      },
      {
        "x": 579.3159862640322,
        "y": 598.6086971470902,
        "z": 0
      }
    ],
    "handle": "22C2",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 584.5735064495223,
        "y": 599.9268390396497,
        "z": 0
      },
      {
        "x": 584.5736290015045,
        "y": 599.2246676450412,
        "z": 0
      }
    ],
    "handle": "22C3",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 564.6219335329941,
        "y": 598.6061325501432,
        "z": 0
      },
      {
        "x": 564.2708478268454,
        "y": 598.6060712747121,
        "z": 0
      }
    ],
    "handle": "22C4",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 565.6664252112972,
        "y": 599.9235391309338,
        "z": 0
      },
      {
        "x": 565.6665477632782,
        "y": 599.2213677363324,
        "z": 0
      }
    ],
    "handle": "22C5",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "ARC",
    "handle": "22C8",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 578.9652988490996,
      "y": 596.3265787847229,
      "z": 0
    },
    "radius": 0.5266285714285716,
    "startAngle": 3.141767186235127,
    "endAngle": 4.712563513321064,
    "angleLength": 1.570796327085937
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 578.4383639055882,
        "y": 598.0819153710981,
        "z": 0
      },
      {
        "x": 578.4386702857443,
        "y": 596.3264868687619,
        "z": 0
      }
    ],
    "handle": "22C9",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 579.8427067413583,
        "y": 598.0821604747143,
        "z": 0
      },
      {
        "x": 579.8431050354841,
        "y": 595.8001033887111,
        "z": 0
      }
    ],
    "handle": "22CA",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 582.6513924128382,
        "y": 598.0826506828707,
        "z": 0
      },
      {
        "x": 582.6517907069642,
        "y": 595.8005935959326,
        "z": 0
      }
    ],
    "handle": "22CB",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 582.1251621436091,
        "y": 595.8005016827955,
        "z": 0
      },
      {
        "x": 580.3697335989542,
        "y": 595.8001953027923,
        "z": 0
      }
    ],
    "handle": "22CC",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "ARC",
    "handle": "22CD",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 583.5294130681996,
      "y": 596.3273753728532,
      "z": 0
    },
    "radius": 0.5266285714285716,
    "startAngle": 4.712563513321064,
    "endAngle": 0.00017453264533675135,
    "angleLength": -4.712388980675727
  },
  {
    "type": "ARC",
    "handle": "22CE",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 583.1783273564631,
      "y": 596.3273140964837,
      "z": 0
    },
    "radius": 0.5266285714285716,
    "startAngle": 3.141767186235127,
    "endAngle": 4.712563513321064,
    "angleLength": 1.570796327085937
  },
  {
    "type": "ARC",
    "handle": "22CF",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 582.1250702296392,
      "y": 596.3271302683132,
      "z": 0
    },
    "radius": 0.5266285714285716,
    "startAngle": 4.712563513321064,
    "endAngle": 0.00017453264533675135,
    "angleLength": -4.712388980675727
  },
  {
    "type": "ARC",
    "handle": "22D0",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 580.3696416849263,
      "y": 596.3268238901917,
      "z": 0
    },
    "radius": 0.5266285714285716,
    "startAngle": 3.141767186235127,
    "endAngle": 4.712563513321064,
    "angleLength": 1.570796327085937
  },
  {
    "type": "ARC",
    "handle": "22D1",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 579.3163845580992,
      "y": 596.3266400610846,
      "z": 0
    },
    "radius": 0.5266285714285716,
    "startAngle": 4.712563513321064,
    "endAngle": 0.00017453264533675135,
    "angleLength": -4.712388980675727
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 579.3164764720711,
        "y": 595.8000114755533,
        "z": 0
      },
      {
        "x": 578.9653907631874,
        "y": 595.7999501991799,
        "z": 0
      }
    ],
    "handle": "22D2",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 583.5295049821723,
        "y": 595.8007467882522,
        "z": 0
      },
      {
        "x": 583.1784192703763,
        "y": 595.8006855109514,
        "z": 0
      }
    ],
    "handle": "22D3",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 583.5295049821723,
        "y": 595.8007467882522,
        "z": 0
      },
      {
        "x": 578.9653907631874,
        "y": 595.7999501991799,
        "z": 0
      }
    ],
    "handle": "22D4",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 584.0557352486063,
        "y": 598.0828957864904,
        "z": 0
      },
      {
        "x": 584.0560416288203,
        "y": 596.3274672860134,
        "z": 0
      }
    ],
    "handle": "22D5",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 582.6522350846785,
        "y": 593.2544978540219,
        "z": 0
      },
      {
        "x": 579.8435494130242,
        "y": 593.2540076458606,
        "z": 0
      }
    ],
    "handle": "22D6",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 582.6522350846785,
        "y": 593.2544978540219,
        "z": 0
      },
      {
        "x": 582.6517868306255,
        "y": 595.8228034851916,
        "z": 0
      }
    ],
    "handle": "22D7",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 579.8435494130242,
        "y": 593.2540076458606,
        "z": 0
      },
      {
        "x": 579.8431011592032,
        "y": 595.8223132770333,
        "z": 0
      }
    ],
    "handle": "22D8",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 582.3012106515813,
        "y": 592.9033508906022,
        "z": 0
      },
      {
        "x": 580.1946963979863,
        "y": 592.9029832351742,
        "z": 0
      }
    ],
    "handle": "22D9",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 582.3012106515813,
        "y": 592.9033508906022,
        "z": 0
      },
      {
        "x": 582.6522350846785,
        "y": 593.2544978540219,
        "z": 0
      }
    ],
    "handle": "22DA",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 582.3012106515813,
        "y": 592.9033508906022,
        "z": 0
      },
      {
        "x": 582.3007011216234,
        "y": 595.8227422088213,
        "z": 0
      }
    ],
    "handle": "22DB",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 580.1946963979863,
        "y": 592.9029832351742,
        "z": 0
      },
      {
        "x": 579.8435494130242,
        "y": 593.2540076458606,
        "z": 0
      }
    ],
    "handle": "22DC",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 580.1946963979863,
        "y": 592.9029832351742,
        "z": 0
      },
      {
        "x": 580.1941868681446,
        "y": 595.8223745543318,
        "z": 0
      }
    ],
    "handle": "22DD",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 604.3981004472002,
        "y": 574.7736947266227,
        "z": 0
      },
      {
        "x": 582.2276601383923,
        "y": 596.9363974910001,
        "z": 0
      }
    ],
    "handle": "22DE",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 604.3981004472002,
        "y": 574.7736947266227,
        "z": 0
      },
      {
        "x": 628.2853376001574,
        "y": 574.7778638377602,
        "z": 0
      }
    ],
    "handle": "22DF",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 605.6054394724782,
        "y": 589.7303065694678,
        "z": 0
      },
      {
        "x": 628.4064069655722,
        "y": 589.7342860894105,
        "z": 0
      }
    ],
    "handle": "22E0",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 563.7443111774033,
        "y": 598.0793507741625,
        "z": 0
      },
      {
        "x": 563.7447094715311,
        "y": 595.7972936900111,
        "z": 0
      }
    ],
    "handle": "22E1",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "ARC",
    "handle": "22E2",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 564.6223318270632,
      "y": 596.3240754641408,
      "z": 0
    },
    "radius": 0.5266285714285716,
    "startAngle": 4.712563513321064,
    "endAngle": 0.00017453264533675135,
    "angleLength": -4.712388980675727
  },
  {
    "type": "ARC",
    "handle": "22E3",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 564.2712461209155,
      "y": 596.3240141887032,
      "z": 0
    },
    "radius": 0.5266285714285716,
    "startAngle": 3.141767186235127,
    "endAngle": 4.712563513321064,
    "angleLength": 1.570796327085937
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 564.6224237411503,
        "y": 595.7974468795445,
        "z": 0
      },
      {
        "x": 564.2713380350024,
        "y": 595.7973856031713,
        "z": 0
      }
    ],
    "handle": "22E4",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 565.1486540131732,
        "y": 598.0795958796333,
        "z": 0
      },
      {
        "x": 565.1489603932714,
        "y": 596.324167379159,
        "z": 0
      }
    ],
    "handle": "22E5",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 563.7451538490712,
        "y": 593.251197945312,
        "z": 0
      },
      {
        "x": 563.7447055951934,
        "y": 595.8195035783392,
        "z": 0
      }
    ],
    "handle": "22E6",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "ARC",
    "handle": "22EB",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 564.2709397409344,
      "y": 598.0794426891816,
      "z": 0
    },
    "radius": 0.5266285714285716,
    "startAngle": 1.5709708597312715,
    "endAngle": 3.141767186235127,
    "angleLength": 1.5707963265038556
  },
  {
    "type": "ARC",
    "handle": "22EC",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 564.6220254469652,
      "y": 598.0795039655529,
      "z": 0
    },
    "radius": 0.5266285714285716,
    "startAngle": 0.00017453264533675135,
    "endAngle": 1.5709708597312715,
    "angleLength": 1.5707963270859346
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 565.6665477632782,
        "y": 599.2213677363324,
        "z": 0
      },
      {
        "x": 565.1486851918742,
        "y": 597.9009549431321,
        "z": 0
      }
    ],
    "handle": "22ED",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "ARC",
    "handle": "22EE",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 578.9649924689434,
      "y": 598.0820072851927,
      "z": 0
    },
    "radius": 0.5266285714285716,
    "startAngle": 1.5709708597312715,
    "endAngle": 3.141767186235127,
    "angleLength": 1.5707963265038556
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 577.9030005317172,
        "y": 599.2235034005532,
        "z": 0
      },
      {
        "x": 578.4383950844044,
        "y": 597.9032744364594,
        "z": 0
      }
    ],
    "handle": "22EF",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "ARC",
    "handle": "22F0",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 579.3160781780025,
      "y": 598.0820685596908,
      "z": 0
    },
    "radius": 0.5266285714285716,
    "startAngle": 0.00017453264533675135,
    "endAngle": 1.5709708597312715,
    "angleLength": 1.5707963270859346
  },
  {
    "type": "ARC",
    "handle": "22F1",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 580.3693353048283,
      "y": 598.0822523887982,
      "z": 0
    },
    "radius": 0.5266285714285716,
    "startAngle": 1.5709708597312715,
    "endAngle": 3.141767186235127,
    "angleLength": 1.5707963265038556
  },
  {
    "type": "ARC",
    "handle": "22F2",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 582.1247638495402,
      "y": 598.0825587687867,
      "z": 0
    },
    "radius": 0.5266285714285716,
    "startAngle": 0.00017453264533675135,
    "endAngle": 1.5709708597312715,
    "angleLength": 1.5707963270859346
  },
  {
    "type": "ARC",
    "handle": "22F3",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 583.1780209762501,
      "y": 598.0827425960312,
      "z": 0
    },
    "radius": 0.5266285714285716,
    "startAngle": 1.5709708597312715,
    "endAngle": 3.141767186235127,
    "angleLength": 1.5707963265038556
  },
  {
    "type": "ARC",
    "handle": "22F4",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 583.5291066881625,
      "y": 598.0828038742584,
      "z": 0
    },
    "radius": 0.5266285714285716,
    "startAngle": 0.00017453264533675135,
    "endAngle": 1.5709708597312715,
    "angleLength": 1.5707963270859346
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 584.5736290015045,
        "y": 599.2246676450412,
        "z": 0
      },
      {
        "x": 584.0557664273656,
        "y": 597.9042548509103,
        "z": 0
      }
    ],
    "handle": "22F5",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 601.3525231954984,
        "y": 598.8701573358602,
        "z": 0
      },
      {
        "x": 605.6054394724782,
        "y": 589.7303065694678,
        "z": 0
      }
    ],
    "handle": "22F6",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 608.4224904171422,
        "y": 647.126542303711,
        "z": 0
      },
      {
        "x": 608.4258348383005,
        "y": 627.9644213216297,
        "z": 0
      }
    ],
    "handle": "22F7",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "TOPRAK1",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 588.8146937921982,
        "y": 635.5359505694432,
        "z": 0
      },
      {
        "x": 588.8162256926292,
        "y": 626.7588078454098,
        "z": 0
      }
    ],
    "handle": "22FA",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 586.0060081206612,
        "y": 635.5354603603436,
        "z": 0
      },
      {
        "x": 586.0075400210916,
        "y": 626.7583176363195,
        "z": 0
      }
    ],
    "handle": "22FB",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 587.4101250483666,
        "y": 636.8300642166204,
        "z": 0
      },
      {
        "x": 587.4123309848362,
        "y": 624.1909787179682,
        "z": 0
      }
    ],
    "handle": "22FC",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "DASHDOT",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "TEXT",
    "handle": "22FD",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "startPoint": {
      "x": 629.7393690304605,
      "y": 629.3929124642078,
      "z": 0
    },
    "textHeight": 3.949714285714286,
    "text": "IZOLATOR",
    "rotation": 0.0100000010572011
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 591.4945120852202,
        "y": 631.4256408782628,
        "z": 0
      },
      {
        "x": 628.3346702545522,
        "y": 631.4320706995238,
        "z": 0
      }
    ],
    "handle": "22FE",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 602.7885194869582,
        "y": 608.3328171931023,
        "z": 0
      },
      {
        "x": 602.7889239086063,
        "y": 606.0156515156696,
        "z": 0
      }
    ],
    "handle": "2301",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 601.3841766539846,
        "y": 608.3325720904212,
        "z": 0
      },
      {
        "x": 601.3845810757482,
        "y": 606.0154064111192,
        "z": 0
      }
    ],
    "handle": "2302",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 598.5754909825624,
        "y": 608.3320818813341,
        "z": 0
      },
      {
        "x": 598.5758954043253,
        "y": 606.0149162029692,
        "z": 0
      }
    ],
    "handle": "2303",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 597.1711481468526,
        "y": 608.3318367767932,
        "z": 0
      },
      {
        "x": 597.1715525685573,
        "y": 606.0146710993502,
        "z": 0
      }
    ],
    "handle": "2304",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 601.0335703807632,
        "y": 605.5855311248342,
        "z": 0
      },
      {
        "x": 601.0334953640124,
        "y": 606.0153451338193,
        "z": 0
      }
    ],
    "handle": "2305",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 598.9270561297892,
        "y": 605.5851634675406,
        "z": 0
      },
      {
        "x": 598.9269811131522,
        "y": 606.0149774793317,
        "z": 0
      }
    ],
    "handle": "2306",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 598.5759704210782,
        "y": 605.5851021911847,
        "z": 0
      },
      {
        "x": 598.5758954043253,
        "y": 606.0149162029692,
        "z": 0
      }
    ],
    "handle": "2307",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 602.7889239086063,
        "y": 606.0156515156696,
        "z": 0
      },
      {
        "x": 601.8761010682192,
        "y": 606.0154921980427,
        "z": 0
      }
    ],
    "handle": "2308",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 601.8761010682192,
        "y": 606.0154921980427,
        "z": 0
      },
      {
        "x": 597.1715525685573,
        "y": 606.0146710993502,
        "z": 0
      }
    ],
    "handle": "2309",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 601.3846560925014,
        "y": 605.585592399333,
        "z": 0
      },
      {
        "x": 601.3845810757482,
        "y": 606.0154064111192,
        "z": 0
      }
    ],
    "handle": "230A",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 598.9273625100024,
        "y": 603.8297348776612,
        "z": 0
      },
      {
        "x": 598.9273012339833,
        "y": 604.1808206094207,
        "z": 0
      }
    ],
    "handle": "230B",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 598.5762768010604,
        "y": 603.8296736031577,
        "z": 0
      },
      {
        "x": 598.5762155250412,
        "y": 604.1807593330522,
        "z": 0
      }
    ],
    "handle": "230C",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 601.3849624725996,
        "y": 603.8301638103802,
        "z": 0
      },
      {
        "x": 601.3849011965802,
        "y": 604.1812495412122,
        "z": 0
      }
    ],
    "handle": "230D",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 601.0338767608032,
        "y": 603.8301025349427,
        "z": 0
      },
      {
        "x": 601.0338154848425,
        "y": 604.1811882657713,
        "z": 0
      }
    ],
    "handle": "230E",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 602.2969137080954,
        "y": 608.8242513779296,
        "z": 0
      },
      {
        "x": 601.8756108600642,
        "y": 608.8241778462916,
        "z": 0
      }
    ],
    "handle": "2312",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 600.8925708750592,
        "y": 608.8240062743206,
        "z": 0
      },
      {
        "x": 599.0669251886433,
        "y": 608.8236876390692,
        "z": 0
      }
    ],
    "handle": "2313",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 601.8756108600642,
        "y": 608.8241778462916,
        "z": 0
      },
      {
        "x": 597.6625823500214,
        "y": 608.8234425326636,
        "z": 0
      }
    ],
    "handle": "2314",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "ARC",
    "handle": "2315",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 602.2969994944284,
      "y": 608.3327314071201,
      "z": 0
    },
    "radius": 0.4915199999928479,
    "startAngle": 0.00017453264533675135,
    "endAngle": 1.5709708597312715,
    "angleLength": 1.5707963270859346
  },
  {
    "type": "ARC",
    "handle": "2316",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 601.8756966465744,
      "y": 608.3326578773339,
      "z": 0
    },
    "radius": 0.4915199999990742,
    "startAngle": 1.5709708597312715,
    "endAngle": 3.141767186235127,
    "angleLength": 1.5707963265038556
  },
  {
    "type": "ARC",
    "handle": "2317",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 600.8926566615683,
      "y": 608.33248630257,
      "z": 0
    },
    "radius": 0.4915199999928479,
    "startAngle": 0.00017453264533675135,
    "endAngle": 1.5709708597312715,
    "angleLength": 1.5707963270859346
  },
  {
    "type": "ARC",
    "handle": "2318",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 599.0670109750924,
      "y": 608.3321676691812,
      "z": 0
    },
    "radius": 0.4915199999990742,
    "startAngle": 1.5709708597312715,
    "endAngle": 3.141767186235127,
    "angleLength": 1.5707963265038556
  },
  {
    "type": "ARC",
    "handle": "2319",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 598.0839709900303,
      "y": 608.3319960953522,
      "z": 0
    },
    "radius": 0.4915199999928479,
    "startAngle": 0.00017453264533675135,
    "endAngle": 1.5709708597312715,
    "angleLength": 1.5707963270859346
  },
  {
    "type": "ARC",
    "handle": "231A",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 597.6626681365302,
      "y": 608.3319225637132,
      "z": 0
    },
    "radius": 0.4915199999990742,
    "startAngle": 1.5709708597312715,
    "endAngle": 3.141767186235127,
    "angleLength": 1.5707963265038556
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 598.5362342349234,
        "y": 611.74800934641,
        "z": 0
      },
      {
        "x": 601.3449199063463,
        "y": 611.7484995545601,
        "z": 0
      }
    ],
    "handle": "231B",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 598.8873812198285,
        "y": 611.396984890085,
        "z": 0
      },
      {
        "x": 600.9938954735414,
        "y": 611.3973525455037,
        "z": 0
      }
    ],
    "handle": "231C",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 598.5362342349234,
        "y": 611.74800934641,
        "z": 0
      },
      {
        "x": 598.5367437648813,
        "y": 608.8286179825479,
        "z": 0
      }
    ],
    "handle": "231D",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 598.8873812198285,
        "y": 611.396984890085,
        "z": 0
      },
      {
        "x": 598.8878294738245,
        "y": 608.8286792598482,
        "z": 0
      }
    ],
    "handle": "231E",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 601.3449199063463,
        "y": 611.7484995545601,
        "z": 0
      },
      {
        "x": 601.3454294363034,
        "y": 608.8291081907043,
        "z": 0
      }
    ],
    "handle": "231F",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 600.9938954735414,
        "y": 611.3973525455037,
        "z": 0
      },
      {
        "x": 600.9943437273614,
        "y": 608.8290469162018,
        "z": 0
      }
    ],
    "handle": "2320",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 591.9762421771871,
        "y": 625.3550164699344,
        "z": 0
      },
      {
        "x": 591.9764872812661,
        "y": 623.9506736360318,
        "z": 0
      }
    ],
    "handle": "233B",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 593.3805850156922,
        "y": 625.3552615744854,
        "z": 0
      },
      {
        "x": 593.3808301198284,
        "y": 623.9509187396434,
        "z": 0
      }
    ],
    "handle": "233C",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 592.6780248408893,
        "y": 627.5825363332333,
        "z": 0
      },
      {
        "x": 592.6787749131904,
        "y": 623.2849385421514,
        "z": 0
      }
    ],
    "handle": "233D",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "HIDDEN",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 582.8480137448051,
        "y": 625.3534232945892,
        "z": 0
      },
      {
        "x": 582.8482588487672,
        "y": 623.9490804588212,
        "z": 0
      }
    ],
    "handle": "233E",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 581.4436709090364,
        "y": 625.3531781900493,
        "z": 0
      },
      {
        "x": 581.4439160131724,
        "y": 623.9488353552103,
        "z": 0
      }
    ],
    "handle": "233F",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 582.1454535726805,
        "y": 627.5806980533523,
        "z": 0
      },
      {
        "x": 582.1462036450382,
        "y": 623.2831002603997,
        "z": 0
      }
    ],
    "handle": "2340",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "HIDDEN",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 604.5119627023805,
        "y": 617.3334177490104,
        "z": 0
      },
      {
        "x": 628.3371302079752,
        "y": 617.3375760251428,
        "z": 0
      }
    ],
    "handle": "2341",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 603.8595330724482,
        "y": 602.3202265081708,
        "z": 0
      },
      {
        "x": 628.3397504842143,
        "y": 602.324499110669,
        "z": 0
      }
    ],
    "handle": "2342",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "TEXT",
    "handle": "234A",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "startPoint": {
      "x": 630.1306582270183,
      "y": 635.1759991254582,
      "z": 0
    },
    "textHeight": 3.949714285714286,
    "text": "DUVAR",
    "rotation": 0.0100000010572011
  },
  {
    "type": "TEXT",
    "handle": "234B",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "startPoint": {
      "x": 630.1296958571764,
      "y": 640.6899725021692,
      "z": 0
    },
    "textHeight": 3.949714285714286,
    "text": "DUBEL",
    "rotation": 0.0100000010572011
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 585.2359490392264,
        "y": 635.535325959321,
        "z": 0
      },
      {
        "x": 585.2346047642632,
        "y": 643.2374537875837,
        "z": 0
      }
    ],
    "handle": "2365",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 589.5847528765441,
        "y": 635.5360849695244,
        "z": 0
      },
      {
        "x": 589.5834086015825,
        "y": 643.2382127987222,
        "z": 0
      }
    ],
    "handle": "2366",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 604.5081117033272,
        "y": 637.2109305048425,
        "z": 0
      },
      {
        "x": 628.3332792059521,
        "y": 637.2150887819006,
        "z": 0
      }
    ],
    "handle": "2367",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 588.1701539544152,
        "y": 642.722052536901,
        "z": 0
      },
      {
        "x": 628.3323168358762,
        "y": 642.729062156755,
        "z": 0
      }
    ],
    "handle": "2368",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 608.7019330954054,
        "y": 719.5041994545618,
        "z": 0
      },
      {
        "x": 608.6997436829834,
        "y": 732.0360918752859,
        "z": 0
      }
    ],
    "handle": "237B",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 581.4235384048663,
        "y": 691.0815792931207,
        "z": 0
      },
      {
        "x": 581.4221903324352,
        "y": 698.8054649354852,
        "z": 0
      }
    ],
    "handle": "237C",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 588.4452525835945,
        "y": 691.0828048130433,
        "z": 0
      },
      {
        "x": 588.4439045112812,
        "y": 698.8066904554097,
        "z": 0
      }
    ],
    "handle": "237D",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "TEXT",
    "handle": "237E",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "startPoint": {
      "x": 612.6135800212502,
      "y": 690.9536855919355,
      "z": 0
    },
    "textHeight": 3.949714285714286,
    "text": "A",
    "rotation": 0.0100000010572011
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 569.5879550527312,
        "y": 691.0795135954392,
        "z": 0
      },
      {
        "x": 569.5866069803592,
        "y": 698.8033992359442,
        "z": 0
      }
    ],
    "handle": "237F",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 598.8758803369694,
        "y": 694.5954825431116,
        "z": 0
      },
      {
        "x": 598.8715910158344,
        "y": 719.1714821243622,
        "z": 0
      }
    ],
    "handle": "2380",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "HIDDEN",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 607.3019373543192,
        "y": 694.5969531675688,
        "z": 0
      },
      {
        "x": 607.2976480331853,
        "y": 719.1729527488353,
        "z": 0
      }
    ],
    "handle": "2381",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "HIDDEN",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 608.7062801872955,
        "y": 694.5971982711935,
        "z": 0
      },
      {
        "x": 608.7019908661013,
        "y": 719.1731978533716,
        "z": 0
      }
    ],
    "handle": "2382",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 594.5463852912062,
        "y": 720.5750701343601,
        "z": 0
      },
      {
        "x": 594.5511648204995,
        "y": 693.19038483686,
        "z": 0
      }
    ],
    "handle": "2383",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "DASHDOT",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 596.3020589400542,
        "y": 719.1710336562207,
        "z": 0
      },
      {
        "x": 596.3063482611324,
        "y": 694.5950340749623,
        "z": 0
      }
    ],
    "handle": "2384",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "HIDDEN",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 592.7912018506892,
        "y": 719.1704208962617,
        "z": 0
      },
      {
        "x": 592.7954911717684,
        "y": 694.5944213149995,
        "z": 0
      }
    ],
    "handle": "2385",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "HIDDEN",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 589.1825947535685,
        "y": 720.5741339772912,
        "z": 0
      },
      {
        "x": 589.1873742828022,
        "y": 693.1894486797902,
        "z": 0
      }
    ],
    "handle": "2386",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "DASHDOT",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 581.4235384048663,
        "y": 691.0815792931207,
        "z": 0
      },
      {
        "x": 588.4452525835945,
        "y": 691.0828048130433,
        "z": 0
      }
    ],
    "handle": "2387",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 582.1279770325634,
        "y": 678.0915306368797,
        "z": 0
      },
      {
        "x": 582.1257098198405,
        "y": 691.0817018449222,
        "z": 0
      }
    ],
    "handle": "2388",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 587.7453483783745,
        "y": 678.0925110550485,
        "z": 0
      },
      {
        "x": 587.7430811657102,
        "y": 691.0826822621593,
        "z": 0
      }
    ],
    "handle": "2389",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 588.4446398235166,
        "y": 694.5936619471674,
        "z": 0
      },
      {
        "x": 608.7062801872955,
        "y": 694.5971982711935,
        "z": 0
      }
    ],
    "handle": "238A",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 568.8880508473951,
        "y": 678.0892198337204,
        "z": 0
      },
      {
        "x": 568.8857836349042,
        "y": 691.0793910427027,
        "z": 0
      }
    ],
    "handle": "238B",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 569.5873422926522,
        "y": 694.5903707277022,
        "z": 0
      },
      {
        "x": 581.4229256447283,
        "y": 694.5924364281846,
        "z": 0
      }
    ],
    "handle": "238C",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "ARC",
    "handle": "238D",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 584.9318525395354,
      "y": 705.652248998169,
      "z": 0
    },
    "radius": 6.143999999996808,
    "startAngle": 0.6436756414438909,
    "endAngle": 2.4982660787468816,
    "angleLength": 1.8545904373029907
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 579.1384843353885,
        "y": 706.1778664430528,
        "z": 0
      },
      {
        "x": 590.9759158766242,
        "y": 706.1799324648442,
        "z": 0
      }
    ],
    "handle": "238E",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "DASHDOT",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 587.0376621190214,
        "y": 709.6901023061897,
        "z": 0
      },
      {
        "x": 588.7937034239294,
        "y": 706.1795515958229,
        "z": 0
      }
    ],
    "handle": "238F",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 581.0698178245212,
        "y": 706.1782035240939,
        "z": 0
      },
      {
        "x": 582.8246336090374,
        "y": 709.6893669916313,
        "z": 0
      }
    ],
    "handle": "2390",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 582.8246336090374,
        "y": 709.6893669916313,
        "z": 0
      },
      {
        "x": 587.0376621190214,
        "y": 709.6901023061897,
        "z": 0
      }
    ],
    "handle": "2391",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 601.5154809728252,
        "y": 704.7929410962315,
        "z": 0
      },
      {
        "x": 604.4876336302252,
        "y": 707.7661313991922,
        "z": 0
      }
    ],
    "handle": "2392",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 594.0268416348252,
        "y": 713.3104105507907,
        "z": 0
      },
      {
        "x": 595.1413988816794,
        "y": 714.4253569040436,
        "z": 0
      }
    ],
    "handle": "2393",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "HIDDEN",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 593.9524421512032,
        "y": 713.3849641289522,
        "z": 0
      },
      {
        "x": 595.0668193178715,
        "y": 714.4997303616215,
        "z": 0
      }
    ],
    "handle": "2394",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "HIDDEN",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "CIRCLE",
    "handle": "2395",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "HIDDEN",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 594.5475495355215,
      "y": 713.9044416863431,
      "z": 0
    },
    "radius": 0.7899428571428575
  },
  {
    "type": "CIRCLE",
    "handle": "2396",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "HIDDEN",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 594.5475495355215,
      "y": 713.9044416863431,
      "z": 0
    },
    "radius": 0.9479314285652979
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 584.3408836879546,
        "y": 713.3087200326817,
        "z": 0
      },
      {
        "x": 583.2259373192794,
        "y": 714.4232772616588,
        "z": 0
      }
    ],
    "handle": "2397",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "DASHDOT",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 584.4152571429732,
        "y": 713.3832995779846,
        "z": 0
      },
      {
        "x": 583.3004909200253,
        "y": 714.4976767487857,
        "z": 0
      }
    ],
    "handle": "2398",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "DASHDOT",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "CIRCLE",
    "handle": "2399",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "DASHDOT",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 583.8199684629793,
      "y": 713.9025693703516,
      "z": 0
    },
    "radius": 0.7899428571428575
  },
  {
    "type": "CIRCLE",
    "handle": "239A",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "DASHDOT",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 583.8199684629793,
      "y": 713.9025693703516,
      "z": 0
    },
    "radius": 0.9479314285652979
  },
  {
    "type": "CIRCLE",
    "handle": "239B",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "DASHDOT",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 589.1837589978812,
      "y": 713.9035055283417,
      "z": 0
    },
    "radius": 1.263908571425504
  },
  {
    "type": "CIRCLE",
    "handle": "239C",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "DASHDOT",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 589.1837589978812,
      "y": 713.9035055283417,
      "z": 0
    },
    "radius": 1.053257142857142
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 588.3902824853435,
        "y": 713.2108687721194,
        "z": 0
      },
      {
        "x": 589.8761187038615,
        "y": 714.6972237676338,
        "z": 0
      }
    ],
    "handle": "239D",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "DASHDOT",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 588.4894817948802,
        "y": 713.1114640077502,
        "z": 0
      },
      {
        "x": 589.9755581250063,
        "y": 714.5980591587722,
        "z": 0
      }
    ],
    "handle": "239E",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "DASHDOT",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 585.7694876746973,
        "y": 719.1691953763327,
        "z": 0
      },
      {
        "x": 585.7707873254544,
        "y": 711.7227449975842,
        "z": 0
      }
    ],
    "handle": "239F",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "HIDDEN",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 582.2586305852151,
        "y": 719.1685826163628,
        "z": 0
      },
      {
        "x": 582.2600150912194,
        "y": 711.2359480932319,
        "z": 0
      }
    ],
    "handle": "23A0",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "HIDDEN",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 584.0134463697916,
        "y": 722.6797460848474,
        "z": 0
      },
      {
        "x": 584.0160542533274,
        "y": 707.7376743033493,
        "z": 0
      }
    ],
    "handle": "23A1",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "DASHDOT",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 599.9592811584005,
        "y": 706.1815003566408,
        "z": 0
      },
      {
        "x": 614.1180042406785,
        "y": 706.1839715205095,
        "z": 0
      }
    ],
    "handle": "23A2",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 563.9673360836463,
        "y": 709.6860757740205,
        "z": 0
      },
      {
        "x": 568.1803645881005,
        "y": 709.6868110867225,
        "z": 0
      }
    ],
    "handle": "23A3",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 568.1803645881005,
        "y": 709.6868110867225,
        "z": 0
      },
      {
        "x": 569.9364058929502,
        "y": 706.1762603772804,
        "z": 0
      }
    ],
    "handle": "23A4",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "SOLID",
    "points": [
      {
        "x": 614.1195403817113,
        "y": 697.3825324373347,
        "z": 0
      },
      {
        "x": 613.2700339284482,
        "y": 701.1136350752865,
        "z": 0
      },
      {
        "x": 614.9807642253595,
        "y": 701.1109478501538,
        "z": 0
      },
      {
        "x": 614.9807642253595,
        "y": 701.1109478501538,
        "z": 0
      }
    ],
    "handle": "23A5",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 580.0174798405496,
        "y": 700.9117340622432,
        "z": 0
      },
      {
        "x": 589.8478796909322,
        "y": 700.913449791261,
        "z": 0
      }
    ],
    "handle": "23A6",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 581.4221903324352,
        "y": 698.8054649354852,
        "z": 0
      },
      {
        "x": 588.4439045112812,
        "y": 698.8066904554097,
        "z": 0
      }
    ],
    "handle": "23A7",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 580.0174798405496,
        "y": 700.9117340622432,
        "z": 0
      },
      {
        "x": 581.4221903324352,
        "y": 698.8054649354852,
        "z": 0
      }
    ],
    "handle": "23A8",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 587.0388876392961,
        "y": 702.6683881273448,
        "z": 0
      },
      {
        "x": 582.8258591293123,
        "y": 702.6676528146452,
        "z": 0
      }
    ],
    "handle": "23A9",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 588.4439045112812,
        "y": 698.8066904554097,
        "z": 0
      },
      {
        "x": 589.8478796909322,
        "y": 700.913449791261,
        "z": 0
      }
    ],
    "handle": "23AA",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "CIRCLE",
    "handle": "23AB",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "HIDDEN",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 594.5500005761852,
      "y": 699.8610132839538,
      "z": 0
    },
    "radius": 0.9479314285652979
  },
  {
    "type": "CIRCLE",
    "handle": "23AC",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "HIDDEN",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 594.5500005761852,
      "y": 699.8610132839538,
      "z": 0
    },
    "radius": 0.7899428571428575
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 593.9547118962503,
        "y": 700.3802830772447,
        "z": 0
      },
      {
        "x": 595.0694781218774,
        "y": 699.2659059287896,
        "z": 0
      }
    ],
    "handle": "23AD",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "HIDDEN",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 594.0290853511544,
        "y": 700.4548626895921,
        "z": 0
      },
      {
        "x": 595.1440317198294,
        "y": 699.340305414983,
        "z": 0
      }
    ],
    "handle": "23AE",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "HIDDEN",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "ARC",
    "handle": "23AF",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "DASHDOT",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 589.1862100386052,
      "y": 699.8600771259507,
      "z": 0
    },
    "radius": 1.263908571428755,
    "startAngle": 4.026451190000593,
    "endAngle": 1.117785670079483,
    "angleLength": -2.9086655199211098
  },
  {
    "type": "ARC",
    "handle": "23B0",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "DASHDOT",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 589.1862100386052,
      "y": 699.8600771259507,
      "z": 0
    },
    "radius": 1.05325714285211,
    "startAngle": 4.006745660427421,
    "endAngle": 1.1007835052714563,
    "angleLength": -2.9059621551559642
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 589.0564898535374,
        "y": 699.8886705348192,
        "z": 0
      },
      {
        "x": 589.8788467622944,
        "y": 699.0666006374993,
        "z": 0
      }
    ],
    "handle": "23B1",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "DASHDOT",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 589.1359106812172,
        "y": 700.0078468555511,
        "z": 0
      },
      {
        "x": 589.9782515623951,
        "y": 699.165799952111,
        "z": 0
      }
    ],
    "handle": "23B2",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "DASHDOT",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 582.2620007661164,
        "y": 699.8588686259434,
        "z": 0
      },
      {
        "x": 596.3054291210132,
        "y": 699.8613196639316,
        "z": 0
      }
    ],
    "handle": "23B3",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "TOPRAK1",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 569.5866069803592,
        "y": 698.8033992359442,
        "z": 0
      },
      {
        "x": 570.9905821628053,
        "y": 700.9101585708521,
        "z": 0
      }
    ],
    "handle": "23B4",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 568.1815901084335,
        "y": 702.6650969078715,
        "z": 0
      },
      {
        "x": 563.9685616040374,
        "y": 702.6643615951716,
        "z": 0
      }
    ],
    "handle": "23B5",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 588.7937034239294,
        "y": 706.1795515958229,
        "z": 0
      },
      {
        "x": 587.0388876392961,
        "y": 702.6683881273448,
        "z": 0
      }
    ],
    "handle": "23B6",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 580.0174798405496,
        "y": 700.9117340622432,
        "z": 0
      },
      {
        "x": 580.0160092162554,
        "y": 709.3377910554309,
        "z": 0
      }
    ],
    "handle": "23B7",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 584.9325770342252,
        "y": 701.5012002438342,
        "z": 0
      },
      {
        "x": 584.9308940639605,
        "y": 711.1439092922917,
        "z": 0
      }
    ],
    "handle": "23B8",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "DASHDOT",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "CIRCLE",
    "handle": "23B9",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 584.9317606254482,
      "y": 706.1788775604217,
      "z": 0
    },
    "radius": 1.75542857143368
  },
  {
    "type": "CIRCLE",
    "handle": "23BA",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 584.9317606254482,
      "y": 706.1788775604217,
      "z": 0
    },
    "radius": 2.106514285714284
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 582.8258591293123,
        "y": 702.6676528146452,
        "z": 0
      },
      {
        "x": 581.0698178245212,
        "y": 706.1782035240939,
        "z": 0
      }
    ],
    "handle": "23BB",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "CIRCLE",
    "handle": "23BC",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 603.0990792243973,
      "y": 706.1820483561532,
      "z": 0
    },
    "radius": 2.527817142851009
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 603.1000596405934,
        "y": 700.5646770354323,
        "z": 0
      },
      {
        "x": 603.0983118356663,
        "y": 710.5788616817442,
        "z": 0
      }
    ],
    "handle": "23BD",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "DASHDOT",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 589.8478796909322,
        "y": 700.913449791261,
        "z": 0
      },
      {
        "x": 589.8464090665793,
        "y": 709.3395067826019,
        "z": 0
      }
    ],
    "handle": "23BE",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "CIRCLE",
    "handle": "23BF",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 603.0990792243973,
      "y": 706.1820483561532,
      "z": 0
    },
    "radius": 2.106514285714284
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 601.7143598123213,
        "y": 704.5946118980597,
        "z": 0
      },
      {
        "x": 604.6860322523864,
        "y": 707.5673218257725,
        "z": 0
      }
    ],
    "handle": "23C0",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "CIRCLE",
    "handle": "23C1",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 566.0744630945843,
      "y": 706.1755863409531,
      "z": 0
    },
    "radius": 2.106514285714284
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 566.0752795033612,
        "y": 701.4979090252855,
        "z": 0
      },
      {
        "x": 566.0735965330955,
        "y": 711.1406180737492,
        "z": 0
      }
    ],
    "handle": "23C2",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "DASHDOT",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 569.9364058929502,
        "y": 706.1762603772804,
        "z": 0
      },
      {
        "x": 568.1815901084335,
        "y": 702.6650969078715,
        "z": 0
      }
    ],
    "handle": "23C3",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "CIRCLE",
    "handle": "23C4",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 566.0744630945843,
      "y": 706.1755863409531,
      "z": 0
    },
    "radius": 1.75542857143368
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 570.9905821628053,
        "y": 700.9101585708521,
        "z": 0
      },
      {
        "x": 570.9891115385103,
        "y": 709.3362155631113,
        "z": 0
      }
    ],
    "handle": "23C5",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 614.1180042406785,
        "y": 706.1839715205095,
        "z": 0
      },
      {
        "x": 614.1195403817113,
        "y": 697.3825324373347,
        "z": 0
      }
    ],
    "handle": "23C6",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "SOLID",
    "points": [
      {
        "x": 608.6999115381614,
        "y": 731.0753111299126,
        "z": 0
      },
      {
        "x": 605.3419191989815,
        "y": 730.3107553301343,
        "z": 0
      },
      {
        "x": 605.3443376879425,
        "y": 731.8504126043907,
        "z": 0
      },
      {
        "x": 605.3443376879425,
        "y": 731.8504126043907,
        "z": 0
      }
    ],
    "handle": "23C7",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "ARC",
    "handle": "23C8",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "HIDDEN",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 526.5827589147955,
      "y": 733.4370512505919,
      "z": 0
    },
    "radius": 1.745961035494238,
    "startAngle": 0.6364103405674665,
    "endAngle": 2.5055313797145935,
    "angleLength": 1.8691210391471271
  },
  {
    "type": "ARC",
    "handle": "23C9",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "HIDDEN",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 526.5823967934704,
      "y": 735.5118534741913,
      "z": 0
    },
    "radius": 1.745961035494238,
    "startAngle": 3.778002994157258,
    "endAngle": 5.647124033304385,
    "angleLength": 1.8691210391471267
  },
  {
    "type": "ARC",
    "handle": "23CA",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 545.8175437486495,
      "y": 679.1225944031029,
      "z": 0
    },
    "radius": 1.745961035494238,
    "startAngle": 3.778002994157258,
    "endAngle": 5.647124033304385,
    "angleLength": 1.8691210391471267
  },
  {
    "type": "ARC",
    "handle": "23CB",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 548.6265915415715,
      "y": 677.0482823876636,
      "z": 0
    },
    "radius": 1.745961035494238,
    "startAngle": 0.6364103405674665,
    "endAngle": 2.5055313797145935,
    "angleLength": 1.8691210391471271
  },
  {
    "type": "ARC",
    "handle": "23CC",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 548.6262294201874,
      "y": 679.1230846121942,
      "z": 0
    },
    "radius": 1.745961035494238,
    "startAngle": 3.778002994157258,
    "endAngle": 5.647124033304385,
    "angleLength": 1.8691210391471267
  },
  {
    "type": "ARC",
    "handle": "23CD",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 469.6861822100478,
      "y": 679.1093069743328,
      "z": 0
    },
    "radius": 1.745961035494238,
    "startAngle": 3.778002994157258,
    "endAngle": 5.647124033304385,
    "angleLength": 1.8691210391471267
  },
  {
    "type": "ARC",
    "handle": "23CE",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 472.4948678844381,
      "y": 679.1097971806292,
      "z": 0
    },
    "radius": 1.745961035494238,
    "startAngle": 3.778002994157258,
    "endAngle": 5.647124033304385,
    "angleLength": 1.8691210391471267
  },
  {
    "type": "ARC",
    "handle": "23CF",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 469.686544331489,
      "y": 677.0345047498118,
      "z": 0
    },
    "radius": 1.745961035494238,
    "startAngle": 0.6364103405674665,
    "endAngle": 2.5055313797145935,
    "angleLength": 1.8691210391471271
  },
  {
    "type": "ARC",
    "handle": "23D0",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 488.5434797438788,
      "y": 679.1125981928697,
      "z": 0
    },
    "radius": 1.745961035494238,
    "startAngle": 3.778002994157258,
    "endAngle": 5.647124033304385,
    "angleLength": 1.8691210391471267
  },
  {
    "type": "ARC",
    "handle": "23D1",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 491.3521654153008,
      "y": 679.1130884019592,
      "z": 0
    },
    "radius": 1.745961035494238,
    "startAngle": 3.778002994157258,
    "endAngle": 5.647124033304385,
    "angleLength": 1.8691210391471267
  },
  {
    "type": "ARC",
    "handle": "23D2",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 488.5438418650898,
      "y": 677.037795971143,
      "z": 0
    },
    "radius": 1.745961035494238,
    "startAngle": 0.6364103405674665,
    "endAngle": 2.5055313797145935,
    "angleLength": 1.8691210391471271
  },
  {
    "type": "ARC",
    "handle": "23D3",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 529.4178461831752,
      "y": 679.1197321163528,
      "z": 0
    },
    "radius": 1.745961035494238,
    "startAngle": 3.778002994157258,
    "endAngle": 5.647124033304385,
    "angleLength": 1.8691210391471267
  },
  {
    "type": "ARC",
    "handle": "23D4",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 529.4182083045584,
      "y": 677.0449298927477,
      "z": 0
    },
    "radius": 1.745961035494238,
    "startAngle": 0.6364103405674665,
    "endAngle": 2.5055313797145935,
    "angleLength": 1.8691210391471271
  },
  {
    "type": "TEXT",
    "handle": "23D5",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "startPoint": {
      "x": 174.2593147166769,
      "y": 476.0298500163442,
      "z": 0
    },
    "textHeight": 3.949714285714286,
    "text": "80cm",
    "rotation": 90.00999999975443
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 198.2412374317638,
        "y": 507.894373680461,
        "z": 0
      },
      {
        "x": 206.8428373008499,
        "y": 507.8958749417203,
        "z": 0
      }
    ],
    "handle": "23D6",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 241.5566768306309,
        "y": 509.2969515295696,
        "z": 0
      },
      {
        "x": 184.971886286278,
        "y": 509.2870756201408,
        "z": 0
      }
    ],
    "handle": "23D7",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 201.928372690628,
        "y": 503.6819885727009,
        "z": 0
      },
      {
        "x": 203.1571726719851,
        "y": 503.6822030358016,
        "z": 0
      }
    ],
    "handle": "23D8",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 200.6993276051947,
        "y": 505.0861169416418,
        "z": 0
      },
      {
        "x": 204.3857275492048,
        "y": 505.0867603402592,
        "z": 0
      }
    ],
    "handle": "23D9",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 199.4702825199348,
        "y": 506.4902453329413,
        "z": 0
      },
      {
        "x": 205.6142824263659,
        "y": 506.4913176642694,
        "z": 0
      }
    ],
    "handle": "23DA",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 190.6786044662577,
        "y": 503.6800251165332,
        "z": 0
      },
      {
        "x": 191.9074044504079,
        "y": 503.6802395833618,
        "z": 0
      }
    ],
    "handle": "23DB",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 189.449559380999,
        "y": 505.0841534854841,
        "z": 0
      },
      {
        "x": 193.1359593248919,
        "y": 505.0847968850212,
        "z": 0
      }
    ],
    "handle": "23DC",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 188.2205142984168,
        "y": 506.4882818795704,
        "z": 0
      },
      {
        "x": 194.3645142049646,
        "y": 506.4893542071841,
        "z": 0
      }
    ],
    "handle": "23DD",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 186.9914692103049,
        "y": 507.8924102261616,
        "z": 0
      },
      {
        "x": 195.5930690793317,
        "y": 507.8939114883515,
        "z": 0
      }
    ],
    "handle": "23DE",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 182.9699111400977,
        "y": 509.3413254953912,
        "z": 0
      },
      {
        "x": 174.0711962839709,
        "y": 509.3397723771595,
        "z": 0
      }
    ],
    "handle": "23DF",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "SOLID",
    "points": [
      {
        "x": 175.536746851285,
        "y": 509.2854288779198,
        "z": 0
      },
      {
        "x": 176.301302658511,
        "y": 505.9274365082353,
        "z": 0
      },
      {
        "x": 174.7616453937939,
        "y": 505.9298549964976,
        "z": 0
      },
      {
        "x": 174.7616453937939,
        "y": 505.9298549964976,
        "z": 0
      }
    ],
    "handle": "23E0",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 241.5566768306309,
        "y": 509.2969515295696,
        "z": 0
      },
      {
        "x": 243.6631910814902,
        "y": 509.2973191849814,
        "z": 0
      }
    ],
    "handle": "23E1",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 247.5264819522853,
        "y": 501.57410760317,
        "z": 0
      },
      {
        "x": 249.9840819147646,
        "y": 501.5745365349529,
        "z": 0
      }
    ],
    "handle": "23E2",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 247.5264819522853,
        "y": 501.57410760317,
        "z": 0
      },
      {
        "x": 243.6631910814902,
        "y": 509.2973191849814,
        "z": 0
      }
    ],
    "handle": "23E3",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 247.8774451091879,
        "y": 502.2763402760019,
        "z": 0
      },
      {
        "x": 244.3653624993749,
        "y": 509.2974417367913,
        "z": 0
      }
    ],
    "handle": "23E4",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 232.243345069582,
        "y": 507.9003081694207,
        "z": 0
      },
      {
        "x": 240.8449449386668,
        "y": 507.9018094297544,
        "z": 0
      }
    ],
    "handle": "23E5",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 233.4723901548998,
        "y": 506.4961798209733,
        "z": 0
      },
      {
        "x": 239.6163900585376,
        "y": 506.4972521513618,
        "z": 0
      }
    ],
    "handle": "23E6",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 234.7014352403343,
        "y": 505.0920514287425,
        "z": 0
      },
      {
        "x": 238.3878351813769,
        "y": 505.0926948264203,
        "z": 0
      }
    ],
    "handle": "23E7",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 235.930480322859,
        "y": 503.6879230597913,
        "z": 0
      },
      {
        "x": 237.159280306892,
        "y": 503.6881375238333,
        "z": 0
      }
    ],
    "handle": "23E8",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 224.427909136401,
        "y": 503.6859154812918,
        "z": 0
      },
      {
        "x": 225.65670911502,
        "y": 503.6861299462615,
        "z": 0
      }
    ],
    "handle": "23E9",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 223.1988640482879,
        "y": 505.0900438511744,
        "z": 0
      },
      {
        "x": 226.8852639920073,
        "y": 505.0906872479208,
        "z": 0
      }
    ],
    "handle": "23EA",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 221.9698189629697,
        "y": 506.4941722434013,
        "z": 0
      },
      {
        "x": 228.1138188694602,
        "y": 506.4952445738025,
        "z": 0
      }
    ],
    "handle": "23EB",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 220.7407738775948,
        "y": 507.8983005899887,
        "z": 0
      },
      {
        "x": 229.3423737466219,
        "y": 507.8998018521851,
        "z": 0
      }
    ],
    "handle": "23EC",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 249.982103505929,
        "y": 512.9099842421672,
        "z": 0
      },
      {
        "x": 249.9805503871757,
        "y": 521.8086991049303,
        "z": 0
      }
    ],
    "handle": "23ED",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "SOLID",
    "points": [
      {
        "x": 249.9263294698307,
        "y": 520.3403426120021,
        "z": 0
      },
      {
        "x": 253.2843218089548,
        "y": 521.1048983903629,
        "z": 0
      },
      {
        "x": 253.2819033172548,
        "y": 519.5652411812915,
        "z": 0
      },
      {
        "x": 253.2819033172548,
        "y": 519.5652411812915,
        "z": 0
      }
    ],
    "handle": "23EE",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 213.0517434448119,
        "y": 503.6839299658312,
        "z": 0
      },
      {
        "x": 214.2805434260511,
        "y": 503.6841444307929,
        "z": 0
      }
    ],
    "handle": "23EF",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 211.8226983594936,
        "y": 505.0880583357028,
        "z": 0
      },
      {
        "x": 215.5090983033299,
        "y": 505.0887017333842,
        "z": 0
      }
    ],
    "handle": "23F0",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 210.5936532769118,
        "y": 506.4921867279298,
        "z": 0
      },
      {
        "x": 216.7376531832839,
        "y": 506.4932590592579,
        "z": 0
      }
    ],
    "handle": "23F1",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 209.3646081888008,
        "y": 507.896315074522,
        "z": 0
      },
      {
        "x": 217.9662080577111,
        "y": 507.8978163367101,
        "z": 0
      }
    ],
    "handle": "23F2",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 527.4207432558763,
        "y": 660.6594164213093,
        "z": 0
      },
      {
        "x": 527.4168967440482,
        "y": 682.6983054401315,
        "z": 0
      }
    ],
    "handle": "23F3",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 509.2327941355173,
        "y": 660.6562420250948,
        "z": 0
      },
      {
        "x": 509.2289476237493,
        "y": 682.6951310429682,
        "z": 0
      }
    ],
    "handle": "23F4",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 546.0646905471802,
        "y": 660.6626704046503,
        "z": 0
      },
      {
        "x": 546.0608440354104,
        "y": 682.7015594216028,
        "z": 0
      }
    ],
    "handle": "23F5",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 489.3685256992468,
        "y": 660.6527750566603,
        "z": 0
      },
      {
        "x": 489.3646791874198,
        "y": 682.6916640726813,
        "z": 0
      }
    ],
    "handle": "23F6",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 470.8855845884537,
        "y": 660.6495491750503,
        "z": 0
      },
      {
        "x": 470.8817380766851,
        "y": 682.6884381929302,
        "z": 0
      }
    ],
    "handle": "23F7",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 524.2722516693754,
        "y": 609.737318720651,
        "z": 0
      },
      {
        "x": 524.2754953654954,
        "y": 591.1523094940821,
        "z": 0
      }
    ],
    "handle": "23F8",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "DASHDOT",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 562.3379331542524,
        "y": 609.7398543758097,
        "z": 0
      },
      {
        "x": 562.3411510350423,
        "y": 591.3027560645533,
        "z": 0
      }
    ],
    "handle": "23F9",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "DASHDOT",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 543.4805689337663,
        "y": 610.1186833083402,
        "z": 0
      },
      {
        "x": 543.4837868144382,
        "y": 591.6815849952219,
        "z": 0
      }
    ],
    "handle": "23FA",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "DASHDOT",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 505.0638024568333,
        "y": 610.1119783157336,
        "z": 0
      },
      {
        "x": 505.0670203374464,
        "y": 591.6748800026141,
        "z": 0
      }
    ],
    "handle": "23FB",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "DASHDOT",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 486.206571618561,
        "y": 609.7265669470496,
        "z": 0
      },
      {
        "x": 486.2097894992901,
        "y": 591.2894686339212,
        "z": 0
      }
    ],
    "handle": "23FC",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "DASHDOT",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 467.2994903830118,
        "y": 609.7232670392586,
        "z": 0
      },
      {
        "x": 467.302708263741,
        "y": 591.2861687261426,
        "z": 0
      }
    ],
    "handle": "23FD",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "DASHDOT",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 484.2775434899967,
        "y": 598.5921098077498,
        "z": 0
      },
      {
        "x": 488.1394862881868,
        "y": 598.5927838450114,
        "z": 0
      }
    ],
    "handle": "23FE",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 482.8815063074579,
        "y": 599.9090904379126,
        "z": 0
      },
      {
        "x": 489.5521347774198,
        "y": 599.9102546833309,
        "z": 0
      }
    ],
    "handle": "2400",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 482.8816288594969,
        "y": 599.2069190433027,
        "z": 0
      },
      {
        "x": 489.5522573294567,
        "y": 599.2080832859418,
        "z": 0
      }
    ],
    "handle": "2401",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 488.1394862881868,
        "y": 598.5927838450114,
        "z": 0
      },
      {
        "x": 488.490571997245,
        "y": 598.5928451213839,
        "z": 0
      }
    ],
    "handle": "2402",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 489.5521347774198,
        "y": 599.9102546833309,
        "z": 0
      },
      {
        "x": 489.5522573294567,
        "y": 599.2080832859418,
        "z": 0
      }
    ],
    "handle": "2403",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 482.8815063074579,
        "y": 599.9090904379126,
        "z": 0
      },
      {
        "x": 482.8816288594969,
        "y": 599.2069190433027,
        "z": 0
      }
    ],
    "handle": "2404",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 483.926457780996,
        "y": 598.5920485332417,
        "z": 0
      },
      {
        "x": 484.2775434899967,
        "y": 598.5921098077498,
        "z": 0
      }
    ],
    "handle": "2405",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 463.9744250694037,
        "y": 599.9057905291992,
        "z": 0
      },
      {
        "x": 470.6450535418686,
        "y": 599.9069547746183,
        "z": 0
      }
    ],
    "handle": "2406",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 463.9745476212107,
        "y": 599.2036191345912,
        "z": 0
      },
      {
        "x": 470.6451760939668,
        "y": 599.2047833781508,
        "z": 0
      }
    ],
    "handle": "2407",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 465.3704622543897,
        "y": 598.5888098999712,
        "z": 0
      },
      {
        "x": 469.2324050528701,
        "y": 598.5894839362987,
        "z": 0
      }
    ],
    "handle": "2408",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 465.0193765427689,
        "y": 598.5887486254612,
        "z": 0
      },
      {
        "x": 465.3704622543897,
        "y": 598.5888098999712,
        "z": 0
      }
    ],
    "handle": "2409",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 469.2324050528701,
        "y": 598.5894839362987,
        "z": 0
      },
      {
        "x": 469.583490761695,
        "y": 598.5895452126714,
        "z": 0
      }
    ],
    "handle": "240B",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 470.6450535418686,
        "y": 599.9069547746183,
        "z": 0
      },
      {
        "x": 470.6451760939668,
        "y": 599.2047833781508,
        "z": 0
      }
    ],
    "handle": "240C",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 463.9744250694037,
        "y": 599.9057905291992,
        "z": 0
      },
      {
        "x": 463.9745476212107,
        "y": 599.2036191345912,
        "z": 0
      }
    ],
    "handle": "240D",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 485.156253624008,
        "y": 592.8863958977006,
        "z": 0
      },
      {
        "x": 487.2627678775468,
        "y": 592.8867635540627,
        "z": 0
      }
    ],
    "handle": "240E",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 484.805106639047,
        "y": 593.2374203093237,
        "z": 0
      },
      {
        "x": 487.6137923105272,
        "y": 593.2379105174731,
        "z": 0
      }
    ],
    "handle": "240F",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 483.9269479891518,
        "y": 595.7833628598454,
        "z": 0
      },
      {
        "x": 488.4910622053431,
        "y": 595.7841594507724,
        "z": 0
      }
    ],
    "handle": "2410",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 487.2627678775468,
        "y": 592.8867635540627,
        "z": 0
      },
      {
        "x": 487.2622583477058,
        "y": 595.8061548713449,
        "z": 0
      }
    ],
    "handle": "2412",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 487.2627678775468,
        "y": 592.8867635540627,
        "z": 0
      },
      {
        "x": 487.6137923105272,
        "y": 593.2379105174731,
        "z": 0
      }
    ],
    "handle": "2413",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 487.6137923105272,
        "y": 593.2379105174731,
        "z": 0
      },
      {
        "x": 487.6133440566491,
        "y": 595.80621614771,
        "z": 0
      }
    ],
    "handle": "2414",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 488.1399764964578,
        "y": 595.7840981725391,
        "z": 0
      },
      {
        "x": 488.4910622053431,
        "y": 595.7841594507724,
        "z": 0
      }
    ],
    "handle": "2415",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "ARC",
    "handle": "2416",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 488.1398845824286,
      "y": 596.3107267590093,
      "z": 0
    },
    "radius": 0.5266285714285716,
    "startAngle": 3.141767186235127,
    "endAngle": 4.712563513321064,
    "angleLength": 1.570796327085937
  },
  {
    "type": "ARC",
    "handle": "2417",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 487.0866274583388,
      "y": 596.3105429308305,
      "z": 0
    },
    "radius": 0.5266285714285716,
    "startAngle": 4.712563513321064,
    "endAngle": 0.00017453264533675135,
    "angleLength": -4.712388980675727
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 487.6129496388029,
        "y": 598.0660633453926,
        "z": 0
      },
      {
        "x": 487.613347932929,
        "y": 595.7840062603173,
        "z": 0
      }
    ],
    "handle": "2418",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 489.017292474514,
        "y": 598.0663084499317,
        "z": 0
      },
      {
        "x": 489.0175988548429,
        "y": 596.3108799485317,
        "z": 0
      }
    ],
    "handle": "2419",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "ARC",
    "handle": "241A",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 488.490970291256,
      "y": 596.3107880344432,
      "z": 0
    },
    "radius": 0.5266285714285716,
    "startAngle": 4.712563513321064,
    "endAngle": 0.00017453264533675135,
    "angleLength": -4.712388980675727
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 485.156253624008,
        "y": 592.8863958977006,
        "z": 0
      },
      {
        "x": 485.1557440940508,
        "y": 595.8057872149911,
        "z": 0
      }
    ],
    "handle": "241B",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 485.156253624008,
        "y": 592.8863958977006,
        "z": 0
      },
      {
        "x": 484.805106639047,
        "y": 593.2374203093237,
        "z": 0
      }
    ],
    "handle": "241C",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 484.805106639047,
        "y": 593.2374203093237,
        "z": 0
      },
      {
        "x": 484.8046583851091,
        "y": 595.8057259395529,
        "z": 0
      }
    ],
    "handle": "241D",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 483.3999211316108,
        "y": 598.0653280326922,
        "z": 0
      },
      {
        "x": 483.4002275117681,
        "y": 596.3098995331493,
        "z": 0
      }
    ],
    "handle": "241E",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 483.9269479891518,
        "y": 595.7833628598454,
        "z": 0
      },
      {
        "x": 484.278033698093,
        "y": 595.7834241380733,
        "z": 0
      }
    ],
    "handle": "241F",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "ARC",
    "handle": "2420",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 485.3311989136858,
      "y": 596.3102365499223,
      "z": 0
    },
    "radius": 0.5266285714285716,
    "startAngle": 3.141767186235127,
    "endAngle": 4.712563513321064,
    "angleLength": 1.570796327085937
  },
  {
    "type": "ARC",
    "handle": "2421",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 484.2779417840066,
      "y": 596.3100527217427,
      "z": 0
    },
    "radius": 0.5266285714285716,
    "startAngle": 4.712563513321064,
    "endAngle": 0.00017453264533675135,
    "angleLength": -4.712388980675727
  },
  {
    "type": "ARC",
    "handle": "2422",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 483.9268560751226,
      "y": 596.3099914472324,
      "z": 0
    },
    "radius": 0.5266285714285716,
    "startAngle": 3.141767186235127,
    "endAngle": 4.712563513321064,
    "angleLength": 1.570796327085937
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 484.8042639674388,
        "y": 598.0655731363001,
        "z": 0
      },
      {
        "x": 484.8046622615661,
        "y": 595.7835160521607,
        "z": 0
      }
    ],
    "handle": "2423",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 468.3556866393177,
        "y": 592.8834636453427,
        "z": 0
      },
      {
        "x": 468.355177109478,
        "y": 595.8028549626321,
        "z": 0
      }
    ],
    "handle": "2424",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 468.3556866393177,
        "y": 592.8834636453427,
        "z": 0
      },
      {
        "x": 468.7067110749786,
        "y": 593.2346106087615,
        "z": 0
      }
    ],
    "handle": "2425",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 466.2491723884597,
        "y": 592.883095989913,
        "z": 0
      },
      {
        "x": 466.2486628586187,
        "y": 595.8024873062892,
        "z": 0
      }
    ],
    "handle": "2426",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 466.2491723884597,
        "y": 592.883095989913,
        "z": 0
      },
      {
        "x": 465.8980254034978,
        "y": 593.2341203996692,
        "z": 0
      }
    ],
    "handle": "2427",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 466.2491723884597,
        "y": 592.883095989913,
        "z": 0
      },
      {
        "x": 468.3556866393177,
        "y": 592.8834636453427,
        "z": 0
      }
    ],
    "handle": "2428",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 468.7067110749786,
        "y": 593.2346106087615,
        "z": 0
      },
      {
        "x": 468.7062628211566,
        "y": 595.8029162380743,
        "z": 0
      }
    ],
    "handle": "2429",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 465.8980254034978,
        "y": 593.2341203996692,
        "z": 0
      },
      {
        "x": 465.8975771496771,
        "y": 595.8024260317687,
        "z": 0
      }
    ],
    "handle": "242A",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 465.8980254034978,
        "y": 593.2341203996692,
        "z": 0
      },
      {
        "x": 468.7067110749786,
        "y": 593.2346106087615,
        "z": 0
      }
    ],
    "handle": "242B",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 464.492839896237,
        "y": 598.0620281239898,
        "z": 0
      },
      {
        "x": 464.4931462762176,
        "y": 596.3065996253717,
        "z": 0
      }
    ],
    "handle": "242C",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 465.0198667508667,
        "y": 595.7800629520606,
        "z": 0
      },
      {
        "x": 469.5839809698516,
        "y": 595.7808595420609,
        "z": 0
      }
    ],
    "handle": "242D",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 465.0198667508667,
        "y": 595.7800629520606,
        "z": 0
      },
      {
        "x": 465.3709524625449,
        "y": 595.7801242293599,
        "z": 0
      }
    ],
    "handle": "242E",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 469.232895260967,
        "y": 595.7807982638334,
        "z": 0
      },
      {
        "x": 469.5839809698516,
        "y": 595.7808595420609,
        "z": 0
      }
    ],
    "handle": "242F",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "ARC",
    "handle": "2430",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 469.2328033469387,
      "y": 596.3074268512198,
      "z": 0
    },
    "radius": 0.5266285714285716,
    "startAngle": 3.141767186235127,
    "endAngle": 4.712563513321064,
    "angleLength": 1.570796327085937
  },
  {
    "type": "ARC",
    "handle": "2431",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 468.1795462201107,
      "y": 596.3072430230529,
      "z": 0
    },
    "radius": 0.5266285714285716,
    "startAngle": 4.712563513321064,
    "endAngle": 0.00017453264533675135,
    "angleLength": -4.712388980675727
  },
  {
    "type": "ARC",
    "handle": "2432",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 466.4241176754002,
      "y": 596.3069366421514,
      "z": 0
    },
    "radius": 0.5266285714285716,
    "startAngle": 3.141767186235127,
    "endAngle": 4.712563513321064,
    "angleLength": 1.570796327085937
  },
  {
    "type": "ARC",
    "handle": "2433",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 465.3708605485727,
      "y": 596.3067528139617,
      "z": 0
    },
    "radius": 0.5266285714285716,
    "startAngle": 4.712563513321064,
    "endAngle": 0.00017453264533675135,
    "angleLength": -4.712388980675727
  },
  {
    "type": "ARC",
    "handle": "2434",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 465.0197748368951,
      "y": 596.3066915394592,
      "z": 0
    },
    "radius": 0.5266285714285716,
    "startAngle": 3.141767186235127,
    "endAngle": 4.712563513321064,
    "angleLength": 1.570796327085937
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 465.8971827320049,
        "y": 598.0622732275951,
        "z": 0
      },
      {
        "x": 465.8975810260752,
        "y": 595.7802161415809,
        "z": 0
      }
    ],
    "handle": "2436",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 468.7058684034268,
        "y": 598.0627634366801,
        "z": 0
      },
      {
        "x": 468.7062666974957,
        "y": 595.7807063506699,
        "z": 0
      }
    ],
    "handle": "2437",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 470.1102112364025,
        "y": 598.0630085421516,
        "z": 0
      },
      {
        "x": 470.1105176165578,
        "y": 596.3075800398217,
        "z": 0
      }
    ],
    "handle": "2438",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "ARC",
    "handle": "2439",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 469.583889055822,
      "y": 596.3074881257353,
      "z": 0
    },
    "radius": 0.5266285714285716,
    "startAngle": 4.712563513321064,
    "endAngle": 0.00017453264533675135,
    "angleLength": -4.712388980675727
  },
  {
    "type": "ARC",
    "handle": "243A",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 487.0863210782406,
      "y": 598.0659714313007,
      "z": 0
    },
    "radius": 0.5266285714285716,
    "startAngle": 0.00017453264533675135,
    "endAngle": 1.5709708597312715,
    "angleLength": 1.5707963270859346
  },
  {
    "type": "ARC",
    "handle": "243B",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 488.1395782023321,
      "y": 598.0661552594837,
      "z": 0
    },
    "radius": 0.5266285714285716,
    "startAngle": 1.5709708597312715,
    "endAngle": 3.141767186235127,
    "angleLength": 1.5707963265038556
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 489.5522573294567,
        "y": 599.2080832859418,
        "z": 0
      },
      {
        "x": 489.017323653448,
        "y": 597.8876675153043,
        "z": 0
      }
    ],
    "handle": "243C",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "ARC",
    "handle": "243D",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 488.4906639111581,
      "y": 598.0662165339863,
      "z": 0
    },
    "radius": 0.5266285714285716,
    "startAngle": 0.00017453264533675135,
    "endAngle": 1.5709708597312715,
    "angleLength": 1.5707963270859346
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 482.8816288594969,
        "y": 599.2069190433027,
        "z": 0
      },
      {
        "x": 483.39995231037,
        "y": 597.8866870971212,
        "z": 0
      }
    ],
    "handle": "243E",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "ARC",
    "handle": "243F",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 483.9265496950838,
      "y": 598.0654199458402,
      "z": 0
    },
    "radius": 0.5266285714285716,
    "startAngle": 1.5709708597312715,
    "endAngle": 3.141767186235127,
    "angleLength": 1.5707963265038556
  },
  {
    "type": "ARC",
    "handle": "2440",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 484.2776354040251,
      "y": 598.0654812222239,
      "z": 0
    },
    "radius": 0.5266285714285716,
    "startAngle": 0.00017453264533675135,
    "endAngle": 1.5709708597312715,
    "angleLength": 1.5707963270859346
  },
  {
    "type": "ARC",
    "handle": "2441",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 485.3308925336458,
      "y": 598.0656650503922,
      "z": 0
    },
    "radius": 0.5266285714285716,
    "startAngle": 1.5709708597312715,
    "endAngle": 3.141767186235127,
    "angleLength": 1.5707963265038556
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 463.9745476212107,
        "y": 599.2036191345912,
        "z": 0
      },
      {
        "x": 464.492871074996,
        "y": 597.8833871902605,
        "z": 0
      }
    ],
    "handle": "2442",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "ARC",
    "handle": "2443",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 465.01946845674,
      "y": 598.0621200389904,
      "z": 0
    },
    "radius": 0.5266285714285716,
    "startAngle": 1.5709708597312715,
    "endAngle": 3.141767186235127,
    "angleLength": 1.5707963265038556
  },
  {
    "type": "ARC",
    "handle": "2444",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 465.3705541684748,
      "y": 598.0621813144352,
      "z": 0
    },
    "radius": 0.5266285714285716,
    "startAngle": 0.00017453264533675135,
    "endAngle": 1.5709708597312715,
    "angleLength": 1.5707963270859346
  },
  {
    "type": "ARC",
    "handle": "2445",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 466.4238112953022,
      "y": 598.0623651416797,
      "z": 0
    },
    "radius": 0.5266285714285716,
    "startAngle": 1.5709708597312715,
    "endAngle": 3.141767186235127,
    "angleLength": 1.5707963265038556
  },
  {
    "type": "ARC",
    "handle": "2446",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 468.1792398400138,
      "y": 598.0626715226025,
      "z": 0
    },
    "radius": 0.5266285714285716,
    "startAngle": 0.00017453264533675135,
    "endAngle": 1.5709708597312715,
    "angleLength": 1.5707963270859346
  },
  {
    "type": "ARC",
    "handle": "2447",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 469.2324969668411,
      "y": 598.0628553517017,
      "z": 0
    },
    "radius": 0.5266285714285716,
    "startAngle": 1.5709708597312715,
    "endAngle": 3.141767186235127,
    "angleLength": 1.5707963265038556
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 470.6451760939668,
        "y": 599.2047833781508,
        "z": 0
      },
      {
        "x": 470.1102424151024,
        "y": 597.884367606584,
        "z": 0
      }
    ],
    "handle": "2448",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "ARC",
    "handle": "2449",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 469.5835826757828,
      "y": 598.0629166262006,
      "z": 0
    },
    "radius": 0.5266285714285716,
    "startAngle": 0.00017453264533675135,
    "endAngle": 1.5709708597312715,
    "angleLength": 1.5707963270859346
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 546.8091276804333,
        "y": 599.9202479123924,
        "z": 0
      },
      {
        "x": 540.1384992105882,
        "y": 599.9190836688367,
        "z": 0
      }
    ],
    "handle": "244A",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 540.1384992105882,
        "y": 599.9190836688367,
        "z": 0
      },
      {
        "x": 540.1386217625703,
        "y": 599.2169122723678,
        "z": 0
      }
    ],
    "handle": "244B",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 546.8091276804333,
        "y": 599.9202479123924,
        "z": 0
      },
      {
        "x": 546.8092502324147,
        "y": 599.2180765159353,
        "z": 0
      }
    ],
    "handle": "244C",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 545.4135502959246,
        "y": 598.6027800552401,
        "z": 0
      },
      {
        "x": 541.5516074976765,
        "y": 598.6021060179701,
        "z": 0
      }
    ],
    "handle": "244D",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 541.5516074976765,
        "y": 598.6021060179701,
        "z": 0
      },
      {
        "x": 541.2005217886765,
        "y": 598.6020447425396,
        "z": 0
      }
    ],
    "handle": "244E",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 545.7646360048084,
        "y": 598.6028413306702,
        "z": 0
      },
      {
        "x": 545.4135502959246,
        "y": 598.6027800552401,
        "z": 0
      }
    ],
    "handle": "2450",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 546.8092502324147,
        "y": 599.2180765159353,
        "z": 0
      },
      {
        "x": 540.1386217625703,
        "y": 599.2169122723678,
        "z": 0
      }
    ],
    "handle": "2451",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 558.9957967413933,
        "y": 599.9223748873701,
        "z": 0
      },
      {
        "x": 558.9959192934903,
        "y": 599.2202034918407,
        "z": 0
      }
    ],
    "handle": "2452",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 560.4089050284811,
        "y": 598.6053972374539,
        "z": 0
      },
      {
        "x": 560.0578193195383,
        "y": 598.6053359620138,
        "z": 0
      }
    ],
    "handle": "2453",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 529.8913371009996,
        "y": 599.9172951998016,
        "z": 0
      },
      {
        "x": 529.8915209290564,
        "y": 598.8640380753022,
        "z": 0
      }
    ],
    "handle": "2455",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 518.6565944177563,
        "y": 599.9153343690446,
        "z": 0
      },
      {
        "x": 518.656778245814,
        "y": 598.8620772408101,
        "z": 0
      }
    ],
    "handle": "2456",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 529.8913371009996,
        "y": 599.9172951998016,
        "z": 0
      },
      {
        "x": 518.6565944177563,
        "y": 599.9153343690446,
        "z": 0
      }
    ],
    "handle": "2457",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 529.8915209290564,
        "y": 598.8640380753022,
        "z": 0
      },
      {
        "x": 518.656778245814,
        "y": 598.8620772408101,
        "z": 0
      }
    ],
    "handle": "2458",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 528.8382638022873,
        "y": 598.8638542462031,
        "z": 0
      },
      {
        "x": 519.7100353698474,
        "y": 598.862261068989,
        "z": 0
      }
    ],
    "handle": "2459",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 501.7389263903599,
        "y": 599.2102102609098,
        "z": 0
      },
      {
        "x": 508.4095548574113,
        "y": 599.2113745072709,
        "z": 0
      }
    ],
    "handle": "245A",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 501.7388038383802,
        "y": 599.912381658313,
        "z": 0
      },
      {
        "x": 508.4094323053133,
        "y": 599.9135459009449,
        "z": 0
      }
    ],
    "handle": "245B",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 508.4094323053133,
        "y": 599.9135459009449,
        "z": 0
      },
      {
        "x": 508.4095548574113,
        "y": 599.2113745072709,
        "z": 0
      }
    ],
    "handle": "245C",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 506.9967838163711,
        "y": 598.5960750644854,
        "z": 0
      },
      {
        "x": 507.3478695279914,
        "y": 598.596136339921,
        "z": 0
      }
    ],
    "handle": "245D",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 502.7837553118589,
        "y": 598.5953397508492,
        "z": 0
      },
      {
        "x": 503.1348410208018,
        "y": 598.5954010290842,
        "z": 0
      }
    ],
    "handle": "245F",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 503.1348410208018,
        "y": 598.5954010290842,
        "z": 0
      },
      {
        "x": 506.9967838163711,
        "y": 598.5960750644854,
        "z": 0
      }
    ],
    "handle": "2460",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 501.7388038383802,
        "y": 599.912381658313,
        "z": 0
      },
      {
        "x": 501.7389263903599,
        "y": 599.2102102609098,
        "z": 0
      }
    ],
    "handle": "2461",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 544.5368318852263,
        "y": 592.8967597642695,
        "z": 0
      },
      {
        "x": 544.5363223553862,
        "y": 595.8161510806312,
        "z": 0
      }
    ],
    "handle": "2462",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 542.4303176344843,
        "y": 592.8963921097928,
        "z": 0
      },
      {
        "x": 542.4298081046445,
        "y": 595.8157834252197,
        "z": 0
      }
    ],
    "handle": "2463",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 542.0791706440502,
        "y": 593.2474165176826,
        "z": 0
      },
      {
        "x": 542.0787223899965,
        "y": 595.8157221497822,
        "z": 0
      }
    ],
    "handle": "2464",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 544.8878563182653,
        "y": 593.2479067267702,
        "z": 0
      },
      {
        "x": 544.8874080642714,
        "y": 595.8162123579312,
        "z": 0
      }
    ],
    "handle": "2465",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 544.5368318852263,
        "y": 592.8967597642695,
        "z": 0
      },
      {
        "x": 544.8878563182653,
        "y": 593.2479067267702,
        "z": 0
      }
    ],
    "handle": "2466",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 542.4303176344843,
        "y": 592.8963921097928,
        "z": 0
      },
      {
        "x": 542.0791706440502,
        "y": 593.2474165176826,
        "z": 0
      }
    ],
    "handle": "2467",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 544.8878563182653,
        "y": 593.2479067267702,
        "z": 0
      },
      {
        "x": 542.0791706440502,
        "y": 593.2474165176826,
        "z": 0
      }
    ],
    "handle": "2468",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 544.5368318852263,
        "y": 592.8967597642695,
        "z": 0
      },
      {
        "x": 542.4303176344843,
        "y": 592.8963921097928,
        "z": 0
      }
    ],
    "handle": "2469",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 545.7651262130832,
        "y": 595.7941556600596,
        "z": 0
      },
      {
        "x": 541.2010119967742,
        "y": 595.7933590710015,
        "z": 0
      }
    ],
    "handle": "246A",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 540.6739851420853,
        "y": 598.0753242429198,
        "z": 0
      },
      {
        "x": 540.6742915221834,
        "y": 596.3198957424427,
        "z": 0
      }
    ],
    "handle": "246B",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 542.0783279723264,
        "y": 598.0755693456002,
        "z": 0
      },
      {
        "x": 542.0787262663943,
        "y": 595.7935122605204,
        "z": 0
      }
    ],
    "handle": "246C",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 544.8870136465996,
        "y": 598.0760595546853,
        "z": 0
      },
      {
        "x": 544.8874119406083,
        "y": 595.7940024696107,
        "z": 0
      }
    ],
    "handle": "246D",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 546.2913564823104,
        "y": 598.0763046601602,
        "z": 0
      },
      {
        "x": 546.2916628624083,
        "y": 596.3208761596941,
        "z": 0
      }
    ],
    "handle": "246E",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 545.7651262130832,
        "y": 595.7941556600596,
        "z": 0
      },
      {
        "x": 545.4140405040233,
        "y": 595.7940943827716,
        "z": 0
      }
    ],
    "handle": "246F",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 541.552097705775,
        "y": 595.7934203483007,
        "z": 0
      },
      {
        "x": 541.2010119967742,
        "y": 595.7933590710015,
        "z": 0
      }
    ],
    "handle": "2470",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "ARC",
    "handle": "2471",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 541.2009200828613,
      "y": 596.3199876574618,
      "z": 0
    },
    "radius": 0.5266285714285716,
    "startAngle": 3.141767186235127,
    "endAngle": 4.712563513321064,
    "angleLength": 1.570796327085937
  },
  {
    "type": "ARC",
    "handle": "2472",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 541.5520057918045,
      "y": 596.3200489319679,
      "z": 0
    },
    "radius": 0.5266285714285716,
    "startAngle": 4.712563513321064,
    "endAngle": 0.00017453264533675135,
    "angleLength": -4.712388980675727
  },
  {
    "type": "ARC",
    "handle": "2473",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 542.6052629186304,
      "y": 596.3202327610704,
      "z": 0
    },
    "radius": 0.5266285714285716,
    "startAngle": 3.141767186235127,
    "endAngle": 4.712563513321064,
    "angleLength": 1.570796327085937
  },
  {
    "type": "ARC",
    "handle": "2474",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 544.3606914632255,
      "y": 596.3205391410507,
      "z": 0
    },
    "radius": 0.5266285714285716,
    "startAngle": 4.712563513321064,
    "endAngle": 0.00017453264533675135,
    "angleLength": -4.712388980675727
  },
  {
    "type": "ARC",
    "handle": "2475",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 545.4139485900522,
      "y": 596.3207229692342,
      "z": 0
    },
    "radius": 0.5266285714285716,
    "startAngle": 3.141767186235127,
    "endAngle": 4.712563513321064,
    "angleLength": 1.570796327085937
  },
  {
    "type": "ARC",
    "handle": "2476",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 545.7650342989942,
      "y": 596.3207842437331,
      "z": 0
    },
    "radius": 0.5266285714285716,
    "startAngle": 4.712563513321064,
    "endAngle": 0.00017453264533675135,
    "angleLength": -4.712388980675727
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 544.3607833772555,
        "y": 595.7939105555188,
        "z": 0
      },
      {
        "x": 542.6053548326006,
        "y": 595.7936041746108,
        "z": 0
      }
    ],
    "handle": "2477",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "ARC",
    "handle": "2478",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 560.0582176136083,
      "y": 596.3232788750691,
      "z": 0
    },
    "radius": 0.5266285714285716,
    "startAngle": 3.141767186235127,
    "endAngle": 4.712563513321064,
    "angleLength": 1.570796327085937
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 559.5312826674192,
        "y": 598.0786154642593,
        "z": 0
      },
      {
        "x": 559.5315890475172,
        "y": 596.3231869628542,
        "z": 0
      }
    ],
    "handle": "2479",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 560.9356255058653,
        "y": 598.0788605669322,
        "z": 0
      },
      {
        "x": 560.9360238000515,
        "y": 595.7968034809197,
        "z": 0
      }
    ],
    "handle": "247A",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 563.2180809081773,
        "y": 595.7972017740692,
        "z": 0
      },
      {
        "x": 561.4626523634665,
        "y": 595.7968953950112,
        "z": 0
      }
    ],
    "handle": "247B",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "ARC",
    "handle": "247C",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 561.4625604494342,
      "y": 596.3235239814856,
      "z": 0
    },
    "radius": 0.5266285714285716,
    "startAngle": 3.141767186235127,
    "endAngle": 4.712563513321064,
    "angleLength": 1.570796327085937
  },
  {
    "type": "ARC",
    "handle": "247D",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 560.4093033225503,
      "y": 596.3233401533042,
      "z": 0
    },
    "radius": 0.5266285714285716,
    "startAngle": 4.712563513321064,
    "endAngle": 0.00017453264533675135,
    "angleLength": -4.712388980675727
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 560.4093952366383,
        "y": 595.7967115668442,
        "z": 0
      },
      {
        "x": 560.0583095277545,
        "y": 595.7966502904699,
        "z": 0
      }
    ],
    "handle": "247E",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 560.9364681775922,
        "y": 593.2507077380832,
        "z": 0
      },
      {
        "x": 560.9360199236554,
        "y": 595.8190133683202,
        "z": 0
      }
    ],
    "handle": "247F",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 563.3941294162053,
        "y": 592.9000509837504,
        "z": 0
      },
      {
        "x": 561.2876151598753,
        "y": 592.8996833283187,
        "z": 0
      }
    ],
    "handle": "2480",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 563.3941294162053,
        "y": 592.9000509837504,
        "z": 0
      },
      {
        "x": 563.3936198862494,
        "y": 595.8194423001049,
        "z": 0
      }
    ],
    "handle": "2481",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 561.2876151598753,
        "y": 592.8996833283187,
        "z": 0
      },
      {
        "x": 560.9364681775922,
        "y": 593.2507077380832,
        "z": 0
      }
    ],
    "handle": "2482",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 561.2876151598753,
        "y": 592.8996833283187,
        "z": 0
      },
      {
        "x": 561.2871056298013,
        "y": 595.8190746446935,
        "z": 0
      }
    ],
    "handle": "2483",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "TEXT",
    "handle": "2484",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "startPoint": {
      "x": 506.5974718913192,
      "y": 574.6298570604848,
      "z": 0
    },
    "textHeight": 3.949714285714286,
    "text": "KESIT :  A-A",
    "rotation": 0.0100000010572011
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 526.2943977942923,
        "y": 590.2382230497702,
        "z": 0
      },
      {
        "x": 526.2939495404133,
        "y": 592.806528704219,
        "z": 0
      }
    ],
    "handle": "2485",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 522.2569121387785,
        "y": 590.2375183766535,
        "z": 0
      },
      {
        "x": 522.2564638848414,
        "y": 592.8058240292457,
        "z": 0
      }
    ],
    "handle": "2486",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 522.6080591265923,
        "y": 589.8864939659612,
        "z": 0
      },
      {
        "x": 522.6075495965774,
        "y": 592.8058853037497,
        "z": 0
      }
    ],
    "handle": "2487",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 525.9433733586343,
        "y": 589.8870760872812,
        "z": 0
      },
      {
        "x": 525.9428638287353,
        "y": 592.8064674278529,
        "z": 0
      }
    ],
    "handle": "2488",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 525.9433733586343,
        "y": 589.8870760872812,
        "z": 0
      },
      {
        "x": 522.6080591265923,
        "y": 589.8864939659612,
        "z": 0
      }
    ],
    "handle": "2489",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 525.9433120826712,
        "y": 590.2381617752609,
        "z": 0
      },
      {
        "x": 522.6079978504574,
        "y": 590.2375796520897,
        "z": 0
      }
    ],
    "handle": "248A",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 522.6080591265923,
        "y": 589.8864939659612,
        "z": 0
      },
      {
        "x": 522.2569121387785,
        "y": 590.2375183766535,
        "z": 0
      }
    ],
    "handle": "248B",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 525.9433733586343,
        "y": 589.8870760872812,
        "z": 0
      },
      {
        "x": 526.2943977942923,
        "y": 590.2382230497702,
        "z": 0
      }
    ],
    "handle": "248C",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 527.0083404050096,
        "y": 596.8441391410123,
        "z": 0
      },
      {
        "x": 520.9094277858964,
        "y": 596.8430746812227,
        "z": 0
      }
    ],
    "handle": "248D",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 527.0090450792333,
        "y": 592.8066535116924,
        "z": 0
      },
      {
        "x": 520.9528166000384,
        "y": 592.8055964987504,
        "z": 0
      }
    ],
    "handle": "248E",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "ARC",
    "handle": "248F",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 521.5583161298995,
      "y": 593.5122621692535,
      "z": 0
    },
    "radius": 0.7065600000002558,
    "startAngle": 4.712563513321064,
    "endAngle": 0.00017453264533675135,
    "angleLength": -4.712388980675727
  },
  {
    "type": "ARC",
    "handle": "2490",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 521.5578578663984,
      "y": 596.1379183549324,
      "z": 0
    },
    "radius": 0.7065600000040873,
    "startAngle": 0.00017453264533675135,
    "endAngle": 1.5709708597312715,
    "angleLength": 1.5707963270859346
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 528.8385089062494,
        "y": 597.4595114318507,
        "z": 0
      },
      {
        "x": 519.7102804739264,
        "y": 597.4579182574342,
        "z": 0
      }
    ],
    "handle": "2491",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 520.2461332955864,
        "y": 593.5120331495808,
        "z": 0
      },
      {
        "x": 520.2456750321442,
        "y": 596.1376893371189,
        "z": 0
      }
    ],
    "handle": "2492",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "ARC",
    "handle": "2493",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 520.9526932820434,
      "y": 593.5121564660049,
      "z": 0
    },
    "radius": 0.7065600000040873,
    "startAngle": 3.141767186235127,
    "endAngle": 4.712563513321064,
    "angleLength": 1.570796327085937
  },
  {
    "type": "ARC",
    "handle": "2494",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 520.9522350186014,
      "y": 596.1378126544696,
      "z": 0
    },
    "radius": 0.7065600000002558,
    "startAngle": 1.5709708597312715,
    "endAngle": 3.141767186235127,
    "angleLength": 1.5707963265038556
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 519.7102804739264,
        "y": 597.4579182574342,
        "z": 0
      },
      {
        "x": 520.2456750321442,
        "y": 596.1376893371189,
        "z": 0
      }
    ],
    "handle": "2495",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 528.3211045984065,
        "y": 593.5134424958233,
        "z": 0
      },
      {
        "x": 528.3206463350214,
        "y": 596.1390986842814,
        "z": 0
      }
    ],
    "handle": "2496",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "ARC",
    "handle": "2497",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 527.6145446092121,
      "y": 593.5133191793902,
      "z": 0
    },
    "radius": 0.7065600000002558,
    "startAngle": 4.712563513321064,
    "endAngle": 0.00017453264533675135,
    "angleLength": -4.712388980675727
  },
  {
    "type": "ARC",
    "handle": "2498",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 527.6140863456523,
      "y": 596.1389753660001,
      "z": 0
    },
    "radius": 0.7065600000040873,
    "startAngle": 0.00017453264533675135,
    "endAngle": 1.5709708597312715,
    "angleLength": 1.5707963270859346
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 528.8385089062494,
        "y": 597.4595114318507,
        "z": 0
      },
      {
        "x": 528.3206463350214,
        "y": 596.1390986842814,
        "z": 0
      }
    ],
    "handle": "2499",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 522.2648761192685,
        "y": 593.5123854847407,
        "z": 0
      },
      {
        "x": 522.2644178558265,
        "y": 596.1380416741413,
        "z": 0
      }
    ],
    "handle": "249B",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "ARC",
    "handle": "249C",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 522.9714361084043,
      "y": 593.5125088048962,
      "z": 0
    },
    "radius": 0.7065600000040873,
    "startAngle": 3.141767186235127,
    "endAngle": 4.712563513321064,
    "angleLength": 1.570796327085937
  },
  {
    "type": "ARC",
    "handle": "249D",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 522.9709778450203,
      "y": 596.1381649924224,
      "z": 0
    },
    "radius": 0.7065600000002558,
    "startAngle": 1.5709708597312715,
    "endAngle": 3.141767186235127,
    "angleLength": 1.5707963265038556
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 526.3023617720461,
        "y": 593.513090159722,
        "z": 0
      },
      {
        "x": 526.3019035085443,
        "y": 596.1387463482059,
        "z": 0
      }
    ],
    "handle": "249E",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "ARC",
    "handle": "249F",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 527.0089217612405,
      "y": 593.5132134780093,
      "z": 0
    },
    "radius": 0.7065600000040873,
    "startAngle": 3.141767186235127,
    "endAngle": 4.712563513321064,
    "angleLength": 1.570796327085937
  },
  {
    "type": "ARC",
    "handle": "24A0",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 525.5958017827354,
      "y": 593.5129668433046,
      "z": 0
    },
    "radius": 0.7065600000002558,
    "startAngle": 4.712563513321064,
    "endAngle": 0.00017453264533675135,
    "angleLength": -4.712388980675727
  },
  {
    "type": "ARC",
    "handle": "24A1",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 525.5953435193524,
      "y": 596.1386230299138,
      "z": 0
    },
    "radius": 0.7065600000040873,
    "startAngle": 0.00017453264533675135,
    "endAngle": 1.5709708597312715,
    "angleLength": 1.5707963270859346
  },
  {
    "type": "ARC",
    "handle": "24A2",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 527.0084634977981,
      "y": 596.1388696655457,
      "z": 0
    },
    "radius": 0.7065600000002558,
    "startAngle": 1.5709708597312715,
    "endAngle": 3.141767186235127,
    "angleLength": 1.5707963265038556
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 527.6566473930142,
        "y": 596.8442522920524,
        "z": 0
      },
      {
        "x": 527.0083404050096,
        "y": 596.8441391410123,
        "z": 0
      }
    ],
    "handle": "24A3",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 527.6146679271475,
        "y": 592.8067592130838,
        "z": 0
      },
      {
        "x": 527.0090450792333,
        "y": 592.8066535116924,
        "z": 0
      }
    ],
    "handle": "24A4",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "ARC",
    "handle": "24A5",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 507.3482678222941,
      "y": 596.3140792548511,
      "z": 0
    },
    "radius": 0.5266285714285716,
    "startAngle": 4.712563513321064,
    "endAngle": 0.00017453264533675135,
    "angleLength": -4.712388980675727
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 507.8745900054924,
        "y": 598.0695996675382,
        "z": 0
      },
      {
        "x": 507.8748963855324,
        "y": 596.3141711680036,
        "z": 0
      }
    ],
    "handle": "24A6",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 506.4702471698391,
        "y": 598.0693545639334,
        "z": 0
      },
      {
        "x": 506.4706454638513,
        "y": 595.78729747979,
        "z": 0
      }
    ],
    "handle": "24A7",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 503.6615614983018,
        "y": 598.0688643576431,
        "z": 0
      },
      {
        "x": 503.6619597923706,
        "y": 595.7868072716327,
        "z": 0
      }
    ],
    "handle": "24A8",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "ARC",
    "handle": "24AA",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 502.7841536059278,
      "y": 596.3132826676408,
      "z": 0
    },
    "radius": 0.5266285714285716,
    "startAngle": 3.141767186235127,
    "endAngle": 4.712563513321064,
    "angleLength": 1.570796327085937
  },
  {
    "type": "ARC",
    "handle": "24AB",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 503.1352393149878,
      "y": 596.3133439430817,
      "z": 0
    },
    "radius": 0.5266285714285716,
    "startAngle": 4.712563513321064,
    "endAngle": 0.00017453264533675135,
    "angleLength": -4.712388980675727
  },
  {
    "type": "ARC",
    "handle": "24AC",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 504.1884964418133,
      "y": 596.3135277712507,
      "z": 0
    },
    "radius": 0.5266285714285716,
    "startAngle": 3.141767186235127,
    "endAngle": 4.712563513321064,
    "angleLength": 1.570796327085937
  },
  {
    "type": "ARC",
    "handle": "24AD",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 505.9439249864663,
      "y": 596.3138341503044,
      "z": 0
    },
    "radius": 0.5266285714285716,
    "startAngle": 4.712563513321064,
    "endAngle": 0.00017453264533675135,
    "angleLength": -4.712388980675727
  },
  {
    "type": "ARC",
    "handle": "24AE",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 506.9971821104982,
      "y": 596.3140179794087,
      "z": 0
    },
    "radius": 0.5266285714285716,
    "startAngle": 3.141767186235127,
    "endAngle": 4.712563513321064,
    "angleLength": 1.570796327085937
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 506.9972740244113,
        "y": 595.7873893929387,
        "z": 0
      },
      {
        "x": 507.3483597362052,
        "y": 595.7874506683837,
        "z": 0
      }
    ],
    "handle": "24AF",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 502.7842455200146,
        "y": 595.7866540811809,
        "z": 0
      },
      {
        "x": 503.1353312289009,
        "y": 595.7867153566222,
        "z": 0
      }
    ],
    "handle": "24B0",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 502.7842455200146,
        "y": 595.7866540811809,
        "z": 0
      },
      {
        "x": 507.3483597362052,
        "y": 595.7874506683837,
        "z": 0
      }
    ],
    "handle": "24B1",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 502.2572186625331,
        "y": 598.0686192531037,
        "z": 0
      },
      {
        "x": 502.2575250425727,
        "y": 596.3131907526185,
        "z": 0
      }
    ],
    "handle": "24B2",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 503.6624041698518,
        "y": 593.2407115278619,
        "z": 0
      },
      {
        "x": 506.4710898413903,
        "y": 593.2412017350832,
        "z": 0
      }
    ],
    "handle": "24B3",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 503.6624041698518,
        "y": 593.2407115278619,
        "z": 0
      },
      {
        "x": 503.6619559159738,
        "y": 595.8090171580924,
        "z": 0
      }
    ],
    "handle": "24B4",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 506.4710898413903,
        "y": 593.2412017350832,
        "z": 0
      },
      {
        "x": 506.4706415875114,
        "y": 595.8095073671827,
        "z": 0
      }
    ],
    "handle": "24B5",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 504.013551154813,
        "y": 592.8896871171672,
        "z": 0
      },
      {
        "x": 506.1200654084093,
        "y": 592.890054774456,
        "z": 0
      }
    ],
    "handle": "24B6",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 504.013551154813,
        "y": 592.8896871171672,
        "z": 0
      },
      {
        "x": 503.6624041698518,
        "y": 593.2407115278619,
        "z": 0
      }
    ],
    "handle": "24B7",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 504.013551154813,
        "y": 592.8896871171672,
        "z": 0
      },
      {
        "x": 504.0130416249726,
        "y": 595.8090784344602,
        "z": 0
      }
    ],
    "handle": "24B8",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 506.1200654084093,
        "y": 592.890054774456,
        "z": 0
      },
      {
        "x": 506.4710898413903,
        "y": 593.2412017350832,
        "z": 0
      }
    ],
    "handle": "24B9",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 506.1200654084093,
        "y": 592.890054774456,
        "z": 0
      },
      {
        "x": 506.1195558785672,
        "y": 595.8094460898816,
        "z": 0
      }
    ],
    "handle": "24BA",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 540.1386217625703,
        "y": 599.2169122723678,
        "z": 0
      },
      {
        "x": 540.6740163209024,
        "y": 597.896683309209,
        "z": 0
      }
    ],
    "handle": "24BB",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 546.8092502324147,
        "y": 599.2180765159353,
        "z": 0
      },
      {
        "x": 546.2913876610103,
        "y": 597.8976637245905,
        "z": 0
      }
    ],
    "handle": "24BC",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 519.7100353698474,
        "y": 598.862261068989,
        "z": 0
      },
      {
        "x": 519.7102804739264,
        "y": 597.4579182574342,
        "z": 0
      }
    ],
    "handle": "24BD",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 528.8382638022873,
        "y": 598.8638542462031,
        "z": 0
      },
      {
        "x": 528.8385089062494,
        "y": 597.4595114318507,
        "z": 0
      }
    ],
    "handle": "24BE",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "ARC",
    "handle": "24BF",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 541.2006137027043,
      "y": 598.0754161579316,
      "z": 0
    },
    "radius": 0.5266285714285716,
    "startAngle": 1.5709708597312715,
    "endAngle": 3.141767186235127,
    "angleLength": 1.5707963265038556
  },
  {
    "type": "ARC",
    "handle": "24C0",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 541.5516994116484,
      "y": 598.0754774333687,
      "z": 0
    },
    "radius": 0.5266285714285716,
    "startAngle": 0.00017453264533675135,
    "endAngle": 1.5709708597312715,
    "angleLength": 1.5707963270859346
  },
  {
    "type": "ARC",
    "handle": "24C1",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 542.6049565385324,
      "y": 598.075661259685,
      "z": 0
    },
    "radius": 0.5266285714285716,
    "startAngle": 1.5709708597312715,
    "endAngle": 3.141767186235127,
    "angleLength": 1.5707963265038556
  },
  {
    "type": "ARC",
    "handle": "24C2",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 544.3603850831273,
      "y": 598.0759676406012,
      "z": 0
    },
    "radius": 0.5266285714285716,
    "startAngle": 0.00017453264533675135,
    "endAngle": 1.5709708597312715,
    "angleLength": 1.5707963270859346
  },
  {
    "type": "ARC",
    "handle": "24C3",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 545.4136422099534,
      "y": 598.0761514687692,
      "z": 0
    },
    "radius": 0.5266285714285716,
    "startAngle": 1.5709708597312715,
    "endAngle": 3.141767186235127,
    "angleLength": 1.5707963265038556
  },
  {
    "type": "ARC",
    "handle": "24C4",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 545.7647279189543,
      "y": 598.0762127460692,
      "z": 0
    },
    "radius": 0.5266285714285716,
    "startAngle": 0.00017453264533675135,
    "endAngle": 1.5709708597312715,
    "angleLength": 1.5707963270859346
  },
  {
    "type": "ARC",
    "handle": "24C5",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 560.0579112336264,
      "y": 598.0787073755426,
      "z": 0
    },
    "radius": 0.5266285714285716,
    "startAngle": 1.5709708597312715,
    "endAngle": 3.141767186235127,
    "angleLength": 1.5707963265038556
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 558.9959192934903,
        "y": 599.2202034918407,
        "z": 0
      },
      {
        "x": 559.5313138461204,
        "y": 597.8999745268226,
        "z": 0
      }
    ],
    "handle": "24C6",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "ARC",
    "handle": "24C7",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 560.4089969424522,
      "y": 598.0787686528417,
      "z": 0
    },
    "radius": 0.5266285714285716,
    "startAngle": 0.00017453264533675135,
    "endAngle": 1.5709708597312715,
    "angleLength": 1.5707963270859346
  },
  {
    "type": "ARC",
    "handle": "24C8",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 561.4622540693954,
      "y": 598.0789524810208,
      "z": 0
    },
    "radius": 0.5266285714285716,
    "startAngle": 1.5709708597312715,
    "endAngle": 3.141767186235127,
    "angleLength": 1.5707963265038556
  },
  {
    "type": "ARC",
    "handle": "24C9",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 507.3479614421954,
      "y": 598.0695077543896,
      "z": 0
    },
    "radius": 0.5266285714285716,
    "startAngle": 0.00017453264533675135,
    "endAngle": 1.5709708597312715,
    "angleLength": 1.5707963270859346
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 508.4095548574113,
        "y": 599.2113745072709,
        "z": 0
      },
      {
        "x": 507.8746211843093,
        "y": 597.8909587338421,
        "z": 0
      }
    ],
    "handle": "24CA",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "ARC",
    "handle": "24CB",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 506.9968757303424,
      "y": 598.0694464780096,
      "z": 0
    },
    "radius": 0.5266285714285716,
    "startAngle": 1.5709708597312715,
    "endAngle": 3.141767186235127,
    "angleLength": 1.5707963265038556
  },
  {
    "type": "ARC",
    "handle": "24CC",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 505.9436186063092,
      "y": 598.0692626507807,
      "z": 0
    },
    "radius": 0.5266285714285716,
    "startAngle": 0.00017453264533675135,
    "endAngle": 1.5709708597312715,
    "angleLength": 1.5707963270859346
  },
  {
    "type": "ARC",
    "handle": "24CD",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 504.1881900617144,
      "y": 598.068956270792,
      "z": 0
    },
    "radius": 0.5266285714285716,
    "startAngle": 1.5709708597312715,
    "endAngle": 3.141767186235127,
    "angleLength": 1.5707963265038556
  },
  {
    "type": "ARC",
    "handle": "24CE",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 503.1349329348296,
      "y": 598.0687724426132,
      "z": 0
    },
    "radius": 0.5266285714285716,
    "startAngle": 0.00017453264533675135,
    "endAngle": 1.5709708597312715,
    "angleLength": 1.5707963270859346
  },
  {
    "type": "ARC",
    "handle": "24CF",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 502.7838472258298,
      "y": 598.0687111671832,
      "z": 0
    },
    "radius": 0.5266285714285716,
    "startAngle": 1.5709708597312715,
    "endAngle": 3.141767186235127,
    "angleLength": 1.5707963265038556
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 501.7389263903599,
        "y": 599.2102102609098,
        "z": 0
      },
      {
        "x": 502.2572498411188,
        "y": 597.8899783165942,
        "z": 0
      }
    ],
    "handle": "24D0",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 462.886630488385,
        "y": 636.8083307659177,
        "z": 0
      },
      {
        "x": 462.8888364250308,
        "y": 624.1692452663337,
        "z": 0
      }
    ],
    "handle": "24D1",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "DASHDOT",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 464.2911992323941,
        "y": 635.5142171187317,
        "z": 0
      },
      {
        "x": 464.2927311327659,
        "y": 626.7370743937707,
        "z": 0
      }
    ],
    "handle": "24D3",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 461.4825135607969,
        "y": 635.5137269087132,
        "z": 0
      },
      {
        "x": 461.4840454612856,
        "y": 626.7365841865529,
        "z": 0
      }
    ],
    "handle": "24D4",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 464.4913353666186,
        "y": 606.6823472352514,
        "z": 0
      },
      {
        "x": 464.4917336608042,
        "y": 604.4002901501733,
        "z": 0
      }
    ],
    "handle": "24F0",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "ARC",
    "handle": "24F1",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 465.0179639272378,
      "y": 606.6824391502705,
      "z": 0
    },
    "radius": 0.5266285714285716,
    "startAngle": 1.5709708597312715,
    "endAngle": 3.141767186235127,
    "angleLength": 1.5707963265038556
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 465.017872013267,
        "y": 607.20906773394,
        "z": 0
      },
      {
        "x": 465.3689577250028,
        "y": 607.2091290112402,
        "z": 0
      }
    ],
    "handle": "24F2",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 465.8956782023889,
        "y": 607.2092209410732,
        "z": 0
      },
      {
        "x": 465.8961641135446,
        "y": 603.7826775586153,
        "z": 0
      }
    ],
    "handle": "24F4",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 468.7042719598925,
        "y": 607.2097111319179,
        "z": 0
      },
      {
        "x": 468.7048700045713,
        "y": 603.7831677702528,
        "z": 0
      }
    ],
    "handle": "24F8",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 469.2309005232528,
        "y": 607.2098030457091,
        "z": 0
      },
      {
        "x": 469.5819862321358,
        "y": 607.2098643230092,
        "z": 0
      }
    ],
    "handle": "24FA",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 465.3689577250028,
        "y": 607.2091290112402,
        "z": 0
      },
      {
        "x": 469.2309005232528,
        "y": 607.2098030457091,
        "z": 0
      }
    ],
    "handle": "24FB",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 470.1087067069018,
        "y": 606.6833276506294,
        "z": 0
      },
      {
        "x": 470.1091050009706,
        "y": 604.4012705636922,
        "z": 0
      }
    ],
    "handle": "24FC",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 464.4917336608042,
        "y": 604.4002901501733,
        "z": 0
      },
      {
        "x": 470.1091050009706,
        "y": 604.4012705636922,
        "z": 0
      }
    ],
    "handle": "24FD",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "ARC",
    "handle": "24FE",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 469.5820781462826,
      "y": 606.6832357365455,
      "z": 0
    },
    "radius": 0.5266285714285716,
    "startAngle": 0.00017453264533675135,
    "endAngle": 1.5709708597312715,
    "angleLength": 1.5707963270859346
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 468.1545302810845,
        "y": 627.5608028825335,
        "z": 0
      },
      {
        "x": 468.1552803533851,
        "y": 623.2632050923919,
        "z": 0
      }
    ],
    "handle": "24FF",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "HIDDEN",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 468.857090453093,
        "y": 625.3335281247128,
        "z": 0
      },
      {
        "x": 468.8573355571717,
        "y": 623.92918528894,
        "z": 0
      }
    ],
    "handle": "2502",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 467.4527476172658,
        "y": 625.3332830210956,
        "z": 0
      },
      {
        "x": 467.4529927213428,
        "y": 623.9289401843915,
        "z": 0
      }
    ],
    "handle": "2503",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 457.6219590128168,
        "y": 627.5589646007837,
        "z": 0
      },
      {
        "x": 457.6227090851771,
        "y": 623.2613668097046,
        "z": 0
      }
    ],
    "handle": "2506",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "HIDDEN",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 458.3245191848836,
        "y": 625.3316898457524,
        "z": 0
      },
      {
        "x": 458.3247642889618,
        "y": 623.9273470081196,
        "z": 0
      }
    ],
    "handle": "2507",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 520.2351143267015,
        "y": 607.7409449675832,
        "z": 0
      },
      {
        "x": 520.2356956827563,
        "y": 604.4100193055091,
        "z": 0
      }
    ],
    "handle": "2528",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 522.2538571530004,
        "y": 607.7412973055443,
        "z": 0
      },
      {
        "x": 522.2544385092334,
        "y": 604.4103716416128,
        "z": 0
      }
    ],
    "handle": "2529",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 526.2913428085154,
        "y": 607.7420019814606,
        "z": 0
      },
      {
        "x": 526.2919241647464,
        "y": 604.4110763165909,
        "z": 0
      }
    ],
    "handle": "252A",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 528.3100856350503,
        "y": 607.7423543184813,
        "z": 0
      },
      {
        "x": 528.3106669911652,
        "y": 604.4114286545528,
        "z": 0
      }
    ],
    "handle": "252B",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 526.2920320013063,
        "y": 603.7932186238347,
        "z": 0
      },
      {
        "x": 526.2919241647464,
        "y": 604.4110763165909,
        "z": 0
      }
    ],
    "handle": "252C",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "HIDDEN",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 526.9984841539414,
        "y": 604.4111996348828,
        "z": 0
      },
      {
        "x": 520.2356956827563,
        "y": 604.4100193055091,
        "z": 0
      }
    ],
    "handle": "252D",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 528.3106669911652,
        "y": 604.4114286545528,
        "z": 0
      },
      {
        "x": 526.9984841539414,
        "y": 604.4111996348828,
        "z": 0
      }
    ],
    "handle": "252E",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 522.2545463456765,
        "y": 603.7925139507104,
        "z": 0
      },
      {
        "x": 522.2544385092334,
        "y": 604.4103716416128,
        "z": 0
      }
    ],
    "handle": "252F",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "HIDDEN",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 522.7592320522511,
        "y": 603.7926020352021,
        "z": 0
      },
      {
        "x": 522.7591242158073,
        "y": 604.4104597279583,
        "z": 0
      }
    ],
    "handle": "2530",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "HIDDEN",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 525.7873462946734,
        "y": 603.7931305421332,
        "z": 0
      },
      {
        "x": 525.7872384581713,
        "y": 604.4109882330348,
        "z": 0
      }
    ],
    "handle": "2531",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "HIDDEN",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "ARC",
    "handle": "2532",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 520.9416743158364,
      "y": 607.7410682877324,
      "z": 0
    },
    "radius": 0.7065600000002558,
    "startAngle": 1.5709708597312715,
    "endAngle": 3.141767186235127,
    "angleLength": 1.5707963265038556
  },
  {
    "type": "ARC",
    "handle": "2533",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 521.5472971637495,
      "y": 607.7411739881936,
      "z": 0
    },
    "radius": 0.7065600000040873,
    "startAngle": 0.00017453264533675135,
    "endAngle": 1.5709708597312715,
    "angleLength": 1.5707963270859346
  },
  {
    "type": "ARC",
    "handle": "2534",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 522.9604171421962,
      "y": 607.741420623835,
      "z": 0
    },
    "radius": 0.7065600000002558,
    "startAngle": 1.5709708597312715,
    "endAngle": 3.141767186235127,
    "angleLength": 1.5707963265038556
  },
  {
    "type": "ARC",
    "handle": "2535",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 525.5847828165855,
      "y": 607.7418786631711,
      "z": 0
    },
    "radius": 0.7065600000040873,
    "startAngle": 0.00017453264533675135,
    "endAngle": 1.5709708597312715,
    "angleLength": 1.5707963270859346
  },
  {
    "type": "ARC",
    "handle": "2536",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 526.9979027978243,
      "y": 607.74212529974,
      "z": 0
    },
    "radius": 0.7065600000002558,
    "startAngle": 1.5709708597312715,
    "endAngle": 3.141767186235127,
    "angleLength": 1.5707963265038556
  },
  {
    "type": "ARC",
    "handle": "2537",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 527.6035256457983,
      "y": 607.7422310001921,
      "z": 0
    },
    "radius": 0.7065600000040873,
    "startAngle": 0.00017453264533675135,
    "endAngle": 1.5709708597312715,
    "angleLength": 1.5707963270859346
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 526.9977794798903,
        "y": 608.4486852651307,
        "z": 0
      },
      {
        "x": 520.9415509978425,
        "y": 608.4476282549801,
        "z": 0
      }
    ],
    "handle": "2538",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 527.6034023278042,
        "y": 608.4487909655835,
        "z": 0
      },
      {
        "x": 526.9977794798903,
        "y": 608.4486852651307,
        "z": 0
      }
    ],
    "handle": "253A",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 460.7124544766265,
        "y": 635.5135925095527,
        "z": 0
      },
      {
        "x": 460.7111102016648,
        "y": 643.2157203387396,
        "z": 0
      }
    ],
    "handle": "2559",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 465.0612583138872,
        "y": 635.5143515206836,
        "z": 0
      },
      {
        "x": 465.0599140389817,
        "y": 643.21647934708,
        "z": 0
      }
    ],
    "handle": "255A",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 530.7956063585582,
        "y": 734.4751876872022,
        "z": 0
      },
      {
        "x": 530.7978735711652,
        "y": 721.4850164549423,
        "z": 0
      }
    ],
    "handle": "2584",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "HIDDEN",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 525.1782350155974,
        "y": 734.4742072699507,
        "z": 0
      },
      {
        "x": 525.1805022280892,
        "y": 721.4840360395617,
        "z": 0
      }
    ],
    "handle": "2585",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "HIDDEN",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 562.5662408740013,
        "y": 691.0782880745819,
        "z": 0
      },
      {
        "x": 562.5648928016893,
        "y": 698.8021737160112,
        "z": 0
      }
    ],
    "handle": "2586",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 543.7089433459333,
        "y": 691.0749968560422,
        "z": 0
      },
      {
        "x": 543.707595273501,
        "y": 698.7988824956129,
        "z": 0
      }
    ],
    "handle": "2587",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 550.7306575246031,
        "y": 691.0762223750354,
        "z": 0
      },
      {
        "x": 550.729309452289,
        "y": 698.8001080164612,
        "z": 0
      }
    ],
    "handle": "2588",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 512.3138910450505,
        "y": 691.0695173852107,
        "z": 0
      },
      {
        "x": 512.3125429726774,
        "y": 698.7934030257092,
        "z": 0
      }
    ],
    "handle": "2589",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 505.2921768663215,
        "y": 691.0682918643511,
        "z": 0
      },
      {
        "x": 505.2908287938914,
        "y": 698.7921775048605,
        "z": 0
      }
    ],
    "handle": "258A",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 493.4565935141876,
        "y": 691.0662261657408,
        "z": 0
      },
      {
        "x": 493.4552454418727,
        "y": 698.7901118062401,
        "z": 0
      }
    ],
    "handle": "258B",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 531.5222742849724,
        "y": 691.0728698810535,
        "z": 0
      },
      {
        "x": 531.5209262124263,
        "y": 698.7967555215536,
        "z": 0
      }
    ],
    "handle": "258C",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 524.5005601060112,
        "y": 691.0716443601923,
        "z": 0
      },
      {
        "x": 524.4992120336974,
        "y": 698.7955300007087,
        "z": 0
      }
    ],
    "handle": "258D",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 486.4348793354587,
        "y": 691.0650006467439,
        "z": 0
      },
      {
        "x": 486.433531263087,
        "y": 698.7888862863091,
        "z": 0
      }
    ],
    "handle": "258E",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 474.5992959861178,
        "y": 691.0629349462607,
        "z": 0
      },
      {
        "x": 474.5979479138047,
        "y": 698.7868205867587,
        "z": 0
      }
    ],
    "handle": "258F",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 467.5775818073888,
        "y": 691.061709425412,
        "z": 0
      },
      {
        "x": 467.5762337350755,
        "y": 698.7855950668408,
        "z": 0
      }
    ],
    "handle": "2590",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 459.6024966805698,
        "y": 719.1471750820018,
        "z": 0
      },
      {
        "x": 459.606786001707,
        "y": 694.5711755007541,
        "z": 0
      }
    ],
    "handle": "2591",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "HIDDEN",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 463.113353769993,
        "y": 719.1477878419618,
        "z": 0
      },
      {
        "x": 463.117643091129,
        "y": 694.5717882597826,
        "z": 0
      }
    ],
    "handle": "2592",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "HIDDEN",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 461.3576801212038,
        "y": 720.5518243191717,
        "z": 0
      },
      {
        "x": 461.3624596504946,
        "y": 693.1671390216725,
        "z": 0
      }
    ],
    "handle": "2593",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "DASHDOT",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 466.7214706588997,
        "y": 720.5527604781018,
        "z": 0
      },
      {
        "x": 466.726250188134,
        "y": 693.1680751796702,
        "z": 0
      }
    ],
    "handle": "2594",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "DASHDOT",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 493.4559807539916,
        "y": 694.5770833007919,
        "z": 0
      },
      {
        "x": 505.2915641060103,
        "y": 694.5791489975492,
        "z": 0
      }
    ],
    "handle": "2595",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 492.7566893117042,
        "y": 678.0759324049548,
        "z": 0
      },
      {
        "x": 492.7544220990967,
        "y": 691.0661036130043,
        "z": 0
      }
    ],
    "handle": "2596",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 473.8993917808409,
        "y": 678.0726411854848,
        "z": 0
      },
      {
        "x": 473.8971245682336,
        "y": 691.0628123926032,
        "z": 0
      }
    ],
    "handle": "2597",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 468.2820204406726,
        "y": 678.0716607701049,
        "z": 0
      },
      {
        "x": 468.2797532280678,
        "y": 691.0618319781506,
        "z": 0
      }
    ],
    "handle": "2598",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 487.1393179659498,
        "y": 678.0749519886446,
        "z": 0
      },
      {
        "x": 487.1370507534011,
        "y": 691.0651231957517,
        "z": 0
      }
    ],
    "handle": "2599",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 474.5992959861178,
        "y": 691.0629349462607,
        "z": 0
      },
      {
        "x": 467.5775818073888,
        "y": 691.061709425412,
        "z": 0
      }
    ],
    "handle": "259A",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 474.598683225865,
        "y": 694.5737920803913,
        "z": 0
      },
      {
        "x": 486.4342665752628,
        "y": 694.5758577790001,
        "z": 0
      }
    ],
    "handle": "259B",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 493.4565935141876,
        "y": 691.0662261657408,
        "z": 0
      },
      {
        "x": 486.4348793354587,
        "y": 691.0650006467439,
        "z": 0
      }
    ],
    "handle": "259C",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 533.2770900693724,
        "y": 694.5840333951637,
        "z": 0
      },
      {
        "x": 543.7083305857363,
        "y": 694.5858539901648,
        "z": 0
      }
    ],
    "handle": "259D",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 563.2706795043771,
        "y": 678.0882394183435,
        "z": 0
      },
      {
        "x": 563.2684122918873,
        "y": 691.0784106263928,
        "z": 0
      }
    ],
    "handle": "259E",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 550.0307533193263,
        "y": 678.0859286151817,
        "z": 0
      },
      {
        "x": 550.0284861067773,
        "y": 691.0760998250951,
        "z": 0
      }
    ],
    "handle": "259F",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 544.4133819736292,
        "y": 678.0849481979302,
        "z": 0
      },
      {
        "x": 544.4111147610234,
        "y": 691.0751194059812,
        "z": 0
      }
    ],
    "handle": "25A0",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 543.7089433459333,
        "y": 691.0749968560422,
        "z": 0
      },
      {
        "x": 550.7306575246031,
        "y": 691.0762223750354,
        "z": 0
      }
    ],
    "handle": "25A1",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 550.7300447644654,
        "y": 694.5870795110201,
        "z": 0
      },
      {
        "x": 562.5656281138065,
        "y": 694.5891452077713,
        "z": 0
      }
    ],
    "handle": "25A2",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "ARC",
    "handle": "25A3",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 507.4011393931573,
      "y": 677.0410871887499,
      "z": 0
    },
    "radius": 1.745961035494238,
    "startAngle": 0.6364103405674665,
    "endAngle": 2.5055313797145935,
    "angleLength": 1.8691210391471271
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 505.9966154968132,
        "y": 678.0782432090452,
        "z": 0
      },
      {
        "x": 505.9943482842064,
        "y": 691.0684144170917,
        "z": 0
      }
    ],
    "handle": "25A4",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 511.6139868397734,
        "y": 678.0792236244342,
        "z": 0
      },
      {
        "x": 511.6117196271654,
        "y": 691.069394833401,
        "z": 0
      }
    ],
    "handle": "25A5",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "ARC",
    "handle": "25A6",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 510.2094629434864,
      "y": 679.1163796205028,
      "z": 0
    },
    "radius": 1.745961035494238,
    "startAngle": 3.778002994157258,
    "endAngle": 5.647124033304385,
    "angleLength": 1.8691210391471267
  },
  {
    "type": "ARC",
    "handle": "25A7",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 507.4007772719483,
      "y": 679.115889413282,
      "z": 0
    },
    "radius": 1.745961035494238,
    "startAngle": 3.778002994157258,
    "endAngle": 5.647124033304385,
    "angleLength": 1.8691210391471267
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 512.3138910450505,
        "y": 691.0695173852107,
        "z": 0
      },
      {
        "x": 505.2921768663215,
        "y": 691.0682918643511,
        "z": 0
      }
    ],
    "handle": "25A8",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 512.3132782848553,
        "y": 694.5803745193408,
        "z": 0
      },
      {
        "x": 522.7445188012194,
        "y": 694.5821951143408,
        "z": 0
      }
    ],
    "handle": "25A9",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 524.5005601060112,
        "y": 691.0716443601923,
        "z": 0
      },
      {
        "x": 531.5222742849724,
        "y": 691.0728698810535,
        "z": 0
      }
    ],
    "handle": "25AA",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "ARC",
    "handle": "25AB",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 526.6091605116383,
      "y": 679.1192419072501,
      "z": 0
    },
    "radius": 1.745961035494238,
    "startAngle": 3.778002994157258,
    "endAngle": 5.647124033304385,
    "angleLength": 1.8691210391471267
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 525.2049987366183,
        "y": 678.0815957030089,
        "z": 0
      },
      {
        "x": 525.2027315240122,
        "y": 691.0717669129309,
        "z": 0
      }
    ],
    "handle": "25AC",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 530.8223700795783,
        "y": 678.0825761202684,
        "z": 0
      },
      {
        "x": 530.8201028669714,
        "y": 691.0727473283222,
        "z": 0
      }
    ],
    "handle": "25AD",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 493.805044357257,
        "y": 706.1629729494515,
        "z": 0
      },
      {
        "x": 492.0490030522928,
        "y": 709.6735236560967,
        "z": 0
      }
    ],
    "handle": "25AE",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "ARC",
    "handle": "25AF",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 471.0858959420577,
      "y": 705.6323791295334,
      "z": 0
    },
    "radius": 6.143999999996808,
    "startAngle": 0.6436756414438909,
    "endAngle": 2.4982660787468816,
    "angleLength": 1.8545904373029907
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 476.8790803181481,
        "y": 706.1600188110021,
        "z": 0
      },
      {
        "x": 465.041648776969,
        "y": 706.1579527882822,
        "z": 0
      }
    ],
    "handle": "25B0",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "DASHDOT",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 487.8359745451598,
        "y": 709.6727883461825,
        "z": 0
      },
      {
        "x": 486.0811587605858,
        "y": 706.1616248739839,
        "z": 0
      }
    ],
    "handle": "25B1",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 468.978677014179,
        "y": 709.6694971248497,
        "z": 0
      },
      {
        "x": 467.223861229605,
        "y": 706.1583336563671,
        "z": 0
      }
    ],
    "handle": "25B2",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 474.9477468262778,
        "y": 706.1596817281097,
        "z": 0
      },
      {
        "x": 473.1917055215446,
        "y": 709.6702324375508,
        "z": 0
      }
    ],
    "handle": "25B3",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 473.1917055215446,
        "y": 709.6702324375508,
        "z": 0
      },
      {
        "x": 468.978677014179,
        "y": 709.6694971248497,
        "z": 0
      }
    ],
    "handle": "25B4",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 470.1350679487798,
        "y": 719.1490133609612,
        "z": 0
      },
      {
        "x": 470.1363675994796,
        "y": 711.7025629831405,
        "z": 0
      }
    ],
    "handle": "25B5",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "HIDDEN",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 473.6459250380277,
        "y": 719.1496261209174,
        "z": 0
      },
      {
        "x": 473.6473095440302,
        "y": 711.2169916015082,
        "z": 0
      }
    ],
    "handle": "25B6",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "HIDDEN",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 471.8898837332368,
        "y": 722.6601768322321,
        "z": 0
      },
      {
        "x": 471.8924916167735,
        "y": 707.7181050507422,
        "z": 0
      }
    ],
    "handle": "25B7",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "DASHDOT",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 473.6468441783797,
        "y": 713.8833405319601,
        "z": 0
      },
      {
        "x": 459.6034158208047,
        "y": 713.8808894930334,
        "z": 0
      }
    ],
    "handle": "25B8",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "DASHDOT",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 467.4171885385288,
        "y": 713.0903329048185,
        "z": 0
      },
      {
        "x": 465.9305933821018,
        "y": 714.5764092272155,
        "z": 0
      }
    ],
    "handle": "25B9",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "DASHDOT",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 467.5163531460571,
        "y": 713.1897722901705,
        "z": 0
      },
      {
        "x": 466.0299981823176,
        "y": 714.6756085427402,
        "z": 0
      }
    ],
    "handle": "25BA",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "DASHDOT",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "CIRCLE",
    "handle": "25BB",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "DASHDOT",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 466.7226349032717,
      "y": 713.8821320310207,
      "z": 0
    },
    "radius": 1.053257142857142
  },
  {
    "type": "CIRCLE",
    "handle": "25BC",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "DASHDOT",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 466.7226349032717,
      "y": 713.8821320310207,
      "z": 0
    },
    "radius": 1.263908571425504
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 461.8797595932838,
        "y": 713.2873465344345,
        "z": 0
      },
      {
        "x": 460.7648132218749,
        "y": 714.4019037643402,
        "z": 0
      }
    ],
    "handle": "25BD",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "DASHDOT",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 461.9541330455111,
        "y": 713.3619260787891,
        "z": 0
      },
      {
        "x": 460.8393668226208,
        "y": 714.4763032505168,
        "z": 0
      }
    ],
    "handle": "25BE",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "DASHDOT",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "CIRCLE",
    "handle": "25BF",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "DASHDOT",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 461.358844365459,
      "y": 713.8811958720906,
      "z": 0
    },
    "radius": 0.7899428571428575
  },
  {
    "type": "CIRCLE",
    "handle": "25C0",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "DASHDOT",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 461.358844365459,
      "y": 713.8811958720906,
      "z": 0
    },
    "radius": 0.9479314285652979
  },
  {
    "type": "CIRCLE",
    "handle": "25C1",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "DASHDOT",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 471.891415633611,
      "y": 713.8830341538452,
      "z": 0
    },
    "radius": 0.9479314285652979
  },
  {
    "type": "CIRCLE",
    "handle": "25C2",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "DASHDOT",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 471.891415633611,
      "y": 713.8830341538452,
      "z": 0
    },
    "radius": 0.7899428571428575
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 471.296308249177,
        "y": 713.3635565955072,
        "z": 0
      },
      {
        "x": 472.4106854132268,
        "y": 714.4783228263186,
        "z": 0
      }
    ],
    "handle": "25C3",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "DASHDOT",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 471.3707077300638,
        "y": 713.2890030182933,
        "z": 0
      },
      {
        "x": 472.4852649797101,
        "y": 714.4039493696691,
        "z": 0
      }
    ],
    "handle": "25C4",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "DASHDOT",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 492.0490030522928,
        "y": 709.6735236560967,
        "z": 0
      },
      {
        "x": 487.8359745451598,
        "y": 709.6727883461825,
        "z": 0
      }
    ],
    "handle": "25C5",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "ARC",
    "handle": "25C6",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 489.943193470129,
      "y": 705.635670349001,
      "z": 0
    },
    "radius": 6.143999999996808,
    "startAngle": 0.6436756414438909,
    "endAngle": 2.4982660787468816,
    "angleLength": 1.8545904373029907
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 495.736377846159,
        "y": 706.1633100304725,
        "z": 0
      },
      {
        "x": 483.8989463077738,
        "y": 706.1612440077522,
        "z": 0
      }
    ],
    "handle": "25C7",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "DASHDOT",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 494.8592206242611,
        "y": 700.8968711411541,
        "z": 0
      },
      {
        "x": 493.4552454418727,
        "y": 698.7901118062401,
        "z": 0
      }
    ],
    "handle": "25C8",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 476.0019230933401,
        "y": 700.8935799216804,
        "z": 0
      },
      {
        "x": 474.5979479138047,
        "y": 698.7868205867587,
        "z": 0
      }
    ],
    "handle": "25C9",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 467.5762337350755,
        "y": 698.7855950668408,
        "z": 0
      },
      {
        "x": 466.1715232403357,
        "y": 700.8918641954587,
        "z": 0
      }
    ],
    "handle": "25CA",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 486.433531263087,
        "y": 698.7888862863091,
        "z": 0
      },
      {
        "x": 485.0288207739942,
        "y": 700.8951554130726,
        "z": 0
      }
    ],
    "handle": "25CB",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 474.5979479138047,
        "y": 698.7868205867587,
        "z": 0
      },
      {
        "x": 467.5762337350755,
        "y": 698.7855950668408,
        "z": 0
      }
    ],
    "handle": "25CC",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 476.0019230933401,
        "y": 700.8935799216804,
        "z": 0
      },
      {
        "x": 466.1715232403357,
        "y": 700.8918641954587,
        "z": 0
      }
    ],
    "handle": "25CD",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 468.9799025346301,
        "y": 702.647782946933,
        "z": 0
      },
      {
        "x": 473.1929310418188,
        "y": 702.6485182605612,
        "z": 0
      }
    ],
    "handle": "25CE",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 461.8820033097298,
        "y": 700.4317986732347,
        "z": 0
      },
      {
        "x": 460.7674460600818,
        "y": 699.3168522762141,
        "z": 0
      }
    ],
    "handle": "25CF",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "DASHDOT",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 461.9564027906169,
        "y": 700.3572450261534,
        "z": 0
      },
      {
        "x": 460.8420256266836,
        "y": 699.2424788177021,
        "z": 0
      }
    ],
    "handle": "25D0",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "DASHDOT",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "CIRCLE",
    "handle": "25D1",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "DASHDOT",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 461.3612954061831,
      "y": 699.8377674696927,
      "z": 0
    },
    "radius": 0.7899428571428575
  },
  {
    "type": "CIRCLE",
    "handle": "25D2",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "DASHDOT",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 461.3612954061831,
      "y": 699.8377674696927,
      "z": 0
    },
    "radius": 0.9479314285652979
  },
  {
    "type": "ARC",
    "handle": "25D3",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "DASHDOT",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 466.7250859439368,
      "y": 699.8387036267586,
      "z": 0
    },
    "radius": 1.263908571430607,
    "startAngle": 2.024156049585815,
    "endAngle": 5.398675836785828,
    "angleLength": 3.374519787200013
  },
  {
    "type": "ARC",
    "handle": "25D4",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "DASHDOT",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 466.7250859439368,
      "y": 699.8387036267586,
      "z": 0
    },
    "radius": 1.053257142858843,
    "startAngle": 2.0411582135175093,
    "endAngle": 5.41838136636407,
    "angleLength": 3.3772231528465606
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 466.8547961427826,
        "y": 699.8673423156104,
        "z": 0
      },
      {
        "x": 466.0327262405776,
        "y": 699.0449854098179,
        "z": 0
      }
    ],
    "handle": "25D5",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "DASHDOT",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 466.7753337167668,
        "y": 699.9864909052964,
        "z": 0
      },
      {
        "x": 465.9332868194907,
        "y": 699.1441500214888,
        "z": 0
      }
    ],
    "handle": "25D6",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "DASHDOT",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 473.649295219047,
        "y": 699.8399121314204,
        "z": 0
      },
      {
        "x": 459.6058668615868,
        "y": 699.8374610887839,
        "z": 0
      }
    ],
    "handle": "25D7",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "DASHDOT",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 493.4552454418727,
        "y": 698.7901118062401,
        "z": 0
      },
      {
        "x": 486.433531263087,
        "y": 698.7888862863091,
        "z": 0
      }
    ],
    "handle": "25D8",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 487.837200065435,
        "y": 702.6510741664134,
        "z": 0
      },
      {
        "x": 492.0502285726266,
        "y": 702.6518094781712,
        "z": 0
      }
    ],
    "handle": "25D9",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 494.8592206242611,
        "y": 700.8968711411541,
        "z": 0
      },
      {
        "x": 485.0288207739942,
        "y": 700.8951554130726,
        "z": 0
      }
    ],
    "handle": "25DA",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "CIRCLE",
    "handle": "25DB",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 489.9431015561582,
      "y": 706.1622989121834,
      "z": 0
    },
    "radius": 1.75542857143368
  },
  {
    "type": "CIRCLE",
    "handle": "25DC",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 489.9431015561582,
      "y": 706.1622989121834,
      "z": 0
    },
    "radius": 2.106514285714284
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 489.9439179648176,
        "y": 701.4846215946609,
        "z": 0
      },
      {
        "x": 489.9422349946119,
        "y": 711.1273306449802,
        "z": 0
      }
    ],
    "handle": "25DD",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "DASHDOT",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 492.0502285726266,
        "y": 702.6518094781712,
        "z": 0
      },
      {
        "x": 493.805044357257,
        "y": 706.1629729494515,
        "z": 0
      }
    ],
    "handle": "25DE",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 494.8592206242611,
        "y": 700.8968711411541,
        "z": 0
      },
      {
        "x": 494.8577499998489,
        "y": 709.322928135283,
        "z": 0
      }
    ],
    "handle": "25DF",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 485.0288207739942,
        "y": 700.8951554130726,
        "z": 0
      },
      {
        "x": 485.0273501495831,
        "y": 709.3212124062691,
        "z": 0
      }
    ],
    "handle": "25E0",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 486.0811587605858,
        "y": 706.1616248739839,
        "z": 0
      },
      {
        "x": 487.837200065435,
        "y": 702.6510741664134,
        "z": 0
      }
    ],
    "handle": "25E1",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 476.0019230933401,
        "y": 700.8935799216804,
        "z": 0
      },
      {
        "x": 476.0004524688699,
        "y": 709.3196369139405,
        "z": 0
      }
    ],
    "handle": "25E2",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 471.0866204367486,
        "y": 701.4813303751822,
        "z": 0
      },
      {
        "x": 471.0849374665419,
        "y": 711.1240394245785,
        "z": 0
      }
    ],
    "handle": "25E3",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "DASHDOT",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 467.223861229605,
        "y": 706.1583336563671,
        "z": 0
      },
      {
        "x": 468.9799025346301,
        "y": 702.647782946933,
        "z": 0
      }
    ],
    "handle": "25E4",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "CIRCLE",
    "handle": "25E5",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 471.0858040280291,
      "y": 706.1590076917673,
      "z": 0
    },
    "radius": 1.75542857143368
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 473.1929310418188,
        "y": 702.6485182605612,
        "z": 0
      },
      {
        "x": 474.9477468262778,
        "y": 706.1596817281097,
        "z": 0
      }
    ],
    "handle": "25E6",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "CIRCLE",
    "handle": "25E7",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 471.0858040280291,
      "y": 706.1590076917673,
      "z": 0
    },
    "radius": 2.106514285714284
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 466.1715232403357,
        "y": 700.8918641954587,
        "z": 0
      },
      {
        "x": 466.1700526160406,
        "y": 709.3179211858596,
        "z": 0
      }
    ],
    "handle": "25E8",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 541.4238892764553,
        "y": 706.1712840050376,
        "z": 0
      },
      {
        "x": 553.2613208148973,
        "y": 706.1733500258957,
        "z": 0
      }
    ],
    "handle": "25E9",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "DASHDOT",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "ARC",
    "handle": "25EA",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 547.2172574806611,
      "y": 705.6456665592191,
      "z": 0
    },
    "radius": 6.143999999996808,
    "startAngle": 0.6436756414438909,
    "endAngle": 2.4982660787468816,
    "angleLength": 1.8545904373029907
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 545.1100385499885,
        "y": 709.6827845573462,
        "z": 0
      },
      {
        "x": 549.3230670572954,
        "y": 709.6835198681682,
        "z": 0
      }
    ],
    "handle": "25EB",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 543.3552227655304,
        "y": 706.17162108514,
        "z": 0
      },
      {
        "x": 545.1100385499885,
        "y": 709.6827845573462,
        "z": 0
      }
    ],
    "handle": "25EC",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 549.3230670572954,
        "y": 709.6835198681682,
        "z": 0
      },
      {
        "x": 551.0791083620853,
        "y": 706.1729691587316,
        "z": 0
      }
    ],
    "handle": "25ED",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 514.5936753771374,
        "y": 706.1666012480817,
        "z": 0
      },
      {
        "x": 502.7562438385798,
        "y": 706.1645352272328,
        "z": 0
      }
    ],
    "handle": "25EE",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "DASHDOT",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "ARC",
    "handle": "25EF",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 508.8004910008743,
      "y": 705.6389615666119,
      "z": 0
    },
    "radius": 6.143999999996808,
    "startAngle": 0.6436756414438909,
    "endAngle": 2.4982660787468816,
    "angleLength": 1.8545904373029907
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 512.6623418852694,
        "y": 706.1662641679831,
        "z": 0
      },
      {
        "x": 510.9063005804194,
        "y": 709.6768148774242,
        "z": 0
      }
    ],
    "handle": "25F0",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 510.9063005804194,
        "y": 709.6768148774242,
        "z": 0
      },
      {
        "x": 506.6932720732292,
        "y": 709.676079563787,
        "z": 0
      }
    ],
    "handle": "25F1",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 506.6932720732292,
        "y": 709.676079563787,
        "z": 0
      },
      {
        "x": 504.9384562886543,
        "y": 706.1649160953192,
        "z": 0
      }
    ],
    "handle": "25F2",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 524.1298799701024,
        "y": 706.3871667282627,
        "z": 0
      },
      {
        "x": 525.8846957545604,
        "y": 709.8983301967355,
        "z": 0
      }
    ],
    "handle": "25F3",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "HIDDEN",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 530.0977242644874,
        "y": 709.8990655085036,
        "z": 0
      },
      {
        "x": 531.8537655693943,
        "y": 706.3885147999899,
        "z": 0
      }
    ],
    "handle": "25F4",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "HIDDEN",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 525.8846957545604,
        "y": 709.8983301967355,
        "z": 0
      },
      {
        "x": 530.0977242644874,
        "y": 709.8990655085036,
        "z": 0
      }
    ],
    "handle": "25F5",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "HIDDEN",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 524.4783308102044,
        "y": 721.4839134868233,
        "z": 0
      },
      {
        "x": 524.4796788825764,
        "y": 713.7600278677429,
        "z": 0
      }
    ],
    "handle": "25F6",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "HIDDEN",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 531.5000449890503,
        "y": 721.4851390076793,
        "z": 0
      },
      {
        "x": 531.5013930614793,
        "y": 713.7612533895335,
        "z": 0
      }
    ],
    "handle": "25F7",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "HIDDEN",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 531.5000449890503,
        "y": 721.4851390076793,
        "z": 0
      },
      {
        "x": 524.4783308102044,
        "y": 721.4839134868233,
        "z": 0
      }
    ],
    "handle": "25F8",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "HIDDEN",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 531.5013930614793,
        "y": 713.7612533895335,
        "z": 0
      },
      {
        "x": 524.4796788825764,
        "y": 713.7600278677429,
        "z": 0
      }
    ],
    "handle": "25F9",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "HIDDEN",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 524.4796788825764,
        "y": 713.7600278677429,
        "z": 0
      },
      {
        "x": 523.0757037058355,
        "y": 711.653268532819,
        "z": 0
      }
    ],
    "handle": "25FA",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "HIDDEN",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "ARC",
    "handle": "25FB",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 528.0088742407975,
      "y": 705.6423140643138,
      "z": 0
    },
    "radius": 6.143999999996808,
    "startAngle": 0.6436756414438909,
    "endAngle": 2.4982660787468816,
    "angleLength": 1.8545904373029907
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 532.9061035559853,
        "y": 711.6549842618402,
        "z": 0
      },
      {
        "x": 523.0757037058355,
        "y": 711.653268532819,
        "z": 0
      }
    ],
    "handle": "25FC",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "HIDDEN",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 533.7850990584124,
        "y": 706.3888518810187,
        "z": 0
      },
      {
        "x": 521.9476675171753,
        "y": 706.3867858592457,
        "z": 0
      }
    ],
    "handle": "25FD",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "DASHDOT",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 532.9061035559853,
        "y": 711.6549842618402,
        "z": 0
      },
      {
        "x": 531.5013930614793,
        "y": 713.7612533895335,
        "z": 0
      }
    ],
    "handle": "25FE",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "HIDDEN",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 561.1601823096873,
        "y": 700.9084428418427,
        "z": 0
      },
      {
        "x": 562.5648928016893,
        "y": 698.8021737160112,
        "z": 0
      }
    ],
    "handle": "25FF",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 550.729309452289,
        "y": 698.8001080164612,
        "z": 0
      },
      {
        "x": 552.1332846291475,
        "y": 700.9068673532411,
        "z": 0
      }
    ],
    "handle": "2600",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 542.3028847789383,
        "y": 700.9051516242425,
        "z": 0
      },
      {
        "x": 543.707595273501,
        "y": 698.7988824956129,
        "z": 0
      }
    ],
    "handle": "2601",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 543.707595273501,
        "y": 698.7988824956129,
        "z": 0
      },
      {
        "x": 550.729309452289,
        "y": 698.8001080164612,
        "z": 0
      }
    ],
    "handle": "2602",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 542.3028847789383,
        "y": 700.9051516242425,
        "z": 0
      },
      {
        "x": 552.1332846291475,
        "y": 700.9068673532411,
        "z": 0
      }
    ],
    "handle": "2603",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 549.3242925775705,
        "y": 702.6618056874712,
        "z": 0
      },
      {
        "x": 545.1112640702623,
        "y": 702.6610703766308,
        "z": 0
      }
    ],
    "handle": "2604",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 505.2908287938914,
        "y": 698.7921775048605,
        "z": 0
      },
      {
        "x": 503.8861183020635,
        "y": 700.898446631615,
        "z": 0
      }
    ],
    "handle": "2605",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 513.7165181523884,
        "y": 700.9001623624897,
        "z": 0
      },
      {
        "x": 512.3125429726774,
        "y": 698.7934030257092,
        "z": 0
      }
    ],
    "handle": "2606",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 512.3125429726774,
        "y": 698.7934030257092,
        "z": 0
      },
      {
        "x": 505.2908287938914,
        "y": 698.7921775048605,
        "z": 0
      }
    ],
    "handle": "2607",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 513.7165181523884,
        "y": 700.9001623624897,
        "z": 0
      },
      {
        "x": 503.8861183020635,
        "y": 700.898446631615,
        "z": 0
      }
    ],
    "handle": "2608",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 506.6944975934453,
        "y": 702.6543653849513,
        "z": 0
      },
      {
        "x": 510.9075261007533,
        "y": 702.6551006976514,
        "z": 0
      }
    ],
    "handle": "2609",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 524.4992120336974,
        "y": 698.7955300007087,
        "z": 0
      },
      {
        "x": 531.5209262124263,
        "y": 698.7967555215536,
        "z": 0
      }
    ],
    "handle": "260A",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 523.0945015419265,
        "y": 700.901799129324,
        "z": 0
      },
      {
        "x": 524.4992120336974,
        "y": 698.7955300007087,
        "z": 0
      }
    ],
    "handle": "260B",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 530.0989497848783,
        "y": 702.877351329658,
        "z": 0
      },
      {
        "x": 525.8859212748355,
        "y": 702.8766160178917,
        "z": 0
      }
    ],
    "handle": "260C",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "HIDDEN",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 523.0945015419265,
        "y": 700.901799129324,
        "z": 0
      },
      {
        "x": 532.9249013921363,
        "y": 700.9035148564715,
        "z": 0
      }
    ],
    "handle": "260D",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 531.5209262124263,
        "y": 698.7967555215536,
        "z": 0
      },
      {
        "x": 532.9249013921363,
        "y": 700.9035148564715,
        "z": 0
      }
    ],
    "handle": "260E",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "ARC",
    "handle": "260F",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "HIDDEN",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 527.9917308542643,
      "y": 706.9144693268419,
      "z": 0
    },
    "radius": 6.143999999996808,
    "startAngle": 3.7852682950336822,
    "endAngle": 5.639858732336675,
    "angleLength": 1.854590437302993
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 528.0095987353704,
        "y": 701.4912653099718,
        "z": 0
      },
      {
        "x": 528.0079157651641,
        "y": 711.1339743593697,
        "z": 0
      }
    ],
    "handle": "2610",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "DASHDOT",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 561.1601823096873,
        "y": 700.9084428418427,
        "z": 0
      },
      {
        "x": 561.1587116853343,
        "y": 709.3344998350403,
        "z": 0
      }
    ],
    "handle": "2611",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "CIRCLE",
    "handle": "2612",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 547.2171655666313,
      "y": 706.1722951233313,
      "z": 0
    },
    "radius": 2.106514285714284
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 542.3028847789383,
        "y": 700.9051516242425,
        "z": 0
      },
      {
        "x": 542.3014141545864,
        "y": 709.3312086155638,
        "z": 0
      }
    ],
    "handle": "2613",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 545.1112640702623,
        "y": 702.6610703766308,
        "z": 0
      },
      {
        "x": 543.3552227655304,
        "y": 706.17162108514,
        "z": 0
      }
    ],
    "handle": "2614",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 547.2179819752923,
        "y": 701.4946178039497,
        "z": 0
      },
      {
        "x": 547.2162990050285,
        "y": 711.1373268561437,
        "z": 0
      }
    ],
    "handle": "2615",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "DASHDOT",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 551.0791083620853,
        "y": 706.1729691587316,
        "z": 0
      },
      {
        "x": 549.3242925775705,
        "y": 702.6618056874712,
        "z": 0
      }
    ],
    "handle": "2616",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "CIRCLE",
    "handle": "2617",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 547.2171655666313,
      "y": 706.1722951233313,
      "z": 0
    },
    "radius": 1.75542857143368
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 552.1332846291475,
        "y": 700.9068673532411,
        "z": 0
      },
      {
        "x": 552.1318140047933,
        "y": 709.3329243455037,
        "z": 0
      }
    ],
    "handle": "2618",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 508.8012154956823,
        "y": 701.4879128141326,
        "z": 0
      },
      {
        "x": 508.7995325254153,
        "y": 711.1306218625941,
        "z": 0
      }
    ],
    "handle": "2619",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "DASHDOT",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 510.9075261007533,
        "y": 702.6551006976514,
        "z": 0
      },
      {
        "x": 512.6623418852694,
        "y": 706.1662641679831,
        "z": 0
      }
    ],
    "handle": "261A",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 513.7165181523884,
        "y": 700.9001623624897,
        "z": 0
      },
      {
        "x": 513.7150475279772,
        "y": 709.3262193528925,
        "z": 0
      }
    ],
    "handle": "261B",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "CIRCLE",
    "handle": "261C",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 508.8003990869033,
      "y": 706.1655901307203,
      "z": 0
    },
    "radius": 2.106514285714284
  },
  {
    "type": "CIRCLE",
    "handle": "261D",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 508.8003990869033,
      "y": 706.1655901307203,
      "z": 0
    },
    "radius": 1.75542857143368
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 504.9384562886543,
        "y": 706.1649160953192,
        "z": 0
      },
      {
        "x": 506.6944975934453,
        "y": 702.6543653849513,
        "z": 0
      }
    ],
    "handle": "261E",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 503.8861183020635,
        "y": 700.898446631615,
        "z": 0
      },
      {
        "x": 503.8846476776526,
        "y": 709.3245036238831,
        "z": 0
      }
    ],
    "handle": "261F",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 532.9249013921363,
        "y": 700.9035148564715,
        "z": 0
      },
      {
        "x": 532.9234307678412,
        "y": 709.3295718487312,
        "z": 0
      }
    ],
    "handle": "2620",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 523.0945015419265,
        "y": 700.901799129324,
        "z": 0
      },
      {
        "x": 523.0930309175753,
        "y": 709.3278561206508,
        "z": 0
      }
    ],
    "handle": "2621",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 523.0757037058355,
        "y": 711.653268532819,
        "z": 0
      },
      {
        "x": 523.0771743302462,
        "y": 703.2272115191417,
        "z": 0
      }
    ],
    "handle": "2622",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "HIDDEN",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "CIRCLE",
    "handle": "2623",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "HIDDEN",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 527.9918227684682,
      "y": 706.3878407645896,
      "z": 0
    },
    "radius": 1.75542857143368
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 525.8859212748355,
        "y": 702.8766160178917,
        "z": 0
      },
      {
        "x": 524.1298799701024,
        "y": 706.3871667282627,
        "z": 0
      }
    ],
    "handle": "2624",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "HIDDEN",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 527.9910063595751,
        "y": 711.0655181044675,
        "z": 0
      },
      {
        "x": 527.9926893298983,
        "y": 701.422809031792,
        "z": 0
      }
    ],
    "handle": "2625",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "DASHDOT",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 531.8537655693943,
        "y": 706.3885147999899,
        "z": 0
      },
      {
        "x": 530.0989497848783,
        "y": 702.877351329658,
        "z": 0
      }
    ],
    "handle": "2626",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "HIDDEN",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 532.9061035559853,
        "y": 711.6549842618402,
        "z": 0
      },
      {
        "x": 532.9075741803973,
        "y": 703.2289272481501,
        "z": 0
      }
    ],
    "handle": "2627",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "HIDDEN",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "CIRCLE",
    "handle": "2628",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "HIDDEN",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 527.9918227684682,
      "y": 706.3878407645896,
      "z": 0
    },
    "radius": 2.106514285714284
  },
  {
    "type": "TEXT",
    "handle": "2629",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "startPoint": {
      "x": 468.4709545641656,
      "y": 746.4836555449217,
      "z": 0
    },
    "textHeight": 6.740845714285717,
    "text": "(USTTEN GELIS)",
    "rotation": 0.0100000010572011
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 514.6851778634006,
        "y": 744.185203356661,
        "z": 0
      },
      {
        "x": 528.1566874126432,
        "y": 744.1875545782933,
        "z": 0
      }
    ],
    "handle": "262A",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "TEXT",
    "handle": "262B",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "startPoint": {
      "x": 533.7356375081573,
      "y": 733.1027271160848,
      "z": 0
    },
    "textHeight": 3.949714285714286,
    "text": "230",
    "rotation": 0.0100000010572011
  },
  {
    "type": "ARC",
    "handle": "262C",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "HIDDEN",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 529.3914445861583,
      "y": 733.4375414606106,
      "z": 0
    },
    "radius": 1.745961035494238,
    "startAngle": 0.6364103405674665,
    "endAngle": 2.5055313797145935,
    "angleLength": 1.8691210391471271
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 528.1597107455584,
        "y": 726.865132990293,
        "z": 0
      },
      {
        "x": 528.1566874126432,
        "y": 744.1875545782933,
        "z": 0
      }
    ],
    "handle": "262D",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "ARC",
    "handle": "262E",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 564.6748412796292,
      "y": 679.1258856207105,
      "z": 0
    },
    "radius": 1.745961035494238,
    "startAngle": 3.778002994157258,
    "endAngle": 5.647124033304385,
    "angleLength": 1.8691210391471267
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 247.8774451091879,
        "y": 502.2763402760019,
        "z": 0
      },
      {
        "x": 323.711958239786,
        "y": 502.2895758943631,
        "z": 0
      }
    ],
    "handle": "262F",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 244.3653624993749,
        "y": 509.2974417367913,
        "z": 0
      },
      {
        "x": 327.2215898088179,
        "y": 509.3119028760108,
        "z": 0
      }
    ],
    "handle": "2630",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 249.92620686238,
        "y": 520.3431485490844,
        "z": 0
      },
      {
        "x": 321.656890091195,
        "y": 520.3557512192019,
        "z": 0
      }
    ],
    "handle": "2631",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "TEXT",
    "handle": "2632",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "startPoint": {
      "x": 224.6589179200811,
      "y": 553.8283429713701,
      "z": 0
    },
    "textHeight": 6.740845714285717,
    "text": "TOPRAKLAMA CUBUGU BAGLANTI DETAYI",
    "rotation": 0.0100000010572011
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 565.6665477632782,
        "y": 599.2213677363324,
        "z": 0
      },
      {
        "x": 558.9959192934903,
        "y": 599.2202034918407,
        "z": 0
      }
    ],
    "handle": "2633",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 565.6664252112972,
        "y": 599.9235391309338,
        "z": 0
      },
      {
        "x": 558.9957967413933,
        "y": 599.9223748873701,
        "z": 0
      }
    ],
    "handle": "2634",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 564.2708478268454,
        "y": 598.6060712747121,
        "z": 0
      },
      {
        "x": 560.4089050284811,
        "y": 598.6053972374539,
        "z": 0
      }
    ],
    "handle": "2635",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "ARC",
    "handle": "2636",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 563.2179889940882,
      "y": 596.3238303595998,
      "z": 0
    },
    "radius": 0.5266285714285716,
    "startAngle": 4.712563513321064,
    "endAngle": 0.00017453264533675135,
    "angleLength": -4.712388980675727
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 564.6224237411503,
        "y": 595.7974468795445,
        "z": 0
      },
      {
        "x": 560.0583095277545,
        "y": 595.7966502904699,
        "z": 0
      }
    ],
    "handle": "2637",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 563.7451538490712,
        "y": 593.251197945312,
        "z": 0
      },
      {
        "x": 560.9364681775922,
        "y": 593.2507077380832,
        "z": 0
      }
    ],
    "handle": "2638",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 563.3941294162053,
        "y": 592.9000509837504,
        "z": 0
      },
      {
        "x": 563.7451538490712,
        "y": 593.251197945312,
        "z": 0
      }
    ],
    "handle": "2639",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "ARC",
    "handle": "263A",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 563.2176826141074,
      "y": 598.0792588600698,
      "z": 0
    },
    "radius": 0.5266285714285716,
    "startAngle": 0.00017453264533675135,
    "endAngle": 1.5709708597312715,
    "angleLength": 1.5707963270859346
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 593.9395951109462,
        "y": 660.6710261506958,
        "z": 0
      },
      {
        "x": 470.8855845884537,
        "y": 660.6495491750503,
        "z": 0
      }
    ],
    "handle": "263E",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 562.5662408740013,
        "y": 691.0782880745819,
        "z": 0
      },
      {
        "x": 569.5879550527312,
        "y": 691.0795135954392,
        "z": 0
      }
    ],
    "handle": "2640",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 560.2811868046404,
        "y": 706.1745752254401,
        "z": 0
      },
      {
        "x": 572.1186183458192,
        "y": 706.1766412453716,
        "z": 0
      }
    ],
    "handle": "2641",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "DASHDOT",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "ARC",
    "handle": "2642",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 566.0745550086702,
      "y": 705.6489577768342,
      "z": 0
    },
    "radius": 6.143999999996808,
    "startAngle": 0.6436756414438909,
    "endAngle": 2.4982660787468816,
    "angleLength": 1.8545904373029907
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 562.2125202991874,
        "y": 706.1749123064693,
        "z": 0
      },
      {
        "x": 563.9673360836463,
        "y": 709.6860757740205,
        "z": 0
      }
    ],
    "handle": "2643",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 562.5648928016893,
        "y": 698.8021737160112,
        "z": 0
      },
      {
        "x": 569.5866069803592,
        "y": 698.8033992359442,
        "z": 0
      }
    ],
    "handle": "2644",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 561.1601823096873,
        "y": 700.9084428418427,
        "z": 0
      },
      {
        "x": 570.9905821628053,
        "y": 700.9101585708521,
        "z": 0
      }
    ],
    "handle": "2645",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 563.9685616040374,
        "y": 702.6643615951716,
        "z": 0
      },
      {
        "x": 562.2125202991874,
        "y": 706.1749123064693,
        "z": 0
      }
    ],
    "handle": "2646",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "TEXT",
    "handle": "2647",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "startPoint": {
      "x": 534.0804115494253,
      "y": 776.2167537705943,
      "z": 0
    },
    "textHeight": 6.740845714285717,
    "text": "ESPOTANSIYEL BARA DETAYI",
    "rotation": 0.0100000010572011
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 289.3281738979268,
        "y": 372.7083981530733,
        "z": 0
      },
      {
        "x": 289.3405849339321,
        "y": 301.5984007092084,
        "z": 0
      }
    ],
    "handle": "2648",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 282.3064597191977,
        "y": 372.7071726322128,
        "z": 0
      },
      {
        "x": 282.318870755204,
        "y": 301.597175189293,
        "z": 0
      }
    ],
    "handle": "2649",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 289.3405849339321,
        "y": 301.5984007092084,
        "z": 0
      },
      {
        "x": 287.2442976793967,
        "y": 295.7255605515029,
        "z": 0
      }
    ],
    "handle": "264A",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 284.4172078843686,
        "y": 295.7250671321499,
        "z": 0
      },
      {
        "x": 282.318870755204,
        "y": 301.597175189293,
        "z": 0
      }
    ],
    "handle": "264B",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 284.4172078843686,
        "y": 295.7250671321499,
        "z": 0
      },
      {
        "x": 287.2442976793967,
        "y": 295.7255605515029,
        "z": 0
      }
    ],
    "handle": "264C",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 280.891266744468,
        "y": 434.8736441247125,
        "z": 0
      },
      {
        "x": 280.889796120115,
        "y": 443.2997011626139,
        "z": 0
      }
    ],
    "handle": "264D",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 282.3041882225078,
        "y": 385.7218899791987,
        "z": 0
      },
      {
        "x": 282.2919330192957,
        "y": 455.9390317676514,
        "z": 0
      }
    ],
    "handle": "264E",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 289.3259024013519,
        "y": 385.7231154982029,
        "z": 0
      },
      {
        "x": 289.313647198025,
        "y": 455.9402572866518,
        "z": 0
      }
    ],
    "handle": "264F",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 290.7216665976447,
        "y": 434.8753598546609,
        "z": 0
      },
      {
        "x": 290.7201959731757,
        "y": 443.3014168916233,
        "z": 0
      }
    ],
    "handle": "2650",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 298.4869355921389,
        "y": 455.1520985169335,
        "z": 0
      },
      {
        "x": 346.2482770890932,
        "y": 424.44712714478,
        "z": 0
      }
    ],
    "handle": "2651",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 287.5706001861252,
        "y": 384.998994152993,
        "z": 0
      },
      {
        "x": 287.5729042567541,
        "y": 371.7976421220218,
        "z": 0
      }
    ],
    "handle": "2652",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 284.0594578637979,
        "y": 386.6326460102491,
        "z": 0
      },
      {
        "x": 284.0617293604296,
        "y": 373.6179287079694,
        "z": 0
      }
    ],
    "handle": "2653",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "ARC",
    "handle": "2654",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 284.0621041763219,
      "y": 371.4703921340333,
      "z": 0
    },
    "radius": 2.147536622055485,
    "startAngle": 0.6140617605620284,
    "endAngle": 2.527879958280701,
    "angleLength": 1.9138181977186726
  },
  {
    "type": "ARC",
    "handle": "2655",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 287.5730537119078,
      "y": 370.9413272235515,
      "z": 0
    },
    "radius": 2.490579577538509,
    "startAngle": 0.7887911433429183,
    "endAngle": 2.353150575228811,
    "angleLength": 1.5643594318858929
  },
  {
    "type": "ARC",
    "handle": "2656",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 287.5725294409201,
      "y": 373.9451787192328,
      "z": 0
    },
    "radius": 2.147536622055485,
    "startAngle": 3.7556544141517882,
    "endAngle": 5.669472611870495,
    "angleLength": 1.9138181977187063
  },
  {
    "type": "ARC",
    "handle": "2657",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 284.0598326795726,
      "y": 384.4851094577389,
      "z": 0
    },
    "radius": 2.147536622055485,
    "startAngle": 0.6140617605620284,
    "endAngle": 2.527879958280701,
    "angleLength": 1.9138181977186726
  },
  {
    "type": "ARC",
    "handle": "2658",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 287.5701654980079,
      "y": 387.4895736910403,
      "z": 0
    },
    "radius": 2.490579577538509,
    "startAngle": 3.9303837969327104,
    "endAngle": 5.4947432288186056,
    "angleLength": 1.564359431885895
  },
  {
    "type": "ARC",
    "handle": "2659",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 284.0594008548071,
      "y": 386.9592832373492,
      "z": 0
    },
    "radius": 2.147536622055485,
    "startAngle": 3.7556544141517882,
    "endAngle": 5.669472611870495,
    "angleLength": 1.9138181977187063
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 346.2482770890932,
        "y": 424.44712714478,
        "z": 0
      },
      {
        "x": 360.612591476935,
        "y": 424.4496341906415,
        "z": 0
      }
    ],
    "handle": "265A",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 280.891266744468,
        "y": 434.8736441247125,
        "z": 0
      },
      {
        "x": 290.7216665976447,
        "y": 434.8753598546609,
        "z": 0
      }
    ],
    "handle": "265B",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 330.0432659958598,
        "y": 434.8822227679119,
        "z": 0
      },
      {
        "x": 290.7216665976447,
        "y": 434.8753598546609,
        "z": 0
      }
    ],
    "handle": "265C",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 300.5490026441401,
        "y": 452.4313610317112,
        "z": 0
      },
      {
        "x": 300.5483898840608,
        "y": 455.9422181192821,
        "z": 0
      }
    ],
    "handle": "265D",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "HIDDEN",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 289.313647198025,
        "y": 455.9402572866518,
        "z": 0
      },
      {
        "x": 282.2919330192957,
        "y": 455.9390317676514,
        "z": 0
      }
    ],
    "handle": "265E",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 280.2362225740209,
        "y": 445.3758153160988,
        "z": 0
      },
      {
        "x": 280.2336436953618,
        "y": 460.15170114021,
        "z": 0
      }
    ],
    "handle": "265F",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 278.8318797355748,
        "y": 445.3755702124799,
        "z": 0
      },
      {
        "x": 278.8295459608779,
        "y": 458.7471132222516,
        "z": 0
      }
    ],
    "handle": "2660",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 280.2362225740209,
        "y": 445.3758153160988,
        "z": 0
      },
      {
        "x": 278.8318797355748,
        "y": 445.3755702124799,
        "z": 0
      }
    ],
    "handle": "2661",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 292.1208622450949,
        "y": 464.3668044880031,
        "z": 0
      },
      {
        "x": 276.6730910518678,
        "y": 464.364108341746,
        "z": 0
      }
    ],
    "handle": "2662",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "HIDDEN",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 292.1244162541117,
        "y": 444.0038333898455,
        "z": 0
      },
      {
        "x": 276.6766450607682,
        "y": 444.0011372454391,
        "z": 0
      }
    ],
    "handle": "2663",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "HIDDEN",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "ARC",
    "handle": "2664",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 282.2923273200289,
      "y": 453.6798547254829,
      "z": 0
    },
    "radius": 2.057554045757544,
    "startAngle": 1.5709708597312715,
    "endAngle": 4.712563513321064,
    "angleLength": 3.1415926535897927
  },
  {
    "type": "ARC",
    "handle": "2665",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 282.2934820610088,
      "y": 447.0636763880017,
      "z": 0
    },
    "radius": 2.057554045757544,
    "startAngle": 1.5709708597312715,
    "endAngle": 4.712563513321064,
    "angleLength": 3.1415926535897927
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 290.7201959731757,
        "y": 443.3014168916233,
        "z": 0
      },
      {
        "x": 321.6157383569509,
        "y": 443.3068091804122,
        "z": 0
      }
    ],
    "handle": "2666",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "ARC",
    "handle": "2667",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "HIDDEN",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 292.1223328695628,
      "y": 455.9407474957443,
      "z": 0
    },
    "radius": 8.426057142857143,
    "startAngle": 0.00017453264533675135,
    "endAngle": 1.5709708597312715,
    "angleLength": 1.5707963270859346
  },
  {
    "type": "ARC",
    "handle": "2668",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "HIDDEN",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 292.1229456296418,
      "y": 452.4298904063114,
      "z": 0
    },
    "radius": 8.426057142857143,
    "startAngle": 4.712563513321064,
    "endAngle": 0.00017453264533675135,
    "angleLength": -4.712388980675727
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 259.4188808330789,
        "y": 296.9829962840184,
        "z": 0
      },
      {
        "x": 259.3910439359027,
        "y": 455.9995956569943,
        "z": 0
      }
    ],
    "handle": "2669",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 266.8520451189817,
        "y": 297.0388929257088,
        "z": 0
      },
      {
        "x": 257.9533302628541,
        "y": 297.0373398056208,
        "z": 0
      }
    ],
    "handle": "266A",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "SOLID",
    "points": [
      {
        "x": 259.4216867407086,
        "y": 296.9831188945136,
        "z": 0
      },
      {
        "x": 258.6571309390718,
        "y": 300.3411112437035,
        "z": 0
      },
      {
        "x": 260.1967882038437,
        "y": 300.3386927312194,
        "z": 0
      },
      {
        "x": 260.1967882038437,
        "y": 300.3386927312194,
        "z": 0
      }
    ],
    "handle": "266B",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 241.5657456810587,
        "y": 457.3362665632738,
        "z": 0
      },
      {
        "x": 241.5696673461338,
        "y": 434.8667812123931,
        "z": 0
      }
    ],
    "handle": "266C",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 232.6581855728288,
        "y": 459.0522013911939,
        "z": 0
      },
      {
        "x": 214.8354104473251,
        "y": 436.5463380189613,
        "z": 0
      }
    ],
    "handle": "266D",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "TEXT",
    "handle": "266E",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "startPoint": {
      "x": 257.0622082428311,
      "y": 365.6254262151124,
      "z": 0
    },
    "textHeight": 3.949714285714286,
    "text": "150cm",
    "rotation": 90.00999999975443
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 199.2276277384951,
        "y": 436.5436139479206,
        "z": 0
      },
      {
        "x": 214.8354104473251,
        "y": 436.5463380189613,
        "z": 0
      }
    ],
    "handle": "266F",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 198.9337945196317,
        "y": 424.7002540016501,
        "z": 0
      },
      {
        "x": 263.2315932612397,
        "y": 424.7114760838448,
        "z": 0
      }
    ],
    "handle": "2670",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 183.0068935708249,
        "y": 459.4304187362903,
        "z": 0
      },
      {
        "x": 174.1081787175497,
        "y": 459.4288656171483,
        "z": 0
      }
    ],
    "handle": "2671",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "SOLID",
    "points": [
      {
        "x": 175.5765351954039,
        "y": 459.3746446827387,
        "z": 0
      },
      {
        "x": 174.8119793909137,
        "y": 462.7326370533528,
        "z": 0
      },
      {
        "x": 176.3516366557447,
        "y": 462.7302185641601,
        "z": 0
      },
      {
        "x": 176.3516366557447,
        "y": 462.7302185641601,
        "z": 0
      }
    ],
    "handle": "2672",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "ARC",
    "handle": "2673",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 220.7508969953039,
      "y": 460.5486248731611,
      "z": 0
    },
    "radius": 1.476537023195239,
    "startAngle": 5.255887088929074,
    "endAngle": 1.027647284217122,
    "angleLength": -4.2282398047119525
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 268.2491174219176,
        "y": 452.4257236355815,
        "z": 0
      },
      {
        "x": 268.248504661722,
        "y": 455.9365807250115,
        "z": 0
      }
    ],
    "handle": "2675",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "HIDDEN",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 266.7960235142369,
        "y": 456.0362305482811,
        "z": 0
      },
      {
        "x": 257.8973086579939,
        "y": 456.0346774272619,
        "z": 0
      }
    ],
    "handle": "2676",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "SOLID",
    "points": [
      {
        "x": 259.3628592253657,
        "y": 455.9803339065957,
        "z": 0
      },
      {
        "x": 260.1274150298551,
        "y": 452.6223415583308,
        "z": 0
      },
      {
        "x": 258.5877577650828,
        "y": 452.6247600698844,
        "z": 0
      },
      {
        "x": 258.5877577650828,
        "y": 452.6247600698844,
        "z": 0
      }
    ],
    "handle": "2677",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 249.9942537335448,
        "y": 443.2943088747523,
        "z": 0
      },
      {
        "x": 249.9918026928201,
        "y": 457.3377371858685,
        "z": 0
      }
    ],
    "handle": "2678",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 249.9918026928201,
        "y": 457.3377371858685,
        "z": 0
      },
      {
        "x": 241.5657456810587,
        "y": 457.3362665632738,
        "z": 0
      }
    ],
    "handle": "2679",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 249.991067380644,
        "y": 461.5507657155328,
        "z": 0
      },
      {
        "x": 241.565010368825,
        "y": 461.5492950920013,
        "z": 0
      }
    ],
    "handle": "267A",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 249.9918026928201,
        "y": 457.3377371858685,
        "z": 0
      },
      {
        "x": 249.9915575889168,
        "y": 458.7420800440011,
        "z": 0
      }
    ],
    "handle": "267B",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 241.5657456810587,
        "y": 457.3362665632738,
        "z": 0
      },
      {
        "x": 241.5655005770379,
        "y": 458.7406094204595,
        "z": 0
      }
    ],
    "handle": "267C",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 281.8297299336408,
        "y": 448.1964339250589,
        "z": 0
      },
      {
        "x": 263.2315932612397,
        "y": 424.7114760838448,
        "z": 0
      }
    ],
    "handle": "267D",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 241.5696673461338,
        "y": 434.8667812123931,
        "z": 0
      },
      {
        "x": 280.891266744468,
        "y": 434.8736441247125,
        "z": 0
      }
    ],
    "handle": "267E",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "ARC",
    "handle": "267F",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "HIDDEN",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 276.6745616762209,
      "y": 455.938051350412,
      "z": 0
    },
    "radius": 8.426057142857143,
    "startAngle": 1.5709708597312715,
    "endAngle": 3.141767186235127,
    "angleLength": 1.5707963265038556
  },
  {
    "type": "ARC",
    "handle": "2680",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "HIDDEN",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 276.6751744363002,
      "y": 452.4271942600616,
      "z": 0
    },
    "radius": 8.426057142857143,
    "startAngle": 3.141767186235127,
    "endAngle": 4.712563513321064,
    "angleLength": 1.570796327085937
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 280.889796120115,
        "y": 443.2997011626139,
        "z": 0
      },
      {
        "x": 249.9942537335448,
        "y": 443.2943088747523,
        "z": 0
      }
    ],
    "handle": "2681",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 278.8295459608779,
        "y": 458.7471132222516,
        "z": 0
      },
      {
        "x": 220.9866789736549,
        "y": 458.7370177377013,
        "z": 0
      }
    ],
    "handle": "2682",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 280.2336436953618,
        "y": 460.15170114021,
        "z": 0
      },
      {
        "x": 222.1702157070399,
        "y": 460.1415671603708,
        "z": 0
      }
    ],
    "handle": "2683",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 330.0302754803569,
        "y": 509.312393086031,
        "z": 0
      },
      {
        "x": 330.0432659958598,
        "y": 434.8822227679119,
        "z": 0
      }
    ],
    "handle": "2684",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 321.6157383569509,
        "y": 443.3068091804122,
        "z": 0
      },
      {
        "x": 321.6055665382297,
        "y": 501.5870368406102,
        "z": 0
      }
    ],
    "handle": "2685",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 249.9913124846629,
        "y": 460.1464228592923,
        "z": 0
      },
      {
        "x": 249.9840819147646,
        "y": 501.5745365349529,
        "z": 0
      }
    ],
    "handle": "2686",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 241.5652554729597,
        "y": 460.1449522338842,
        "z": 0
      },
      {
        "x": 241.5566768306309,
        "y": 509.2969515295696,
        "z": 0
      }
    ],
    "handle": "2687",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 175.5737292848641,
        "y": 459.3745220731943,
        "z": 0
      },
      {
        "x": 175.5649315646139,
        "y": 509.3046906059653,
        "z": 0
      }
    ],
    "handle": "2688",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "TEXT",
    "handle": "2689",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "startPoint": {
      "x": 364.1612167253633,
      "y": 422.9208943685515,
      "z": 0
    },
    "textHeight": 3.949714285714286,
    "text": "BITUM HAVUZUNA ALINACAK",
    "rotation": 0.0100000010572011
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 330.0302754803569,
        "y": 509.312393086031,
        "z": 0
      },
      {
        "x": 386.4078755982348,
        "y": 509.3222328340623,
        "z": 0
      }
    ],
    "handle": "268A",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 376.4679082161161,
        "y": 507.9254801031129,
        "z": 0
      },
      {
        "x": 385.0695080851439,
        "y": 507.9269813653054,
        "z": 0
      }
    ],
    "handle": "268B",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "TEXT",
    "handle": "268C",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "startPoint": {
      "x": 644.9907362126394,
      "y": 596.5688285166204,
      "z": 0
    },
    "textHeight": 3.949714285714286,
    "text": "(230x30x5 mm)",
    "rotation": 0.0100000010572011
  },
  {
    "type": "TEXT",
    "handle": "268D",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "startPoint": {
      "x": 629.7145667190192,
      "y": 587.5299252876827,
      "z": 0
    },
    "textHeight": 3.949714285714286,
    "text": "LAMA TESBIT CIVATA VE SOMUNU",
    "rotation": 0.0100000010572011
  },
  {
    "type": "TEXT",
    "handle": "268E",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "startPoint": {
      "x": 629.7491838358114,
      "y": 573.1582211116217,
      "z": 0
    },
    "textHeight": 3.949714285714286,
    "text": "M6 CIVATA SOMUN",
    "rotation": 0.0100000010572011
  },
  {
    "type": "TEXT",
    "handle": "268F",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "startPoint": {
      "x": 630.1345092263074,
      "y": 615.2984863482197,
      "z": 0
    },
    "textHeight": 3.949714285714286,
    "text": "LAMA TESBIT PARCASI - 2mm SAC",
    "rotation": 0.0100000010572011
  },
  {
    "type": "TEXT",
    "handle": "2690",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "startPoint": {
      "x": 630.0340186365644,
      "y": 602.3144028289132,
      "z": 0
    },
    "textHeight": 3.949714285714286,
    "text": "SICAK DALDIRMA BAKIR LAMA",
    "rotation": 0.0100000010572011
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 441.7052165086495,
        "y": 595.9816776215857,
        "z": 0
      },
      {
        "x": 441.7030562395217,
        "y": 607.8066616207169,
        "z": 0
      }
    ],
    "handle": "2692",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 451.3035926735031,
        "y": 612.740324515831,
        "z": 0
      },
      {
        "x": 451.3062062661616,
        "y": 597.7655423097121,
        "z": 0
      }
    ],
    "handle": "2693",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "DASHDOT",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 452.2663000801688,
        "y": 599.9037470761541,
        "z": 0
      },
      {
        "x": 452.2662362544789,
        "y": 600.269441489112,
        "z": 0
      }
    ],
    "handle": "2694",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 452.6173857891699,
        "y": 599.9038083506503,
        "z": 0
      },
      {
        "x": 452.6173219634798,
        "y": 600.2695027673426,
        "z": 0
      }
    ],
    "handle": "2695",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 444.6891189396848,
        "y": 600.2681190343427,
        "z": 0
      },
      {
        "x": 440.4992454292956,
        "y": 600.2673877635925,
        "z": 0
      }
    ],
    "handle": "2696",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 449.808700117573,
        "y": 599.9033181452943,
        "z": 0
      },
      {
        "x": 449.8086362918262,
        "y": 600.2690125573208,
        "z": 0
      }
    ],
    "handle": "2697",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 450.1597858265726,
        "y": 599.9033794198002,
        "z": 0
      },
      {
        "x": 450.1597220008256,
        "y": 600.2690738355623,
        "z": 0
      }
    ],
    "handle": "2698",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "SOLID",
    "points": [
      {
        "x": 441.7044335274261,
        "y": 600.2675981093005,
        "z": 0
      },
      {
        "x": 442.3160781710751,
        "y": 597.5812042159811,
        "z": 0
      },
      {
        "x": 441.0843523596987,
        "y": 597.5831389930017,
        "z": 0
      },
      {
        "x": 441.0843523596987,
        "y": 597.5831389930017,
        "z": 0
      }
    ],
    "handle": "26A1",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 433.3936345004476,
        "y": 647.0959940049834,
        "z": 0
      },
      {
        "x": 433.3969322170591,
        "y": 628.2014697156837,
        "z": 0
      }
    ],
    "handle": "26A2",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "TOPRAK1",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 452.6159233846708,
        "y": 608.2827681144562,
        "z": 0
      },
      {
        "x": 452.6163278064918,
        "y": 605.9656024118702,
        "z": 0
      }
    ],
    "handle": "26A4",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 454.0202662204976,
        "y": 608.2830132171356,
        "z": 0
      },
      {
        "x": 454.020670642144,
        "y": 605.9658475154828,
        "z": 0
      }
    ],
    "handle": "26A5",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 452.265623494283,
        "y": 603.7802985794694,
        "z": 0
      },
      {
        "x": 452.2655622182061,
        "y": 604.1313842665186,
        "z": 0
      }
    ],
    "handle": "26A6",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 452.616709203402,
        "y": 603.7803598558312,
        "z": 0
      },
      {
        "x": 452.6166479272657,
        "y": 604.1314455419588,
        "z": 0
      }
    ],
    "handle": "26A7",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 452.6164028231881,
        "y": 605.5357884000841,
        "z": 0
      },
      {
        "x": 452.6163278064918,
        "y": 605.9656024118702,
        "z": 0
      }
    ],
    "handle": "26A8",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 454.020670642144,
        "y": 605.9658475154828,
        "z": 0
      },
      {
        "x": 453.1078477990809,
        "y": 605.9656881987864,
        "z": 0
      }
    ],
    "handle": "26A9",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 452.2653171141866,
        "y": 605.535727124643,
        "z": 0
      },
      {
        "x": 452.2652420974911,
        "y": 605.9655411355077,
        "z": 0
      }
    ],
    "handle": "26AA",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 452.2256422041677,
        "y": 611.3475485695308,
        "z": 0
      },
      {
        "x": 452.2260904580456,
        "y": 608.7792429607105,
        "z": 0
      }
    ],
    "handle": "26AC",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 452.5766666370909,
        "y": 611.6986955553158,
        "z": 0
      },
      {
        "x": 452.5771761670468,
        "y": 608.779304238018,
        "z": 0
      }
    ],
    "handle": "26AD",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "ARC",
    "handle": "26AE",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 452.1244033949918,
      "y": 608.282682326604,
      "z": 0
    },
    "radius": 0.4915199999928479,
    "startAngle": 0.00017453264533675135,
    "endAngle": 1.5709708597312715,
    "angleLength": 1.5707963270859346
  },
  {
    "type": "ARC",
    "handle": "26AF",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 453.1074433772602,
      "y": 608.2828539004403,
      "z": 0
    },
    "radius": 0.4915199999995532,
    "startAngle": 1.5709708597312715,
    "endAngle": 3.141767186235127,
    "angleLength": 1.5707963265038556
  },
  {
    "type": "ARC",
    "handle": "26B0",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 453.5287462279668,
      "y": 608.2829274311616,
      "z": 0
    },
    "radius": 0.4915199999928479,
    "startAngle": 0.00017453264533675135,
    "endAngle": 1.5709708597312715,
    "angleLength": 1.5707963270859346
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 453.5286604415738,
        "y": 608.7744474224519,
        "z": 0
      },
      {
        "x": 453.107357590808,
        "y": 608.7743738908102,
        "z": 0
      }
    ],
    "handle": "26B1",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 456.9201763491157,
        "y": 625.3314447402853,
        "z": 0
      },
      {
        "x": 456.9204214532499,
        "y": 623.9271019054402,
        "z": 0
      }
    ],
    "handle": "26B2",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 448.402894880215,
        "y": 608.2820327998922,
        "z": 0
      },
      {
        "x": 448.4032993019797,
        "y": 605.9648671001131,
        "z": 0
      }
    ],
    "handle": "26B5",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 449.8072377132488,
        "y": 608.2822779053637,
        "z": 0
      },
      {
        "x": 449.8076421348957,
        "y": 605.9651122027826,
        "z": 0
      }
    ],
    "handle": "26B6",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 444.6885093558235,
        "y": 603.7607767255829,
        "z": 0
      },
      {
        "x": 440.4986358454336,
        "y": 603.7600454548193,
        "z": 0
      }
    ],
    "handle": "26B7",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 444.688450422253,
        "y": 604.0984413642425,
        "z": 0
      },
      {
        "x": 431.873333926545,
        "y": 604.0962047027213,
        "z": 0
      }
    ],
    "handle": "26B8",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 449.8080235316876,
        "y": 603.7798696467424,
        "z": 0
      },
      {
        "x": 449.8079622558431,
        "y": 604.1309553337996,
        "z": 0
      }
    ],
    "handle": "26B9",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 450.1591092406307,
        "y": 603.7799309231193,
        "z": 0
      },
      {
        "x": 450.159047964669,
        "y": 604.1310166110989,
        "z": 0
      }
    ],
    "handle": "26BA",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 449.807717151707,
        "y": 605.5352981909917,
        "z": 0
      },
      {
        "x": 449.8076421348957,
        "y": 605.9651122027826,
        "z": 0
      }
    ],
    "handle": "26BB",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 450.1588028605898,
        "y": 605.5353594692205,
        "z": 0
      },
      {
        "x": 450.158727843897,
        "y": 605.9651734800834,
        "z": 0
      }
    ],
    "handle": "26BC",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 450.119127950515,
        "y": 611.3471809131842,
        "z": 0
      },
      {
        "x": 450.1195762044508,
        "y": 608.7788753062302,
        "z": 0
      }
    ],
    "handle": "26BD",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 449.7679809655518,
        "y": 611.6982053462232,
        "z": 0
      },
      {
        "x": 449.7684904955097,
        "y": 608.7788140289302,
        "z": 0
      }
    ],
    "handle": "26BE",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "ARC",
    "handle": "26BF",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 448.8944148700688,
      "y": 608.2821185877401,
      "z": 0
    },
    "radius": 0.4915199999995532,
    "startAngle": 1.5709708597312715,
    "endAngle": 3.141767186235127,
    "angleLength": 1.5707963265038556
  },
  {
    "type": "ARC",
    "handle": "26C0",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 449.3157177207761,
      "y": 608.2821921193835,
      "z": 0
    },
    "radius": 0.4915199999928479,
    "startAngle": 0.00017453264533675135,
    "endAngle": 1.5709708597312715,
    "angleLength": 1.5707963270859346
  },
  {
    "type": "ARC",
    "handle": "26C1",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 450.2987577057198,
      "y": 608.2823636904212,
      "z": 0
    },
    "radius": 0.4915199999995532,
    "startAngle": 1.5709708597312715,
    "endAngle": 3.141767186235127,
    "angleLength": 1.5707963265038556
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 446.7397503124669,
        "y": 619.2590345470132,
        "z": 0
      },
      {
        "x": 450.803282629581,
        "y": 619.2597021376532,
        "z": 0
      }
    ],
    "handle": "26C2",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 446.739750311477,
        "y": 619.2590401721936,
        "z": 0
      },
      {
        "x": 441.1703388868477,
        "y": 619.2580208713007,
        "z": 0
      }
    ],
    "handle": "26C3",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 444.6861660378631,
        "y": 625.2641220688627,
        "z": 0
      },
      {
        "x": 431.8694672289997,
        "y": 625.2618851326197,
        "z": 0
      }
    ],
    "handle": "26C4",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "SOLID",
    "points": [
      {
        "x": 446.7295922405319,
        "y": 619.2613039128327,
        "z": 0
      },
      {
        "x": 449.415986109641,
        "y": 619.8729485683042,
        "z": 0
      },
      {
        "x": 449.4140513179007,
        "y": 618.6412227433028,
        "z": 0
      },
      {
        "x": 449.4140513179007,
        "y": 618.6412227433028,
        "z": 0
      }
    ],
    "handle": "26C5",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "SOLID",
    "points": [
      {
        "x": 445.2966664765847,
        "y": 619.2610311638527,
        "z": 0
      },
      {
        "x": 442.6102726074746,
        "y": 618.6493865093033,
        "z": 0
      },
      {
        "x": 442.6122073993308,
        "y": 619.881112335236,
        "z": 0
      },
      {
        "x": 442.6122073993308,
        "y": 619.881112335236,
        "z": 0
      }
    ],
    "handle": "26C6",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "SOLID",
    "points": [
      {
        "x": 441.7037337769285,
        "y": 604.0979204326723,
        "z": 0
      },
      {
        "x": 441.0920891333367,
        "y": 606.7843143250611,
        "z": 0
      },
      {
        "x": 442.323814944539,
        "y": 606.7823795014835,
        "z": 0
      },
      {
        "x": 442.323814944539,
        "y": 606.7823795014835,
        "z": 0
      }
    ],
    "handle": "26C7",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "SOLID",
    "points": [
      {
        "x": 433.277676762431,
        "y": 604.0964498100581,
        "z": 0
      },
      {
        "x": 432.5131209578826,
        "y": 607.4544421555319,
        "z": 0
      },
      {
        "x": 434.0527782198038,
        "y": 607.4520236663337,
        "z": 0
      },
      {
        "x": 434.0527782198038,
        "y": 607.4520236663337,
        "z": 0
      }
    ],
    "handle": "26C8",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "TEXT",
    "handle": "26C9",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "startPoint": {
      "x": 441.4270494353258,
      "y": 620.541977236961,
      "z": 0
    },
    "textHeight": 3.949714285714286,
    "text": "2",
    "rotation": 0.0100000010572011
  },
  {
    "type": "TEXT",
    "handle": "26CA",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "startPoint": {
      "x": 432.6659827800457,
      "y": 613.2934441249638,
      "z": 0
    },
    "textHeight": 3.949714285714286,
    "text": "30",
    "rotation": 90.00999999975443
  },
  {
    "type": "TEXT",
    "handle": "26CB",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "startPoint": {
      "x": 440.7660468827238,
      "y": 601.1039725318396,
      "z": 0
    },
    "textHeight": 3.949714285714286,
    "text": "5",
    "rotation": 90.00999999975443
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 433.277676762431,
        "y": 604.0964498100581,
        "z": 0
      },
      {
        "x": 433.2738100648847,
        "y": 625.2621302362312,
        "z": 0
      }
    ],
    "handle": "26CC",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "SOLID",
    "points": [
      {
        "x": 433.2738100648847,
        "y": 625.2621302362312,
        "z": 0
      },
      {
        "x": 433.8854547112718,
        "y": 622.575736322422,
        "z": 0
      },
      {
        "x": 432.6537289000106,
        "y": 622.5776711450707,
        "z": 0
      },
      {
        "x": 432.6537289000106,
        "y": 622.5776711450707,
        "z": 0
      }
    ],
    "handle": "26CD",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 453.1078477990809,
        "y": 605.9656881987864,
        "z": 0
      },
      {
        "x": 448.4032993019797,
        "y": 605.9648671001131,
        "z": 0
      }
    ],
    "handle": "26CE",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 450.119127950515,
        "y": 611.3471809131842,
        "z": 0
      },
      {
        "x": 452.2256422041677,
        "y": 611.3475485695308,
        "z": 0
      }
    ],
    "handle": "26D1",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 449.7679809655518,
        "y": 611.6982053462232,
        "z": 0
      },
      {
        "x": 452.5766666370909,
        "y": 611.6986955553158,
        "z": 0
      }
    ],
    "handle": "26D2",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 453.107357590808,
        "y": 608.7743738908102,
        "z": 0
      },
      {
        "x": 448.8943290836179,
        "y": 608.7736385799725,
        "z": 0
      }
    ],
    "handle": "26D3",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 452.124317608541,
        "y": 608.7742023179122,
        "z": 0
      },
      {
        "x": 450.2986719193868,
        "y": 608.7738836835958,
        "z": 0
      }
    ],
    "handle": "26D4",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 447.3109815915822,
        "y": 719.4760314198219,
        "z": 0
      },
      {
        "x": 447.3087921761318,
        "y": 732.0079238405413,
        "z": 0
      }
    ],
    "handle": "26D5",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "TEXT",
    "handle": "26D6",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "startPoint": {
      "x": 449.9927909617538,
      "y": 723.8027472291149,
      "z": 0
    },
    "textHeight": 3.949714285714286,
    "text": "15",
    "rotation": 0.0100000010572011
  },
  {
    "type": "TEXT",
    "handle": "26D7",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "startPoint": {
      "x": 438.3840689864002,
      "y": 690.6996249733419,
      "z": 0
    },
    "textHeight": 3.949714285714286,
    "text": "A",
    "rotation": 0.0100000010572011
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 457.0372539287786,
        "y": 694.5707270316818,
        "z": 0
      },
      {
        "x": 457.0329646075838,
        "y": 719.1467266147919,
        "z": 0
      }
    ],
    "handle": "26D8",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "HIDDEN",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 448.6111969113697,
        "y": 694.569256408141,
        "z": 0
      },
      {
        "x": 448.6069075901768,
        "y": 719.1452559903198,
        "z": 0
      }
    ],
    "handle": "26D9",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "HIDDEN",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 447.2068540784521,
        "y": 694.5690113045237,
        "z": 0
      },
      {
        "x": 447.2025647572595,
        "y": 719.1450108848512,
        "z": 0
      }
    ],
    "handle": "26DA",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 454.421832281631,
        "y": 704.7711028093426,
        "z": 0
      },
      {
        "x": 451.4491223511288,
        "y": 707.7427752465007,
        "z": 0
      }
    ],
    "handle": "26DB",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 457.0470980538519,
        "y": 719.4069383935993,
        "z": 0
      },
      {
        "x": 457.0464475014596,
        "y": 723.1343287155023,
        "z": 0
      }
    ],
    "handle": "26DC",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "SOLID",
    "points": [
      {
        "x": 457.0465367884017,
        "y": 722.6227526301507,
        "z": 0
      },
      {
        "x": 453.688544449163,
        "y": 721.8581968489988,
        "z": 0
      },
      {
        "x": 453.6909629408616,
        "y": 723.3978541027672,
        "z": 0
      },
      {
        "x": 453.6909629408616,
        "y": 723.3978541027672,
        "z": 0
      }
    ],
    "handle": "26DD",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "SOLID",
    "points": [
      {
        "x": 447.3104326888568,
        "y": 722.6210117507727,
        "z": 0
      },
      {
        "x": 450.6684250253596,
        "y": 723.385567554268,
        "z": 0
      },
      {
        "x": 450.6660065363397,
        "y": 721.8459102762863,
        "z": 0
      },
      {
        "x": 450.6660065363397,
        "y": 721.8459102762863,
        "z": 0
      }
    ],
    "handle": "26DE",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 439.78160535032,
        "y": 706.1535440776422,
        "z": 0
      },
      {
        "x": 456.6041471057681,
        "y": 706.1564801661325,
        "z": 0
      }
    ],
    "handle": "26DF",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 447.3104326888568,
        "y": 722.6210117507727,
        "z": 0
      },
      {
        "x": 457.0486661550236,
        "y": 722.6227530231589,
        "z": 0
      }
    ],
    "handle": "26E0",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "SOLID",
    "points": [
      {
        "x": 439.7832136212951,
        "y": 696.9388297107022,
        "z": 0
      },
      {
        "x": 438.933707171003,
        "y": 700.6699323058127,
        "z": 0
      },
      {
        "x": 440.6444374651178,
        "y": 700.6672450779007,
        "z": 0
      },
      {
        "x": 440.6444374651178,
        "y": 700.6672450779007,
        "z": 0
      }
    ],
    "handle": "26E1",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 452.8352122075163,
        "y": 701.4781449027386,
        "z": 0
      },
      {
        "x": 452.8336284100658,
        "y": 710.5526355458422,
        "z": 0
      }
    ],
    "handle": "26E2",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "DASHDOT",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "CIRCLE",
    "handle": "26E3",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 452.8343957987957,
      "y": 706.1558222211822,
      "z": 0
    },
    "radius": 2.527817142851009
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 454.2235030721061,
        "y": 704.5722239492524,
        "z": 0
      },
      {
        "x": 451.25031275372,
        "y": 707.5443766368516,
        "z": 0
      }
    ],
    "handle": "26E4",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "CIRCLE",
    "handle": "26E5",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 452.8343957987957,
      "y": 706.1558222211822,
      "z": 0
    },
    "radius": 2.106514285714284
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 439.78160535032,
        "y": 706.1535440776422,
        "z": 0
      },
      {
        "x": 439.7832136212951,
        "y": 696.9388297107022,
        "z": 0
      }
    ],
    "handle": "26E6",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "SOLID",
    "points": [
      {
        "x": 447.3090826404516,
        "y": 731.044328294694,
        "z": 0
      },
      {
        "x": 450.6670749797478,
        "y": 731.8088840981952,
        "z": 0
      },
      {
        "x": 450.66465649067,
        "y": 730.2692268220623,
        "z": 0
      },
      {
        "x": 450.66465649067,
        "y": 730.2692268220623,
        "z": 0
      }
    ],
    "handle": "26E7",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "TEXT",
    "handle": "26E8",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "startPoint": {
      "x": 132.5872139590789,
      "y": 434.8439369704491,
      "z": 0
    },
    "textHeight": 3.949714285714286,
    "text": "TOPRAKLAMA ILETKENI",
    "rotation": 0.0100000010572011
  },
  {
    "type": "TEXT",
    "handle": "26E9",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "startPoint": {
      "x": 152.0197580263479,
      "y": 422.7719906149431,
      "z": 0
    },
    "textHeight": 3.949714285714286,
    "text": "TERMIK KAYNAK",
    "rotation": 0.0100000010572011
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 433.3939411145419,
        "y": 645.3392246803185,
        "z": 0
      },
      {
        "x": 608.4227970313513,
        "y": 645.3697729781197,
        "z": 0
      }
    ],
    "handle": "26EF",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "TOPRAK1",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 433.3955955670666,
        "y": 635.8599105374813,
        "z": 0
      },
      {
        "x": 608.4244514837337,
        "y": 635.8904588375447,
        "z": 0
      }
    ],
    "handle": "26F1",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 447.2068540784521,
        "y": 694.5690113045237,
        "z": 0
      },
      {
        "x": 467.5769690471939,
        "y": 694.5725665595309,
        "z": 0
      }
    ],
    "handle": "26F2",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 447.2025647572595,
        "y": 719.1450108848512,
        "z": 0
      },
      {
        "x": 608.7019908661013,
        "y": 719.1731978533716,
        "z": 0
      }
    ],
    "handle": "26F3",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "TEXT",
    "handle": "26F4",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "startPoint": {
      "x": 444.5269316555931,
      "y": 755.898895620372,
      "z": 0
    },
    "textHeight": 6.740845714285717,
    "text": "TOPRAKLAMA ILETKENI (1x50 NYY)",
    "rotation": 0.0100000010572011
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 447.308941777097,
        "y": 731.0470687402412,
        "z": 0
      },
      {
        "x": 608.6998932680002,
        "y": 731.0753111280416,
        "z": 0
      }
    ],
    "handle": "26F5",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "TEXT",
    "handle": "26F6",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "startPoint": {
      "x": 226.087701546842,
      "y": 975.417914427979,
      "z": 0
    },
    "textHeight": 7.021714285714286,
    "text": "2) Gömülü iletken ana panoda eş potansiyel bara ile irtibatlandırılacaktır.",
    "rotation": 0.0100000010572011
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 87.67497558059401,
        "y": 139.1794463060687,
        "z": 0
      },
      {
        "x": 120.775706255343,
        "y": 106.0902679692926,
        "z": 0
      }
    ],
    "handle": "26FE",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 86.81878780049728,
        "y": 139.5116422129831,
        "z": 0
      },
      {
        "x": 64.28628328291188,
        "y": 116.6951501388103,
        "z": 0
      }
    ],
    "handle": "26FF",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 105.1089173601939,
        "y": 139.18248910084,
        "z": 0
      },
      {
        "x": 120.7726634584827,
        "y": 123.5242097349801,
        "z": 0
      }
    ],
    "handle": "2700",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 96.39194646902617,
        "y": 139.1809677043893,
        "z": 0
      },
      {
        "x": 120.7741848570299,
        "y": 114.807238841422,
        "z": 0
      }
    ],
    "handle": "2701",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 82.7478528863868,
        "y": 135.3893994055615,
        "z": 0
      },
      {
        "x": 121.8136139950937,
        "y": 96.33727245125921,
        "z": 0
      }
    ],
    "handle": "2704",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 122.8513691566188,
        "y": 87.4585006944835,
        "z": 0
      },
      {
        "x": 122.8422830720668,
        "y": 139.5179294981025,
        "z": 0
      }
    ],
    "handle": "2705",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 78.41666604194211,
        "y": 131.0036246310992,
        "z": 0
      },
      {
        "x": 121.7692125479228,
        "y": 87.66620838642118,
        "z": 0
      }
    ],
    "handle": "2706",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "TEXT",
    "handle": "2707",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "startPoint": {
      "x": 226.1064407069359,
      "y": 868.0504370370696,
      "z": 0
    },
    "textHeight": 7.021714285714286,
    "text": "7) Eş potansiyel bara ile gömülü iletken 1 veya 7 yerden irtibatlandırılacaktır.",
    "rotation": 0.0100000010572011
  },
  {
    "type": "TEXT",
    "handle": "2708",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "startPoint": {
      "x": 226.1092672071538,
      "y": 851.8557840261378,
      "z": 0
    },
    "textHeight": 7.021714285714286,
    "text": "8) Çubuklar dik olarak yerleştirilecek, gömülü iletken ile birleştirilecektir.",
    "rotation": 0.0100000010572011
  },
  {
    "type": "TEXT",
    "handle": "2709",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "startPoint": {
      "x": 324.6765098598543,
      "y": 44.12392543163149,
      "z": 0
    },
    "textHeight": 7.021714285714286,
    "text": "Demir donatısı bulunan temel",
    "rotation": 0.0100000010572011
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 105.7568767215708,
        "y": 79.09629701450373,
        "z": 0
      },
      {
        "x": 105.7579143278999,
        "y": 73.15125067718327,
        "z": 0
      }
    ],
    "handle": "270A",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 121.8134976417058,
        "y": 97.00392721686148,
        "z": 0
      },
      {
        "x": 121.8188821540101,
        "y": 66.15294507610177,
        "z": 0
      }
    ],
    "handle": "270B",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "TEXT",
    "handle": "270C",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "startPoint": {
      "x": 226.1002768606429,
      "y": 903.3666752047567,
      "z": 0
    },
    "textHeight": 7.021714285714286,
    "text": "5) Gömülü iletken ise en az 4 yerden bina temel demiri ile irtibatlandırılmalıdır.",
    "rotation": 0.0100000010572011
  },
  {
    "type": "TEXT",
    "handle": "270D",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "startPoint": {
      "x": 226.1035740545489,
      "y": 884.4751454258059,
      "z": 0
    },
    "textHeight": 7.021714285714286,
    "text": "6) Gömülü iletken yüzeyden 0.5 - 1 m derinlikte gömülü olmalıdır.",
    "rotation": 0.0100000010572011
  },
  {
    "type": "TEXT",
    "handle": "270E",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "startPoint": {
      "x": 151.5921415204659,
      "y": 63.43947803508489,
      "z": 0
    },
    "textHeight": 7.021714285714286,
    "text": "Temel Topraklayıcı",
    "rotation": 0.0100000010572011
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 121.8188821540101,
        "y": 66.15294507610177,
        "z": 0
      },
      {
        "x": 150.8774513710518,
        "y": 66.15801675339388,
        "z": 0
      }
    ],
    "handle": "270F",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "TEXT",
    "handle": "2710",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "startPoint": {
      "x": 83.90953459037667,
      "y": 68.0909919356918,
      "z": 0
    },
    "textHeight": 6.471211885714285,
    "text": "5 cm",
    "rotation": 0.0100000010572011
  },
  {
    "type": "ARC",
    "handle": "2711",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "center": {
      "x": 69.91518460441112,
      "y": 66.70298495329189,
      "z": 0
    },
    "radius": 6.09212143853736,
    "startAngle": 0.7222598212327201,
    "endAngle": 2.540658526143184,
    "angleLength": 1.818398704910464
  },
  {
    "type": "ARC",
    "handle": "2712",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "center": {
      "x": 77.58089368330502,
      "y": 74.9141381979034,
      "z": 0
    },
    "radius": 5.203947854108031,
    "startAngle": 4.075515903617749,
    "endAngle": 5.6189153367526545,
    "angleLength": 1.5433994331349057
  },
  {
    "type": "TEXT",
    "handle": "2713",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "startPoint": {
      "x": 90.26960654696406,
      "y": 45.44257205630856,
      "z": 0
    },
    "textHeight": 7.021714285714286,
    "text": "Demir donatısı bulunmayan temel",
    "rotation": 0.0100000010572011
  },
  {
    "type": "TEXT",
    "handle": "2714",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "startPoint": {
      "x": 226.0908150732279,
      "y": 957.5787224892289,
      "z": 0
    },
    "textHeight": 7.021714285714286,
    "text": "3) Özel binalarda (villa, tripleks, işyerleri) kaçak akımı 30mA geçen yerlerde,",
    "rotation": 0.0100000010572011
  },
  {
    "type": "TEXT",
    "handle": "2715",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "startPoint": {
      "x": 226.0970515768278,
      "y": 921.8461894990673,
      "z": 0
    },
    "textHeight": 7.021714285714286,
    "text": "4) Temel demirleri 2 - 3 metre yükseklikte birbirleri ile irtibatlandırılmalıdır.",
    "rotation": 0.0100000010572011
  },
  {
    "type": "CIRCLE",
    "handle": "2716",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "center": {
      "x": 277.3385751268358,
      "y": 116.6337798209824,
      "z": 0
    },
    "radius": 4.909838529633177
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 135.800435840443,
        "y": 111.2873772783205,
        "z": 0
      },
      {
        "x": 141.0622318355599,
        "y": 112.7798345852607,
        "z": 0
      }
    ],
    "handle": "2717",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 135.800435840443,
        "y": 111.2873772783205,
        "z": 0
      },
      {
        "x": 141.0627524808509,
        "y": 109.7967567741798,
        "z": 0
      }
    ],
    "handle": "2718",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "ARC",
    "handle": "271A",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "center": {
      "x": 153.490088154912,
      "y": 107.1687966063618,
      "z": 0
    },
    "radius": 5.203947854108031,
    "startAngle": 4.075515903617749,
    "endAngle": 5.6189153367526545,
    "angleLength": 1.5433994331349057
  },
  {
    "type": "ARC",
    "handle": "271B",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "center": {
      "x": 145.8243790732218,
      "y": 98.95764333940045,
      "z": 0
    },
    "radius": 6.09212143853736,
    "startAngle": 0.7222598212327201,
    "endAngle": 2.540658526143184,
    "angleLength": 1.818398704910464
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 141.0624921582631,
        "y": 111.2882956787898,
        "z": 0
      },
      {
        "x": 152.9525848343027,
        "y": 111.2903708927406,
        "z": 0
      }
    ],
    "handle": "271C",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 141.0627524808509,
        "y": 109.7967567741798,
        "z": 0
      },
      {
        "x": 141.0622318355599,
        "y": 112.7798345852607,
        "z": 0
      }
    ],
    "handle": "271D",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "TEXT",
    "handle": "271E",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "startPoint": {
      "x": 159.8187290591299,
      "y": 100.3456502770996,
      "z": 0
    },
    "textHeight": 6.471211885714285,
    "text": "5 cm",
    "rotation": 0.0100000010572011
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 108.5830656614847,
        "y": 126.9941033050418,
        "z": 0
      },
      {
        "x": 7.685005591250785,
        "y": 126.9764932710595,
        "z": 0
      }
    ],
    "handle": "2721",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "TEXT",
    "handle": "2722",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "startPoint": {
      "x": 7.798230563231867,
      "y": 104.1990331560291,
      "z": 0
    },
    "textHeight": 7.021714285714286,
    "text": "Drenaj",
    "rotation": 0.0100000010572011
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 49.11859722150289,
        "y": 101.6468966221437,
        "z": 0
      },
      {
        "x": 7.539873055646921,
        "y": 101.6396397650196,
        "z": 0
      }
    ],
    "handle": "2723",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "CIRCLE",
    "handle": "2724",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "center": {
      "x": 49.11859722150289,
      "y": 101.6468966221437,
      "z": 0
    },
    "radius": 4.909838529633177
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 105.6720256386328,
        "y": 103.8873630743428,
        "z": 0
      },
      {
        "x": 105.6709880322439,
        "y": 109.8324094349518,
        "z": 0
      }
    ],
    "handle": "2726",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 107.1635645334029,
        "y": 103.8876233967021,
        "z": 0
      },
      {
        "x": 104.1804867411269,
        "y": 103.8871027501336,
        "z": 0
      }
    ],
    "handle": "2727",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 105.672944040735,
        "y": 98.62530676927143,
        "z": 0
      },
      {
        "x": 104.1804867411269,
        "y": 103.8871027501336,
        "z": 0
      }
    ],
    "handle": "2729",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 125.4825105769548,
        "y": 97.0045675830925,
        "z": 0
      },
      {
        "x": 100.3907515059687,
        "y": 97.00018824264409,
        "z": 0
      }
    ],
    "handle": "272A",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 128.8805256447508,
        "y": 84.09394942410289,
        "z": 0
      },
      {
        "x": 144.2921739005238,
        "y": 84.09663926437133,
        "z": 0
      }
    ],
    "handle": "272B",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "TEXT",
    "handle": "272C",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "startPoint": {
      "x": 148.1904429696139,
      "y": 82.328014324411,
      "z": 0
    },
    "textHeight": 7.021714285714286,
    "text": "Tespit elemanı",
    "rotation": 0.0100000010572011
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 104.2653378240637,
        "y": 79.09603669214631,
        "z": 0
      },
      {
        "x": 107.2484156162248,
        "y": 79.0965573359199,
        "z": 0
      }
    ],
    "handle": "272D",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 105.7559583194078,
        "y": 84.35835334099102,
        "z": 0
      },
      {
        "x": 107.2484156162248,
        "y": 79.0965573359199,
        "z": 0
      }
    ],
    "handle": "272F",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 64.29135153995503,
        "y": 87.65617660712178,
        "z": 0
      },
      {
        "x": 122.8513328718829,
        "y": 87.66639725212005,
        "z": 0
      }
    ],
    "handle": "2730",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 65.42310551158198,
        "y": 117.8463002638918,
        "z": 0
      },
      {
        "x": 95.95070317294405,
        "y": 87.32935688924408,
        "z": 0
      }
    ],
    "handle": "2732",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 64.28628328291188,
        "y": 116.6951501388103,
        "z": 0
      },
      {
        "x": 64.29135153995503,
        "y": 87.65617660712178,
        "z": 0
      }
    ],
    "handle": "2733",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 64.28892675280781,
        "y": 101.5491831591325,
        "z": 0
      },
      {
        "x": 78.184358102852,
        "y": 87.65860139485174,
        "z": 0
      }
    ],
    "handle": "2734",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 64.28740535432007,
        "y": 110.2661540526824,
        "z": 0
      },
      {
        "x": 87.23373228171793,
        "y": 87.32783548999215,
        "z": 0
      }
    ],
    "handle": "2735",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 69.75429235608294,
        "y": 122.2320750616427,
        "z": 0
      },
      {
        "x": 104.6676740612599,
        "y": 87.33087828755015,
        "z": 0
      }
    ],
    "handle": "2736",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 74.08547920035198,
        "y": 126.6178498351919,
        "z": 0
      },
      {
        "x": 113.384644949808,
        "y": 87.33239968585897,
        "z": 0
      }
    ],
    "handle": "2737",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 64.29044815129589,
        "y": 92.8322122646468,
        "z": 0
      },
      {
        "x": 69.4673872116249,
        "y": 87.65707999468212,
        "z": 0
      }
    ],
    "handle": "2738",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 334.0997267779297,
        "y": 101.8323022462427,
        "z": 0
      },
      {
        "x": 334.105491253256,
        "y": 68.80429190024006,
        "z": 0
      }
    ],
    "handle": "2739",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 334.105491253256,
        "y": 68.80429190024006,
        "z": 0
      },
      {
        "x": 363.1640604702983,
        "y": 68.80936357751123,
        "z": 0
      }
    ],
    "handle": "273A",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "TEXT",
    "handle": "273B",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "startPoint": {
      "x": 364.6157617915898,
      "y": 66.09095351304404,
      "z": 0
    },
    "textHeight": 7.021714285714286,
    "text": "Temel Topraklayıcı",
    "rotation": 0.0100000010572011
  },
  {
    "type": "TEXT",
    "handle": "2741",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "startPoint": {
      "x": 359.8353767499798,
      "y": 115.420682922002,
      "z": 0
    },
    "textHeight": 6.471211885714285,
    "text": "Temel",
    "rotation": 0.0100000010572011
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 506.1003995537173,
        "y": 213.2100882995792,
        "z": 0
      },
      {
        "x": 506.1196775353733,
        "y": 102.7553908070513,
        "z": 0
      }
    ],
    "handle": "2742",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 510.2195367454544,
        "y": 213.2108072238007,
        "z": 0
      },
      {
        "x": 510.2388147271133,
        "y": 102.7561097322032,
        "z": 0
      }
    ],
    "handle": "2743",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "TEXT",
    "handle": "2744",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "startPoint": {
      "x": 359.0171137934091,
      "y": 230.4488695152031,
      "z": 0
    },
    "textHeight": 7.021714285714286,
    "text": "Bodrum dış",
    "rotation": 0.0100000010572011
  },
  {
    "type": "TEXT",
    "handle": "2745",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "startPoint": {
      "x": 146.7302566802826,
      "y": 229.2185211749711,
      "z": 0
    },
    "textHeight": 7.021714285714286,
    "text": "Bodrum dış",
    "rotation": 0.0100000010572011
  },
  {
    "type": "TEXT",
    "handle": "2746",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "startPoint": {
      "x": 5.963821734067946,
      "y": 228.869012278501,
      "z": 0
    },
    "textHeight": 7.021714285714286,
    "text": "Toprak",
    "rotation": 0.0100000010572011
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 77.80026448157105,
        "y": 249.9647690402344,
        "z": 0
      },
      {
        "x": 77.81954246328702,
        "y": 139.510071547701,
        "z": 0
      }
    ],
    "handle": "2747",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 81.91940167325104,
        "y": 249.9654879644586,
        "z": 0
      },
      {
        "x": 81.93867965496702,
        "y": 139.5107904719116,
        "z": 0
      }
    ],
    "handle": "2748",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 74.7948743832518,
        "y": 143.1413408201197,
        "z": 0
      },
      {
        "x": 75.10313528717893,
        "y": 249.9642983013691,
        "z": 0
      }
    ],
    "handle": "2749",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 290.086873583612,
        "y": 252.6161158867117,
        "z": 0
      },
      {
        "x": 290.1061515652099,
        "y": 142.161418370898,
        "z": 0
      }
    ],
    "handle": "274A",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 294.2060107725549,
        "y": 252.6168348109359,
        "z": 0
      },
      {
        "x": 294.225288754213,
        "y": 142.1621372979098,
        "z": 0
      }
    ],
    "handle": "274B",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 58.10398951120372,
        "y": 248.0012833252522,
        "z": 0
      },
      {
        "x": 47.33438518771378,
        "y": 141.8298493344337,
        "z": 0
      }
    ],
    "handle": "274C",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "TEXT",
    "handle": "274D",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "startPoint": {
      "x": 257.8650379499897,
      "y": 1036.803183729919,
      "z": 0
    },
    "textHeight": 7.021714285714286,
    "text": "TEMEL TOPRAKLAMASI TESİSATI İLE İLGİLİ AÇIKLAMA",
    "rotation": 0.0100000010572011
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 123.8540856242178,
        "y": 179.1452973866799,
        "z": 0
      },
      {
        "x": 129.115881619276,
        "y": 180.6377546964213,
        "z": 0
      }
    ],
    "handle": "274F",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 129.1164022644509,
        "y": 177.6546769058304,
        "z": 0
      },
      {
        "x": 129.115881619276,
        "y": 180.6377546964213,
        "z": 0
      }
    ],
    "handle": "2750",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "TEXT",
    "handle": "2751",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "startPoint": {
      "x": 142.5242342207337,
      "y": 176.7765692332723,
      "z": 0
    },
    "textHeight": 7.021714285714286,
    "text": "Bağlantı Filizi",
    "rotation": 0.0100000010572011
  },
  {
    "type": "TEXT",
    "handle": "2752",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "startPoint": {
      "x": 226.084484658089,
      "y": 993.8493291914261,
      "z": 0
    },
    "textHeight": 7.021714285714286,
    "text": "1) Gömülü iletken ve çubuklar inşaat başlamadan önce inşaat temeline yerleştirilecektir.",
    "rotation": 0.0100000010572011
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 123.8540856242178,
        "y": 179.1452973866799,
        "z": 0
      },
      {
        "x": 129.1164022644509,
        "y": 177.6546769058304,
        "z": 0
      }
    ],
    "handle": "2753",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 129.116141941806,
        "y": 179.1462157880814,
        "z": 0
      },
      {
        "x": 141.0062346206967,
        "y": 179.1482910029517,
        "z": 0
      }
    ],
    "handle": "2754",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 287.4045426128432,
        "y": 167.8280544532417,
        "z": 0
      },
      {
        "x": 297.5903477255489,
        "y": 167.8298322120599,
        "z": 0
      }
    ],
    "handle": "2755",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 287.4031856317298,
        "y": 175.6029835101171,
        "z": 0
      },
      {
        "x": 297.5889907443208,
        "y": 175.6047612670809,
        "z": 0
      }
    ],
    "handle": "2756",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 287.4038641222298,
        "y": 171.7155189933219,
        "z": 0
      },
      {
        "x": 297.5896692349331,
        "y": 171.7172967502838,
        "z": 0
      }
    ],
    "handle": "2757",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 287.4025071412329,
        "y": 179.4904480483419,
        "z": 0
      },
      {
        "x": 297.5883122537638,
        "y": 179.4922258071592,
        "z": 0
      }
    ],
    "handle": "2758",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 163.9275542547118,
        "y": 138.0525614581929,
        "z": 0
      },
      {
        "x": 163.9241123308897,
        "y": 157.7733320062916,
        "z": 0
      }
    ],
    "handle": "2759",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "TEXT",
    "handle": "275A",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "startPoint": {
      "x": 166.879749604268,
      "y": 151.3597283456401,
      "z": 0
    },
    "textHeight": 7.021714285714286,
    "text": "Zemin Betonu",
    "rotation": 0.0100000010572011
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 287.4058995938987,
        "y": 160.0531254429297,
        "z": 0
      },
      {
        "x": 297.5917047066029,
        "y": 160.0549031998925,
        "z": 0
      }
    ],
    "handle": "275B",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 287.4086135561817,
        "y": 144.5032673524729,
        "z": 0
      },
      {
        "x": 297.5944186688279,
        "y": 144.505045111291,
        "z": 0
      }
    ],
    "handle": "275C",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 287.4079350655671,
        "y": 148.3907318701931,
        "z": 0
      },
      {
        "x": 297.5937401782721,
        "y": 148.3925096280836,
        "z": 0
      }
    ],
    "handle": "275D",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 287.406578084454,
        "y": 156.1656609037854,
        "z": 0
      },
      {
        "x": 297.5923831971011,
        "y": 156.1674386616796,
        "z": 0
      }
    ],
    "handle": "275E",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 287.4072565750689,
        "y": 152.278196407482,
        "z": 0
      },
      {
        "x": 297.5930616877152,
        "y": 152.2799741681592,
        "z": 0
      }
    ],
    "handle": "275F",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 287.4052211033998,
        "y": 163.9405899587981,
        "z": 0
      },
      {
        "x": 297.5910262160469,
        "y": 163.9423677157527,
        "z": 0
      }
    ],
    "handle": "2760",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 75.11793351353901,
        "y": 165.1767076291107,
        "z": 0
      },
      {
        "x": 85.30373862630222,
        "y": 165.1784853879317,
        "z": 0
      }
    ],
    "handle": "2761",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 75.11657653236693,
        "y": 172.9516366627022,
        "z": 0
      },
      {
        "x": 85.30238164507205,
        "y": 172.9534144196595,
        "z": 0
      }
    ],
    "handle": "2762",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 75.11725502292416,
        "y": 169.0641721682623,
        "z": 0
      },
      {
        "x": 85.30306013568666,
        "y": 169.0659499261537,
        "z": 0
      }
    ],
    "handle": "2763",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 75.11589804186985,
        "y": 176.8391011776339,
        "z": 0
      },
      {
        "x": 85.30170315451598,
        "y": 176.8408789364621,
        "z": 0
      }
    ],
    "handle": "2764",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 120.7698720907799,
        "y": 139.51756779477,
        "z": 0
      },
      {
        "x": 86.81878780049728,
        "y": 139.5116422129831,
        "z": 0
      }
    ],
    "handle": "2765",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 75.11929049459195,
        "y": 157.4017785750402,
        "z": 0
      },
      {
        "x": 85.30509560741505,
        "y": 157.4035563319921,
        "z": 0
      }
    ],
    "handle": "2766",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 75.12200445687573,
        "y": 141.8519205283301,
        "z": 0
      },
      {
        "x": 85.30780956963893,
        "y": 141.8536982871483,
        "z": 0
      }
    ],
    "handle": "2768",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 75.12132596637909,
        "y": 145.7393850237131,
        "z": 0
      },
      {
        "x": 85.3071310790259,
        "y": 145.7411627806677,
        "z": 0
      }
    ],
    "handle": "2769",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 75.11996898520806,
        "y": 153.5143140777936,
        "z": 0
      },
      {
        "x": 85.30577409791319,
        "y": 153.516091835696,
        "z": 0
      }
    ],
    "handle": "276A",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 75.12064747570616,
        "y": 149.6268495628601,
        "z": 0
      },
      {
        "x": 85.30645258852812,
        "y": 149.6286273216792,
        "z": 0
      }
    ],
    "handle": "276B",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 57.47029018279909,
        "y": 132.6846994282641,
        "z": 0
      },
      {
        "x": 63.68164364842098,
        "y": 132.685783513818,
        "z": 0
      }
    ],
    "handle": "276C",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 63.68164364842098,
        "y": 132.685783513818,
        "z": 0
      },
      {
        "x": 74.7948743832518,
        "y": 143.1413408201197,
        "z": 0
      }
    ],
    "handle": "276E",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "TEXT",
    "handle": "276F",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "startPoint": {
      "x": 6.921417761245037,
      "y": 130.2893865928054,
      "z": 0
    },
    "textHeight": 7.021714285714286,
    "text": "Temel",
    "rotation": 0.0100000010572011
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 47.33438518771378,
        "y": 141.8298493344337,
        "z": 0
      },
      {
        "x": 57.47029018279909,
        "y": 132.6846994282641,
        "z": 0
      }
    ],
    "handle": "2770",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 75.11861200409498,
        "y": 161.2892431123109,
        "z": 0
      },
      {
        "x": 85.30441711679896,
        "y": 161.2910208702124,
        "z": 0
      }
    ],
    "handle": "2771",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 113.8258882486259,
        "y": 139.1840105000838,
        "z": 0
      },
      {
        "x": 121.8075284011996,
        "y": 131.2051559826322,
        "z": 0
      }
    ],
    "handle": "2772",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 134.9428992333706,
        "y": 210.1992580667102,
        "z": 0
      },
      {
        "x": 132.8704882492299,
        "y": 210.1988963633703,
        "z": 0
      }
    ],
    "handle": "2773",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "TEXT",
    "handle": "2774",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "startPoint": {
      "x": 146.7322039998258,
      "y": 218.0612024590328,
      "z": 0
    },
    "textHeight": 7.021714285714286,
    "text": "duvarı",
    "rotation": 0.0100000010572011
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 134.9428992333706,
        "y": 210.1992580667102,
        "z": 0
      },
      {
        "x": 122.831674590765,
        "y": 200.3000498898373,
        "z": 0
      }
    ],
    "handle": "2775",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 287.3950437449969,
        "y": 222.252557754513,
        "z": 0
      },
      {
        "x": 297.58084885776,
        "y": 222.2543355133302,
        "z": 0
      }
    ],
    "handle": "2776",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 287.3957222355528,
        "y": 218.3650932358496,
        "z": 0
      },
      {
        "x": 297.5815273482,
        "y": 218.3668709946833,
        "z": 0
      }
    ],
    "handle": "2777",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 287.3964007261678,
        "y": 214.4776286995038,
        "z": 0
      },
      {
        "x": 297.5822058388147,
        "y": 214.4794064564576,
        "z": 0
      }
    ],
    "handle": "2778",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 287.3970792166077,
        "y": 210.5901642031931,
        "z": 0
      },
      {
        "x": 297.5828843293708,
        "y": 210.591941962939,
        "z": 0
      }
    ],
    "handle": "2779",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 287.3943652543819,
        "y": 226.1400222480334,
        "z": 0
      },
      {
        "x": 297.580170367029,
        "y": 226.1418000068507,
        "z": 0
      }
    ],
    "handle": "277A",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 287.393686763825,
        "y": 230.0274867881135,
        "z": 0
      },
      {
        "x": 297.5794918765317,
        "y": 230.02926454506,
        "z": 0
      }
    ],
    "handle": "277B",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 287.3977577071638,
        "y": 206.7026996426166,
        "z": 0
      },
      {
        "x": 297.5835628200439,
        "y": 206.7044774005044,
        "z": 0
      }
    ],
    "handle": "277C",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 287.3984361977201,
        "y": 202.8152351491108,
        "z": 0
      },
      {
        "x": 297.5842413104838,
        "y": 202.8170129060699,
        "z": 0
      }
    ],
    "handle": "277D",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 287.3991146883919,
        "y": 198.9277706528046,
        "z": 0
      },
      {
        "x": 297.5849198009809,
        "y": 198.9295484116236,
        "z": 0
      }
    ],
    "handle": "277E",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 287.4018286505018,
        "y": 183.3779125427826,
        "z": 0
      },
      {
        "x": 297.587633763265,
        "y": 183.3796903006696,
        "z": 0
      }
    ],
    "handle": "277F",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 287.4011501600038,
        "y": 187.2653770577135,
        "z": 0
      },
      {
        "x": 297.586955272709,
        "y": 187.267154817462,
        "z": 0
      }
    ],
    "handle": "2780",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 287.3997931788906,
        "y": 195.0403060922445,
        "z": 0
      },
      {
        "x": 297.5855982915378,
        "y": 195.0420838501195,
        "z": 0
      }
    ],
    "handle": "2781",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 287.4004716695048,
        "y": 191.1528415987231,
        "z": 0
      },
      {
        "x": 297.586276782095,
        "y": 191.154619355686,
        "z": 0
      }
    ],
    "handle": "2782",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "TEXT",
    "handle": "2783",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "startPoint": {
      "x": 142.5223794713969,
      "y": 187.403500052158,
      "z": 0
    },
    "textHeight": 7.021714285714286,
    "text": "En az 150cm'lik",
    "rotation": 0.0100000010572011
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 75.10979162680495,
        "y": 211.8262818744442,
        "z": 0
      },
      {
        "x": 85.29559673950894,
        "y": 211.8280596332625,
        "z": 0
      }
    ],
    "handle": "2784",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 75.11047011741789,
        "y": 207.9388173557827,
        "z": 0
      },
      {
        "x": 85.29627523006594,
        "y": 207.9405951164626,
        "z": 0
      }
    ],
    "handle": "2785",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 75.10843464569211,
        "y": 219.6012109071016,
        "z": 0
      },
      {
        "x": 85.29423975851319,
        "y": 219.6029886649921,
        "z": 0
      }
    ],
    "handle": "2786",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 75.10911313619022,
        "y": 215.7137463679501,
        "z": 0
      },
      {
        "x": 85.29491824895273,
        "y": 215.7155241258415,
        "z": 0
      }
    ],
    "handle": "2787",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 75.1077561550768,
        "y": 223.4886754248209,
        "z": 0
      },
      {
        "x": 85.29356126778168,
        "y": 223.4904531827205,
        "z": 0
      }
    ],
    "handle": "2788",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 75.10707766452195,
        "y": 227.3761399621107,
        "z": 0
      },
      {
        "x": 85.29288277728506,
        "y": 227.3779177209326,
        "z": 0
      }
    ],
    "handle": "2789",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 75.11114860785915,
        "y": 204.0513528194196,
        "z": 0
      },
      {
        "x": 85.29695372073772,
        "y": 204.0531305763834,
        "z": 0
      }
    ],
    "handle": "278A",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 75.11182709841466,
        "y": 200.1638883017003,
        "z": 0
      },
      {
        "x": 85.29763221117867,
        "y": 200.1656660595918,
        "z": 0
      }
    ],
    "handle": "278B",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 75.1125055890287,
        "y": 196.2764237616202,
        "z": 0
      },
      {
        "x": 85.29831070173395,
        "y": 196.2782015204393,
        "z": 0
      }
    ],
    "handle": "278C",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "TEXT",
    "handle": "278D",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "startPoint": {
      "x": 5.469978040665806,
      "y": 202.869693859483,
      "z": 0
    },
    "textHeight": 7.021714285714286,
    "text": "Yalıtım",
    "rotation": 0.0100000010572011
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 60.38147059740675,
        "y": 225.9995941463822,
        "z": 0
      },
      {
        "x": 7.547886005834811,
        "y": 225.9903729464859,
        "z": 0
      }
    ],
    "handle": "278E",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 77.80895629280599,
        "y": 200.1643590405556,
        "z": 0
      },
      {
        "x": 8.44546951726005,
        "y": 200.1522528259011,
        "z": 0
      }
    ],
    "handle": "278F",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 75.11521955125386,
        "y": 180.7265657195811,
        "z": 0
      },
      {
        "x": 85.30102466407695,
        "y": 180.72834347561,
        "z": 0
      }
    ],
    "handle": "2790",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 75.11454106064116,
        "y": 184.6140302121603,
        "z": 0
      },
      {
        "x": 85.30034617346303,
        "y": 184.6158079700508,
        "z": 0
      }
    ],
    "handle": "2791",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 75.1131840796428,
        "y": 192.3889592681007,
        "z": 0
      },
      {
        "x": 85.29898919235006,
        "y": 192.3907370260021,
        "z": 0
      }
    ],
    "handle": "2792",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 75.11386257008314,
        "y": 188.501494752243,
        "z": 0
      },
      {
        "x": 85.29966768284669,
        "y": 188.5032725101336,
        "z": 0
      }
    ],
    "handle": "2793",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 161.6239189467151,
        "y": 225.1158302109734,
        "z": 0
      },
      {
        "x": 120.7549336205121,
        "y": 225.10869722813,
        "z": 0
      }
    ],
    "handle": "2794",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 132.8704882492299,
        "y": 210.1988963633703,
        "z": 0
      },
      {
        "x": 120.7592636094187,
        "y": 200.2996881864892,
        "z": 0
      }
    ],
    "handle": "2795",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 341.4030113666097,
        "y": 180.3060237299622,
        "z": 0
      },
      {
        "x": 341.4024907212577,
        "y": 183.2891015410423,
        "z": 0
      }
    ],
    "handle": "2797",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 336.1406947261418,
        "y": 181.7966442340903,
        "z": 0
      },
      {
        "x": 341.4024907212577,
        "y": 183.2891015410423,
        "z": 0
      }
    ],
    "handle": "2799",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "TEXT",
    "handle": "279A",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "startPoint": {
      "x": 354.8108433200399,
      "y": 179.427916078821,
      "z": 0
    },
    "textHeight": 7.021714285714286,
    "text": "Bağlantı Filizi",
    "rotation": 0.0100000010572011
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 341.4027510439049,
        "y": 181.7975626355037,
        "z": 0
      },
      {
        "x": 353.2928437199432,
        "y": 181.799637847568,
        "z": 0
      }
    ],
    "handle": "279B",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 336.1406947261418,
        "y": 181.7966442340903,
        "z": 0
      },
      {
        "x": 341.4030113666097,
        "y": 180.3060237299622,
        "z": 0
      }
    ],
    "handle": "279C",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "TEXT",
    "handle": "279D",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "startPoint": {
      "x": 361.2789774287969,
      "y": 151.5593494232744,
      "z": 0
    },
    "textHeight": 7.021714285714286,
    "text": "Zemin Betonu",
    "rotation": 0.0100000010572011
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 347.229508335353,
        "y": 212.8506048899226,
        "z": 0
      },
      {
        "x": 335.1182836900118,
        "y": 202.9513967363091,
        "z": 0
      }
    ],
    "handle": "279E",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 345.1570973513879,
        "y": 212.8502431884453,
        "z": 0
      },
      {
        "x": 333.045872708666,
        "y": 202.9510350329829,
        "z": 0
      }
    ],
    "handle": "279F",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 404.7970939623197,
        "y": 227.7725677806839,
        "z": 0
      },
      {
        "x": 333.0415427198169,
        "y": 227.760044074611,
        "z": 0
      }
    ],
    "handle": "27A1",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 347.229508335353,
        "y": 212.8506048899226,
        "z": 0
      },
      {
        "x": 345.1570973513879,
        "y": 212.8502431884453,
        "z": 0
      }
    ],
    "handle": "27A2",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "TEXT",
    "handle": "27A3",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "startPoint": {
      "x": 359.0190611127769,
      "y": 219.2915508020633,
      "z": 0
    },
    "textHeight": 7.021714285714286,
    "text": "duvarı",
    "rotation": 0.0100000010572011
  },
  {
    "type": "TEXT",
    "handle": "27A4",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "startPoint": {
      "x": 146.6292984811579,
      "y": 253.372209724962,
      "z": 0
    },
    "textHeight": 12.94242377142857,
    "text": "KESIT  A-A'",
    "rotation": 0.0100000010572011
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 287.3916512920409,
        "y": 241.6898803357026,
        "z": 0
      },
      {
        "x": 297.5774564049209,
        "y": 241.6916580963843,
        "z": 0
      }
    ],
    "handle": "27A5",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 287.3902943110429,
        "y": 249.4648093925616,
        "z": 0
      },
      {
        "x": 297.5760994236917,
        "y": 249.4665871513935,
        "z": 0
      }
    ],
    "handle": "27A6",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 287.3909728016007,
        "y": 245.5773448543623,
        "z": 0
      },
      {
        "x": 297.5767779142479,
        "y": 245.5791226131841,
        "z": 0
      }
    ],
    "handle": "27A7",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 75.10504219285303,
        "y": 239.0385335115688,
        "z": 0
      },
      {
        "x": 85.29084730567317,
        "y": 239.0403112713211,
        "z": 0
      }
    ],
    "handle": "27A8",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 75.10436370229604,
        "y": 242.9259980069428,
        "z": 0
      },
      {
        "x": 85.29016881500206,
        "y": 242.9277757666896,
        "z": 0
      }
    ],
    "handle": "27A9",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 75.10368521179794,
        "y": 246.8134625470229,
        "z": 0
      },
      {
        "x": 85.28949032444382,
        "y": 246.8152403039894,
        "z": 0
      }
    ],
    "handle": "27AA",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 75.10313528717893,
        "y": 249.9642983013691,
        "z": 0
      },
      {
        "x": 58.10398951120372,
        "y": 248.0012833252522,
        "z": 0
      }
    ],
    "handle": "27AB",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 287.3923297827121,
        "y": 237.8024158431208,
        "z": 0
      },
      {
        "x": 297.578134895476,
        "y": 237.8041936000836,
        "z": 0
      }
    ],
    "handle": "27AC",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 287.3930082732698,
        "y": 233.9149513030425,
        "z": 0
      },
      {
        "x": 297.5788133859758,
        "y": 233.9167290627956,
        "z": 0
      }
    ],
    "handle": "27AD",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 75.10639917408093,
        "y": 231.2636044556202,
        "z": 0
      },
      {
        "x": 85.29220428667088,
        "y": 231.2653822163011,
        "z": 0
      }
    ],
    "handle": "27AE",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 75.10572068346721,
        "y": 235.1510689742818,
        "z": 0
      },
      {
        "x": 85.29152579611423,
        "y": 235.1528467321705,
        "z": 0
      }
    ],
    "handle": "27AF",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "TEXT",
    "handle": "27B0",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "startPoint": {
      "x": 377.287677225889,
      "y": 10.3607740458101,
      "z": 0
    },
    "textHeight": 12.94242377142857,
    "text": "TEMEL TOPRAKLAMA DETAYLARI",
    "rotation": 0.0100000010572011
  },
  {
    "type": "TEXT",
    "handle": "27B1",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "startPoint": {
      "x": 656.6536434070432,
      "y": 63.68941113539039,
      "z": 0
    },
    "textHeight": 7.021714285714286,
    "text": "Tesviye Betonu",
    "rotation": 0.0100000010572011
  },
  {
    "type": "TEXT",
    "handle": "27B2",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "startPoint": {
      "x": 528.3724834998142,
      "y": 42.72869052550958,
      "z": 0
    },
    "textHeight": 7.021714285714286,
    "text": "Bina yalıtımının içinde kalan temel",
    "rotation": 0.0100000010572011
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 593.8464911725601,
        "y": 64.54011925401934,
        "z": 0
      },
      {
        "x": 652.4025312627784,
        "y": 64.55033921169888,
        "z": 0
      }
    ],
    "handle": "27B8",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 580.6913503739632,
        "y": 64.53782325050996,
        "z": 0
      },
      {
        "x": 593.8471419792032,
        "y": 60.81127201206982,
        "z": 0
      }
    ],
    "handle": "27BA",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 580.6913503739632,
        "y": 64.53782325050996,
        "z": 0
      },
      {
        "x": 593.8458403659732,
        "y": 68.26896647549438,
        "z": 0
      }
    ],
    "handle": "27BB",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 593.8471419792032,
        "y": 60.81127201206982,
        "z": 0
      },
      {
        "x": 593.8458403659732,
        "y": 68.26896647549438,
        "z": 0
      }
    ],
    "handle": "27BC",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 503.422139529139,
        "y": 105.0972397876903,
        "z": 0
      },
      {
        "x": 513.6079446418444,
        "y": 105.0990175465076,
        "z": 0
      }
    ],
    "handle": "27BD",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "TEXT",
    "handle": "27BF",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "startPoint": {
      "x": 585.6514008002124,
      "y": 111.4523602807931,
      "z": 0
    },
    "textHeight": 7.021714285714286,
    "text": "Temel",
    "rotation": 0.0100000010572011
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 503.4173900951868,
        "y": 132.3094914257526,
        "z": 0
      },
      {
        "x": 513.6031952078914,
        "y": 132.3112691855049,
        "z": 0
      }
    ],
    "handle": "27C5",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 503.4146761329026,
        "y": 147.859349517148,
        "z": 0
      },
      {
        "x": 513.6004812456675,
        "y": 147.8611272750386,
        "z": 0
      }
    ],
    "handle": "27C6",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 503.4153546234578,
        "y": 143.9718849761348,
        "z": 0
      },
      {
        "x": 513.6011597361654,
        "y": 143.973662734963,
        "z": 0
      }
    ],
    "handle": "27C7",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 503.4160331138998,
        "y": 140.0844204826171,
        "z": 0
      },
      {
        "x": 513.6018382267793,
        "y": 140.0861982414499,
        "z": 0
      }
    ],
    "handle": "27C8",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 503.4167116045722,
        "y": 136.1969559220633,
        "z": 0
      },
      {
        "x": 513.6025167173933,
        "y": 136.1987336790189,
        "z": 0
      }
    ],
    "handle": "27C9",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 503.4133191517319,
        "y": 155.6342785283967,
        "z": 0
      },
      {
        "x": 513.5991242645533,
        "y": 155.6360562853524,
        "z": 0
      }
    ],
    "handle": "27CA",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 503.4139976424047,
        "y": 151.7468140330093,
        "z": 0
      },
      {
        "x": 513.5998027550503,
        "y": 151.7485917908998,
        "z": 0
      }
    ],
    "handle": "27CB",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 511.7189332525592,
        "y": 138.6298477156024,
        "z": 0
      },
      {
        "x": 511.7194538977932,
        "y": 135.6467699483046,
        "z": 0
      }
    ],
    "handle": "27CD",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 516.9812498928522,
        "y": 137.1392272561706,
        "z": 0
      },
      {
        "x": 511.7194538977932,
        "y": 135.6467699483046,
        "z": 0
      }
    ],
    "handle": "27CE",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 516.9812498928522,
        "y": 137.1392272561706,
        "z": 0
      },
      {
        "x": 511.7189332525592,
        "y": 138.6298477156024,
        "z": 0
      }
    ],
    "handle": "27CF",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 503.4180685856851,
        "y": 128.4220269098841,
        "z": 0
      },
      {
        "x": 513.6038736983882,
        "y": 128.423804667771,
        "z": 0
      }
    ],
    "handle": "27D0",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 503.4187470762998,
        "y": 124.5345623707335,
        "z": 0
      },
      {
        "x": 513.604552188887,
        "y": 124.5363401314216,
        "z": 0
      }
    ],
    "handle": "27D1",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 503.4194255669135,
        "y": 120.6470978762918,
        "z": 0
      },
      {
        "x": 513.6052306795614,
        "y": 120.6488756341823,
        "z": 0
      }
    ],
    "handle": "27D2",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 503.420104057412,
        "y": 116.7596333371439,
        "z": 0
      },
      {
        "x": 513.6059091701163,
        "y": 116.7614110968898,
        "z": 0
      }
    ],
    "handle": "27D3",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 503.4207825480268,
        "y": 112.8721688212899,
        "z": 0
      },
      {
        "x": 513.6065876607314,
        "y": 112.8739465801045,
        "z": 0
      }
    ],
    "handle": "27D4",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 503.4214610386396,
        "y": 108.9847043258997,
        "z": 0
      },
      {
        "x": 513.6072661512293,
        "y": 108.9864820856601,
        "z": 0
      }
    ],
    "handle": "27D5",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 503.4044987745001,
        "y": 206.1713173110029,
        "z": 0
      },
      {
        "x": 513.5903038872063,
        "y": 206.1730950679594,
        "z": 0
      }
    ],
    "handle": "27D7",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 503.405177265057,
        "y": 202.2838527718531,
        "z": 0
      },
      {
        "x": 513.5909823777615,
        "y": 202.2856305306695,
        "z": 0
      }
    ],
    "handle": "27D8",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "TEXT",
    "handle": "27D9",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "startPoint": {
      "x": 584.8431198619652,
      "y": 169.2877789745143,
      "z": 0
    },
    "textHeight": 7.021714285714286,
    "text": "duvarı",
    "rotation": 0.0100000010572011
  },
  {
    "type": "TEXT",
    "handle": "27DA",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "startPoint": {
      "x": 584.8411725425973,
      "y": 180.4450976876542,
      "z": 0
    },
    "textHeight": 7.021714285714286,
    "text": "Bodrum dış",
    "rotation": 0.0100000010572011
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 629.9952703107845,
        "y": 176.3476881682845,
        "z": 0
      },
      {
        "x": 558.8658494799743,
        "y": 176.3352737417454,
        "z": 0
      }
    ],
    "handle": "27DB",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 503.4092482083948,
        "y": 178.9590656729424,
        "z": 0
      },
      {
        "x": 513.5950533211004,
        "y": 178.960843430832,
        "z": 0
      }
    ],
    "handle": "27DC",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 503.4085697178376,
        "y": 182.846530166451,
        "z": 0
      },
      {
        "x": 513.5943748306013,
        "y": 182.8483079252692,
        "z": 0
      }
    ],
    "handle": "27DD",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 503.4072127366671,
        "y": 190.6214592205324,
        "z": 0
      },
      {
        "x": 513.5930178494893,
        "y": 190.6232369812214,
        "z": 0
      }
    ],
    "handle": "27DE",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 503.4078912273399,
        "y": 186.7339947056025,
        "z": 0
      },
      {
        "x": 513.5936963401023,
        "y": 186.7357724625579,
        "z": 0
      }
    ],
    "handle": "27DF",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 503.405855755671,
        "y": 198.3963882541211,
        "z": 0
      },
      {
        "x": 513.5916608682602,
        "y": 198.3981660138806,
        "z": 0
      }
    ],
    "handle": "27E0",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 503.406534246169,
        "y": 194.5089237168422,
        "z": 0
      },
      {
        "x": 513.5923393588743,
        "y": 194.5107014737996,
        "z": 0
      }
    ],
    "handle": "27E1",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 503.4119621706188,
        "y": 163.4092075824701,
        "z": 0
      },
      {
        "x": 513.5977672834402,
        "y": 163.4109853412919,
        "z": 0
      }
    ],
    "handle": "27E2",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 503.4126406611768,
        "y": 159.5217430675402,
        "z": 0
      },
      {
        "x": 513.5984457739382,
        "y": 159.523520824504,
        "z": 0
      }
    ],
    "handle": "27E3",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 503.4099266990089,
        "y": 175.0716011328622,
        "z": 0
      },
      {
        "x": 513.5957318117723,
        "y": 175.0733788916805,
        "z": 0
      }
    ],
    "handle": "27E4",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 503.4106051896237,
        "y": 171.1841366169928,
        "z": 0
      },
      {
        "x": 513.5964103023281,
        "y": 171.185914373953,
        "z": 0
      }
    ],
    "handle": "27E5",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 503.411283680063,
        "y": 167.2966721197517,
        "z": 0
      },
      {
        "x": 513.5970887928265,
        "y": 167.2984498795122,
        "z": 0
      }
    ],
    "handle": "27E6",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 576.6919025310794,
        "y": 221.2039094306492,
        "z": 0
      },
      {
        "x": 581.9536985289305,
        "y": 222.6963667161727,
        "z": 0
      }
    ],
    "handle": "27E8",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 576.6919025310794,
        "y": 221.2039094306492,
        "z": 0
      },
      {
        "x": 581.9542191742202,
        "y": 219.7132889274435,
        "z": 0
      }
    ],
    "handle": "27E9",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 581.9542191742202,
        "y": 219.7132889274435,
        "z": 0
      },
      {
        "x": 581.9536985289305,
        "y": 222.6963667161727,
        "z": 0
      }
    ],
    "handle": "27EA",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "TEXT",
    "handle": "27EB",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "startPoint": {
      "x": 584.8320444813594,
      "y": 232.7450355747705,
      "z": 0
    },
    "textHeight": 7.021714285714286,
    "text": "Bağlantı Filizi",
    "rotation": 0.0100000010572011
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 503.4038202839438,
        "y": 210.0587818054409,
        "z": 0
      },
      {
        "x": 513.5896253967652,
        "y": 210.0605595642701,
        "z": 0
      }
    ],
    "handle": "27EC",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 523.3963652595985,
        "y": 221.1946076042914,
        "z": 0
      },
      {
        "x": 629.9874397995884,
        "y": 221.2132112560721,
        "z": 0
      }
    ],
    "handle": "27ED",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "TEXT",
    "handle": "27EE",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "startPoint": {
      "x": 413.4653255330631,
      "y": 281.6163260471003,
      "z": 0
    },
    "textHeight": 12.94242377142857,
    "text": "TEMEL TOPRAKLAMA DETAYLARI KESiT",
    "rotation": 0.0100000010572011
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 485.8612041088047,
        "y": 519.9845369076318,
        "z": 0
      },
      {
        "x": 545.6177260379764,
        "y": 519.9949663905425,
        "z": 0
      }
    ],
    "handle": "27EF",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 485.8630740777006,
        "y": 509.270404731851,
        "z": 0
      },
      {
        "x": 545.6195960068146,
        "y": 509.2808342128908,
        "z": 0
      }
    ],
    "handle": "27F0",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 545.6177260379764,
        "y": 519.9949663905425,
        "z": 0
      },
      {
        "x": 545.6195960068146,
        "y": 509.2808342128908,
        "z": 0
      }
    ],
    "handle": "27F1",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "TOPRAK1",
    "lineTypeScale": 8,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 564.228312721009,
        "y": 519.9982145493804,
        "z": 0
      },
      {
        "x": 623.984834650123,
        "y": 520.0086440294943,
        "z": 0
      }
    ],
    "handle": "27F2",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 564.2301826899632,
        "y": 509.2840823745309,
        "z": 0
      },
      {
        "x": 623.9867046190193,
        "y": 509.2945118546447,
        "z": 0
      }
    ],
    "handle": "27F3",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 560.5149902079723,
        "y": 554.2000667052134,
        "z": 0
      },
      {
        "x": 560.5203817555442,
        "y": 523.3087752843239,
        "z": 0
      }
    ],
    "handle": "27F4",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 549.8008580342292,
        "y": 554.198196737081,
        "z": 0
      },
      {
        "x": 549.806249581626,
        "y": 523.3069053143226,
        "z": 0
      }
    ],
    "handle": "27F5",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 560.5234510731532,
        "y": 505.7228809455444,
        "z": 0
      },
      {
        "x": 560.5282008575743,
        "y": 478.5086216451524,
        "z": 0
      }
    ],
    "handle": "27F6",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 549.8093188992923,
        "y": 505.721010974601,
        "z": 0
      },
      {
        "x": 549.8140686836554,
        "y": 478.5067516751523,
        "z": 0
      }
    ],
    "handle": "27F7",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "CIRCLE",
    "handle": "27F8",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "TOPRAK1",
    "lineTypeScale": 8,
    "lineweight": 18,
    "center": {
      "x": 548.3689607739225,
      "y": 520.6137359542707,
      "z": 0
    },
    "radius": 1.249569453674316
  },
  {
    "type": "CIRCLE",
    "handle": "27F9",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "TOPRAK1",
    "lineTypeScale": 8,
    "lineweight": 18,
    "center": {
      "x": 561.5443561313443,
      "y": 520.6160354949534,
      "z": 0
    },
    "radius": 1.249569453674316
  },
  {
    "type": "CIRCLE",
    "handle": "27FA",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "TOPRAK1",
    "lineTypeScale": 8,
    "lineweight": 18,
    "center": {
      "x": 548.3710828406612,
      "y": 508.4551892112902,
      "z": 0
    },
    "radius": 1.249569453674316
  },
  {
    "type": "CIRCLE",
    "handle": "27FB",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "TOPRAK1",
    "lineTypeScale": 8,
    "lineweight": 18,
    "center": {
      "x": 561.5464781980245,
      "y": 508.4574887510313,
      "z": 0
    },
    "radius": 1.249569453674316
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 608.7713577876574,
        "y": 530.9683239981493,
        "z": 0
      },
      {
        "x": 575.5001548881405,
        "y": 530.9625170770996,
        "z": 0
      }
    ],
    "handle": "27FC",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 575.5001548881405,
        "y": 530.9625170770996,
        "z": 0
      },
      {
        "x": 564.2277348062482,
        "y": 523.3094223393126,
        "z": 0
      }
    ],
    "handle": "27FD",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 485.8766676670058,
        "y": 431.3848755611115,
        "z": 0
      },
      {
        "x": 545.6331895961775,
        "y": 431.3953050430819,
        "z": 0
      }
    ],
    "handle": "27FE",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 485.8785376359011,
        "y": 420.6707433862503,
        "z": 0
      },
      {
        "x": 545.6350595650734,
        "y": 420.6811728663669,
        "z": 0
      }
    ],
    "handle": "27FF",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 545.6331895961775,
        "y": 431.3953050430819,
        "z": 0
      },
      {
        "x": 545.6350595650734,
        "y": 420.6811728663669,
        "z": 0
      }
    ],
    "handle": "2800",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "TOPRAK1",
    "lineTypeScale": 8,
    "lineweight": 18
  },
  {
    "type": "CIRCLE",
    "handle": "2801",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "TOPRAK1",
    "lineTypeScale": 8,
    "lineweight": 18,
    "center": {
      "x": 548.3844243321803,
      "y": 432.0140745732931,
      "z": 0
    },
    "radius": 1.249569453674316
  },
  {
    "type": "CIRCLE",
    "handle": "2802",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "TOPRAK1",
    "lineTypeScale": 8,
    "lineweight": 18,
    "center": {
      "x": 561.5598196894855,
      "y": 432.0163741120995,
      "z": 0
    },
    "radius": 1.249569453674316
  },
  {
    "type": "CIRCLE",
    "handle": "2803",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "TOPRAK1",
    "lineTypeScale": 8,
    "lineweight": 18,
    "center": {
      "x": 548.3865463988604,
      "y": 419.8555278293713,
      "z": 0
    },
    "radius": 1.249569453674316
  },
  {
    "type": "CIRCLE",
    "handle": "2804",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "TOPRAK1",
    "lineTypeScale": 8,
    "lineweight": 18,
    "center": {
      "x": 561.5619417562843,
      "y": 419.8578273700512,
      "z": 0
    },
    "radius": 1.249569453674316
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 608.7868213459142,
        "y": 442.3686626162306,
        "z": 0
      },
      {
        "x": 575.5156184463992,
        "y": 442.3628556942521,
        "z": 0
      }
    ],
    "handle": "2805",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 575.5156184463992,
        "y": 442.3628556942521,
        "z": 0
      },
      {
        "x": 564.2431983645065,
        "y": 434.7097609732188,
        "z": 0
      }
    ],
    "handle": "2806",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 564.2437762792682,
        "y": 431.3985532037921,
        "z": 0
      },
      {
        "x": 624.0002982084404,
        "y": 431.4089826829692,
        "z": 0
      }
    ],
    "handle": "2807",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 564.2456462481631,
        "y": 420.6844210270718,
        "z": 0
      },
      {
        "x": 624.0021681771602,
        "y": 420.6948505071932,
        "z": 0
      }
    ],
    "handle": "2808",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 485.8880360067116,
        "y": 366.2490884456856,
        "z": 0
      },
      {
        "x": 545.6445579357672,
        "y": 366.2595179257915,
        "z": 0
      }
    ],
    "handle": "2809",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 485.8899059755498,
        "y": 355.5349562698939,
        "z": 0
      },
      {
        "x": 545.6464279046054,
        "y": 355.5453857509419,
        "z": 0
      }
    ],
    "handle": "280A",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 545.6445579357672,
        "y": 366.2595179257915,
        "z": 0
      },
      {
        "x": 545.6464279046054,
        "y": 355.5453857509419,
        "z": 0
      }
    ],
    "handle": "280B",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "TOPRAK1",
    "lineTypeScale": 8,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 560.5502829709433,
        "y": 351.9874324463199,
        "z": 0
      },
      {
        "x": 560.5550327552482,
        "y": 324.7731731459426,
        "z": 0
      }
    ],
    "handle": "280C",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 549.8361507970822,
        "y": 351.9855624781949,
        "z": 0
      },
      {
        "x": 549.8409005813885,
        "y": 324.7713031778139,
        "z": 0
      }
    ],
    "handle": "280D",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "CIRCLE",
    "handle": "280E",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "TOPRAK1",
    "lineTypeScale": 8,
    "lineweight": 18,
    "center": {
      "x": 548.3957926718281,
      "y": 366.8782874587896,
      "z": 0
    },
    "radius": 1.249569453674316
  },
  {
    "type": "CIRCLE",
    "handle": "280F",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "TOPRAK1",
    "lineTypeScale": 8,
    "lineweight": 18,
    "center": {
      "x": 561.5711880291343,
      "y": 366.8805869976031,
      "z": 0
    },
    "radius": 1.249569453674316
  },
  {
    "type": "CIRCLE",
    "handle": "2810",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "TOPRAK1",
    "lineTypeScale": 8,
    "lineweight": 18,
    "center": {
      "x": 548.3979147384514,
      "y": 354.7197407130042,
      "z": 0
    },
    "radius": 1.249569453674316
  },
  {
    "type": "CIRCLE",
    "handle": "2811",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "TOPRAK1",
    "lineTypeScale": 8,
    "lineweight": 18,
    "center": {
      "x": 561.5733100958164,
      "y": 354.7220402546191,
      "z": 0
    },
    "radius": 1.249569453674316
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 608.7981896854462,
        "y": 377.2328754998707,
        "z": 0
      },
      {
        "x": 575.5269867860475,
        "y": 377.2270685788199,
        "z": 0
      }
    ],
    "handle": "2812",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 575.5269867860475,
        "y": 377.2270685788199,
        "z": 0
      },
      {
        "x": 564.2545667040392,
        "y": 369.5739738410304,
        "z": 0
      }
    ],
    "handle": "2813",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "TEXT",
    "handle": "2814",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "startPoint": {
      "x": 235.040074345306,
      "y": 940.7395737061081,
      "z": 0
    },
    "textHeight": 7.021714285714286,
    "text": "yerine uygun kaçak akım koruma rölesi seçilmelidir.",
    "rotation": 0.0100000010572011
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 736.2690623310042,
        "y": 0,
        "z": 0
      },
      {
        "x": 736.0483825883123,
        "y": 1162.918591290707,
        "z": 0
      }
    ],
    "handle": "2815",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "TEXT",
    "handle": "2816",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "startPoint": {
      "x": 510.6136918476543,
      "y": 317.8459188006855,
      "z": 0
    },
    "textHeight": 5.392676571428575,
    "text": "TOPRAKLAMA ÇUBUGU",
    "rotation": 0.0100000010572011
  },
  {
    "type": "TEXT",
    "handle": "2817",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "startPoint": {
      "x": 569.7277854498833,
      "y": 380.5703318016604,
      "z": 0
    },
    "textHeight": 5.392676571428575,
    "text": "EK MALZEMESİ",
    "rotation": 0.0100000010572011
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 545.6470493386155,
        "y": 351.984831340611,
        "z": 0
      },
      {
        "x": 564.2576360216472,
        "y": 351.9880795013087,
        "z": 0
      }
    ],
    "handle": "2818",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "TOPRAK1",
    "lineTypeScale": 8,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 564.2576360216472,
        "y": 351.9880795013087,
        "z": 0
      },
      {
        "x": 564.2545667040392,
        "y": 369.5739738410304,
        "z": 0
      }
    ],
    "handle": "2819",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "TOPRAK1",
    "lineTypeScale": 8,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 564.2545667040392,
        "y": 369.5739738410304,
        "z": 0
      },
      {
        "x": 545.6439800210075,
        "y": 369.5707256812602,
        "z": 0
      }
    ],
    "handle": "281A",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "TOPRAK1",
    "lineTypeScale": 8,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 545.6439800210075,
        "y": 369.5707256812602,
        "z": 0
      },
      {
        "x": 545.6470493386155,
        "y": 351.984831340611,
        "z": 0
      }
    ],
    "handle": "281B",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "TOPRAK1",
    "lineTypeScale": 8,
    "lineweight": 18
  },
  {
    "type": "TEXT",
    "handle": "281C",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "startPoint": {
      "x": 510.1834200898884,
      "y": 401.5068828500696,
      "z": 0
    },
    "textHeight": 5.392676571428575,
    "text": "UC UCA EK",
    "rotation": 0.0100000010572011
  },
  {
    "type": "TEXT",
    "handle": "281D",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "startPoint": {
      "x": 569.7164171102932,
      "y": 445.7061189180211,
      "z": 0
    },
    "textHeight": 5.392676571428575,
    "text": "EK MALZEMESİ",
    "rotation": 0.0100000010572011
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 545.6356809990245,
        "y": 417.1206184551119,
        "z": 0
      },
      {
        "x": 564.2462676820581,
        "y": 417.1238666167455,
        "z": 0
      }
    ],
    "handle": "281E",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "TOPRAK1",
    "lineTypeScale": 8,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 564.2462676820581,
        "y": 417.1238666167455,
        "z": 0
      },
      {
        "x": 564.2431983645065,
        "y": 434.7097609732188,
        "z": 0
      }
    ],
    "handle": "281F",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "TOPRAK1",
    "lineTypeScale": 8,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 564.2431983645065,
        "y": 434.7097609732188,
        "z": 0
      },
      {
        "x": 545.6326116814754,
        "y": 434.7065128143803,
        "z": 0
      }
    ],
    "handle": "2820",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "TOPRAK1",
    "lineTypeScale": 8,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 545.6326116814754,
        "y": 434.7065128143803,
        "z": 0
      },
      {
        "x": 545.6356809990245,
        "y": 417.1206184551119,
        "z": 0
      }
    ],
    "handle": "2821",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "TOPRAK1",
    "lineTypeScale": 8,
    "lineweight": 18
  },
  {
    "type": "TEXT",
    "handle": "2822",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "startPoint": {
      "x": 510.2118381651822,
      "y": 470.5218946812591,
      "z": 0
    },
    "textHeight": 5.392676571428575,
    "text": "BAKIR İLETKEN",
    "rotation": 0.0100000010572011
  },
  {
    "type": "TEXT",
    "handle": "2823",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "startPoint": {
      "x": 569.7009535520322,
      "y": 534.305780299931,
      "z": 0
    },
    "textHeight": 5.392676571428575,
    "text": "EK MALZEMESİ",
    "rotation": 0.0100000010572011
  },
  {
    "type": "TEXT",
    "handle": "2824",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "startPoint": {
      "x": 470.1890262971868,
      "y": 527.0969276195318,
      "z": 0
    },
    "textHeight": 5.392676571428575,
    "text": "GALVANİZ LAMA 30x3.5",
    "rotation": 0.0100000010572011
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 545.6202174407651,
        "y": 505.7202798388932,
        "z": 0
      },
      {
        "x": 564.2308041238575,
        "y": 505.7235280005179,
        "z": 0
      }
    ],
    "handle": "2825",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "TOPRAK1",
    "lineTypeScale": 8,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 564.2308041238575,
        "y": 505.7235280005179,
        "z": 0
      },
      {
        "x": 564.2277348062482,
        "y": 523.3094223393126,
        "z": 0
      }
    ],
    "handle": "2826",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "TOPRAK1",
    "lineTypeScale": 8,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 564.2277348062482,
        "y": 523.3094223393126,
        "z": 0
      },
      {
        "x": 545.6171481231573,
        "y": 523.3061741767449,
        "z": 0
      }
    ],
    "handle": "2827",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "TOPRAK1",
    "lineTypeScale": 8,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 545.6171481231573,
        "y": 523.3061741767449,
        "z": 0
      },
      {
        "x": 545.6202174407651,
        "y": 505.7202798388932,
        "z": 0
      }
    ],
    "handle": "2828",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "TOPRAK1",
    "lineTypeScale": 8,
    "lineweight": 18
  },
  {
    "type": "ARC",
    "handle": "283D",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "center": {
      "x": 513.9671151465744,
      "y": 209.1359643181722,
      "z": 0
    },
    "radius": 0.0323560588747919,
    "startAngle": 3.141767186235127,
    "endAngle": 0.00017453264533675135,
    "angleLength": -3.1415926535897905
  },
  {
    "type": "ARC",
    "handle": "283E",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "center": {
      "x": 513.9671151465744,
      "y": 209.1359643181722,
      "z": 0
    },
    "radius": 0.0323560588746348,
    "startAngle": 0.00017453264533675135,
    "endAngle": 3.141767186235127,
    "angleLength": 3.1415926535897905
  },
  {
    "type": "ARC",
    "handle": "2905",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "center": {
      "x": 513.5903038872063,
      "y": 206.1730950679594,
      "z": 0
    },
    "radius": 0.032356060266607,
    "startAngle": 3.141767186235127,
    "endAngle": 0.00017453264533675135,
    "angleLength": -3.1415926535897905
  },
  {
    "type": "ARC",
    "handle": "2906",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "center": {
      "x": 513.5903038872063,
      "y": 206.1730950679594,
      "z": 0
    },
    "radius": 0.0323560602664498,
    "startAngle": 0.00017453264533675135,
    "endAngle": 3.141767186235127,
    "angleLength": 3.1415926535897905
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 530.5328478722356,
        "y": 130.6560466643423,
        "z": 0
      },
      {
        "x": 535.3760317520944,
        "y": 130.6568919606396,
        "z": 0
      }
    ],
    "handle": "290F",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 535.3760317520944,
        "y": 130.6568919606396,
        "z": 0
      },
      {
        "x": 535.3764967060424,
        "y": 127.9929024921693,
        "z": 0
      }
    ],
    "handle": "2910",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 535.3764967060424,
        "y": 127.9929024921693,
        "z": 0
      },
      {
        "x": 530.5333128261263,
        "y": 127.9920571958609,
        "z": 0
      }
    ],
    "handle": "2911",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 530.5333128261263,
        "y": 127.9920571958609,
        "z": 0
      },
      {
        "x": 530.5328478722356,
        "y": 130.6560466643423,
        "z": 0
      }
    ],
    "handle": "2912",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "ARC",
    "handle": "2959",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "center": {
      "x": 513.9824172900403,
      "y": 121.4611423947017,
      "z": 0
    },
    "radius": 0.0323560588746348,
    "startAngle": 3.141767186235127,
    "endAngle": 0.00017453264533675135,
    "angleLength": -3.1415926535897905
  },
  {
    "type": "ARC",
    "handle": "295A",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "center": {
      "x": 513.9824172900403,
      "y": 121.4611423947017,
      "z": 0
    },
    "radius": 0.0323560588747919,
    "startAngle": 0.00017453264533675135,
    "endAngle": 3.141767186235127,
    "angleLength": 3.1415926535897905
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 560.9462321299953,
        "y": 130.6613548016139,
        "z": 0
      },
      {
        "x": 565.7894160070575,
        "y": 130.6622000960597,
        "z": 0
      }
    ],
    "handle": "29C9",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 565.7894160070575,
        "y": 130.6622000960597,
        "z": 0
      },
      {
        "x": 565.7898809608885,
        "y": 127.998210627592,
        "z": 0
      }
    ],
    "handle": "29CA",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 565.7898809608885,
        "y": 127.998210627592,
        "z": 0
      },
      {
        "x": 560.9466970838822,
        "y": 127.9973653331317,
        "z": 0
      }
    ],
    "handle": "29CB",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 560.9466970838822,
        "y": 127.9973653331317,
        "z": 0
      },
      {
        "x": 560.9462321299953,
        "y": 130.6613548016139,
        "z": 0
      }
    ],
    "handle": "29CC",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 647.4498746321764,
        "y": 130.6764525370599,
        "z": 0
      },
      {
        "x": 652.2930585092392,
        "y": 130.6772978315093,
        "z": 0
      }
    ],
    "handle": "29CD",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 652.2930585092392,
        "y": 130.6772978315093,
        "z": 0
      },
      {
        "x": 652.2935234631875,
        "y": 128.0133083630317,
        "z": 0
      }
    ],
    "handle": "29CE",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 652.2935234631875,
        "y": 128.0133083630317,
        "z": 0
      },
      {
        "x": 647.4503395860082,
        "y": 128.0124630676509,
        "z": 0
      }
    ],
    "handle": "29CF",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 647.4503395860082,
        "y": 128.0124630676509,
        "z": 0
      },
      {
        "x": 647.4498746321764,
        "y": 130.6764525370599,
        "z": 0
      }
    ],
    "handle": "29D0",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 672.1295888990275,
        "y": 130.6807599589219,
        "z": 0
      },
      {
        "x": 676.9727727790025,
        "y": 130.6816052543035,
        "z": 0
      }
    ],
    "handle": "29D1",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 676.9727727790025,
        "y": 130.6816052543035,
        "z": 0
      },
      {
        "x": 676.9732377328912,
        "y": 128.0176157848836,
        "z": 0
      }
    ],
    "handle": "29D2",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 676.9732377328912,
        "y": 128.0176157848836,
        "z": 0
      },
      {
        "x": 672.1300538529174,
        "y": 128.0167704904406,
        "z": 0
      }
    ],
    "handle": "29D3",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 672.1300538529174,
        "y": 128.0167704904406,
        "z": 0
      },
      {
        "x": 672.1295888990275,
        "y": 130.6807599589219,
        "z": 0
      }
    ],
    "handle": "29D4",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 619.0308098110254,
        "y": 130.67149247415,
        "z": 0
      },
      {
        "x": 623.8739936911144,
        "y": 130.6723377685957,
        "z": 0
      }
    ],
    "handle": "29D5",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 623.8739936911144,
        "y": 130.6723377685957,
        "z": 0
      },
      {
        "x": 623.8744586448872,
        "y": 128.0083483001181,
        "z": 0
      }
    ],
    "handle": "29D6",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 623.8744586448872,
        "y": 128.0083483001181,
        "z": 0
      },
      {
        "x": 619.0312747649144,
        "y": 128.0075030056678,
        "z": 0
      }
    ],
    "handle": "29D7",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 619.0312747649144,
        "y": 128.0075030056678,
        "z": 0
      },
      {
        "x": 619.0308098110254,
        "y": 130.67149247415,
        "z": 0
      }
    ],
    "handle": "29D8",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 588.1188424833252,
        "y": 130.6660973187508,
        "z": 0
      },
      {
        "x": 592.9620263632394,
        "y": 130.6669426131966,
        "z": 0
      }
    ],
    "handle": "29D9",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 592.9620263632394,
        "y": 130.6669426131966,
        "z": 0
      },
      {
        "x": 592.9624913171872,
        "y": 128.0029531437866,
        "z": 0
      }
    ],
    "handle": "29DA",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 592.9624913171872,
        "y": 128.0029531437866,
        "z": 0
      },
      {
        "x": 588.1193074372713,
        "y": 128.00210784934,
        "z": 0
      }
    ],
    "handle": "29DB",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 588.1193074372713,
        "y": 128.00210784934,
        "z": 0
      },
      {
        "x": 588.1188424833252,
        "y": 130.6660973187508,
        "z": 0
      }
    ],
    "handle": "29DC",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 558.8716499078434,
        "y": 143.1012703860097,
        "z": 0
      },
      {
        "x": 694.3055372172964,
        "y": 143.124908058904,
        "z": 0
      }
    ],
    "handle": "29DD",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 694.3055372172964,
        "y": 143.124908058904,
        "z": 0
      },
      {
        "x": 694.3064583530651,
        "y": 137.8471887866035,
        "z": 0
      }
    ],
    "handle": "29DE",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 694.3064583530651,
        "y": 137.8471887866035,
        "z": 0
      },
      {
        "x": 558.8725710436704,
        "y": 137.8235511137145,
        "z": 0
      }
    ],
    "handle": "29DF",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 558.8725710436704,
        "y": 137.8235511137145,
        "z": 0
      },
      {
        "x": 558.8716499078434,
        "y": 143.1012703860097,
        "z": 0
      }
    ],
    "handle": "29E0",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "ARC",
    "handle": "29F9",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "center": {
      "x": 513.9849165190232,
      "y": 107.1416145097437,
      "z": 0
    },
    "radius": 0.0323560588747919,
    "startAngle": 3.141767186235127,
    "endAngle": 0.00017453264533675135,
    "angleLength": -3.1415926535897905
  },
  {
    "type": "ARC",
    "handle": "29FA",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "center": {
      "x": 513.9849165190232,
      "y": 107.1416145097437,
      "z": 0
    },
    "radius": 0.0323560588746348,
    "startAngle": 0.00017453264533675135,
    "endAngle": 3.141767186235127,
    "angleLength": 3.1415926535897905
  },
  {
    "type": "ARC",
    "handle": "2A2F",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "center": {
      "x": 513.9931534524643,
      "y": 96.22704176418029,
      "z": 0
    },
    "radius": 0.0323560588752634,
    "startAngle": 3.141767186235127,
    "endAngle": 0.00017453264533675135,
    "angleLength": -3.1415926535897905
  },
  {
    "type": "ARC",
    "handle": "2A30",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "center": {
      "x": 513.9931534524643,
      "y": 96.22704176418029,
      "z": 0
    },
    "radius": 0.0323560588752634,
    "startAngle": 0.00017453264533675135,
    "endAngle": 3.141767186235127,
    "angleLength": 3.1415926535897905
  },
  {
    "type": "ARC",
    "handle": "2A39",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "center": {
      "x": 513.9868159336613,
      "y": 96.25877110287092,
      "z": 0
    },
    "radius": 0.0323560588746348,
    "startAngle": 3.141767186235127,
    "endAngle": 0.00017453264533675135,
    "angleLength": -3.1415926535897905
  },
  {
    "type": "ARC",
    "handle": "2A3A",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "center": {
      "x": 513.9868159336613,
      "y": 96.25877110287092,
      "z": 0
    },
    "radius": 0.0323560588747919,
    "startAngle": 0.00017453264533675135,
    "endAngle": 3.141767186235127,
    "angleLength": 3.1415926535897905
  },
  {
    "type": "ARC",
    "handle": "2A65",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "center": {
      "x": 513.988083674164,
      "y": 88.99515297915148,
      "z": 0
    },
    "radius": 0.0323560588746348,
    "startAngle": 3.141767186235127,
    "endAngle": 0.00017453264533675135,
    "angleLength": -3.1415926535897905
  },
  {
    "type": "ARC",
    "handle": "2A66",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "center": {
      "x": 513.988083674164,
      "y": 88.99515297915148,
      "z": 0
    },
    "radius": 0.0323560588747919,
    "startAngle": 0.00017453264533675135,
    "endAngle": 3.141767186235127,
    "angleLength": 3.1415926535897905
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 530.5385720625053,
        "y": 97.85885236505057,
        "z": 0
      },
      {
        "x": 535.3817559423624,
        "y": 97.85969766043122,
        "z": 0
      }
    ],
    "handle": "2A6D",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 535.3817559423624,
        "y": 97.85969766043122,
        "z": 0
      },
      {
        "x": 535.3812909884721,
        "y": 100.5236870842018,
        "z": 0
      }
    ],
    "handle": "2A6E",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 535.3812909884721,
        "y": 100.5236870842018,
        "z": 0
      },
      {
        "x": 530.5381071086157,
        "y": 100.5228417906946,
        "z": 0
      }
    ],
    "handle": "2A6F",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 530.5381071086157,
        "y": 100.5228417906946,
        "z": 0
      },
      {
        "x": 530.5385720625053,
        "y": 97.85885236505057,
        "z": 0
      }
    ],
    "handle": "2A70",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 560.9519563202053,
        "y": 97.8641605032635,
        "z": 0
      },
      {
        "x": 565.7951401973835,
        "y": 97.86500579676797,
        "z": 0
      }
    ],
    "handle": "2AC5",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 565.7951401973835,
        "y": 97.86500579676797,
        "z": 0
      },
      {
        "x": 565.7946752435512,
        "y": 100.5289952205421,
        "z": 0
      }
    ],
    "handle": "2AC6",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 565.7946752435512,
        "y": 100.5289952205421,
        "z": 0
      },
      {
        "x": 560.9514913663713,
        "y": 100.5281499270313,
        "z": 0
      }
    ],
    "handle": "2AC7",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 560.9514913663713,
        "y": 100.5281499270313,
        "z": 0
      },
      {
        "x": 560.9519563202053,
        "y": 97.8641605032635,
        "z": 0
      }
    ],
    "handle": "2AC8",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 647.4555988225032,
        "y": 97.87925823684144,
        "z": 0
      },
      {
        "x": 652.2987826995675,
        "y": 97.88010353128993,
        "z": 0
      }
    ],
    "handle": "2B29",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 652.2987826995675,
        "y": 97.88010353128993,
        "z": 0
      },
      {
        "x": 652.2983177456765,
        "y": 100.5440929541328,
        "z": 0
      }
    ],
    "handle": "2B2A",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 652.2983177456765,
        "y": 100.5440929541328,
        "z": 0
      },
      {
        "x": 647.4551338686124,
        "y": 100.5432476596943,
        "z": 0
      }
    ],
    "handle": "2B2B",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 647.4551338686124,
        "y": 100.5432476596943,
        "z": 0
      },
      {
        "x": 647.4555988225032,
        "y": 97.87925823684144,
        "z": 0
      }
    ],
    "handle": "2B2C",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 672.1353130894115,
        "y": 97.88356565963569,
        "z": 0
      },
      {
        "x": 676.9784969693865,
        "y": 97.88441095406868,
        "z": 0
      }
    ],
    "handle": "2B5B",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 676.9784969693865,
        "y": 97.88441095406868,
        "z": 0
      },
      {
        "x": 676.9780320154373,
        "y": 100.548400378786,
        "z": 0
      }
    ],
    "handle": "2B5C",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 676.9780320154373,
        "y": 100.548400378786,
        "z": 0
      },
      {
        "x": 672.1348481355802,
        "y": 100.5475550824703,
        "z": 0
      }
    ],
    "handle": "2B5D",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 672.1348481355802,
        "y": 100.5475550824703,
        "z": 0
      },
      {
        "x": 672.1353130894115,
        "y": 97.88356565963569,
        "z": 0
      }
    ],
    "handle": "2B5E",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 619.0365340014682,
        "y": 97.8742981730038,
        "z": 0
      },
      {
        "x": 623.8797178813825,
        "y": 97.8751434693113,
        "z": 0
      }
    ],
    "handle": "2B93",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 623.8797178813825,
        "y": 97.8751434693113,
        "z": 0
      },
      {
        "x": 623.8792529274352,
        "y": 100.5391328921505,
        "z": 0
      }
    ],
    "handle": "2B94",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 623.8792529274352,
        "y": 100.5391328921505,
        "z": 0
      },
      {
        "x": 619.0360690475204,
        "y": 100.5382875977002,
        "z": 0
      }
    ],
    "handle": "2B95",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 619.0360690475204,
        "y": 100.5382875977002,
        "z": 0
      },
      {
        "x": 619.0365340014682,
        "y": 97.8742981730038,
        "z": 0
      }
    ],
    "handle": "2B96",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 588.1245666737664,
        "y": 97.86890301760195,
        "z": 0
      },
      {
        "x": 592.9677505535655,
        "y": 97.86974831298357,
        "z": 0
      }
    ],
    "handle": "2BAD",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 592.9677505535655,
        "y": 97.86974831298357,
        "z": 0
      },
      {
        "x": 592.967285599675,
        "y": 100.5337377358228,
        "z": 0
      }
    ],
    "handle": "2BAE",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 592.967285599675,
        "y": 100.5337377358228,
        "z": 0
      },
      {
        "x": 588.1241017198172,
        "y": 100.5328924413697,
        "z": 0
      }
    ],
    "handle": "2BAF",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 588.1241017198172,
        "y": 100.5328924413697,
        "z": 0
      },
      {
        "x": 588.1245666737664,
        "y": 97.86890301760195,
        "z": 0
      }
    ],
    "handle": "2BB0",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 527.9392835227183,
        "y": 130.6555940033822,
        "z": 0
      },
      {
        "x": 694.3077084552498,
        "y": 130.6846307720916,
        "z": 0
      }
    ],
    "handle": "2BB5",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 694.3077084552498,
        "y": 130.6846307720916,
        "z": 0
      },
      {
        "x": 694.3134326455754,
        "y": 97.88743647187219,
        "z": 0
      }
    ],
    "handle": "2BB6",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 694.3134326455754,
        "y": 97.88743647187219,
        "z": 0
      },
      {
        "x": 527.9450077130465,
        "y": 97.85839970316013,
        "z": 0
      }
    ],
    "handle": "2BB7",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 527.9450077130465,
        "y": 97.85839970316013,
        "z": 0
      },
      {
        "x": 527.9392835227183,
        "y": 130.6555940033822,
        "z": 0
      }
    ],
    "handle": "2BB8",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 523.4108515282273,
        "y": 138.1944027738635,
        "z": 0
      },
      {
        "x": 694.3063925470335,
        "y": 138.2242296747818,
        "z": 0
      }
    ],
    "handle": "2BB9",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 694.3063925470335,
        "y": 138.2242296747818,
        "z": 0
      },
      {
        "x": 694.3147485326042,
        "y": 90.3479593992206,
        "z": 0
      }
    ],
    "handle": "2BBA",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 694.3147485326042,
        "y": 90.3479593992206,
        "z": 0
      },
      {
        "x": 523.4192075138544,
        "y": 90.31813250016054,
        "z": 0
      }
    ],
    "handle": "2BBB",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 523.4192075138544,
        "y": 90.31813250016054,
        "z": 0
      },
      {
        "x": 523.4108515282273,
        "y": 138.1944027738635,
        "z": 0
      }
    ],
    "handle": "2BBC",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 694.3055372172964,
        "y": 143.124908058904,
        "z": 0
      },
      {
        "x": 716.5633771183195,
        "y": 143.1287927860321,
        "z": 0
      }
    ],
    "handle": "2BBD",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 716.5633771183195,
        "y": 143.1287927860321,
        "z": 0
      },
      {
        "x": 716.5745622960392,
        "y": 79.04244574811219,
        "z": 0
      }
    ],
    "handle": "2BBE",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 716.5745622960392,
        "y": 79.04244574811219,
        "z": 0
      },
      {
        "x": 694.3167223950154,
        "y": 79.03856102097414,
        "z": 0
      }
    ],
    "handle": "2BBF",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 694.3167223950154,
        "y": 79.03856102097414,
        "z": 0
      },
      {
        "x": 694.3055372172964,
        "y": 143.124908058904,
        "z": 0
      }
    ],
    "handle": "2BC0",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 333.0556258603467,
        "y": 147.0695929825197,
        "z": 0
      },
      {
        "x": 468.4895131670044,
        "y": 147.093230654481,
        "z": 0
      }
    ],
    "handle": "2BC1",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 468.4895131670044,
        "y": 147.093230654481,
        "z": 0
      },
      {
        "x": 468.490434302891,
        "y": 141.815511426881,
        "z": 0
      }
    ],
    "handle": "2BC2",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 468.490434302891,
        "y": 141.815511426881,
        "z": 0
      },
      {
        "x": 333.0565469961721,
        "y": 141.7918737539985,
        "z": 0
      }
    ],
    "handle": "2BC3",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 333.0565469961721,
        "y": 141.7918737539985,
        "z": 0
      },
      {
        "x": 333.0556258603467,
        "y": 147.0695929825197,
        "z": 0
      }
    ],
    "handle": "2BC4",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 120.7690167611001,
        "y": 144.418246135111,
        "z": 0
      },
      {
        "x": 256.2029040706109,
        "y": 144.4418838080091,
        "z": 0
      }
    ],
    "handle": "2BC5",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 256.2029040706109,
        "y": 144.4418838080091,
        "z": 0
      },
      {
        "x": 256.2038252063209,
        "y": 139.1641645804011,
        "z": 0
      }
    ],
    "handle": "2BC6",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 256.2038252063209,
        "y": 139.1641645804011,
        "z": 0
      },
      {
        "x": 120.7699378969258,
        "y": 139.1405269075112,
        "z": 0
      }
    ],
    "handle": "2BC7",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 120.7699378969258,
        "y": 139.1405269075112,
        "z": 0
      },
      {
        "x": 120.7690167611001,
        "y": 144.418246135111,
        "z": 0
      }
    ],
    "handle": "2BC8",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 287.3897443864258,
        "y": 252.6156451487914,
        "z": 0
      },
      {
        "x": 297.5755494992478,
        "y": 252.617422906681,
        "z": 0
      }
    ],
    "handle": "2CA7",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 297.5755494992478,
        "y": 252.617422906681,
        "z": 0
      },
      {
        "x": 297.5948274808478,
        "y": 142.1627253927217,
        "z": 0
      }
    ],
    "handle": "2CA8",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 297.5948274808478,
        "y": 142.1627253927217,
        "z": 0
      },
      {
        "x": 287.4090223681418,
        "y": 142.1609476348349,
        "z": 0
      }
    ],
    "handle": "2CA9",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 287.4090223681418,
        "y": 142.1609476348349,
        "z": 0
      },
      {
        "x": 287.3897443864258,
        "y": 252.6156451487914,
        "z": 0
      }
    ],
    "handle": "2CAA",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 297.5754837143467,
        "y": 252.9943419406118,
        "z": 0
      },
      {
        "x": 333.0371374237592,
        "y": 253.0005311677205,
        "z": 0
      }
    ],
    "handle": "2CAB",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 333.0371374237592,
        "y": 253.0005311677205,
        "z": 0
      },
      {
        "x": 333.0564811900839,
        "y": 142.1689146189028,
        "z": 0
      }
    ],
    "handle": "2CAC",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 333.0564811900839,
        "y": 142.1689146189028,
        "z": 0
      },
      {
        "x": 297.5948274808478,
        "y": 142.1627253927217,
        "z": 0
      }
    ],
    "handle": "2CAD",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 297.5948274808478,
        "y": 142.1627253927217,
        "z": 0
      },
      {
        "x": 297.5754837143467,
        "y": 252.9943419406118,
        "z": 0
      }
    ],
    "handle": "2CAE",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 297.5758028005951,
        "y": 251.1661126371437,
        "z": 0
      },
      {
        "x": 299.4037130172949,
        "y": 252.9946610266297,
        "z": 0
      }
    ],
    "handle": "2CAF",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 297.5774256255247,
        "y": 241.8680103560828,
        "z": 0
      },
      {
        "x": 308.7018152993997,
        "y": 252.9962838524916,
        "z": 0
      }
    ],
    "handle": "2CB0",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 297.5790484505709,
        "y": 232.5699080750337,
        "z": 0
      },
      {
        "x": 317.9999175813298,
        "y": 252.9979066774222,
        "z": 0
      }
    ],
    "handle": "2CB1",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 297.580671275617,
        "y": 223.2718057930433,
        "z": 0
      },
      {
        "x": 327.2980198633157,
        "y": 252.99952950235,
        "z": 0
      }
    ],
    "handle": "2CB2",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 297.5822941006054,
        "y": 213.973703510117,
        "z": 0
      },
      {
        "x": 333.0377585837849,
        "y": 249.4415464466401,
        "z": 0
      }
    ],
    "handle": "2CB3",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 297.5839169257087,
        "y": 204.6756012300038,
        "z": 0
      },
      {
        "x": 333.039381408657,
        "y": 240.1434441627934,
        "z": 0
      }
    ],
    "handle": "2CB4",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 297.5855397505788,
        "y": 195.3774989461517,
        "z": 0
      },
      {
        "x": 333.04100423376,
        "y": 230.8453418826721,
        "z": 0
      }
    ],
    "handle": "2CB5",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 297.5871625756257,
        "y": 186.0793966660203,
        "z": 0
      },
      {
        "x": 333.0426270586908,
        "y": 221.5472396006844,
        "z": 0
      }
    ],
    "handle": "2CB6",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 297.5887854006138,
        "y": 176.78129438217,
        "z": 0
      },
      {
        "x": 333.0442498837371,
        "y": 212.2491373177582,
        "z": 0
      }
    ],
    "handle": "2CB7",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 297.5904082256601,
        "y": 167.4831921011209,
        "z": 0
      },
      {
        "x": 333.045872708666,
        "y": 202.9510350357741,
        "z": 0
      }
    ],
    "handle": "2CB8",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 297.5920310506489,
        "y": 158.1850898182056,
        "z": 0
      },
      {
        "x": 333.0474955337706,
        "y": 193.6529327547141,
        "z": 0
      }
    ],
    "handle": "2CB9",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 297.593653875693,
        "y": 148.8869875371491,
        "z": 0
      },
      {
        "x": 333.0491183587578,
        "y": 184.3548304727192,
        "z": 0
      }
    ],
    "handle": "2CBA",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 300.1686676187668,
        "y": 142.163174612444,
        "z": 0
      },
      {
        "x": 333.0507411838049,
        "y": 175.0567281907433,
        "z": 0
      }
    ],
    "handle": "2CBB",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 309.4667699009291,
        "y": 142.1647974364423,
        "z": 0
      },
      {
        "x": 333.0523640086759,
        "y": 165.7586259078198,
        "z": 0
      }
    ],
    "handle": "2CBC",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 318.7648721828599,
        "y": 142.1664202632336,
        "z": 0
      },
      {
        "x": 333.0539868337798,
        "y": 156.4605236258321,
        "z": 0
      }
    ],
    "handle": "2CBD",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 328.0629744647879,
        "y": 142.1680430881606,
        "z": 0
      },
      {
        "x": 333.0556096588258,
        "y": 147.1624213438444,
        "z": 0
      }
    ],
    "handle": "2CBE",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 303.188913598656,
        "y": 145.1844750400587,
        "z": 0
      },
      {
        "x": 297.5933238121221,
        "y": 150.7781119402389,
        "z": 0
      }
    ],
    "handle": "2CBF",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 315.5083163091906,
        "y": 142.1658518863842,
        "z": 0
      },
      {
        "x": 305.5122220503979,
        "y": 152.1584574598845,
        "z": 0
      }
    ],
    "handle": "2CC0",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 298.5374282201518,
        "y": 159.1308170510419,
        "z": 0
      },
      {
        "x": 297.5917009871912,
        "y": 160.0762142203712,
        "z": 0
      }
    ],
    "handle": "2CC1",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 324.8064185911787,
        "y": 142.1674747113102,
        "z": 0
      },
      {
        "x": 319.4601868859039,
        "y": 147.5118405539515,
        "z": 0
      }
    ],
    "handle": "2CC2",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 312.4853930556568,
        "y": 154.4842001479128,
        "z": 0
      },
      {
        "x": 300.8607366719517,
        "y": 166.1047994699329,
        "z": 0
      }
    ],
    "handle": "2CC3",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 326.4333578911611,
        "y": 149.8375832447818,
        "z": 0
      },
      {
        "x": 314.8087015074559,
        "y": 161.4581825649329,
        "z": 0
      }
    ],
    "handle": "2CC4",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 307.8339076771527,
        "y": 168.4305421588942,
        "z": 0
      },
      {
        "x": 297.5884553371577,
        "y": 178.6724187862119,
        "z": 0
      }
    ],
    "handle": "2CC5",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 333.0546754477536,
        "y": 152.515056584034,
        "z": 0
      },
      {
        "x": 328.7566663427873,
        "y": 156.8115656618038,
        "z": 0
      }
    ],
    "handle": "2CC6",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 321.7818725125968,
        "y": 163.7839252548219,
        "z": 0
      },
      {
        "x": 310.1572161288938,
        "y": 175.4045245759071,
        "z": 0
      }
    ],
    "handle": "2CC7",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 303.1824222987038,
        "y": 182.3768841680103,
        "z": 0
      },
      {
        "x": 297.5868325121121,
        "y": 187.9705210663342,
        "z": 0
      }
    ],
    "handle": "2CC8",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 333.0530526227068,
        "y": 161.8131588660098,
        "z": 0
      },
      {
        "x": 324.105180964456,
        "y": 170.7579076718501,
        "z": 0
      }
    ],
    "handle": "2CC9",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 317.1303871340932,
        "y": 177.7302672658124,
        "z": 0
      },
      {
        "x": 305.5057307503889,
        "y": 189.3508665878335,
        "z": 0
      }
    ],
    "handle": "2CCA",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 298.5309369201408,
        "y": 196.323226178989,
        "z": 0
      },
      {
        "x": 297.5852096870079,
        "y": 197.2686233492522,
        "z": 0
      }
    ],
    "handle": "2CCB",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 331.0783519695402,
        "y": 173.0836503626697,
        "z": 0
      },
      {
        "x": 319.453695585834,
        "y": 184.7042496828335,
        "z": 0
      }
    ],
    "handle": "2CCC",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 312.4789017555888,
        "y": 191.6766092749312,
        "z": 0
      },
      {
        "x": 300.8542453719987,
        "y": 203.2972085978845,
        "z": 0
      }
    ],
    "handle": "2CCD",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 326.4268665910917,
        "y": 187.0299923727215,
        "z": 0
      },
      {
        "x": 314.8022102073878,
        "y": 198.6505916947535,
        "z": 0
      }
    ],
    "handle": "2CCE",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 307.8274163770839,
        "y": 205.6229512859108,
        "z": 0
      },
      {
        "x": 297.581964037149,
        "y": 215.8648279141598,
        "z": 0
      }
    ],
    "handle": "2CCF",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 333.0481841476876,
        "y": 189.7074657129124,
        "z": 0
      },
      {
        "x": 328.7501750427769,
        "y": 194.0039747897535,
        "z": 0
      }
    ],
    "handle": "2CD0",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 321.7753812125882,
        "y": 200.9763343837112,
        "z": 0
      },
      {
        "x": 310.1507248289421,
        "y": 212.5969337048018,
        "z": 0
      }
    ],
    "handle": "2CD1",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 303.1759309986961,
        "y": 219.5692932959646,
        "z": 0
      },
      {
        "x": 297.5803412121028,
        "y": 225.1629301952198,
        "z": 0
      }
    ],
    "handle": "2CD2",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 333.0465613227581,
        "y": 199.0055679930347,
        "z": 0
      },
      {
        "x": 324.0986896643302,
        "y": 207.9503167998018,
        "z": 0
      }
    ],
    "handle": "2CD3",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 317.1238958340828,
        "y": 214.9226763928355,
        "z": 0
      },
      {
        "x": 305.499239450378,
        "y": 226.5432757148484,
        "z": 0
      }
    ],
    "handle": "2CD4",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 298.524445620075,
        "y": 233.515635307871,
        "z": 0
      },
      {
        "x": 297.5787183870572,
        "y": 234.4610324772048,
        "z": 0
      }
    ],
    "handle": "2CD5",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 331.07186066953,
        "y": 210.2760594906212,
        "z": 0
      },
      {
        "x": 319.4472042857668,
        "y": 221.8966588107833,
        "z": 0
      }
    ],
    "handle": "2CD6",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 312.4724104555791,
        "y": 228.8690184028828,
        "z": 0
      },
      {
        "x": 300.847754071932,
        "y": 240.4896177239716,
        "z": 0
      }
    ],
    "handle": "2CD7",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 326.420375291083,
        "y": 224.2224015006677,
        "z": 0
      },
      {
        "x": 314.7957189073778,
        "y": 235.8430008217692,
        "z": 0
      }
    ],
    "handle": "2CD8",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 307.8209250770725,
        "y": 242.815360414791,
        "z": 0
      },
      {
        "x": 297.6383788139791,
        "y": 252.994352918111,
        "z": 0
      }
    ],
    "handle": "2CD9",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 333.0416928476187,
        "y": 226.8998748399317,
        "z": 0
      },
      {
        "x": 328.7436837428248,
        "y": 231.1963839177015,
        "z": 0
      }
    ],
    "handle": "2CDA",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 321.768889912579,
        "y": 238.168743511661,
        "z": 0
      },
      {
        "x": 310.1442335288731,
        "y": 249.7893428308853,
        "z": 0
      }
    ],
    "handle": "2CDB",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 333.0400700225716,
        "y": 236.1979771209799,
        "z": 0
      },
      {
        "x": 324.0921983642618,
        "y": 245.1427259277516,
        "z": 0
      }
    ],
    "handle": "2CDC",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 317.1174045340738,
        "y": 252.1150855198475,
        "z": 0
      },
      {
        "x": 316.2345833778389,
        "y": 252.9975985679703,
        "z": 0
      }
    ],
    "handle": "2CDD",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 331.0653693695191,
        "y": 247.4684686176442,
        "z": 0
      },
      {
        "x": 325.5326856598252,
        "y": 252.999221392899,
        "z": 0
      }
    ],
    "handle": "2CDE",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 85.28919370134678,
        "y": 248.5147657915913,
        "z": 0
      },
      {
        "x": 87.11710391816405,
        "y": 250.3433141801542,
        "z": 0
      }
    ],
    "handle": "2CDF",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 85.29081652633488,
        "y": 239.2166635096,
        "z": 0
      },
      {
        "x": 96.41520620009304,
        "y": 250.344937005083,
        "z": 0
      }
    ],
    "handle": "2CE0",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 85.29243935144083,
        "y": 229.9185612285519,
        "z": 0
      },
      {
        "x": 105.7133084820807,
        "y": 250.3465598309449,
        "z": 0
      }
    ],
    "handle": "2CE1",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 85.29406217631094,
        "y": 220.620458945632,
        "z": 0
      },
      {
        "x": 115.011410763952,
        "y": 250.3481826549422,
        "z": 0
      }
    ],
    "handle": "2CE2",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 85.29568500129983,
        "y": 211.3223566636434,
        "z": 0
      },
      {
        "x": 120.7511494843637,
        "y": 246.7901996001528,
        "z": 0
      }
    ],
    "handle": "2CE3",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 85.2973078263459,
        "y": 202.0242543816521,
        "z": 0
      },
      {
        "x": 120.7527723094678,
        "y": 237.4920973162989,
        "z": 0
      }
    ],
    "handle": "2CE4",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 85.29893065133297,
        "y": 192.726152099669,
        "z": 0
      },
      {
        "x": 120.754395134513,
        "y": 228.1939950361812,
        "z": 0
      }
    ],
    "handle": "2CE5",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 85.30055347643692,
        "y": 183.4280498176821,
        "z": 0
      },
      {
        "x": 120.7560179594429,
        "y": 218.8958927541889,
        "z": 0
      }
    ],
    "handle": "2CE6",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 85.30217630131003,
        "y": 174.1299475347623,
        "z": 0
      },
      {
        "x": 120.7576407843739,
        "y": 209.5977904722131,
        "z": 0
      }
    ],
    "handle": "2CE7",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 85.30379912635487,
        "y": 164.8318452546345,
        "z": 0
      },
      {
        "x": 120.7592636094187,
        "y": 200.2996881892832,
        "z": 0
      }
    ],
    "handle": "2CE8",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 85.30542195134387,
        "y": 155.5337429707833,
        "z": 0
      },
      {
        "x": 120.7608864344657,
        "y": 191.0015859082341,
        "z": 0
      }
    ],
    "handle": "2CE9",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 85.30704477638916,
        "y": 146.2356406897233,
        "z": 0
      },
      {
        "x": 120.7625092593958,
        "y": 181.7034836262426,
        "z": 0
      }
    ],
    "handle": "2CEA",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 87.88205854198894,
        "y": 139.5118277892434,
        "z": 0
      },
      {
        "x": 120.7641320844409,
        "y": 172.4053813451891,
        "z": 0
      }
    ],
    "handle": "2CEB",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 97.18016082397708,
        "y": 139.5134506132417,
        "z": 0
      },
      {
        "x": 120.7657549094861,
        "y": 163.1072790613434,
        "z": 0
      }
    ],
    "handle": "2CEC",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 106.4782631058472,
        "y": 139.5150734381713,
        "z": 0
      },
      {
        "x": 120.767377734533,
        "y": 153.8091767802843,
        "z": 0
      }
    ],
    "handle": "2CED",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 115.7763653878361,
        "y": 139.516696263101,
        "z": 0
      },
      {
        "x": 120.7690005595211,
        "y": 144.5110744982921,
        "z": 0
      }
    ],
    "handle": "2CEE",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 90.90230449940998,
        "y": 142.5331281945155,
        "z": 0
      },
      {
        "x": 85.30671471281698,
        "y": 148.1267650928357,
        "z": 0
      }
    ],
    "handle": "2CEF",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 103.2217071877088,
        "y": 139.5145050631836,
        "z": 0
      },
      {
        "x": 93.2256129512092,
        "y": 149.5071106124633,
        "z": 0
      }
    ],
    "handle": "2CF0",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 86.25081912090593,
        "y": 156.4794702045509,
        "z": 0
      },
      {
        "x": 85.30509188794485,
        "y": 157.4248673738912,
        "z": 0
      }
    ],
    "handle": "2CF1",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 112.5198094695807,
        "y": 139.5161278881132,
        "z": 0
      },
      {
        "x": 107.1735777865968,
        "y": 144.8604937074697,
        "z": 0
      }
    ],
    "handle": "2CF2",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 100.1987839564667,
        "y": 151.8328533014209,
        "z": 0
      },
      {
        "x": 88.57412757264618,
        "y": 163.4534526225116,
        "z": 0
      }
    ],
    "handle": "2CF3",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 114.1467487918551,
        "y": 147.1862363982918,
        "z": 0
      },
      {
        "x": 102.5220924080919,
        "y": 158.8068357203119,
        "z": 0
      }
    ],
    "handle": "2CF4",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 95.54729857784695,
        "y": 165.7791953114902,
        "z": 0
      },
      {
        "x": 85.30184623779405,
        "y": 176.0210719387896,
        "z": 0
      }
    ],
    "handle": "2CF5",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 120.7680663483929,
        "y": 149.8637097366108,
        "z": 0
      },
      {
        "x": 116.4700572435978,
        "y": 154.1602188171864,
        "z": 0
      }
    ],
    "handle": "2CF6",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 109.4952634132919,
        "y": 161.1325784092696,
        "z": 0
      },
      {
        "x": 97.87060702964595,
        "y": 172.7531777303629,
        "z": 0
      }
    ],
    "handle": "2CF7",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 90.89581319945795,
        "y": 179.7255373224615,
        "z": 0
      },
      {
        "x": 85.3002234129242,
        "y": 185.3191742198505,
        "z": 0
      }
    ],
    "handle": "2CF8",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 120.766443523403,
        "y": 159.1618120195307,
        "z": 0
      },
      {
        "x": 111.8185718650929,
        "y": 168.1065608253629,
        "z": 0
      }
    ],
    "handle": "2CF9",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 104.8437780347879,
        "y": 175.0789204193206,
        "z": 0
      },
      {
        "x": 93.21912165114179,
        "y": 186.6995197413453,
        "z": 0
      }
    ],
    "handle": "2CFA",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 86.24432782089593,
        "y": 193.6718793325135,
        "z": 0
      },
      {
        "x": 85.29860058787823,
        "y": 194.6172765018409,
        "z": 0
      }
    ],
    "handle": "2CFB",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 118.7917428702339,
        "y": 170.4323035161933,
        "z": 0
      },
      {
        "x": 107.1670864865888,
        "y": 182.0529028363526,
        "z": 0
      }
    ],
    "handle": "2CFC",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 100.1922926564008,
        "y": 189.025262430302,
        "z": 0
      },
      {
        "x": 88.5676362727528,
        "y": 200.6458617513935,
        "z": 0
      }
    ],
    "handle": "2CFD",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 114.1402574918467,
        "y": 184.3786455262416,
        "z": 0
      },
      {
        "x": 102.515601108083,
        "y": 195.9992448464027,
        "z": 0
      }
    ],
    "handle": "2CFE",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 95.54080727777875,
        "y": 202.9716044394335,
        "z": 0
      },
      {
        "x": 85.29535493778396,
        "y": 213.2134810667458,
        "z": 0
      }
    ],
    "handle": "2CFF",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 120.761575048439,
        "y": 187.0561188654928,
        "z": 0
      },
      {
        "x": 116.4635659435288,
        "y": 191.3526279432635,
        "z": 0
      }
    ],
    "handle": "2D00",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 109.4887721132837,
        "y": 198.3249875362899,
        "z": 0
      },
      {
        "x": 97.86411572952093,
        "y": 209.94558685831,
        "z": 0
      }
    ],
    "handle": "2D01",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 90.88932189938976,
        "y": 216.9179464504123,
        "z": 0
      },
      {
        "x": 85.29373211285474,
        "y": 222.5115833478048,
        "z": 0
      }
    ],
    "handle": "2D02",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 120.7599522233928,
        "y": 196.3542211456224,
        "z": 0
      },
      {
        "x": 111.8120805650247,
        "y": 205.2989699533209,
        "z": 0
      }
    ],
    "handle": "2D03",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 104.8372867348378,
        "y": 212.2713295463436,
        "z": 0
      },
      {
        "x": 93.2126303511908,
        "y": 223.8919288693032,
        "z": 0
      }
    ],
    "handle": "2D04",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 86.23783652082761,
        "y": 230.86428846139,
        "z": 0
      },
      {
        "x": 85.29210928780992,
        "y": 231.8096856297925,
        "z": 0
      }
    ],
    "handle": "2D05",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 118.785251570342,
        "y": 207.6247126441412,
        "z": 0
      },
      {
        "x": 107.1605951865189,
        "y": 219.2453119643033,
        "z": 0
      }
    ],
    "handle": "2D06",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 100.1858013563908,
        "y": 226.2176715582637,
        "z": 0
      },
      {
        "x": 88.5611449726848,
        "y": 237.8382708793506,
        "z": 0
      }
    ],
    "handle": "2D07",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 114.1337661917778,
        "y": 221.5710546541923,
        "z": 0
      },
      {
        "x": 102.5091098080158,
        "y": 233.1916539752938,
        "z": 0
      }
    ],
    "handle": "2D08",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 95.53431597776896,
        "y": 240.1640135683119,
        "z": 0
      },
      {
        "x": 85.35176971467308,
        "y": 250.3430060734936,
        "z": 0
      }
    ],
    "handle": "2D09",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 120.7550837483737,
        "y": 224.2485279943721,
        "z": 0
      },
      {
        "x": 116.4570746435781,
        "y": 228.5450370712197,
        "z": 0
      }
    ],
    "handle": "2D0A",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 109.4822808132737,
        "y": 235.517396665171,
        "z": 0
      },
      {
        "x": 97.85762442951123,
        "y": 247.1379959862616,
        "z": 0
      }
    ],
    "handle": "2D0B",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 120.7534609234427,
        "y": 233.5466302745044,
        "z": 0
      },
      {
        "x": 111.805589265073,
        "y": 242.4913790812716,
        "z": 0
      }
    ],
    "handle": "2D0C",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 104.8307954348268,
        "y": 249.463738675222,
        "z": 0
      },
      {
        "x": 103.9479742785917,
        "y": 250.3462517205617,
        "z": 0
      }
    ],
    "handle": "2D0D",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 118.7787602702732,
        "y": 244.8171217711643,
        "z": 0
      },
      {
        "x": 113.2460765605198,
        "y": 250.3478745464236,
        "z": 0
      }
    ],
    "handle": "2D0E",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 85.2888746151009,
        "y": 250.3429950941309,
        "z": 0
      },
      {
        "x": 120.7505283243949,
        "y": 250.3491843212396,
        "z": 0
      }
    ],
    "handle": "2D0F",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 120.7505283243949,
        "y": 250.3491843212396,
        "z": 0
      },
      {
        "x": 120.7698720907799,
        "y": 139.51756779477,
        "z": 0
      }
    ],
    "handle": "2D10",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 120.7698720907799,
        "y": 139.51756779477,
        "z": 0
      },
      {
        "x": 85.30821838148391,
        "y": 139.5113785667345,
        "z": 0
      }
    ],
    "handle": "2D11",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 85.30821838148391,
        "y": 139.5113785667345,
        "z": 0
      },
      {
        "x": 85.2888746151009,
        "y": 250.3429950941309,
        "z": 0
      }
    ],
    "handle": "2D12",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 75.10313528717893,
        "y": 249.9642983013691,
        "z": 0
      },
      {
        "x": 85.28894039988404,
        "y": 249.9660760592597,
        "z": 0
      }
    ],
    "handle": "2D13",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 85.28894039988404,
        "y": 249.9660760592597,
        "z": 0
      },
      {
        "x": 85.30821838148391,
        "y": 139.5113785667345,
        "z": 0
      }
    ],
    "handle": "2D14",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 85.30821838148391,
        "y": 139.5113785667345,
        "z": 0
      },
      {
        "x": 75.12241326889477,
        "y": 139.5096008097707,
        "z": 0
      }
    ],
    "handle": "2D15",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 75.12241326889477,
        "y": 139.5096008097707,
        "z": 0
      },
      {
        "x": 75.10313528717893,
        "y": 249.9642983013691,
        "z": 0
      }
    ],
    "handle": "2D16",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 523.3918268480912,
        "y": 247.1977899949925,
        "z": 0
      },
      {
        "x": 525.2197370899364,
        "y": 249.0263384096361,
        "z": 0
      }
    ],
    "handle": "2D17",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 523.3934496730803,
        "y": 237.8996877130085,
        "z": 0
      },
      {
        "x": 534.5178393720414,
        "y": 249.0279612345621,
        "z": 0
      }
    ],
    "handle": "2D18",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 523.3950724980092,
        "y": 228.6015854319557,
        "z": 0
      },
      {
        "x": 543.8159416538543,
        "y": 249.0295840604203,
        "z": 0
      }
    ],
    "handle": "2D19",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 523.3966953230555,
        "y": 219.3034831490331,
        "z": 0
      },
      {
        "x": 553.1140439359585,
        "y": 249.0312068844215,
        "z": 0
      }
    ],
    "handle": "2D1A",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 523.3983181481013,
        "y": 210.0053808679695,
        "z": 0
      },
      {
        "x": 558.8537826311652,
        "y": 245.4732238026345,
        "z": 0
      }
    ],
    "handle": "2D1B",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 523.3999409730304,
        "y": 200.7072785850614,
        "z": 0
      },
      {
        "x": 558.8554054562123,
        "y": 236.17512152157,
        "z": 0
      }
    ],
    "handle": "2D1C",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 523.4015637980762,
        "y": 191.4091763049336,
        "z": 0
      },
      {
        "x": 558.8570282812574,
        "y": 226.8770192395886,
        "z": 0
      }
    ],
    "handle": "2D1D",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 523.4031866230061,
        "y": 182.1110740220138,
        "z": 0
      },
      {
        "x": 558.8586511062452,
        "y": 217.5789169576019,
        "z": 0
      }
    ],
    "handle": "2D1E",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 523.4048094481694,
        "y": 172.8129717390911,
        "z": 0
      },
      {
        "x": 558.8602739311762,
        "y": 208.2808146756115,
        "z": 0
      }
    ],
    "handle": "2D1F",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 523.4064322731003,
        "y": 163.514869458042,
        "z": 0
      },
      {
        "x": 558.8618967562211,
        "y": 198.9827123917612,
        "z": 0
      }
    ],
    "handle": "2D20",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 523.4080550981452,
        "y": 154.2167671760517,
        "z": 0
      },
      {
        "x": 558.8635195812094,
        "y": 189.6846101116316,
        "z": 0
      }
    ],
    "handle": "2D21",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 523.4096779231315,
        "y": 144.9186648940631,
        "z": 0
      },
      {
        "x": 558.8651424062564,
        "y": 180.3865078296521,
        "z": 0
      }
    ],
    "handle": "2D22",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 525.9846916914693,
        "y": 138.1948519954421,
        "z": 0
      },
      {
        "x": 558.8667652311264,
        "y": 171.0884055485985,
        "z": 0
      }
    ],
    "handle": "2D23",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 535.2827939734551,
        "y": 138.1964748203718,
        "z": 0
      },
      {
        "x": 558.8683880562894,
        "y": 161.7903032647409,
        "z": 0
      }
    ],
    "handle": "2D24",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 544.5808962554433,
        "y": 138.1980976453042,
        "z": 0
      },
      {
        "x": 558.8700108812775,
        "y": 152.4922009846204,
        "z": 0
      }
    ],
    "handle": "2D25",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 553.8789985374314,
        "y": 138.1997204702356,
        "z": 0
      },
      {
        "x": 558.8716337062643,
        "y": 143.1940987016905,
        "z": 0
      }
    ],
    "handle": "2D26",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 529.0049376488885,
        "y": 141.216152401641,
        "z": 0
      },
      {
        "x": 523.4093478597355,
        "y": 146.809789301823,
        "z": 0
      }
    ],
    "handle": "2D27",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 541.3243403371893,
        "y": 138.1975292703146,
        "z": 0
      },
      {
        "x": 531.3282461008054,
        "y": 148.1901348195906,
        "z": 0
      }
    ],
    "handle": "2D28",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 550.6224426191764,
        "y": 138.1991520933843,
        "z": 0
      },
      {
        "x": 545.2762109361342,
        "y": 143.5435179164587,
        "z": 0
      }
    ],
    "handle": "2D2A",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 538.3014171058894,
        "y": 150.5158775076196,
        "z": 0
      },
      {
        "x": 526.6767607221843,
        "y": 162.1364768296444,
        "z": 0
      }
    ],
    "handle": "2D2B",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 552.2493819413944,
        "y": 145.869260605421,
        "z": 0
      },
      {
        "x": 540.6247255576884,
        "y": 157.4898599274411,
        "z": 0
      }
    ],
    "handle": "2D2C",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 533.6499317274435,
        "y": 164.4622195176807,
        "z": 0
      },
      {
        "x": 523.4044793845964,
        "y": 174.704096146851,
        "z": 0
      }
    ],
    "handle": "2D2D",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 558.8706994951945,
        "y": 148.5467339456008,
        "z": 0
      },
      {
        "x": 554.5726903931933,
        "y": 152.8432430233688,
        "z": 0
      }
    ],
    "handle": "2D2E",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 547.5978965628883,
        "y": 159.8156026145396,
        "z": 0
      },
      {
        "x": 535.9732401792435,
        "y": 171.4362019365653,
        "z": 0
      }
    ],
    "handle": "2D2F",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 528.9984463489373,
        "y": 178.4085615295917,
        "z": 0
      },
      {
        "x": 523.4028565597253,
        "y": 184.0021984297709,
        "z": 0
      }
    ],
    "handle": "2D30",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 558.8690766701473,
        "y": 157.8448362275921,
        "z": 0
      },
      {
        "x": 549.9212050145144,
        "y": 166.7895850325003,
        "z": 0
      }
    ],
    "handle": "2D31",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 542.9464111843841,
        "y": 173.7619446255194,
        "z": 0
      },
      {
        "x": 531.3217548006213,
        "y": 185.3825439475404,
        "z": 0
      }
    ],
    "handle": "2D32",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 556.8943760198883,
        "y": 169.1153277233197,
        "z": 0
      },
      {
        "x": 545.2697196361834,
        "y": 180.7359270444094,
        "z": 0
      }
    ],
    "handle": "2D34",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 538.2949258058803,
        "y": 187.708286635574,
        "z": 0
      },
      {
        "x": 526.6702694221743,
        "y": 199.3288859566601,
        "z": 0
      }
    ],
    "handle": "2D35",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 552.2428906412085,
        "y": 183.0616697333716,
        "z": 0
      },
      {
        "x": 540.6182342576792,
        "y": 194.6822690526031,
        "z": 0
      }
    ],
    "handle": "2D36",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 533.6434404273753,
        "y": 201.6546286474804,
        "z": 0
      },
      {
        "x": 523.3979880845875,
        "y": 211.896505275733,
        "z": 0
      }
    ],
    "handle": "2D37",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 558.8642081950665,
        "y": 185.7391430744927,
        "z": 0
      },
      {
        "x": 554.5661990931253,
        "y": 190.0356521494585,
        "z": 0
      }
    ],
    "handle": "2D38",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 547.5914052628793,
        "y": 197.0080117424912,
        "z": 0
      },
      {
        "x": 535.9667488791732,
        "y": 208.6286110645124,
        "z": 0
      }
    ],
    "handle": "2D39",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 528.9919550489294,
        "y": 215.6009706566101,
        "z": 0
      },
      {
        "x": 523.3963652595985,
        "y": 221.1946075577216,
        "z": 0
      }
    ],
    "handle": "2D3A",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 558.8625853700794,
        "y": 195.0372453564705,
        "z": 0
      },
      {
        "x": 549.9147137146202,
        "y": 203.9819941604401,
        "z": 0
      }
    ],
    "handle": "2D3B",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 542.9399198844322,
        "y": 210.9543537525378,
        "z": 0
      },
      {
        "x": 531.3152635006693,
        "y": 222.5749530745634,
        "z": 0
      }
    ],
    "handle": "2D3C",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 524.3404696704232,
        "y": 229.547312666662,
        "z": 0
      },
      {
        "x": 523.3947424346113,
        "y": 230.4927098387852,
        "z": 0
      }
    ],
    "handle": "2D3D",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 556.8878847198791,
        "y": 206.3077368503436,
        "z": 0
      },
      {
        "x": 545.2632283361745,
        "y": 217.9283361705047,
        "z": 0
      }
    ],
    "handle": "2D3E",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 538.2884345059285,
        "y": 224.9006957644587,
        "z": 0
      },
      {
        "x": 526.6637781221643,
        "y": 236.5212950855412,
        "z": 0
      }
    ],
    "handle": "2D3F",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 552.2363993412584,
        "y": 220.254078860391,
        "z": 0
      },
      {
        "x": 540.6117429576116,
        "y": 231.8746781814843,
        "z": 0
      }
    ],
    "handle": "2D40",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 533.6369491274233,
        "y": 238.847037775442,
        "z": 0
      },
      {
        "x": 523.4544028418603,
        "y": 249.0260303001823,
        "z": 0
      }
    ],
    "handle": "2D41",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 558.8577168950573,
        "y": 222.9315522024399,
        "z": 0
      },
      {
        "x": 554.5597077930574,
        "y": 227.2280612783516,
        "z": 0
      }
    ],
    "handle": "2D42",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 547.5849139628693,
        "y": 234.200420870442,
        "z": 0
      },
      {
        "x": 535.9602575791064,
        "y": 245.8210201924621,
        "z": 0
      }
    ],
    "handle": "2D43",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 558.856094070069,
        "y": 232.2296544844212,
        "z": 0
      },
      {
        "x": 549.9082224145523,
        "y": 241.1744032902607,
        "z": 0
      }
    ],
    "handle": "2D44",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 542.9334285842485,
        "y": 248.1467628814198,
        "z": 0
      },
      {
        "x": 542.0506074057773,
        "y": 249.0292759519007,
        "z": 0
      }
    ],
    "handle": "2D45",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 556.8813934198113,
        "y": 243.5001459773593,
        "z": 0
      },
      {
        "x": 551.3487096877643,
        "y": 249.0308987758981,
        "z": 0
      }
    ],
    "handle": "2D46",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 523.3915077618444,
        "y": 249.0260193217537,
        "z": 0
      },
      {
        "x": 558.8531614711962,
        "y": 249.0322085497892,
        "z": 0
      }
    ],
    "handle": "2D47",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 558.8531614711962,
        "y": 249.0322085497892,
        "z": 0
      },
      {
        "x": 558.8725052376394,
        "y": 138.2005920019,
        "z": 0
      }
    ],
    "handle": "2D48",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 558.8725052376394,
        "y": 138.2005920019,
        "z": 0
      },
      {
        "x": 523.4108515282273,
        "y": 138.1944027738635,
        "z": 0
      }
    ],
    "handle": "2D49",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 523.4108515282273,
        "y": 138.1944027738635,
        "z": 0
      },
      {
        "x": 523.3915077618444,
        "y": 249.0260193217537,
        "z": 0
      }
    ],
    "handle": "2D4A",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 503.4032703593841,
        "y": 213.2096175607185,
        "z": 0
      },
      {
        "x": 513.5890754720884,
        "y": 213.2113953195448,
        "z": 0
      }
    ],
    "handle": "2D4B",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 513.5890754720884,
        "y": 213.2113953195448,
        "z": 0
      },
      {
        "x": 513.6083534536883,
        "y": 102.7566978279492,
        "z": 0
      }
    ],
    "handle": "2D4C",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 513.6083534536883,
        "y": 102.7566978279492,
        "z": 0
      },
      {
        "x": 503.4225483409821,
        "y": 102.7549200691201,
        "z": 0
      }
    ],
    "handle": "2D4D",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 503.4225483409821,
        "y": 102.7549200691201,
        "z": 0
      },
      {
        "x": 503.4032703593841,
        "y": 213.2096175607185,
        "z": 0
      }
    ],
    "handle": "2D4E",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 513.9646273714022,
        "y": 223.3898588102338,
        "z": 0
      },
      {
        "x": 523.0186534639214,
        "y": 223.3914390364625,
        "z": 0
      }
    ],
    "handle": "2D4F",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 523.0186534639214,
        "y": 223.3914390364625,
        "z": 0
      },
      {
        "x": 523.0458926586444,
        "y": 67.3223508987503,
        "z": 0
      }
    ],
    "handle": "2D50",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 523.0458926586444,
        "y": 67.3223508987503,
        "z": 0
      },
      {
        "x": 513.9918665661245,
        "y": 67.32077067438239,
        "z": 0
      }
    ],
    "handle": "2D51",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 513.9918665661245,
        "y": 67.32077067438239,
        "z": 0
      },
      {
        "x": 513.9646273714022,
        "y": 223.3898588102338,
        "z": 0
      }
    ],
    "handle": "2D52",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 362.3085426262122,
        "y": 101.8372256131852,
        "z": 0
      },
      {
        "x": 367.151726503391,
        "y": 101.8380709094917,
        "z": 0
      }
    ],
    "handle": "2D53",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 367.151726503391,
        "y": 101.8380709094917,
        "z": 0
      },
      {
        "x": 367.151261549559,
        "y": 104.5020603770435,
        "z": 0
      }
    ],
    "handle": "2D54",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 367.151261549559,
        "y": 104.5020603770435,
        "z": 0
      },
      {
        "x": 362.3080776722642,
        "y": 104.5012150807342,
        "z": 0
      }
    ],
    "handle": "2D55",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 362.3080776722642,
        "y": 104.5012150807342,
        "z": 0
      },
      {
        "x": 362.3085426262122,
        "y": 101.8372256131852,
        "z": 0
      }
    ],
    "handle": "2D56",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 446.3192890419151,
        "y": 101.8518882542848,
        "z": 0
      },
      {
        "x": 451.1624729217727,
        "y": 101.8527335487306,
        "z": 0
      }
    ],
    "handle": "2D85",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 451.1624729217727,
        "y": 101.8527335487306,
        "z": 0
      },
      {
        "x": 451.1620079679418,
        "y": 104.5167230200013,
        "z": 0
      }
    ],
    "handle": "2D86",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 451.1620079679418,
        "y": 104.5167230200013,
        "z": 0
      },
      {
        "x": 446.318824088084,
        "y": 104.5158777218303,
        "z": 0
      }
    ],
    "handle": "2D87",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 446.318824088084,
        "y": 104.5158777218303,
        "z": 0
      },
      {
        "x": 446.3192890419151,
        "y": 101.8518882542848,
        "z": 0
      }
    ],
    "handle": "2D88",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 393.2205099539141,
        "y": 101.842620769512,
        "z": 0
      },
      {
        "x": 398.0636938312092,
        "y": 101.8434660648927,
        "z": 0
      }
    ],
    "handle": "2DB7",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 398.0636938312092,
        "y": 101.8434660648927,
        "z": 0
      },
      {
        "x": 398.063228877145,
        "y": 104.5074555333703,
        "z": 0
      }
    ],
    "handle": "2DB8",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 398.063228877145,
        "y": 104.5074555333703,
        "z": 0
      },
      {
        "x": 393.220045000082,
        "y": 104.5066102379933,
        "z": 0
      }
    ],
    "handle": "2DB9",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 393.220045000082,
        "y": 104.5066102379933,
        "z": 0
      },
      {
        "x": 393.2205099539141,
        "y": 101.842620769512,
        "z": 0
      }
    ],
    "handle": "2DBA",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 421.6395747722118,
        "y": 101.8475808333605,
        "z": 0
      },
      {
        "x": 426.4827586521858,
        "y": 101.8484261268713,
        "z": 0
      }
    ],
    "handle": "2DCB",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 426.4827586521858,
        "y": 101.8484261268713,
        "z": 0
      },
      {
        "x": 426.482293698237,
        "y": 104.5124155953517,
        "z": 0
      }
    ],
    "handle": "2DCC",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 426.482293698237,
        "y": 104.5124155953517,
        "z": 0
      },
      {
        "x": 421.6391098183225,
        "y": 104.5115702999719,
        "z": 0
      }
    ],
    "handle": "2DCD",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 421.6391098183225,
        "y": 104.5115702999719,
        "z": 0
      },
      {
        "x": 421.6395747722118,
        "y": 101.8475808333605,
        "z": 0
      }
    ],
    "handle": "2DCE",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 335.1359322700298,
        "y": 101.8324830969686,
        "z": 0
      },
      {
        "x": 339.9791161498299,
        "y": 101.8333283932806,
        "z": 0
      }
    ],
    "handle": "2DCF",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 339.9791161498299,
        "y": 101.8333283932806,
        "z": 0
      },
      {
        "x": 339.9786511959969,
        "y": 104.4973178608306,
        "z": 0
      }
    ],
    "handle": "2DD0",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 339.9786511959969,
        "y": 104.4973178608306,
        "z": 0
      },
      {
        "x": 335.1354673161406,
        "y": 104.4964725663922,
        "z": 0
      }
    ],
    "handle": "2DD1",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 335.1354673161406,
        "y": 104.4964725663922,
        "z": 0
      },
      {
        "x": 335.1359322700298,
        "y": 101.8324830969686,
        "z": 0
      }
    ],
    "handle": "2DD2",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 363.16507873463,
        "y": 62.97513846494257,
        "z": 0
      },
      {
        "x": 447.7186206443589,
        "y": 62.98989584296942,
        "z": 0
      }
    ],
    "handle": "2DDD",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 447.7186206443589,
        "y": 62.98989584296942,
        "z": 0
      },
      {
        "x": 447.7165841155808,
        "y": 74.65834611188257,
        "z": 0
      }
    ],
    "handle": "2DDE",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 447.7165841155808,
        "y": 74.65834611188257,
        "z": 0
      },
      {
        "x": 363.163042205852,
        "y": 74.64358873386298,
        "z": 0
      }
    ],
    "handle": "2DDF",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 363.163042205852,
        "y": 74.64358873386298,
        "z": 0
      },
      {
        "x": 363.16507873463,
        "y": 62.97513846494257,
        "z": 0
      }
    ],
    "handle": "2DE0",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 60.22214655519872,
        "y": 115.081084874454,
        "z": 0
      },
      {
        "x": 36.98183964076497,
        "y": 115.0770286740699,
        "z": 0
      }
    ],
    "handle": "2DE3",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 36.98183964076497,
        "y": 115.0770286740699,
        "z": 0
      },
      {
        "x": 36.98668838437789,
        "y": 87.2957744989508,
        "z": 0
      }
    ],
    "handle": "2DE4",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 36.98668838437789,
        "y": 87.2957744989508,
        "z": 0
      },
      {
        "x": 60.22699529881413,
        "y": 87.29983069747325,
        "z": 0
      }
    ],
    "handle": "2DE5",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 60.22699529881413,
        "y": 87.29983069747325,
        "z": 0
      },
      {
        "x": 60.22214655519872,
        "y": 115.081084874454,
        "z": 0
      }
    ],
    "handle": "2DE6",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 113.7586977532478,
        "y": 97.00252139009537,
        "z": 0
      },
      {
        "x": 115.3337064736979,
        "y": 97.00279628111822,
        "z": 0
      }
    ],
    "handle": "2E21",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 115.3337064736979,
        "y": 97.00279628111822,
        "z": 0
      },
      {
        "x": 115.3314078722619,
        "y": 110.1728121293599,
        "z": 0
      }
    ],
    "handle": "2E22",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 115.3314078722619,
        "y": 110.1728121293599,
        "z": 0
      },
      {
        "x": 113.7563991518678,
        "y": 110.1725372392584,
        "z": 0
      }
    ],
    "handle": "2E23",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 113.7563991518678,
        "y": 110.1725372392584,
        "z": 0
      },
      {
        "x": 113.7586977532478,
        "y": 97.00252139009537,
        "z": 0
      }
    ],
    "handle": "2E24",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 304.7225480150077,
        "y": 101.8271749597052,
        "z": 0
      },
      {
        "x": 309.5657318948649,
        "y": 101.828020256944,
        "z": 0
      }
    ],
    "handle": "2EE7",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 309.5657318948649,
        "y": 101.828020256944,
        "z": 0
      },
      {
        "x": 309.5652669410918,
        "y": 104.4920097244949,
        "z": 0
      }
    ],
    "handle": "2EE8",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 309.5652669410918,
        "y": 104.4920097244949,
        "z": 0
      },
      {
        "x": 304.7220830611192,
        "y": 104.4911644291132,
        "z": 0
      }
    ],
    "handle": "2EE9",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 304.7220830611192,
        "y": 104.4911644291132,
        "z": 0
      },
      {
        "x": 304.7225480150077,
        "y": 101.8271749597052,
        "z": 0
      }
    ],
    "handle": "2EEA",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 131.9184213118277,
        "y": 122.2302138553932,
        "z": 0
      },
      {
        "x": 256.2067769522549,
        "y": 122.2519062664323,
        "z": 0
      }
    ],
    "handle": "2F71",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 256.2061020439722,
        "y": 126.1188454478906,
        "z": 0
      },
      {
        "x": 131.9177464036028,
        "y": 126.0971530387105,
        "z": 0
      }
    ],
    "handle": "2F73",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 131.9177464036028,
        "y": 126.0971530387105,
        "z": 0
      },
      {
        "x": 131.9184213118277,
        "y": 122.2302138553932,
        "z": 0
      }
    ],
    "handle": "2F74",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 288.4421244577967,
        "y": 130.067968050942,
        "z": 0
      },
      {
        "x": 265.2018175433629,
        "y": 130.0639118524232,
        "z": 0
      }
    ],
    "handle": "2FED",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 265.2018175433629,
        "y": 130.0639118524232,
        "z": 0
      },
      {
        "x": 265.2066662869767,
        "y": 102.282657654021,
        "z": 0
      }
    ],
    "handle": "2FEE",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 265.2066662869767,
        "y": 102.282657654021,
        "z": 0
      },
      {
        "x": 288.4469732013528,
        "y": 102.2867138525398,
        "z": 0
      }
    ],
    "handle": "2FEF",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 288.4469732013528,
        "y": 102.2867138525398,
        "z": 0
      },
      {
        "x": 288.4421244577967,
        "y": 130.067968050942,
        "z": 0
      }
    ],
    "handle": "2FF0",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "ARC",
    "handle": "2FF3",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "center": {
      "x": 325.5669823088112,
      "y": 107.6346697406843,
      "z": 0
    },
    "radius": 0.0080890150666124,
    "startAngle": 3.141767186235127,
    "endAngle": 0.00017453264533675135,
    "angleLength": -3.1415926535897905
  },
  {
    "type": "ARC",
    "handle": "2FF4",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "center": {
      "x": 325.5669823088112,
      "y": 107.6346697406843,
      "z": 0
    },
    "radius": 0.0080890150666125,
    "startAngle": 0.00017453264533675135,
    "endAngle": 3.141767186235127,
    "angleLength": 3.1415926535897905
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 150.8784696353829,
        "y": 60.32379164174564,
        "z": 0
      },
      {
        "x": 235.4320115451697,
        "y": 60.33854901976154,
        "z": 0
      }
    ],
    "handle": "3005",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 235.4320115451697,
        "y": 60.33854901976154,
        "z": 0
      },
      {
        "x": 235.4299750162759,
        "y": 72.00699926540165,
        "z": 0
      }
    ],
    "handle": "3006",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 235.4299750162759,
        "y": 72.00699926540165,
        "z": 0
      },
      {
        "x": 150.8764331066046,
        "y": 71.99224188736935,
        "z": 0
      }
    ],
    "handle": "3007",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 150.8764331066046,
        "y": 71.99224188736935,
        "z": 0
      },
      {
        "x": 150.8784696353829,
        "y": 60.32379164174564,
        "z": 0
      }
    ],
    "handle": "3008",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 468.4887177896448,
        "y": 151.6504074372315,
        "z": 0
      },
      {
        "x": 485.4274118256868,
        "y": 151.6533637978127,
        "z": 0
      }
    ],
    "handle": "3009",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 485.4274118256868,
        "y": 151.6533637978127,
        "z": 0
      },
      {
        "x": 485.4385970034058,
        "y": 87.56701678315856,
        "z": 0
      }
    ],
    "handle": "300A",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 485.4385970034058,
        "y": 87.56701678315856,
        "z": 0
      },
      {
        "x": 468.4999029674799,
        "y": 87.56406042259458,
        "z": 0
      }
    ],
    "handle": "300B",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 468.4999029674799,
        "y": 87.56406042259458,
        "z": 0
      },
      {
        "x": 468.4887177896448,
        "y": 151.6504074372315,
        "z": 0
      }
    ],
    "handle": "300C",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 122.8423488780957,
        "y": 139.1408886108511,
        "z": 0
      },
      {
        "x": 131.9154695658948,
        "y": 139.1424721693619,
        "z": 0
      }
    ],
    "handle": "300D",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 131.9154695658948,
        "y": 139.1424721693619,
        "z": 0
      },
      {
        "x": 131.9244535594478,
        "y": 87.66798081062007,
        "z": 0
      }
    ],
    "handle": "300E",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 131.9244535594478,
        "y": 87.66798081062007,
        "z": 0
      },
      {
        "x": 122.8513328718829,
        "y": 87.66639725212005,
        "z": 0
      }
    ],
    "handle": "300F",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 122.8513328718829,
        "y": 87.66639725212005,
        "z": 0
      },
      {
        "x": 122.8423488780957,
        "y": 139.1408886108511,
        "z": 0
      }
    ],
    "handle": "3010",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 297.5948274808478,
        "y": 142.1627253927217,
        "z": 0
      },
      {
        "x": 468.4903684968011,
        "y": 142.1925522908495,
        "z": 0
      }
    ],
    "handle": "3011",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 468.4903684968011,
        "y": 142.1925522908495,
        "z": 0
      },
      {
        "x": 468.4987244823722,
        "y": 94.3162819948011,
        "z": 0
      }
    ],
    "handle": "3012",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 468.4987244823722,
        "y": 94.3162819948011,
        "z": 0
      },
      {
        "x": 297.6031834664746,
        "y": 94.28645509574196,
        "z": 0
      }
    ],
    "handle": "3013",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 297.6031834664746,
        "y": 94.28645509574196,
        "z": 0
      },
      {
        "x": 297.5948274808478,
        "y": 142.1627253927217,
        "z": 0
      }
    ],
    "handle": "3014",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 120.7592636094187,
        "y": 200.2996881864892,
        "z": 0
      },
      {
        "x": 122.831674590765,
        "y": 200.3000498898373,
        "z": 0
      }
    ],
    "handle": "3015",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 122.831674590765,
        "y": 200.3000498898373,
        "z": 0
      },
      {
        "x": 122.8497031337469,
        "y": 97.00410807131993,
        "z": 0
      }
    ],
    "handle": "3016",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 122.8497031337469,
        "y": 97.00410807131993,
        "z": 0
      },
      {
        "x": 120.7772921525758,
        "y": 97.00374636705236,
        "z": 0
      }
    ],
    "handle": "3017",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 120.7772921525758,
        "y": 97.00374636705236,
        "z": 0
      },
      {
        "x": 120.7592636094187,
        "y": 200.2996881864892,
        "z": 0
      }
    ],
    "handle": "3018",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 333.045872708666,
        "y": 202.9510350329829,
        "z": 0
      },
      {
        "x": 335.1182836900118,
        "y": 202.9513967363091,
        "z": 0
      }
    ],
    "handle": "3019",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 335.1182836900118,
        "y": 202.9513967363091,
        "z": 0
      },
      {
        "x": 335.1359322700298,
        "y": 101.8324830969686,
        "z": 0
      }
    ],
    "handle": "301A",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 335.1359322700298,
        "y": 101.8324830969686,
        "z": 0
      },
      {
        "x": 333.0635212887433,
        "y": 101.832121392712,
        "z": 0
      }
    ],
    "handle": "301B",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 333.0635212887433,
        "y": 101.832121392712,
        "z": 0
      },
      {
        "x": 333.045872708666,
        "y": 202.9510350329829,
        "z": 0
      }
    ],
    "handle": "301C",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 302.1232594723698,
        "y": 134.6239166203913,
        "z": 0
      },
      {
        "x": 468.491684405017,
        "y": 134.6529533881621,
        "z": 0
      }
    ],
    "handle": "301D",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 468.491684405017,
        "y": 134.6529533881621,
        "z": 0
      },
      {
        "x": 468.4974085954025,
        "y": 101.8557590674536,
        "z": 0
      }
    ],
    "handle": "301E",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 468.4974085954025,
        "y": 101.8557590674536,
        "z": 0
      },
      {
        "x": 302.1289836628128,
        "y": 101.8267222987424,
        "z": 0
      }
    ],
    "handle": "301F",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 302.1289836628128,
        "y": 101.8267222987424,
        "z": 0
      },
      {
        "x": 302.1232594723698,
        "y": 134.6239166203913,
        "z": 0
      }
    ],
    "handle": "3020",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 304.7168238246801,
        "y": 134.6243692832031,
        "z": 0
      },
      {
        "x": 309.5600077045377,
        "y": 134.6252145795105,
        "z": 0
      }
    ],
    "handle": "3021",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 309.5600077045377,
        "y": 134.6252145795105,
        "z": 0
      },
      {
        "x": 309.560472658486,
        "y": 131.9612251101025,
        "z": 0
      }
    ],
    "handle": "3022",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 309.560472658486,
        "y": 131.9612251101025,
        "z": 0
      },
      {
        "x": 304.7172887786299,
        "y": 131.9603798137905,
        "z": 0
      }
    ],
    "handle": "3023",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 304.7172887786299,
        "y": 131.9603798137905,
        "z": 0
      },
      {
        "x": 304.7168238246801,
        "y": 134.6243692832031,
        "z": 0
      }
    ],
    "handle": "3024",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 131.9154695658948,
        "y": 139.1424721693619,
        "z": 0
      },
      {
        "x": 256.2038252063209,
        "y": 139.1641645804011,
        "z": 0
      }
    ],
    "handle": "3057",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 256.2038252063209,
        "y": 139.1641645804011,
        "z": 0
      },
      {
        "x": 256.2073983856238,
        "y": 118.6913554947823,
        "z": 0
      }
    ],
    "handle": "3058",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 256.2073983856238,
        "y": 118.6913554947823,
        "z": 0
      },
      {
        "x": 131.9190427451391,
        "y": 118.66966308467,
        "z": 0
      }
    ],
    "handle": "3059",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 131.9190427451391,
        "y": 118.66966308467,
        "z": 0
      },
      {
        "x": 131.9154695658948,
        "y": 139.1424721693619,
        "z": 0
      }
    ],
    "handle": "305A",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 362.3028184358848,
        "y": 134.6344199338918,
        "z": 0
      },
      {
        "x": 367.146002312948,
        "y": 134.6352652311316,
        "z": 0
      }
    ],
    "handle": "305B",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 367.146002312948,
        "y": 134.6352652311316,
        "z": 0
      },
      {
        "x": 367.146467266838,
        "y": 131.9712757626512,
        "z": 0
      }
    ],
    "handle": "305C",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 367.146467266838,
        "y": 131.9712757626512,
        "z": 0
      },
      {
        "x": 362.3032833897752,
        "y": 131.9704304663419,
        "z": 0
      }
    ],
    "handle": "305D",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 362.3032833897752,
        "y": 131.9704304663419,
        "z": 0
      },
      {
        "x": 362.3028184358848,
        "y": 134.6344199338918,
        "z": 0
      }
    ],
    "handle": "305E",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 446.313564851646,
        "y": 134.6490825759101,
        "z": 0
      },
      {
        "x": 451.1567487316201,
        "y": 134.6499278722331,
        "z": 0
      }
    ],
    "handle": "305F",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 451.1567487316201,
        "y": 134.6499278722331,
        "z": 0
      },
      {
        "x": 451.1572136853938,
        "y": 131.9859384037509,
        "z": 0
      }
    ],
    "handle": "3060",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 451.1572136853938,
        "y": 131.9859384037509,
        "z": 0
      },
      {
        "x": 446.3140298055948,
        "y": 131.9850931093133,
        "z": 0
      }
    ],
    "handle": "3061",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 446.3140298055948,
        "y": 131.9850931093133,
        "z": 0
      },
      {
        "x": 446.313564851646,
        "y": 134.6490825759101,
        "z": 0
      }
    ],
    "handle": "3062",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 393.2147857635282,
        "y": 134.6398150920795,
        "z": 0
      },
      {
        "x": 398.0579696408239,
        "y": 134.6406603856012,
        "z": 0
      }
    ],
    "handle": "3063",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 398.0579696408239,
        "y": 134.6406603856012,
        "z": 0
      },
      {
        "x": 398.0584345945958,
        "y": 131.9766709180512,
        "z": 0
      }
    ],
    "handle": "3064",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 398.0584345945958,
        "y": 131.9766709180512,
        "z": 0
      },
      {
        "x": 393.2152507174748,
        "y": 131.9758256245332,
        "z": 0
      }
    ],
    "handle": "3065",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 393.2152507174748,
        "y": 131.9758256245332,
        "z": 0
      },
      {
        "x": 393.2147857635282,
        "y": 134.6398150920795,
        "z": 0
      }
    ],
    "handle": "3066",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 421.6338505819435,
        "y": 134.6447751531304,
        "z": 0
      },
      {
        "x": 426.4770344618579,
        "y": 134.6456204494461,
        "z": 0
      }
    ],
    "handle": "3067",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 426.4770344618579,
        "y": 134.6456204494461,
        "z": 0
      },
      {
        "x": 426.4774994156907,
        "y": 131.9816309800398,
        "z": 0
      }
    ],
    "handle": "3068",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 426.4774994156907,
        "y": 131.9816309800398,
        "z": 0
      },
      {
        "x": 421.6343155357738,
        "y": 131.9807856855923,
        "z": 0
      }
    ],
    "handle": "3069",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 421.6343155357738,
        "y": 131.9807856855923,
        "z": 0
      },
      {
        "x": 421.6338505819435,
        "y": 134.6447751531304,
        "z": 0
      }
    ],
    "handle": "306A",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 335.130208079703,
        "y": 134.6296774195498,
        "z": 0
      },
      {
        "x": 339.9733919595599,
        "y": 134.6305227149241,
        "z": 0
      }
    ],
    "handle": "306B",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 339.9733919595599,
        "y": 134.6305227149241,
        "z": 0
      },
      {
        "x": 339.9738569134509,
        "y": 131.9665332464501,
        "z": 0
      }
    ],
    "handle": "306C",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 339.9738569134509,
        "y": 131.9665332464501,
        "z": 0
      },
      {
        "x": 335.1306730335351,
        "y": 131.9656879510693,
        "z": 0
      }
    ],
    "handle": "306D",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 335.1306730335351,
        "y": 131.9656879510693,
        "z": 0
      },
      {
        "x": 335.130208079703,
        "y": 134.6296774195498,
        "z": 0
      }
    ],
    "handle": "306E",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 347.0530724804849,
        "y": 503.9583598226417,
        "z": 0
      },
      {
        "x": 347.0530724804849,
        "y": 503.9583598226417,
        "z": 0
      }
    ],
    "handle": "33F4",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 225.780283893633,
        "y": 502.1154795000401,
        "z": 0
      },
      {
        "x": 225.780283893633,
        "y": 502.1154795000401,
        "z": 0
      }
    ],
    "handle": "3C06",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 250.3341804688089,
        "y": 442.0610227752404,
        "z": 0
      },
      {
        "x": 251.0110602793867,
        "y": 442.8679827069816,
        "z": 0
      }
    ],
    "handle": "3D97",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 260.4071262649958,
        "y": 441.1815256960688,
        "z": 0
      },
      {
        "x": 261.0840060753977,
        "y": 441.9884856268727,
        "z": 0
      }
    ],
    "handle": "3D98",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 317.2650303448901,
        "y": 508.9661599481414,
        "z": 0
      },
      {
        "x": 317.553624891792,
        "y": 509.3102154694522,
        "z": 0
      }
    ],
    "handle": "3D99",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 270.4800720610068,
        "y": 440.3020286187536,
        "z": 0
      },
      {
        "x": 271.156951871585,
        "y": 441.1089885505034,
        "z": 0
      }
    ],
    "handle": "3D9A",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 327.3379761409611,
        "y": 508.086662869903,
        "z": 0
      },
      {
        "x": 328.0148559514198,
        "y": 508.8936228016435,
        "z": 0
      }
    ],
    "handle": "3D9B",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 280.5530178571346,
        "y": 439.4225315405056,
        "z": 0
      },
      {
        "x": 280.890402612044,
        "y": 439.8247535815433,
        "z": 0
      }
    ],
    "handle": "3D9C",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 321.6078738429339,
        "y": 488.3671495709531,
        "z": 0
      },
      {
        "x": 321.8426862962082,
        "y": 488.6470873653925,
        "z": 0
      }
    ],
    "handle": "3D9D",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 329.2883642113297,
        "y": 497.5236466126522,
        "z": 0
      },
      {
        "x": 329.9652440217331,
        "y": 498.3306065453178,
        "z": 0
      }
    ],
    "handle": "3D9E",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 290.721006687964,
        "y": 438.656342496164,
        "z": 0
      },
      {
        "x": 291.3028434636057,
        "y": 439.3499943939887,
        "z": 0
      }
    ],
    "handle": "3D9F",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 323.1161945561189,
        "y": 477.2771111782637,
        "z": 0
      },
      {
        "x": 323.7930743666367,
        "y": 478.0840711081337,
        "z": 0
      }
    ],
    "handle": "3DA0",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 300.6989094493899,
        "y": 437.6635373830722,
        "z": 0
      },
      {
        "x": 301.375789259793,
        "y": 438.4704973157531,
        "z": 0
      }
    ],
    "handle": "3DA1",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 325.066582626489,
        "y": 466.7140949200838,
        "z": 0
      },
      {
        "x": 325.7434624368332,
        "y": 467.521054852749,
        "z": 0
      }
    ],
    "handle": "3DA2",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 310.7718552454019,
        "y": 436.7840403066908,
        "z": 0
      },
      {
        "x": 311.4487350559798,
        "y": 437.5910002375021,
        "z": 0
      }
    ],
    "handle": "3DA3",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 327.0169706968578,
        "y": 456.1510786637581,
        "z": 0
      },
      {
        "x": 327.6938505073772,
        "y": 456.9580385955051,
        "z": 0
      }
    ],
    "handle": "3DA4",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 320.8448010415307,
        "y": 435.9045432303019,
        "z": 0
      },
      {
        "x": 321.5216808519318,
        "y": 436.7115031601823,
        "z": 0
      }
    ],
    "handle": "3DA5",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 328.9673587672877,
        "y": 445.5880624083828,
        "z": 0
      },
      {
        "x": 329.6442385777488,
        "y": 446.3950223391803,
        "z": 0
      }
    ],
    "handle": "3DA6",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 248.3837923984971,
        "y": 452.6240390315686,
        "z": 0
      },
      {
        "x": 249.0606722088988,
        "y": 453.4309989642351,
        "z": 0
      }
    ],
    "handle": "3DA7",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 246.4334043280113,
        "y": 463.1870552888092,
        "z": 0
      },
      {
        "x": 247.1102841385869,
        "y": 463.994015221484,
        "z": 0
      }
    ],
    "handle": "3DA8",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 279.2261741521647,
        "y": 502.2818116750502,
        "z": 0
      },
      {
        "x": 279.600515041325,
        "y": 502.7280919356189,
        "z": 0
      }
    ],
    "handle": "3DA9",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 244.48301625764,
        "y": 473.7500715451305,
        "z": 0
      },
      {
        "x": 245.1598960680998,
        "y": 474.5570314768701,
        "z": 0
      }
    ],
    "handle": "3DAA",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 268.8506894349119,
        "y": 502.8006290811998,
        "z": 0
      },
      {
        "x": 269.5275692451972,
        "y": 503.6075890129396,
        "z": 0
      }
    ],
    "handle": "3DAB",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 242.5326281872111,
        "y": 484.3130878023692,
        "z": 0
      },
      {
        "x": 243.2095079977301,
        "y": 485.1200477341108,
        "z": 0
      }
    ],
    "handle": "3DAC",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 258.7777436387262,
        "y": 503.680126159459,
        "z": 0
      },
      {
        "x": 259.4546234491282,
        "y": 504.4870860902592,
        "z": 0
      }
    ],
    "handle": "3DAD",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 248.7047978425388,
        "y": 504.5596232377028,
        "z": 0
      },
      {
        "x": 249.3816776530591,
        "y": 505.366583170361,
        "z": 0
      }
    ],
    "handle": "3DAE",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 244.4830166207399,
        "y": 473.7500722147522,
        "z": 0
      },
      {
        "x": 245.3224287705968,
        "y": 473.6767807938083,
        "z": 0
      }
    ],
    "handle": "3DAF",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 325.0665829924409,
        "y": 466.7140956148513,
        "z": 0
      },
      {
        "x": 325.9059951420638,
        "y": 466.6408041911081,
        "z": 0
      }
    ],
    "handle": "3DB0",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 242.5326285540932,
        "y": 484.3130884720058,
        "z": 0
      },
      {
        "x": 243.372040703835,
        "y": 484.2397970492019,
        "z": 0
      }
    ],
    "handle": "3DB1",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 323.1161949258527,
        "y": 477.2771118693015,
        "z": 0
      },
      {
        "x": 323.955607075476,
        "y": 477.2038204483606,
        "z": 0
      }
    ],
    "handle": "3DB2",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 321.607972563827,
        "y": 487.8015213999822,
        "z": 0
      },
      {
        "x": 322.005219008832,
        "y": 487.7668367028198,
        "z": 0
      }
    ],
    "handle": "3DB3",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 329.2883645890971,
        "y": 497.5236473064905,
        "z": 0
      },
      {
        "x": 330.0323443413948,
        "y": 497.4586883522531,
        "z": 0
      }
    ],
    "handle": "3DB4",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 248.7047982172797,
        "y": 504.5596239082524,
        "z": 0
      },
      {
        "x": 249.544210367138,
        "y": 504.4863324845136,
        "z": 0
      }
    ],
    "handle": "3DB5",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 258.7777440138159,
        "y": 503.6801268327936,
        "z": 0
      },
      {
        "x": 259.617156163557,
        "y": 503.6068354090629,
        "z": 0
      }
    ],
    "handle": "3DB6",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 268.8506898103508,
        "y": 502.8006297582731,
        "z": 0
      },
      {
        "x": 269.6901019599769,
        "y": 502.7273383345415,
        "z": 0
      }
    ],
    "handle": "3DB7",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 317.2650307259758,
        "y": 508.9661606382541,
        "z": 0
      },
      {
        "x": 318.1044428756577,
        "y": 508.8928692145244,
        "z": 0
      }
    ],
    "handle": "3DB8",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 327.3379765223948,
        "y": 508.0866635628043,
        "z": 0
      },
      {
        "x": 328.1773886722499,
        "y": 508.0133721381415,
        "z": 0
      }
    ],
    "handle": "3DB9",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 246.4334046873848,
        "y": 463.1870559612207,
        "z": 0
      },
      {
        "x": 247.2728168370089,
        "y": 463.1137645384331,
        "z": 0
      }
    ],
    "handle": "3DBA",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 327.016971058969,
        "y": 456.1510793594606,
        "z": 0
      },
      {
        "x": 327.8563832087681,
        "y": 456.0777879366614,
        "z": 0
      }
    ],
    "handle": "3DBB",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 248.3837927540301,
        "y": 452.6240397039692,
        "z": 0
      },
      {
        "x": 249.2232049037109,
        "y": 452.5507482830426,
        "z": 0
      }
    ],
    "handle": "3DBC",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 328.967359125614,
        "y": 445.5880631040626,
        "z": 0
      },
      {
        "x": 329.8067712753546,
        "y": 445.5147716803439,
        "z": 0
      }
    ],
    "handle": "3DBD",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 250.3341808206161,
        "y": 442.0610234495215,
        "z": 0
      },
      {
        "x": 251.1735929702403,
        "y": 441.98773202579,
        "z": 0
      }
    ],
    "handle": "3DBE",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 260.4071266170348,
        "y": 441.1815263731405,
        "z": 0
      },
      {
        "x": 261.2465387667759,
        "y": 441.1082349512688,
        "z": 0
      }
    ],
    "handle": "3DBF",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 270.4800724134537,
        "y": 440.3020292976823,
        "z": 0
      },
      {
        "x": 271.319484563312,
        "y": 440.2287378758225,
        "z": 0
      }
    ],
    "handle": "3DC0",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 280.553018209989,
        "y": 439.4225322231614,
        "z": 0
      },
      {
        "x": 280.8904779553999,
        "y": 439.3930676700509,
        "z": 0
      }
    ],
    "handle": "3DC1",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 290.7210279125721,
        "y": 438.5347348526118,
        "z": 0
      },
      {
        "x": 291.4653761561488,
        "y": 438.4697437258392,
        "z": 0
      }
    ],
    "handle": "3DC2",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 300.6989098029448,
        "y": 437.6635380750475,
        "z": 0
      },
      {
        "x": 301.5383219526837,
        "y": 437.5902466503903,
        "z": 0
      }
    ],
    "handle": "3DC3",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 310.771855599305,
        "y": 436.7840409977406,
        "z": 0
      },
      {
        "x": 311.6112677489872,
        "y": 436.7107495749332,
        "z": 0
      }
    ],
    "handle": "3DC4",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 320.8448013957808,
        "y": 435.9045439222827,
        "z": 0
      },
      {
        "x": 321.6842135455812,
        "y": 435.8312525013413,
        "z": 0
      }
    ],
    "handle": "3DC5",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 291.4657307503499,
        "y": 438.4677171222827,
        "z": 0
      },
      {
        "x": 291.3031991035678,
        "y": 439.3479685764723,
        "z": 0
      }
    ],
    "handle": "3DC6",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 279.6829352958596,
        "y": 502.2818913943991,
        "z": 0
      },
      {
        "x": 279.6009201981939,
        "y": 502.726075099781,
        "z": 0
      }
    ],
    "handle": "3DC7",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 301.5386757799432,
        "y": 437.5882121352405,
        "z": 0
      },
      {
        "x": 301.3761441331591,
        "y": 438.4684635875707,
        "z": 0
      }
    ],
    "handle": "3DC8",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 311.6116208093598,
        "y": 436.7087071454115,
        "z": 0
      },
      {
        "x": 311.4490891625769,
        "y": 437.5889586005321,
        "z": 0
      }
    ],
    "handle": "3DC9",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 321.6845658388329,
        "y": 435.8292021593042,
        "z": 0
      },
      {
        "x": 321.522034192109,
        "y": 436.7094536125586,
        "z": 0
      }
    ],
    "handle": "3DCA",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 327.8567512331658,
        "y": 456.0757326791017,
        "z": 0
      },
      {
        "x": 327.6942195863796,
        "y": 456.9559841332921,
        "z": 0
      }
    ],
    "handle": "3DCC",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 325.9063714155348,
        "y": 466.6387504311206,
        "z": 0
      },
      {
        "x": 325.7438397688078,
        "y": 467.5190018853126,
        "z": 0
      }
    ],
    "handle": "3DCD",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 323.9559915980787,
        "y": 477.201768185012,
        "z": 0
      },
      {
        "x": 323.793459951178,
        "y": 478.0820196392013,
        "z": 0
      }
    ],
    "handle": "3DCE",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 322.0056117804487,
        "y": 487.7647859398202,
        "z": 0
      },
      {
        "x": 321.8430801336652,
        "y": 488.6450373940103,
        "z": 0
      }
    ],
    "handle": "3DCF",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 318.1048521453051,
        "y": 508.890821445733,
        "z": 0
      },
      {
        "x": 318.0273990035047,
        "y": 509.3102981587833,
        "z": 0
      }
    ],
    "handle": "3DD0",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 330.0322554848958,
        "y": 497.9677978195214,
        "z": 0
      },
      {
        "x": 329.965645345625,
        "y": 498.328550158988,
        "z": 0
      }
    ],
    "handle": "3DD1",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 328.177797174779,
        "y": 508.0113164605536,
        "z": 0
      },
      {
        "x": 328.0152655280539,
        "y": 508.891567913808,
        "z": 0
      }
    ],
    "handle": "3DD2",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 269.6905068153287,
        "y": 502.7253286316908,
        "z": 0
      },
      {
        "x": 269.5279751686611,
        "y": 503.6055800886824,
        "z": 0
      }
    ],
    "handle": "3DD3",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 271.3198406914017,
        "y": 440.2267270982192,
        "z": 0
      },
      {
        "x": 271.1573090446169,
        "y": 441.1069785533391,
        "z": 0
      }
    ],
    "handle": "3DD4",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 259.6175617859702,
        "y": 503.6048336215434,
        "z": 0
      },
      {
        "x": 259.4550301391868,
        "y": 504.4850850747834,
        "z": 0
      }
    ],
    "handle": "3DD5",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 261.2468956619257,
        "y": 441.1062320871212,
        "z": 0
      },
      {
        "x": 261.0843640151433,
        "y": 441.9864835403832,
        "z": 0
      }
    ],
    "handle": "3DD6",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 249.5446167564371,
        "y": 504.4843386095006,
        "z": 0
      },
      {
        "x": 249.3820851096539,
        "y": 505.3645900627498,
        "z": 0
      }
    ],
    "handle": "3DD7",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 251.1739506323932,
        "y": 441.9857370750942,
        "z": 0
      },
      {
        "x": 251.011418985668,
        "y": 442.8659885283521,
        "z": 0
      }
    ],
    "handle": "3DD8",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 247.2731909973658,
        "y": 463.1117725810033,
        "z": 0
      },
      {
        "x": 247.1106593504079,
        "y": 463.9920240370519,
        "z": 0
      }
    ],
    "handle": "3DD9",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 245.3228111797938,
        "y": 473.674790335812,
        "z": 0
      },
      {
        "x": 245.1602795328946,
        "y": 474.5550417900012,
        "z": 0
      }
    ],
    "handle": "3DDA",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 243.3724313621641,
        "y": 484.2378080887709,
        "z": 0
      },
      {
        "x": 243.2098997153226,
        "y": 485.1180595438917,
        "z": 0
      }
    ],
    "handle": "3DDB",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 249.223570814822,
        "y": 452.5487548280541,
        "z": 0
      },
      {
        "x": 249.0610391680968,
        "y": 453.4290062831713,
        "z": 0
      }
    ],
    "handle": "3DDC",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 247.1192569641851,
        "y": 447.2370182750707,
        "z": 0
      },
      {
        "x": 248.2128795025648,
        "y": 448.3772062463649,
        "z": 0
      }
    ],
    "handle": "3DDD",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 299.9194775518268,
        "y": 502.2854233374818,
        "z": 0
      },
      {
        "x": 300.7067613477709,
        "y": 503.1062289476428,
        "z": 0
      }
    ],
    "handle": "3DDE",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 277.0955147650091,
        "y": 442.5933411372816,
        "z": 0
      },
      {
        "x": 277.7725050706649,
        "y": 443.2991570616141,
        "z": 0
      }
    ],
    "handle": "3DDF",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 329.589396610158,
        "y": 497.3223638376183,
        "z": 0
      },
      {
        "x": 330.0322875441641,
        "y": 497.7841126583514,
        "z": 0
      }
    ],
    "handle": "3DE0",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 292.083643665421,
        "y": 440.271502570249,
        "z": 0
      },
      {
        "x": 293.1772662038569,
        "y": 441.4116905424706,
        "z": 0
      }
    ],
    "handle": "3DE1",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 307.071772565833,
        "y": 437.949664000421,
        "z": 0
      },
      {
        "x": 308.1653951042668,
        "y": 439.0898519726432,
        "z": 0
      }
    ],
    "handle": "3DE2",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 322.0599014662437,
        "y": 435.6278254333854,
        "z": 0
      },
      {
        "x": 323.153524004738,
        "y": 436.7680134046821,
        "z": 0
      }
    ],
    "handle": "3DE3",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 245.2545985250041,
        "y": 463.2411125171937,
        "z": 0
      },
      {
        "x": 246.3482210634971,
        "y": 464.3813004894115,
        "z": 0
      }
    ],
    "handle": "3DE4",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 284.625009908922,
        "y": 504.2878795433933,
        "z": 0
      },
      {
        "x": 285.7186324473598,
        "y": 505.4280675165364,
        "z": 0
      }
    ],
    "handle": "3DE5",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 243.3899400859389,
        "y": 479.2452067611738,
        "z": 0
      },
      {
        "x": 244.4835626243139,
        "y": 480.3853947343312,
        "z": 0
      }
    ],
    "handle": "3DE6",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 269.6368810084538,
        "y": 506.6097181113445,
        "z": 0
      },
      {
        "x": 270.7305035468879,
        "y": 507.7499060845036,
        "z": 0
      }
    ],
    "handle": "3DE7",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 241.5591224468069,
        "y": 495.2845827145502,
        "z": 0
      },
      {
        "x": 242.6189041851306,
        "y": 496.3894889783112,
        "z": 0
      }
    ],
    "handle": "3DE8",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 254.6487521079821,
        "y": 508.931556679312,
        "z": 0
      },
      {
        "x": 255.0014748788087,
        "y": 509.2992980601191,
        "z": 0
      }
    ],
    "handle": "3DE9",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 278.3448685636967,
        "y": 442.398137782693,
        "z": 0
      },
      {
        "x": 278.239880810608,
        "y": 443.2992386361537,
        "z": 0
      }
    ],
    "handle": "3DEA",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 270.8862858845971,
        "y": 506.4145112168041,
        "z": 0
      },
      {
        "x": 270.7308987227138,
        "y": 507.7481858599931,
        "z": 0
      }
    ],
    "handle": "3DEB",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 293.3329953748026,
        "y": 440.0762898521461,
        "z": 0
      },
      {
        "x": 293.1776082128051,
        "y": 441.4099644944008,
        "z": 0
      }
    ],
    "handle": "3DEC",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 285.8744126957611,
        "y": 504.0926632862498,
        "z": 0
      },
      {
        "x": 285.7190255338788,
        "y": 505.4263379275844,
        "z": 0
      }
    ],
    "handle": "3DED",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 308.3211221858511,
        "y": 437.7544419215919,
        "z": 0
      },
      {
        "x": 308.1657350239701,
        "y": 439.0881165629206,
        "z": 0
      }
    ],
    "handle": "3DEE",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 300.8025642919821,
        "y": 502.2855774657837,
        "z": 0
      },
      {
        "x": 300.707152344984,
        "y": 503.1044899988919,
        "z": 0
      }
    ],
    "handle": "3DEF",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 323.309248996898,
        "y": 435.4325939901136,
        "z": 0
      },
      {
        "x": 323.153861835075,
        "y": 436.7662686342327,
        "z": 0
      }
    ],
    "handle": "3DF0",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 255.8981590735509,
        "y": 508.7363591482826,
        "z": 0
      },
      {
        "x": 255.832553853164,
        "y": 509.29944310895,
        "z": 0
      }
    ],
    "handle": "3DF1",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 248.3686149416038,
        "y": 447.0418336438013,
        "z": 0
      },
      {
        "x": 248.2132277796048,
        "y": 448.3755082851167,
        "z": 0
      }
    ],
    "handle": "3DF2",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 246.5039692717839,
        "y": 463.0459270030176,
        "z": 0
      },
      {
        "x": 246.3485821097852,
        "y": 464.3796016452843,
        "z": 0
      }
    ],
    "handle": "3DF3",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 244.6393236020799,
        "y": 479.0500203603794,
        "z": 0
      },
      {
        "x": 244.4839364400821,
        "y": 480.38369500171,
        "z": 0
      }
    ],
    "handle": "3DF4",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 242.7746779322029,
        "y": 495.0541137205446,
        "z": 0
      },
      {
        "x": 242.6192907702648,
        "y": 496.3877883609338,
        "z": 0
      }
    ],
    "handle": "3DF5",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 245.2545985894977,
        "y": 463.2411131989136,
        "z": 0
      },
      {
        "x": 246.5036093312089,
        "y": 463.0476266527511,
        "z": 0
      }
    ],
    "handle": "3DF6",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 243.3899401490342,
        "y": 479.2452074429018,
        "z": 0
      },
      {
        "x": 244.6389508907448,
        "y": 479.0517208957997,
        "z": 0
      }
    ],
    "handle": "3DF7",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 241.55912951962,
        "y": 495.2440582578918,
        "z": 0
      },
      {
        "x": 242.7742924501649,
        "y": 495.0558151360491,
        "z": 0
      }
    ],
    "handle": "3DF8",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 254.6487521691589,
        "y": 508.9315573629026,
        "z": 0
      },
      {
        "x": 255.8977629108698,
        "y": 508.7380708158014,
        "z": 0
      }
    ],
    "handle": "3DF9",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 269.6368810703278,
        "y": 506.6097187977357,
        "z": 0
      },
      {
        "x": 270.8858918120959,
        "y": 506.4162322506308,
        "z": 0
      }
    ],
    "handle": "3DFA",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 284.6250099715537,
        "y": 504.2878802325502,
        "z": 0
      },
      {
        "x": 285.874020713382,
        "y": 504.0943936863913,
        "z": 0
      }
    ],
    "handle": "3DFB",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 329.5893966754078,
        "y": 497.322364541702,
        "z": 0
      },
      {
        "x": 330.0323801113977,
        "y": 497.2537411646907,
        "z": 0
      }
    ],
    "handle": "3DFC",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 247.1192570300768,
        "y": 447.2370189568035,
        "z": 0
      },
      {
        "x": 248.3682677718458,
        "y": 447.0435324097015,
        "z": 0
      }
    ],
    "handle": "3DFD",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 292.0836437338146,
        "y": 440.2715032640851,
        "z": 0
      },
      {
        "x": 293.3326544755839,
        "y": 440.0780167188421,
        "z": 0
      }
    ],
    "handle": "3DFE",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 307.0717726351588,
        "y": 437.9496647007717,
        "z": 0
      },
      {
        "x": 308.320783376694,
        "y": 437.7561781555411,
        "z": 0
      }
    ],
    "handle": "3DFF",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 322.0599015363258,
        "y": 435.6278261356019,
        "z": 0
      },
      {
        "x": 323.3089122780959,
        "y": 435.4343395894346,
        "z": 0
      }
    ],
    "handle": "3E00",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 277.095514832647,
        "y": 442.5933418292552,
        "z": 0
      },
      {
        "x": 278.344525574357,
        "y": 442.3998552821512,
        "z": 0
      }
    ],
    "handle": "3E01",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 248.0607448202789,
        "y": 461.5504288030723,
        "z": 0
      },
      {
        "x": 248.738160244772,
        "y": 461.8105998830833,
        "z": 0
      }
    ],
    "handle": "3E02",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 244.3397218278827,
        "y": 451.2487855842343,
        "z": 0
      },
      {
        "x": 245.322956187651,
        "y": 451.6264107981586,
        "z": 0
      }
    ],
    "handle": "3E03",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 326.9314080328909,
        "y": 482.9693036554409,
        "z": 0
      },
      {
        "x": 327.9146423924249,
        "y": 483.3469288721608,
        "z": 0
      }
    ],
    "handle": "3E04",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 241.5685424494437,
        "y": 441.3119433857428,
        "z": 0
      },
      {
        "x": 241.9077521303547,
        "y": 441.4422217141797,
        "z": 0
      }
    ],
    "handle": "3E05",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 323.5162039757701,
        "y": 472.785114571452,
        "z": 0
      },
      {
        "x": 324.499438335245,
        "y": 473.1627397863083,
        "z": 0
      }
    ],
    "handle": "3E06",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 249.3081260286278,
        "y": 435.4119099956005,
        "z": 0
      },
      {
        "x": 250.2913603881608,
        "y": 435.7895352104613,
        "z": 0
      }
    ],
    "handle": "3E07",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 261.106938343612,
        "y": 439.9434125768019,
        "z": 0
      },
      {
        "x": 262.0901727031441,
        "y": 440.3210377926152,
        "z": 0
      }
    ],
    "handle": "3E08",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 328.4846081763968,
        "y": 456.9482389837501,
        "z": 0
      },
      {
        "x": 329.4678425359308,
        "y": 457.3258641976827,
        "z": 0
      }
    ],
    "handle": "3E09",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 301.4717794890748,
        "y": 437.7010447345599,
        "z": 0
      },
      {
        "x": 302.455013848725,
        "y": 438.0786699503623,
        "z": 0
      }
    ],
    "handle": "3E0A",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 313.2705918042337,
        "y": 442.2325473166892,
        "z": 0
      },
      {
        "x": 314.253826163651,
        "y": 442.6101725315628,
        "z": 0
      }
    ],
    "handle": "3E0B",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 325.0694041191007,
        "y": 446.7640498997607,
        "z": 0
      },
      {
        "x": 326.0526384786932,
        "y": 447.1416751127608,
        "z": 0
      }
    ],
    "handle": "3E0C",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 321.6542000619221,
        "y": 436.5798608148423,
        "z": 0
      },
      {
        "x": 322.6374344215717,
        "y": 436.9574860287902,
        "z": 0
      }
    ],
    "handle": "3E0D",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 321.9630038322649,
        "y": 498.8061792450023,
        "z": 0
      },
      {
        "x": 322.9462381919149,
        "y": 499.1838044570721,
        "z": 0
      }
    ],
    "handle": "3E0E",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 242.7865216844947,
        "y": 477.2698502559186,
        "z": 0
      },
      {
        "x": 243.7697560440867,
        "y": 477.6474754726513,
        "z": 0
      }
    ],
    "handle": "3E0F",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 313.5793955744008,
        "y": 504.4588657468521,
        "z": 0
      },
      {
        "x": 314.562629933993,
        "y": 504.8364909617192,
        "z": 0
      }
    ],
    "handle": "3E10",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 325.3782078894441,
        "y": 508.9903683280535,
        "z": 0
      },
      {
        "x": 326.2149397229089,
        "y": 509.311727154064,
        "z": 0
      }
    ],
    "handle": "3E11",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 246.2017257417307,
        "y": 487.4540393408314,
        "z": 0
      },
      {
        "x": 247.1849601013822,
        "y": 487.8316645557105,
        "z": 0
      }
    ],
    "handle": "3E12",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 293.39697500167,
        "y": 505.5800496675001,
        "z": 0
      },
      {
        "x": 294.3802093613201,
        "y": 505.9576748833022,
        "z": 0
      }
    ],
    "handle": "3E13",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 249.6169297988517,
        "y": 497.6382284257524,
        "z": 0
      },
      {
        "x": 249.9847442740579,
        "y": 497.779492834582,
        "z": 0
      }
    ],
    "handle": "3E14",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 261.6996052685432,
        "y": 502.2787527116014,
        "z": 0
      },
      {
        "x": 262.3989764734868,
        "y": 502.5473562227498,
        "z": 0
      }
    ],
    "handle": "3E15",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 273.2145544288798,
        "y": 506.7012335890829,
        "z": 0
      },
      {
        "x": 274.1977887884708,
        "y": 507.0788588048854,
        "z": 0
      }
    ],
    "handle": "3E16",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 241.557703334255,
        "y": 503.4154983945118,
        "z": 0
      },
      {
        "x": 242.2165559006388,
        "y": 503.6685401443317,
        "z": 0
      }
    ],
    "handle": "3E17",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 253.0321338560909,
        "y": 507.8224175097418,
        "z": 0
      },
      {
        "x": 254.0153682156248,
        "y": 508.2000427255342,
        "z": 0
      }
    ],
    "handle": "3E18",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 246.2017266154288,
        "y": 487.4540393510833,
        "z": 0
      },
      {
        "x": 246.9003606369961,
        "y": 486.982982140962,
        "z": 0
      }
    ],
    "handle": "3E19",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 313.270592691492,
        "y": 442.2325473455712,
        "z": 0
      },
      {
        "x": 313.9692267130598,
        "y": 441.7614901363812,
        "z": 0
      }
    ],
    "handle": "3E1A",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 321.6542009509868,
        "y": 436.5798608437116,
        "z": 0
      },
      {
        "x": 322.3528349726696,
        "y": 436.1088036363943,
        "z": 0
      }
    ],
    "handle": "3E1B",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 241.557763258287,
        "y": 503.072159199044,
        "z": 0
      },
      {
        "x": 241.9319564374748,
        "y": 502.8198577249421,
        "z": 0
      }
    ],
    "handle": "3E1C",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 249.6169306753438,
        "y": 497.638228433203,
        "z": 0
      },
      {
        "x": 249.9848122214901,
        "y": 497.3901826040828,
        "z": 0
      }
    ],
    "handle": "3E1D",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 325.0694050109601,
        "y": 446.7640499249127,
        "z": 0
      },
      {
        "x": 325.768039032527,
        "y": 446.2929927175817,
        "z": 0
      }
    ],
    "handle": "3E1E",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 253.0321347353169,
        "y": 507.8224175125359,
        "z": 0
      },
      {
        "x": 253.7307687568248,
        "y": 507.3513603052123,
        "z": 0
      }
    ],
    "handle": "3E1F",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 328.4846090707576,
        "y": 456.948239007961,
        "z": 0
      },
      {
        "x": 329.1832430923839,
        "y": 456.4771817997122,
        "z": 0
      }
    ],
    "handle": "3E20",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 273.2145553141603,
        "y": 506.7012335946682,
        "z": 0
      },
      {
        "x": 273.9131893357849,
        "y": 506.2301763864233,
        "z": 0
      }
    ],
    "handle": "3E21",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 323.516204871062,
        "y": 472.7851145900712,
        "z": 0
      },
      {
        "x": 324.2148388928051,
        "y": 472.3140573827513,
        "z": 0
      }
    ],
    "handle": "3E22",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 293.3969758930608,
        "y": 505.5800496740201,
        "z": 0
      },
      {
        "x": 294.0956099146277,
        "y": 505.1089924666992,
        "z": 0
      }
    ],
    "handle": "3E23",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 326.9314089310351,
        "y": 482.9693036712695,
        "z": 0
      },
      {
        "x": 327.6300429526596,
        "y": 482.4982464630092,
        "z": 0
      }
    ],
    "handle": "3E24",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 313.5793964719637,
        "y": 504.4588657552329,
        "z": 0
      },
      {
        "x": 314.2780304935298,
        "y": 503.9878085479103,
        "z": 0
      }
    ],
    "handle": "3E25",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 321.9630047314556,
        "y": 498.806179254312,
        "z": 0
      },
      {
        "x": 322.6616387530226,
        "y": 498.3351220460606,
        "z": 0
      }
    ],
    "handle": "3E26",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 325.3782087912551,
        "y": 508.9903683364437,
        "z": 0
      },
      {
        "x": 326.0768428129371,
        "y": 508.5193111281841,
        "z": 0
      }
    ],
    "handle": "3E27",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 242.7865225555716,
        "y": 477.2698502680166,
        "z": 0
      },
      {
        "x": 243.485156577138,
        "y": 476.79879305977,
        "z": 0
      }
    ],
    "handle": "3E28",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 293.16512773349,
        "y": 443.3018435826522,
        "z": 0
      },
      {
        "x": 293.7868061341582,
        "y": 442.8826740551703,
        "z": 0
      }
    ],
    "handle": "3E29",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 301.4717803720847,
        "y": 437.7010447643623,
        "z": 0
      },
      {
        "x": 302.1704143936511,
        "y": 437.2299875561107,
        "z": 0
      }
    ],
    "handle": "3E2A",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 244.3397226953521,
        "y": 451.2487856056504,
        "z": 0
      },
      {
        "x": 245.0383567169179,
        "y": 450.7777283955328,
        "z": 0
      }
    ],
    "handle": "3E2B",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 261.1069392142808,
        "y": 439.9434126038103,
        "z": 0
      },
      {
        "x": 261.8055732359648,
        "y": 439.4723553946213,
        "z": 0
      }
    ],
    "handle": "3E2C",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 249.3081268948738,
        "y": 435.4119100216713,
        "z": 0
      },
      {
        "x": 250.0067609164971,
        "y": 434.9408528124921,
        "z": 0
      }
    ],
    "handle": "3E2E",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 294.0960127065789,
        "y": 505.1069740764724,
        "z": 0
      },
      {
        "x": 294.3806136985078,
        "y": 505.9556562518628,
        "z": 0
      }
    ],
    "handle": "3E2F",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 293.7871602065868,
        "y": 442.8806560141892,
        "z": 0
      },
      {
        "x": 293.9284478633189,
        "y": 443.3019768083386,
        "z": 0
      }
    ],
    "handle": "3E30",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 314.278432212654,
        "y": 503.9857743708416,
        "z": 0
      },
      {
        "x": 314.5630332045259,
        "y": 504.8344565453033,
        "z": 0
      }
    ],
    "handle": "3E31",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 302.17076395906,
        "y": 437.2279629642116,
        "z": 0
      },
      {
        "x": 302.4553649510491,
        "y": 438.0766451377422,
        "z": 0
      }
    ],
    "handle": "3E32",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 326.0772479661966,
        "y": 508.5172677142534,
        "z": 0
      },
      {
        "x": 326.3436731905689,
        "y": 509.3117496212918,
        "z": 0
      }
    ],
    "handle": "3E33",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 322.6620359651267,
        "y": 498.3330813208522,
        "z": 0
      },
      {
        "x": 322.9466369570598,
        "y": 499.1817634962425,
        "z": 0
      }
    ],
    "handle": "3E34",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 313.9695797126039,
        "y": 441.7594563066922,
        "z": 0
      },
      {
        "x": 314.2541807044748,
        "y": 442.6081384830104,
        "z": 0
      }
    ],
    "handle": "3E35",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 324.2152157156962,
        "y": 472.3120154850112,
        "z": 0
      },
      {
        "x": 324.4998167074518,
        "y": 473.1606976604123,
        "z": 0
      }
    ],
    "handle": "3E36",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 327.6304277165912,
        "y": 482.4962018793412,
        "z": 0
      },
      {
        "x": 327.9150287084618,
        "y": 483.3448840538003,
        "z": 0
      }
    ],
    "handle": "3E37",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 322.3531834651948,
        "y": 436.1067632576413,
        "z": 0
      },
      {
        "x": 322.6377844569507,
        "y": 436.9554454330319,
        "z": 0
      }
    ],
    "handle": "3E38",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 325.7683954660322,
        "y": 446.2909496501052,
        "z": 0
      },
      {
        "x": 326.0529964580198,
        "y": 447.1396318264232,
        "z": 0
      }
    ],
    "handle": "3E39",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 329.1836074670418,
        "y": 456.4751360444351,
        "z": 0
      },
      {
        "x": 329.4682084590312,
        "y": 457.3238182188942,
        "z": 0
      }
    ],
    "handle": "3E3A",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 261.8059249470249,
        "y": 439.4703623764216,
        "z": 0
      },
      {
        "x": 262.0905259389549,
        "y": 440.3190445499529,
        "z": 0
      }
    ],
    "handle": "3E3B",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 250.0071091935969,
        "y": 434.9388690330079,
        "z": 0
      },
      {
        "x": 250.2917101854099,
        "y": 435.7875512065328,
        "z": 0
      }
    ],
    "handle": "3E3C",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 273.913593200617,
        "y": 506.2281737830407,
        "z": 0
      },
      {
        "x": 274.1981941924898,
        "y": 507.0768559593696,
        "z": 0
      }
    ],
    "handle": "3E3D",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 241.6235054411227,
        "y": 440.5915620811208,
        "z": 0
      },
      {
        "x": 241.9081064329367,
        "y": 441.4402442555838,
        "z": 0
      }
    ],
    "handle": "3E3E",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 245.0387174420769,
        "y": 450.7757484745233,
        "z": 0
      },
      {
        "x": 245.3233184339472,
        "y": 451.6244306489907,
        "z": 0
      }
    ],
    "handle": "3E3F",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 262.3100079712452,
        "y": 502.2788592455905,
        "z": 0
      },
      {
        "x": 262.3993784390627,
        "y": 502.5453626150191,
        "z": 0
      }
    ],
    "handle": "3E40",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 248.6519830052852,
        "y": 461.5505319954817,
        "z": 0
      },
      {
        "x": 248.7385304350172,
        "y": 461.8086170433016,
        "z": 0
      }
    ],
    "handle": "3E41",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 243.4855376915647,
        "y": 476.7968143103607,
        "z": 0
      },
      {
        "x": 243.7701386834961,
        "y": 477.6454964848189,
        "z": 0
      }
    ],
    "handle": "3E42",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 246.900749692692,
        "y": 486.9810007037604,
        "z": 0
      },
      {
        "x": 247.1853506845649,
        "y": 487.829682880084,
        "z": 0
      }
    ],
    "handle": "3E43",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 253.7311736945999,
        "y": 507.3493734896218,
        "z": 0
      },
      {
        "x": 254.0157746865889,
        "y": 508.1980556631432,
        "z": 0
      }
    ],
    "handle": "3E44",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 241.9323579411728,
        "y": 502.8178801452702,
        "z": 0
      },
      {
        "x": 242.216958933045,
        "y": 503.6665623206598,
        "z": 0
      }
    ],
    "handle": "3E45",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 245.0928122330222,
        "y": 473.9978956794329,
        "z": 0
      },
      {
        "x": 245.0928122330222,
        "y": 473.9978956794329,
        "z": 0
      }
    ],
    "handle": "3EF3",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 294.0144145499208,
        "y": 442.8434002241107,
        "z": 0
      },
      {
        "x": 294.0144145499208,
        "y": 442.8434002241107,
        "z": 0
      }
    ],
    "handle": "3EF4",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 243.2645312909729,
        "y": 477.5135477306212,
        "z": 0
      },
      {
        "x": 243.2645312909729,
        "y": 477.5135477306212,
        "z": 0
      }
    ],
    "handle": "3F25",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 268.423887710028,
        "y": 457.6482613142541,
        "z": 0
      },
      {
        "x": 274.9614717843932,
        "y": 464.1881278352857,
        "z": 0
      }
    ],
    "handle": "3F2F",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 268.2489135926589,
        "y": 453.5935631496831,
        "z": 0
      },
      {
        "x": 279.0161086021097,
        "y": 464.3645172752401,
        "z": 0
      }
    ],
    "handle": "3F30",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 268.5899240248249,
        "y": 450.0550296781502,
        "z": 0
      },
      {
        "x": 282.8950943140676,
        "y": 464.3651942862224,
        "z": 0
      }
    ],
    "handle": "3F31",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 269.8710966217328,
        "y": 447.4569866089121,
        "z": 0
      },
      {
        "x": 286.774080026079,
        "y": 464.3658712981192,
        "z": 0
      }
    ],
    "handle": "3F32",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 271.8280102240969,
        "y": 445.5349204633312,
        "z": 0
      },
      {
        "x": 290.6530657380941,
        "y": 464.3665483091017,
        "z": 0
      }
    ],
    "handle": "3F33",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 274.4673594980261,
        "y": 444.2955282442189,
        "z": 0
      },
      {
        "x": 294.2568760192369,
        "y": 464.0919538158952,
        "z": 0
      }
    ],
    "handle": "3F34",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 278.051620075014,
        "y": 444.0013772239908,
        "z": 0
      },
      {
        "x": 296.914813594078,
        "y": 462.8711563888946,
        "z": 0
      }
    ],
    "handle": "3F35",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 281.930605786969,
        "y": 444.0020542340353,
        "z": 0
      },
      {
        "x": 298.8870403202011,
        "y": 460.9644087152528,
        "z": 0
      }
    ],
    "handle": "3F36",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 285.80959149904,
        "y": 444.0027312478049,
        "z": 0
      },
      {
        "x": 300.1862594102279,
        "y": 458.384418438185,
        "z": 0
      }
    ],
    "handle": "3F37",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 289.6885772109952,
        "y": 444.0034082559831,
        "z": 0
      },
      {
        "x": 300.5485775072,
        "y": 454.8672000700616,
        "z": 0
      }
    ],
    "handle": "3F38",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 293.719991178135,
        "y": 444.1565667390823,
        "z": 0
      },
      {
        "x": 300.3968262629351,
        "y": 450.8357328847123,
        "z": 0
      }
    ],
    "handle": "3F39",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "ARC",
    "handle": "3F3A",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 282.2934820638041,
      "y": 447.0636763926631,
      "z": 0
    },
    "radius": 1.028777028464191,
    "startAngle": 1.570970862408824,
    "endAngle": 3.141767189029092,
    "angleLength": 1.570796326620268
  },
  {
    "type": "ARC",
    "handle": "3F3B",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 282.2934820638041,
      "y": 447.0636763861429,
      "z": 0
    },
    "radius": 1.028777028464789,
    "startAngle": 3.1417671834411607,
    "endAngle": 4.712563510585307,
    "angleLength": 1.570796327144146
  },
  {
    "type": "ARC",
    "handle": "3F3C",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 282.2923273452317,
      "y": 453.6798547049901,
      "z": 0
    },
    "radius": 1.028777050785534,
    "startAngle": 1.5709708841202819,
    "endAngle": 3.141767210449515,
    "angleLength": 1.570796326329233
  },
  {
    "type": "ARC",
    "handle": "3F3D",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 282.292327300588,
      "y": 453.6798546994105,
      "z": 0
    },
    "radius": 1.028777006143537,
    "startAngle": 3.1417672048615812,
    "endAngle": 4.7125635322967625,
    "angleLength": 1.5707963274351813
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 506.7567837890242,
        "y": 677.4930362682717,
        "z": 0
      },
      {
        "x": 506.0739993736492,
        "y": 678.1755823874817,
        "z": 0
      }
    ],
    "handle": "3F3E",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 507.4698288129873,
        "y": 677.3712943829479,
        "z": 0
      },
      {
        "x": 506.3820030014023,
        "y": 678.4587405379942,
        "z": 0
      }
    ],
    "handle": "3F3F",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 507.9677881650273,
        "y": 677.4645631024601,
        "z": 0
      },
      {
        "x": 506.7649254924034,
        "y": 678.6670059692112,
        "z": 0
      }
    ],
    "handle": "3F40",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 508.3639254757435,
        "y": 677.6596183283209,
        "z": 0
      },
      {
        "x": 507.2432574798583,
        "y": 678.7798952050498,
        "z": 0
      }
    ],
    "handle": "3F41",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 508.6834059800024,
        "y": 677.9313036054309,
        "z": 0
      },
      {
        "x": 507.9002465438092,
        "y": 678.7141897166111,
        "z": 0
      }
    ],
    "handle": "3F42",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 528.4782619233594,
        "y": 677.6481474731117,
        "z": 0
      },
      {
        "x": 528.0267291806524,
        "y": 678.0995226288169,
        "z": 0
      }
    ],
    "handle": "3F43",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 529.3423616691725,
        "y": 677.3754035849114,
        "z": 0
      },
      {
        "x": 528.3173255429724,
        "y": 678.4000819697912,
        "z": 0
      }
    ],
    "handle": "3F44",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 529.8744667605494,
        "y": 677.4345384826927,
        "z": 0
      },
      {
        "x": 528.6809795263105,
        "y": 678.6276091830732,
        "z": 0
      }
    ],
    "handle": "3F45",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 530.2918997001245,
        "y": 677.6083055110603,
        "z": 0
      },
      {
        "x": 529.1324526753735,
        "y": 678.7673478852947,
        "z": 0
      }
    ],
    "handle": "3F46",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 530.6291103716935,
        "y": 677.8622668096687,
        "z": 0
      },
      {
        "x": 529.7278477132772,
        "y": 678.7632149243727,
        "z": 0
      }
    ],
    "handle": "3F47",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 487.7935830990316,
        "y": 677.5358816804292,
        "z": 0
      },
      {
        "x": 487.1895352801078,
        "y": 678.1397186825023,
        "z": 0
      }
    ],
    "handle": "3F48",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 488.5541149410987,
        "y": 677.3666695495992,
        "z": 0
      },
      {
        "x": 487.4903240795259,
        "y": 678.4300891431013,
        "z": 0
      }
    ],
    "handle": "3F49",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 489.065511216119,
        "y": 677.4465060364427,
        "z": 0
      },
      {
        "x": 487.86515109794,
        "y": 678.6464472226716,
        "z": 0
      }
    ],
    "handle": "3F4A",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 489.4702823988047,
        "y": 677.6329304026439,
        "z": 0
      },
      {
        "x": 488.3319623967401,
        "y": 678.7708531254817,
        "z": 0
      }
    ],
    "handle": "3F4B",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 489.7970636728565,
        "y": 677.897317458868,
        "z": 0
      },
      {
        "x": 488.960867148359,
        "y": 678.7332221483836,
        "z": 0
      }
    ],
    "handle": "3F4C",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 468.8099737752919,
        "y": 677.5991286039315,
        "z": 0
      },
      {
        "x": 468.3058055542649,
        "y": 678.1031208680906,
        "z": 0
      }
    ],
    "handle": "3F4D",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 469.6363889710048,
        "y": 677.364056112241,
        "z": 0
      },
      {
        "x": 468.5993890495725,
        "y": 678.4006941160113,
        "z": 0
      }
    ],
    "handle": "3F4E",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 470.162194896605,
        "y": 677.4294879781017,
        "z": 0
      },
      {
        "x": 468.9662864288538,
        "y": 678.6249790675938,
        "z": 0
      }
    ],
    "handle": "3F4F",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 470.575858286931,
        "y": 677.6070232409911,
        "z": 0
      },
      {
        "x": 469.4221483090663,
        "y": 678.7603305680638,
        "z": 0
      }
    ],
    "handle": "3F50",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 470.909998190765,
        "y": 677.8640542347017,
        "z": 0
      },
      {
        "x": 470.0267426705111,
        "y": 678.7470014952122,
        "z": 0
      }
    ],
    "handle": "3F51",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 548.2108274848424,
        "y": 677.4272599825597,
        "z": 0
      },
      {
        "x": 547.3736105235283,
        "y": 678.2641847533994,
        "z": 0
      }
    ],
    "handle": "3F52",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 548.8391998503932,
        "y": 677.3901612050831,
        "z": 0
      },
      {
        "x": 547.7005420023333,
        "y": 678.5284216571481,
        "z": 0
      }
    ],
    "handle": "3F53",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 549.3057812436012,
        "y": 677.5147969340942,
        "z": 0
      },
      {
        "x": 548.1054927537322,
        "y": 678.7146665155822,
        "z": 0
      }
    ],
    "handle": "3F54",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 549.6804441321874,
        "y": 677.7313190866224,
        "z": 0
      },
      {
        "x": 548.6171740846485,
        "y": 678.7942180465834,
        "z": 0
      }
    ],
    "handle": "3F55",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 549.9810851893255,
        "y": 678.0218372363521,
        "z": 0
      },
      {
        "x": 549.3788285241455,
        "y": 678.6238837111741,
        "z": 0
      }
    ],
    "handle": "3F56",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 525.6428125308003,
        "y": 734.0402688337417,
        "z": 0
      },
      {
        "x": 525.1912797880944,
        "y": 734.4916439875922,
        "z": 0
      }
    ],
    "handle": "3F57",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 526.5069122766154,
        "y": 733.7675249455415,
        "z": 0
      },
      {
        "x": 525.4818761503543,
        "y": 734.7922033276437,
        "z": 0
      }
    ],
    "handle": "3F58",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 527.0390173679934,
        "y": 733.8266598414592,
        "z": 0
      },
      {
        "x": 525.8455301338103,
        "y": 735.019730544649,
        "z": 0
      }
    ],
    "handle": "3F59",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 527.4564503076264,
        "y": 734.000426871703,
        "z": 0
      },
      {
        "x": 526.2970032829323,
        "y": 735.159469242204,
        "z": 0
      }
    ],
    "handle": "3F5A",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 527.7936609791352,
        "y": 734.254388170315,
        "z": 0
      },
      {
        "x": 526.8923983207204,
        "y": 735.155336283141,
        "z": 0
      }
    ],
    "handle": "3F5B",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 567.1448562180152,
        "y": 677.4135763468221,
        "z": 0
      },
      {
        "x": 566.2606908214495,
        "y": 678.2974331639706,
        "z": 0
      }
    ],
    "handle": "3F5C",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 567.7489846699764,
        "y": 677.4007130209318,
        "z": 0
      },
      {
        "x": 566.5949822657283,
        "y": 678.5543126715337,
        "z": 0
      }
    ],
    "handle": "3F5D",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 568.2046275631285,
        "y": 677.5362834306405,
        "z": 0
      },
      {
        "x": 567.0088308532712,
        "y": 678.7316628033223,
        "z": 0
      }
    ],
    "handle": "3F5E",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 568.5713639906605,
        "y": 677.7607292793738,
        "z": 0
      },
      {
        "x": 567.5349435009982,
        "y": 678.7967880517197,
        "z": 0
      }
    ],
    "handle": "3F5F",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 568.8647998023664,
        "y": 678.0584501605442,
        "z": 0
      },
      {
        "x": 568.3630254174934,
        "y": 678.5600494230083,
        "z": 0
      }
    ],
    "handle": "3F60",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 586.0746636398824,
        "y": 677.4041125467008,
        "z": 0
      },
      {
        "x": 585.1484941369862,
        "y": 678.3299588132612,
        "z": 0
      }
    ],
    "handle": "3F61",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 586.6573893890022,
        "y": 677.4126444561325,
        "z": 0
      },
      {
        "x": 585.4902182015933,
        "y": 678.5794082945137,
        "z": 0
      }
    ],
    "handle": "3F62",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 587.1025920715194,
        "y": 677.5586514333232,
        "z": 0
      },
      {
        "x": 585.9132568459604,
        "y": 678.7475715745237,
        "z": 0
      }
    ],
    "handle": "3F63",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 587.4615469309495,
        "y": 677.7908761315001,
        "z": 0
      },
      {
        "x": 586.4549565442135,
        "y": 678.7971152141737,
        "z": 0
      }
    ],
    "handle": "3F64",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 587.7280496064924,
        "y": 678.1155207492457,
        "z": 0
      },
      {
        "x": 587.4013583306224,
        "y": 678.442098009389,
        "z": 0
      }
    ],
    "handle": "3F65",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "TEXT",
    "handle": "3F66",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "startPoint": {
      "x": 111.3876171823349,
      "y": 793.3930671401313,
      "z": 0
    },
    "textHeight": 7.5,
    "text": "RADYEL DEMiR iLE GALVANiZ SERIT"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 209.7156517800757,
        "y": 709.0629089036919,
        "z": 0
      },
      {
        "x": 210.2956360880051,
        "y": 709.0629089036919,
        "z": 0
      }
    ],
    "handle": "3F67",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 209.7156517785621,
        "y": 708.8703951891403,
        "z": 0
      },
      {
        "x": 210.2956360880051,
        "y": 708.8703951891403,
        "z": 0
      }
    ],
    "handle": "3F68",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 209.7156517800757,
        "y": 709.4291065614598,
        "z": 0
      },
      {
        "x": 209.829223119887,
        "y": 709.4291065614598,
        "z": 0
      }
    ],
    "handle": "3F69",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 208.840803953993,
        "y": 709.176359698169,
        "z": 0
      },
      {
        "x": 213.4332924914778,
        "y": 711.7520303810006,
        "z": 0
      }
    ],
    "handle": "3F6A",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 208.840803952422,
        "y": 708.8637065160981,
        "z": 0
      },
      {
        "x": 213.358713787748,
        "y": 706.1687595443725,
        "z": 0
      }
    ],
    "handle": "3F6B",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 208.840803953993,
        "y": 709.176359698169,
        "z": 0
      },
      {
        "x": 213.3628570482832,
        "y": 706.4789412571118,
        "z": 0
      }
    ],
    "handle": "3F6C",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 208.840803953993,
        "y": 708.5351000726193,
        "z": 0
      },
      {
        "x": 213.3628570482832,
        "y": 705.8376816343516,
        "z": 0
      }
    ],
    "handle": "3F6D",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 208.8408039535847,
        "y": 708.2224468868225,
        "z": 0
      },
      {
        "x": 213.358713787748,
        "y": 705.5274999206848,
        "z": 0
      }
    ],
    "handle": "3F6E",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 209.7156517800757,
        "y": 709.0629089036919,
        "z": 0
      },
      {
        "x": 209.5681117523917,
        "y": 709.2460077321118,
        "z": 0
      }
    ],
    "handle": "3F6F",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 209.5681117523917,
        "y": 709.2460077321118,
        "z": 0
      },
      {
        "x": 209.5681117523917,
        "y": 709.0534940129097,
        "z": 0
      }
    ],
    "handle": "3F70",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 209.7156517800757,
        "y": 709.0629089036919,
        "z": 0
      },
      {
        "x": 209.7156517785621,
        "y": 708.8703951891403,
        "z": 0
      }
    ],
    "handle": "3F71",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 209.7156517785621,
        "y": 708.8703951891403,
        "z": 0
      },
      {
        "x": 209.5681117523917,
        "y": 709.0534940203611,
        "z": 0
      }
    ],
    "handle": "3F72",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 209.7156517800757,
        "y": 709.4291065614598,
        "z": 0
      },
      {
        "x": 209.5681117523917,
        "y": 709.2460077321118,
        "z": 0
      }
    ],
    "handle": "3F73",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 208.8408039535847,
        "y": 708.5351000726193,
        "z": 0
      },
      {
        "x": 208.8408039532359,
        "y": 708.2224468914716,
        "z": 0
      }
    ],
    "handle": "3F74",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 208.840803953993,
        "y": 708.5351000726193,
        "z": 0
      },
      {
        "x": 209.1247346713788,
        "y": 708.6943409778149,
        "z": 0
      }
    ],
    "handle": "3F75",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 208.8408039535847,
        "y": 709.176359696309,
        "z": 0
      },
      {
        "x": 208.8408039532359,
        "y": 708.8637065160981,
        "z": 0
      }
    ],
    "handle": "3F76",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 217.0347580888781,
        "y": 709.6037451894916,
        "z": 0
      },
      {
        "x": 261.4190230243843,
        "y": 734.4964039456019,
        "z": 0
      }
    ],
    "handle": "3F77",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 217.566764336079,
        "y": 709.2864018445784,
        "z": 0
      },
      {
        "x": 261.9580978183079,
        "y": 734.1830249559108,
        "z": 0
      }
    ],
    "handle": "3F78",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 214.3747268554289,
        "y": 711.1904619168417,
        "z": 0
      },
      {
        "x": 258.758991791343,
        "y": 736.0831206748187,
        "z": 0
      }
    ],
    "handle": "3F79",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 216.8083677836112,
        "y": 707.4622184513097,
        "z": 0
      },
      {
        "x": 217.9553455880951,
        "y": 708.1054943306297,
        "z": 0
      }
    ],
    "handle": "3F7A",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 216.4811342272431,
        "y": 707.5865493854496,
        "z": 0
      },
      {
        "x": 217.9553455880951,
        "y": 708.4133523153147,
        "z": 0
      }
    ],
    "handle": "3F7B",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "SPLINE",
    "handle": "3F7C",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "normalVector": {
      "x": 0,
      "y": 0,
      "z": 1
    },
    "planar": true,
    "degreeOfSplineCurve": 3,
    "numberOfKnots": 12,
    "numberOfControlPoints": 8,
    "numberOfFitPoints": 0,
    "knotValues": [
      1.601014487257268,
      1.601014487257268,
      1.601014487257268,
      1.601014487257268,
      2.144527230635417,
      2.144527230635417,
      2.684476675754792,
      2.684476675754792,
      2.822521534132349,
      2.822521534132349,
      2.822521534132349,
      2.822521534132349
    ],
    "controlPoints": [
      {
        "x": 216.2987941035528,
        "y": 706.5487015265927,
        "z": 0
      },
      {
        "x": 216.1604631703818,
        "y": 706.4784925952507,
        "z": 0
      },
      {
        "x": 216.0060891839677,
        "y": 706.4399883206931,
        "z": 0
      },
      {
        "x": 215.6991696845517,
        "y": 706.4410847630361,
        "z": 0
      },
      {
        "x": 215.5464236953992,
        "y": 706.4805402271456,
        "z": 0
      },
      {
        "x": 215.3830219171931,
        "y": 706.5801379037982,
        "z": 0
      },
      {
        "x": 215.3513365824481,
        "y": 706.6030905460948,
        "z": 0
      },
      {
        "x": 215.321609897597,
        "y": 706.6283788727478,
        "z": 0
      }
    ]
  },
  {
    "type": "SPLINE",
    "handle": "3F7D",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "normalVector": {
      "x": 0,
      "y": 0,
      "z": 1
    },
    "planar": true,
    "degreeOfSplineCurve": 3,
    "numberOfKnots": 10,
    "numberOfControlPoints": 6,
    "numberOfFitPoints": 0,
    "knotValues": [
      0.2866710058334736,
      0.2866710058334736,
      0.2866710058334736,
      0.2866710058334736,
      0.3202527597656655,
      0.3202527597656655,
      0.632600549675783,
      0.632600549675783,
      0.632600549675783,
      0.632600549675783
    ],
    "controlPoints": [
      {
        "x": 216.8083677847752,
        "y": 707.4622184513097,
        "z": 0
      },
      {
        "x": 216.8098881252241,
        "y": 707.4528477694847,
        "z": 0
      },
      {
        "x": 216.8112261850632,
        "y": 707.4434493454089,
        "z": 0
      },
      {
        "x": 216.8231169645439,
        "y": 707.3464250843888,
        "z": 0
      },
      {
        "x": 216.8178816201392,
        "y": 707.25747480895,
        "z": 0
      },
      {
        "x": 216.7988149462039,
        "y": 707.1713959490843,
        "z": 0
      }
    ]
  },
  {
    "type": "ELLIPSE",
    "handle": "3F7E",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "center": {
      "x": 215.9409537065081,
      "y": 707.2642263816589,
      "z": 0
    },
    "majorAxisEndPoint": {
      "x": 0.5533977571668851,
      "y": 0.2995272764091438,
      "z": 0
    },
    "axisRatio": 0.8446940944788723,
    "startAngle": 1.937062951397157,
    "endAngle": 3.155582229527015
  },
  {
    "type": "ELLIPSE",
    "handle": "3F7F",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "center": {
      "x": 215.9409537065081,
      "y": 707.2642263816589,
      "z": 0
    },
    "majorAxisEndPoint": {
      "x": 0.5533977571762492,
      "y": 0.299527276386044,
      "z": 0
    },
    "axisRatio": 0.8446940944687678,
    "startAngle": -0.0495734242638319,
    "endAngle": 0.4882933596806325
  },
  {
    "type": "ELLIPSE",
    "handle": "3F80",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "center": {
      "x": 213.3577106079317,
      "y": 711.388554627072,
      "z": 0
    },
    "majorAxisEndPoint": {
      "x": -0.1764129755113634,
      "y": 0,
      "z": 0
    },
    "axisRatio": 0.6259016496518008,
    "startAngle": 0,
    "endAngle": 6.283185307179584
  },
  {
    "type": "SPLINE",
    "handle": "3F81",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "normalVector": {
      "x": 0,
      "y": 0,
      "z": 1
    },
    "planar": true,
    "degreeOfSplineCurve": 3,
    "numberOfKnots": 12,
    "numberOfControlPoints": 8,
    "numberOfFitPoints": 0,
    "knotValues": [
      0.7387853746015494,
      0.7387853746015494,
      0.7387853746015494,
      0.7387853746015494,
      0.7844749931928205,
      0.7844749931928205,
      1.696252131471398,
      1.696252131471398,
      2.401878553014586,
      2.401878553014586,
      2.401878553014586,
      2.401878553014586
    ],
    "controlPoints": [
      {
        "x": 213.1812976283832,
        "y": 711.2472815029324,
        "z": 0
      },
      {
        "x": 213.1840672249672,
        "y": 711.2453803671496,
        "z": 0
      },
      {
        "x": 213.1868749999551,
        "y": 711.2435396946927,
        "z": 0
      },
      {
        "x": 213.2464141104129,
        "y": 711.2062051994687,
        "z": 0
      },
      {
        "x": 213.3174330380271,
        "y": 711.192632983435,
        "z": 0
      },
      {
        "x": 213.4393733334718,
        "y": 711.2022586520724,
        "z": 0
      },
      {
        "x": 213.4916258268631,
        "y": 711.2174787726171,
        "z": 0
      },
      {
        "x": 213.5341235804948,
        "y": 711.2470215456514,
        "z": 0
      }
    ]
  },
  {
    "type": "SPLINE",
    "handle": "3F82",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "normalVector": {
      "x": 0,
      "y": 0,
      "z": 1
    },
    "planar": true,
    "degreeOfSplineCurve": 3,
    "numberOfKnots": 14,
    "numberOfControlPoints": 10,
    "numberOfFitPoints": 0,
    "knotValues": [
      0.9221147950801091,
      0.9221147950801091,
      0.9221147950801091,
      0.9221147950801091,
      0.9338670167145838,
      0.9338670167145838,
      1.505248745831563,
      1.505248745831563,
      2.210109023906936,
      2.210109023906936,
      2.218899873798678,
      2.218899873798678,
      2.218899873798678,
      2.218899873798678
    ],
    "controlPoints": [
      {
        "x": 213.1812976283832,
        "y": 711.1538884397631,
        "z": 0
      },
      {
        "x": 213.1823107384257,
        "y": 711.1534057287427,
        "z": 0
      },
      {
        "x": 213.1833247337489,
        "y": 711.1529277283697,
        "z": 0
      },
      {
        "x": 213.2336776154116,
        "y": 711.1294388743124,
        "z": 0
      },
      {
        "x": 213.2868190411251,
        "y": 711.1180830281226,
        "z": 0
      },
      {
        "x": 213.4049158725529,
        "y": 711.1135206231849,
        "z": 0
      },
      {
        "x": 213.4703383730951,
        "y": 711.1237690802582,
        "z": 0
      },
      {
        "x": 213.5325923195348,
        "y": 711.1528191361549,
        "z": 0
      },
      {
        "x": 213.5333583676259,
        "y": 711.1531796557836,
        "z": 0
      },
      {
        "x": 213.5341235804948,
        "y": 711.1535428892813,
        "z": 0
      }
    ]
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 213.1812976298971,
        "y": 711.388554627072,
        "z": 0
      },
      {
        "x": 213.1812976298971,
        "y": 711.1538884378932,
        "z": 0
      }
    ],
    "handle": "3F83",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 213.5341235804948,
        "y": 711.388554627072,
        "z": 0
      },
      {
        "x": 213.5341235804948,
        "y": 711.1535428892813,
        "z": 0
      }
    ],
    "handle": "3F84",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 213.6477105999359,
        "y": 710.9429005421579,
        "z": 0
      },
      {
        "x": 213.7952506268621,
        "y": 711.1259993733839,
        "z": 0
      }
    ],
    "handle": "3F85",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 213.067726291191,
        "y": 710.9429005421579,
        "z": 0
      },
      {
        "x": 212.9201862642652,
        "y": 711.1259993733839,
        "z": 0
      }
    ],
    "handle": "3F86",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 212.9201862642652,
        "y": 711.1259993733839,
        "z": 0
      },
      {
        "x": 212.9201862642652,
        "y": 710.933485651392,
        "z": 0
      }
    ],
    "handle": "3F87",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 213.6477105999359,
        "y": 710.9429005421579,
        "z": 0
      },
      {
        "x": 213.6477105999359,
        "y": 710.7503868294842,
        "z": 0
      }
    ],
    "handle": "3F88",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 213.7952506268621,
        "y": 711.1259993733839,
        "z": 0
      },
      {
        "x": 213.7952506250008,
        "y": 710.9334856616333,
        "z": 0
      }
    ],
    "handle": "3F89",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 213.067726291191,
        "y": 710.9429005421579,
        "z": 0
      },
      {
        "x": 213.067726290028,
        "y": 710.7503868294842,
        "z": 0
      }
    ],
    "handle": "3F8A",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 213.067726290028,
        "y": 710.7503868294842,
        "z": 0
      },
      {
        "x": 212.9201862642652,
        "y": 710.9334856616333,
        "z": 0
      }
    ],
    "handle": "3F8B",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 213.6477105999359,
        "y": 710.7503868294842,
        "z": 0
      },
      {
        "x": 213.7952506268621,
        "y": 710.9334856616333,
        "z": 0
      }
    ],
    "handle": "3F8C",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "ELLIPSE",
    "handle": "3F8D",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "center": {
      "x": 213.3577106079317,
      "y": 711.1656233174717,
      "z": 0
    },
    "majorAxisEndPoint": {
      "x": 0.1764129755138129,
      "y": 2.17674e-11,
      "z": 0
    },
    "axisRatio": 0.6259016496423861,
    "startAngle": 3.252782333826853,
    "endAngle": 6.168573069506875
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 213.067726291191,
        "y": 710.9429005421579,
        "z": 0
      },
      {
        "x": 213.6477105999359,
        "y": 710.9429005421579,
        "z": 0
      }
    ],
    "handle": "3F8E",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 213.067726290028,
        "y": 710.7503868294842,
        "z": 0
      },
      {
        "x": 213.6477105999359,
        "y": 710.7503868294842,
        "z": 0
      }
    ],
    "handle": "3F8F",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 213.067726291191,
        "y": 711.3090982008686,
        "z": 0
      },
      {
        "x": 212.9201862642652,
        "y": 711.1259993733839,
        "z": 0
      }
    ],
    "handle": "3F90",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 213.067726291191,
        "y": 711.3090982008686,
        "z": 0
      },
      {
        "x": 213.1812976311179,
        "y": 711.3090981980714,
        "z": 0
      }
    ],
    "handle": "3F91",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 213.6477105999359,
        "y": 711.3090982008686,
        "z": 0
      },
      {
        "x": 213.7952506268621,
        "y": 711.1259993733839,
        "z": 0
      }
    ],
    "handle": "3F92",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 213.534123582008,
        "y": 711.3090982027351,
        "z": 0
      },
      {
        "x": 213.6477105999359,
        "y": 711.3090982008686,
        "z": 0
      }
    ],
    "handle": "3F93",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "ELLIPSE",
    "handle": "3F94",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "center": {
      "x": 210.0056360972798,
      "y": 709.5085629867352,
      "z": 0
    },
    "majorAxisEndPoint": {
      "x": -0.1764129755113634,
      "y": 0,
      "z": 0
    },
    "axisRatio": 0.6259016496518008,
    "startAngle": 0,
    "endAngle": 6.283185307179584
  },
  {
    "type": "SPLINE",
    "handle": "3F95",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "normalVector": {
      "x": 0,
      "y": 0,
      "z": 1
    },
    "planar": true,
    "degreeOfSplineCurve": 3,
    "numberOfKnots": 12,
    "numberOfControlPoints": 8,
    "numberOfFitPoints": 0,
    "knotValues": [
      0.7387853746015494,
      0.7387853746015494,
      0.7387853746015494,
      0.7387853746015494,
      0.7844749931928205,
      0.7844749931928205,
      1.696252131471398,
      1.696252131471398,
      2.401878553014586,
      2.401878553014586,
      2.401878553014586,
      2.401878553014586
    ],
    "controlPoints": [
      {
        "x": 209.8292231168601,
        "y": 709.3672898653822,
        "z": 0
      },
      {
        "x": 209.8319927143169,
        "y": 709.3653887277403,
        "z": 0
      },
      {
        "x": 209.834800488374,
        "y": 709.3635480552936,
        "z": 0
      },
      {
        "x": 209.8943395982487,
        "y": 709.326213560991,
        "z": 0
      },
      {
        "x": 209.9653585266789,
        "y": 709.3126413431019,
        "z": 0
      },
      {
        "x": 210.0872988226468,
        "y": 709.3222670145332,
        "z": 0
      },
      {
        "x": 210.1395513153399,
        "y": 709.3374871313542,
        "z": 0
      },
      {
        "x": 210.182049069786,
        "y": 709.3670299071844,
        "z": 0
      }
    ]
  },
  {
    "type": "SPLINE",
    "handle": "3F96",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "normalVector": {
      "x": 0,
      "y": 0,
      "z": 1
    },
    "planar": true,
    "degreeOfSplineCurve": 3,
    "numberOfKnots": 14,
    "numberOfControlPoints": 10,
    "numberOfFitPoints": 0,
    "knotValues": [
      0.9221147950801091,
      0.9221147950801091,
      0.9221147950801091,
      0.9221147950801091,
      0.9338670167145838,
      0.9338670167145838,
      1.505248745831563,
      1.505248745831563,
      2.210109023906936,
      2.210109023906936,
      2.218899873798678,
      2.218899873798678,
      2.218899873798678,
      2.218899873798678
    ],
    "controlPoints": [
      {
        "x": 209.8292231168601,
        "y": 709.2738967994189,
        "z": 0
      },
      {
        "x": 209.830236226961,
        "y": 709.2734140893408,
        "z": 0
      },
      {
        "x": 209.8312502222839,
        "y": 709.2729360889598,
        "z": 0
      },
      {
        "x": 209.8816031046449,
        "y": 709.24944723397,
        "z": 0
      },
      {
        "x": 209.934744530357,
        "y": 709.2380913887127,
        "z": 0
      },
      {
        "x": 210.0528413610298,
        "y": 709.2335289856419,
        "z": 0
      },
      {
        "x": 210.1182638616879,
        "y": 709.2437774408617,
        "z": 0
      },
      {
        "x": 210.1805178081258,
        "y": 709.272827495809,
        "z": 0
      },
      {
        "x": 210.1812838553438,
        "y": 709.2731880154413,
        "z": 0
      },
      {
        "x": 210.182049069786,
        "y": 709.2735512498692,
        "z": 0
      }
    ]
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 209.829223118023,
        "y": 709.5085629904614,
        "z": 0
      },
      {
        "x": 209.829223118023,
        "y": 709.2738967994189,
        "z": 0
      }
    ],
    "handle": "3F97",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 210.1820490693791,
        "y": 709.5085629904614,
        "z": 0
      },
      {
        "x": 210.1820490693791,
        "y": 709.2735512508006,
        "z": 0
      }
    ],
    "handle": "3F98",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 210.2956360880051,
        "y": 709.0629089036919,
        "z": 0
      },
      {
        "x": 210.4431761149899,
        "y": 709.2460077321118,
        "z": 0
      }
    ],
    "handle": "3F99",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 210.2956360880051,
        "y": 709.0629089036919,
        "z": 0
      },
      {
        "x": 210.2956360880051,
        "y": 708.8703951891403,
        "z": 0
      }
    ],
    "handle": "3F9A",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 210.4431761149899,
        "y": 709.2460077321118,
        "z": 0
      },
      {
        "x": 210.443176114233,
        "y": 709.0534940203611,
        "z": 0
      }
    ],
    "handle": "3F9B",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 210.2956360880051,
        "y": 708.8703951891403,
        "z": 0
      },
      {
        "x": 210.4431761149899,
        "y": 709.0534940203611,
        "z": 0
      }
    ],
    "handle": "3F9C",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "ELLIPSE",
    "handle": "3F9D",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "center": {
      "x": 210.0056360972798,
      "y": 709.2856316771358,
      "z": 0
    },
    "majorAxisEndPoint": {
      "x": 0.1764129755138129,
      "y": 2.17674e-11,
      "z": 0
    },
    "axisRatio": 0.6259016496423861,
    "startAngle": 3.252782333826853,
    "endAngle": 6.168573069506875
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 210.2956360880051,
        "y": 709.4291065614598,
        "z": 0
      },
      {
        "x": 210.4431761149899,
        "y": 709.2460077321118,
        "z": 0
      }
    ],
    "handle": "3F9E",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 210.1820490704848,
        "y": 709.4291065633242,
        "z": 0
      },
      {
        "x": 210.2956360880051,
        "y": 709.4291065614598,
        "z": 0
      }
    ],
    "handle": "3F9F",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 213.346839898441,
        "y": 707.5412991996844,
        "z": 0
      },
      {
        "x": 213.460426915494,
        "y": 707.5412991959626,
        "z": 0
      }
    ],
    "handle": "3FA0",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 213.460426915494,
        "y": 707.5412991959626,
        "z": 0
      },
      {
        "x": 213.6079669427128,
        "y": 707.3582003675372,
        "z": 0
      }
    ],
    "handle": "3FA1",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 212.8804426071598,
        "y": 707.5412991959626,
        "z": 0
      },
      {
        "x": 212.994013947434,
        "y": 707.5412991931585,
        "z": 0
      }
    ],
    "handle": "3FA2",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 212.8804426071598,
        "y": 707.5412991959626,
        "z": 0
      },
      {
        "x": 212.732902580173,
        "y": 707.3582003675372,
        "z": 0
      }
    ],
    "handle": "3FA3",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 212.880442606285,
        "y": 706.9825878264317,
        "z": 0
      },
      {
        "x": 213.460426915494,
        "y": 706.9825878264317,
        "z": 0
      }
    ],
    "handle": "3FA4",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 212.8804426071598,
        "y": 707.1751015400514,
        "z": 0
      },
      {
        "x": 213.460426915494,
        "y": 707.1751015400514,
        "z": 0
      }
    ],
    "handle": "3FA5",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "ELLIPSE",
    "handle": "3FA6",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "center": {
      "x": 213.1704269238389,
      "y": 707.3978243144201,
      "z": 0
    },
    "majorAxisEndPoint": {
      "x": 0.1764129755138129,
      "y": 2.17674e-11,
      "z": 0
    },
    "axisRatio": 0.6259016496423861,
    "startAngle": 3.252782333826853,
    "endAngle": 6.168573069506875
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 213.460426915494,
        "y": 706.9825878264317,
        "z": 0
      },
      {
        "x": 213.6079669427128,
        "y": 707.1656866585835,
        "z": 0
      }
    ],
    "handle": "3FA7",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 212.880442606285,
        "y": 706.9825878264317,
        "z": 0
      },
      {
        "x": 212.732902580173,
        "y": 707.1656866585835,
        "z": 0
      }
    ],
    "handle": "3FA8",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 212.8804426071598,
        "y": 707.1751015400514,
        "z": 0
      },
      {
        "x": 212.880442606285,
        "y": 706.9825878264317,
        "z": 0
      }
    ],
    "handle": "3FA9",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 213.6079669427128,
        "y": 707.3582003675372,
        "z": 0
      },
      {
        "x": 213.6079669416069,
        "y": 707.1656866585835,
        "z": 0
      }
    ],
    "handle": "3FAA",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 213.460426915494,
        "y": 707.1751015400514,
        "z": 0
      },
      {
        "x": 213.460426915494,
        "y": 706.9825878264317,
        "z": 0
      }
    ],
    "handle": "3FAB",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 212.732902580173,
        "y": 707.3582003675372,
        "z": 0
      },
      {
        "x": 212.732902580173,
        "y": 707.1656866492585,
        "z": 0
      }
    ],
    "handle": "3FAC",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 212.8804426071598,
        "y": 707.1751015400514,
        "z": 0
      },
      {
        "x": 212.732902580173,
        "y": 707.3582003675372,
        "z": 0
      }
    ],
    "handle": "3FAD",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 213.460426915494,
        "y": 707.1751015400514,
        "z": 0
      },
      {
        "x": 213.6079669427128,
        "y": 707.3582003675372,
        "z": 0
      }
    ],
    "handle": "3FAE",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 213.3468398968679,
        "y": 707.6207556240196,
        "z": 0
      },
      {
        "x": 213.3468398968679,
        "y": 707.3857438862321,
        "z": 0
      }
    ],
    "handle": "3FAF",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 212.994013945455,
        "y": 707.6207556240196,
        "z": 0
      },
      {
        "x": 212.994013945455,
        "y": 707.3860894348436,
        "z": 0
      }
    ],
    "handle": "3FB0",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "SPLINE",
    "handle": "3FB1",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "normalVector": {
      "x": 0,
      "y": 0,
      "z": 1
    },
    "planar": true,
    "degreeOfSplineCurve": 3,
    "numberOfKnots": 14,
    "numberOfControlPoints": 10,
    "numberOfFitPoints": 0,
    "knotValues": [
      0.9221147950801091,
      0.9221147950801091,
      0.9221147950801091,
      0.9221147950801091,
      0.9338670167145838,
      0.9338670167145838,
      1.505248745831563,
      1.505248745831563,
      2.210109023906936,
      2.210109023906936,
      2.218899873798678,
      2.218899873798678,
      2.218899873798678,
      2.218899873798678
    ],
    "controlPoints": [
      {
        "x": 212.994013944292,
        "y": 707.386089433912,
        "z": 0
      },
      {
        "x": 212.99502705445,
        "y": 707.3856067229025,
        "z": 0
      },
      {
        "x": 212.9960410497159,
        "y": 707.3851287225218,
        "z": 0
      },
      {
        "x": 213.0463939313202,
        "y": 707.3616398684642,
        "z": 0
      },
      {
        "x": 213.0995353569728,
        "y": 707.3502840232102,
        "z": 0
      },
      {
        "x": 213.2176321893938,
        "y": 707.3457216191997,
        "z": 0
      },
      {
        "x": 213.2830546883048,
        "y": 707.3559700762863,
        "z": 0
      },
      {
        "x": 213.3453086355018,
        "y": 707.3850201321691,
        "z": 0
      },
      {
        "x": 213.3460746842887,
        "y": 707.3853806490013,
        "z": 0
      },
      {
        "x": 213.3468398964037,
        "y": 707.3857438862321,
        "z": 0
      }
    ]
  },
  {
    "type": "SPLINE",
    "handle": "3FB2",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "normalVector": {
      "x": 0,
      "y": 0,
      "z": 1
    },
    "planar": true,
    "degreeOfSplineCurve": 3,
    "numberOfKnots": 12,
    "numberOfControlPoints": 8,
    "numberOfFitPoints": 0,
    "knotValues": [
      0.7387853746015494,
      0.7387853746015494,
      0.7387853746015494,
      0.7387853746015494,
      0.7844749931928205,
      0.7844749931928205,
      1.696252131471398,
      1.696252131471398,
      2.401878553014586,
      2.401878553014586,
      2.401878553014586,
      2.401878553014586
    ],
    "controlPoints": [
      {
        "x": 212.994013944292,
        "y": 707.479482498009,
        "z": 0
      },
      {
        "x": 212.9967835424467,
        "y": 707.4775813631601,
        "z": 0
      },
      {
        "x": 212.9995913157461,
        "y": 707.4757406916432,
        "z": 0
      },
      {
        "x": 213.059130425624,
        "y": 707.4384061964226,
        "z": 0
      },
      {
        "x": 213.1301493532947,
        "y": 707.4248339775937,
        "z": 0
      },
      {
        "x": 213.252089649381,
        "y": 707.4344596490182,
        "z": 0
      },
      {
        "x": 213.3043421420738,
        "y": 707.4496797686431,
        "z": 0
      },
      {
        "x": 213.3468398964037,
        "y": 707.4792225407435,
        "z": 0
      }
    ]
  },
  {
    "type": "ELLIPSE",
    "handle": "3FB3",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "center": {
      "x": 213.1704269238389,
      "y": 707.6207556240196,
      "z": 0
    },
    "majorAxisEndPoint": {
      "x": -0.1764129755113634,
      "y": 0,
      "z": 0
    },
    "axisRatio": 0.6259016496518008,
    "startAngle": 0,
    "endAngle": 6.283185307179584
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 216.6989144094981,
        "y": 709.4212908400212,
        "z": 0
      },
      {
        "x": 216.812501426904,
        "y": 709.4212908381511,
        "z": 0
      }
    ],
    "handle": "3FB4",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 216.812501426904,
        "y": 709.4212908381511,
        "z": 0
      },
      {
        "x": 216.9600414542948,
        "y": 709.2381920069527,
        "z": 0
      }
    ],
    "handle": "3FB5",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 216.232517119381,
        "y": 709.4212908381511,
        "z": 0
      },
      {
        "x": 216.3460884588431,
        "y": 709.4212908316322,
        "z": 0
      }
    ],
    "handle": "3FB6",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 216.232517119381,
        "y": 709.4212908381511,
        "z": 0
      },
      {
        "x": 216.0849770920478,
        "y": 709.2381920069527,
        "z": 0
      }
    ],
    "handle": "3FB7",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 216.2325171170528,
        "y": 708.8625794639709,
        "z": 0
      },
      {
        "x": 216.812501426904,
        "y": 708.8625794639709,
        "z": 0
      }
    ],
    "handle": "3FB8",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 216.232517119381,
        "y": 709.0550931794533,
        "z": 0
      },
      {
        "x": 216.812501426904,
        "y": 709.0550931794533,
        "z": 0
      }
    ],
    "handle": "3FB9",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "ELLIPSE",
    "handle": "3FBA",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "center": {
      "x": 216.5225014345478,
      "y": 709.2778159547532,
      "z": 0
    },
    "majorAxisEndPoint": {
      "x": 0.1764129755138129,
      "y": 2.17674e-11,
      "z": 0
    },
    "axisRatio": 0.6259016496423861,
    "startAngle": 3.252782333826853,
    "endAngle": 6.168573069506875
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 216.812501426904,
        "y": 708.8625794639709,
        "z": 0
      },
      {
        "x": 216.9600414542948,
        "y": 709.0456782961184,
        "z": 0
      }
    ],
    "handle": "3FBB",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 216.2325171170528,
        "y": 708.8625794639709,
        "z": 0
      },
      {
        "x": 216.0849770920478,
        "y": 709.0456782961184,
        "z": 0
      }
    ],
    "handle": "3FBC",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 216.232517119381,
        "y": 709.0550931794533,
        "z": 0
      },
      {
        "x": 216.2325171170528,
        "y": 708.8625794639709,
        "z": 0
      }
    ],
    "handle": "3FBD",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 216.9600414542948,
        "y": 709.2381920069527,
        "z": 0
      },
      {
        "x": 216.960041452781,
        "y": 709.0456782961184,
        "z": 0
      }
    ],
    "handle": "3FBE",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 216.812501426904,
        "y": 709.0550931794533,
        "z": 0
      },
      {
        "x": 216.812501426904,
        "y": 708.8625794639709,
        "z": 0
      }
    ],
    "handle": "3FBF",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 216.0849770920478,
        "y": 709.2381920069527,
        "z": 0
      },
      {
        "x": 216.0849770920478,
        "y": 709.0456782877399,
        "z": 0
      }
    ],
    "handle": "3FC0",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 216.232517119381,
        "y": 709.0550931794533,
        "z": 0
      },
      {
        "x": 216.0849770920478,
        "y": 709.2381920069527,
        "z": 0
      }
    ],
    "handle": "3FC1",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 216.812501426904,
        "y": 709.0550931794533,
        "z": 0
      },
      {
        "x": 216.9600414542948,
        "y": 709.2381920069527,
        "z": 0
      }
    ],
    "handle": "3FC2",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 216.6989144083349,
        "y": 709.5007472652942,
        "z": 0
      },
      {
        "x": 216.6989144083349,
        "y": 709.2657355256297,
        "z": 0
      }
    ],
    "handle": "3FC3",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 216.3460884573868,
        "y": 709.5007472652942,
        "z": 0
      },
      {
        "x": 216.3460884573868,
        "y": 709.266081073321,
        "z": 0
      }
    ],
    "handle": "3FC4",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "SPLINE",
    "handle": "3FC5",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "normalVector": {
      "x": 0,
      "y": 0,
      "z": 1
    },
    "planar": true,
    "degreeOfSplineCurve": 3,
    "numberOfKnots": 14,
    "numberOfControlPoints": 10,
    "numberOfFitPoints": 0,
    "knotValues": [
      0.9221147950801091,
      0.9221147950801091,
      0.9221147950801091,
      0.9221147950801091,
      0.9338670167145838,
      0.9338670167145838,
      1.505248745831563,
      1.505248745831563,
      2.210109023906936,
      2.210109023906936,
      2.218899873798678,
      2.218899873798678,
      2.218899873798678,
      2.218899873798678
    ],
    "controlPoints": [
      {
        "x": 216.3460884549991,
        "y": 709.266081073321,
        "z": 0
      },
      {
        "x": 216.3471015651019,
        "y": 709.2655983623109,
        "z": 0
      },
      {
        "x": 216.3481155604828,
        "y": 709.2651203637898,
        "z": 0
      },
      {
        "x": 216.3984684435421,
        "y": 709.2416315106597,
        "z": 0
      },
      {
        "x": 216.4516098685557,
        "y": 709.2302756635397,
        "z": 0
      },
      {
        "x": 216.5697067007438,
        "y": 709.2257132576706,
        "z": 0
      },
      {
        "x": 216.6351292006439,
        "y": 709.2359617156944,
        "z": 0
      },
      {
        "x": 216.6973831462668,
        "y": 709.265011769723,
        "z": 0
      },
      {
        "x": 216.6981491950576,
        "y": 709.2653722921347,
        "z": 0
      },
      {
        "x": 216.6989144079848,
        "y": 709.2657355256297,
        "z": 0
      }
    ]
  },
  {
    "type": "SPLINE",
    "handle": "3FC6",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "normalVector": {
      "x": 0,
      "y": 0,
      "z": 1
    },
    "planar": true,
    "degreeOfSplineCurve": 3,
    "numberOfKnots": 12,
    "numberOfControlPoints": 8,
    "numberOfFitPoints": 0,
    "knotValues": [
      0.7387853746015494,
      0.7387853746015494,
      0.7387853746015494,
      0.7387853746015494,
      0.7844749931928205,
      0.7844749931928205,
      1.696252131471398,
      1.696252131471398,
      2.401878553014586,
      2.401878553014586,
      2.401878553014586,
      2.401878553014586
    ],
    "controlPoints": [
      {
        "x": 216.3460884549991,
        "y": 709.359474139284,
        "z": 0
      },
      {
        "x": 216.3488580532721,
        "y": 709.3575730007112,
        "z": 0
      },
      {
        "x": 216.3516658273309,
        "y": 709.3557323319847,
        "z": 0
      },
      {
        "x": 216.4112049370298,
        "y": 709.3183978367522,
        "z": 0
      },
      {
        "x": 216.482223864761,
        "y": 709.3048256188621,
        "z": 0
      },
      {
        "x": 216.6041641607877,
        "y": 709.3144512902937,
        "z": 0
      },
      {
        "x": 216.6564166534219,
        "y": 709.3296714080412,
        "z": 0
      },
      {
        "x": 216.6989144079848,
        "y": 709.3592141810841,
        "z": 0
      }
    ]
  },
  {
    "type": "ELLIPSE",
    "handle": "3FC7",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "center": {
      "x": 216.5225014345478,
      "y": 709.5007472652942,
      "z": 0
    },
    "majorAxisEndPoint": {
      "x": -0.1764129755113634,
      "y": 0,
      "z": 0
    },
    "axisRatio": 0.6259016496518008,
    "startAngle": 0,
    "endAngle": 6.283185307179584
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 217.6672716093589,
        "y": 708.5851893247998,
        "z": 0
      },
      {
        "x": 217.9553455880951,
        "y": 708.4133523190358,
        "z": 0
      }
    ],
    "handle": "3FC8",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 217.9553455880951,
        "y": 708.4133523190358,
        "z": 0
      },
      {
        "x": 217.9553455884459,
        "y": 708.1054943306297,
        "z": 0
      }
    ],
    "handle": "3FC9",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 217.9553455880951,
        "y": 709.054611942721,
        "z": 0
      },
      {
        "x": 217.9553455884459,
        "y": 708.7467539543214,
        "z": 0
      }
    ],
    "handle": "3FCA",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 213.4332924914778,
        "y": 711.7520303810006,
        "z": 0
      },
      {
        "x": 217.9553455880951,
        "y": 709.054611942721,
        "z": 0
      }
    ],
    "handle": "3FCB",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 213.358713787748,
        "y": 706.1687595443725,
        "z": 0
      },
      {
        "x": 217.9553455884459,
        "y": 708.7467539543214,
        "z": 0
      }
    ],
    "handle": "3FCC",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 213.3628570482832,
        "y": 706.4789412571118,
        "z": 0
      },
      {
        "x": 217.9553455880951,
        "y": 709.054611942721,
        "z": 0
      }
    ],
    "handle": "3FCD",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 213.3628570482832,
        "y": 705.8376816343516,
        "z": 0
      },
      {
        "x": 215.3840707284398,
        "y": 706.9712676573507,
        "z": 0
      }
    ],
    "handle": "3FCE",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 213.358713787748,
        "y": 705.5274999206848,
        "z": 0
      },
      {
        "x": 215.321609898063,
        "y": 706.6283788727478,
        "z": 0
      }
    ],
    "handle": "3FCF",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 213.3628570482832,
        "y": 705.8376816343516,
        "z": 0
      },
      {
        "x": 213.358713787748,
        "y": 705.5274999206848,
        "z": 0
      }
    ],
    "handle": "3FD0",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 213.3628570482832,
        "y": 706.4789412571118,
        "z": 0
      },
      {
        "x": 213.358713787748,
        "y": 706.1687595443725,
        "z": 0
      }
    ],
    "handle": "3FD1",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 266.8207327448751,
        "y": 736.9102056799411,
        "z": 0
      },
      {
        "x": 284.9726795714819,
        "y": 747.0906202681317,
        "z": 0
      }
    ],
    "handle": "3FD2",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 266.2887264988389,
        "y": 737.2275490239218,
        "z": 0
      },
      {
        "x": 284.4305935039301,
        "y": 747.4023104030638,
        "z": 0
      }
    ],
    "handle": "3FD3",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 263.6286952637009,
        "y": 738.8142657559328,
        "z": 0
      },
      {
        "x": 281.7201631593638,
        "y": 748.9607610805043,
        "z": 0
      }
    ],
    "handle": "3FD4",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 264.9259158723869,
        "y": 735.4517743987891,
        "z": 0
      },
      {
        "x": 316.0059527086569,
        "y": 706.0816346071596,
        "z": 0
      }
    ],
    "handle": "3FD5",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 264.1078351233149,
        "y": 734.9929585326425,
        "z": 0
      },
      {
        "x": 316.0059527086569,
        "y": 705.1524364314897,
        "z": 0
      }
    ],
    "handle": "3FD6",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 247.7799421299709,
        "y": 726.2312881899923,
        "z": 0
      },
      {
        "x": 303.4770494893889,
        "y": 694.2064125137402,
        "z": 0
      }
    ],
    "handle": "3FD7",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 246.961861384277,
        "y": 725.7724723257076,
        "z": 0
      },
      {
        "x": 302.643650457611,
        "y": 693.756404400803,
        "z": 0
      }
    ],
    "handle": "3FD8",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 257.7821200822947,
        "y": 736.0327487615831,
        "z": 0
      },
      {
        "x": 262.3000299158738,
        "y": 733.3378017945212,
        "z": 0
      }
    ],
    "handle": "3FD9",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 257.7821200829939,
        "y": 736.3454019511082,
        "z": 0
      },
      {
        "x": 262.3041731769907,
        "y": 733.6479835081842,
        "z": 0
      }
    ],
    "handle": "3FDA",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "ELLIPSE",
    "handle": "3FDB",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "center": {
      "x": 262.29902673699,
      "y": 739.1988565046339,
      "z": 0
    },
    "majorAxisEndPoint": {
      "x": -0.1764129755113634,
      "y": 0,
      "z": 0
    },
    "axisRatio": 0.6259016496518008,
    "startAngle": 0,
    "endAngle": 6.283185307179584
  },
  {
    "type": "SPLINE",
    "handle": "3FDC",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "normalVector": {
      "x": 0,
      "y": 0,
      "z": 1
    },
    "planar": true,
    "degreeOfSplineCurve": 3,
    "numberOfKnots": 12,
    "numberOfControlPoints": 8,
    "numberOfFitPoints": 0,
    "knotValues": [
      0.7387853746015494,
      0.7387853746015494,
      0.7387853746015494,
      0.7387853746015494,
      0.7844749931928205,
      0.7844749931928205,
      1.696252131471398,
      1.696252131471398,
      2.401878553014586,
      2.401878553014586,
      2.401878553014586,
      2.401878553014586
    ],
    "controlPoints": [
      {
        "x": 262.122613756567,
        "y": 739.0575833776927,
        "z": 0
      },
      {
        "x": 262.125383354782,
        "y": 739.0556822409815,
        "z": 0
      },
      {
        "x": 262.1281911281398,
        "y": 739.0538415713187,
        "z": 0
      },
      {
        "x": 262.1877302378992,
        "y": 739.0165070760949,
        "z": 0
      },
      {
        "x": 262.2587491663878,
        "y": 739.002934858202,
        "z": 0
      },
      {
        "x": 262.3806894624139,
        "y": 739.0125605287026,
        "z": 0
      },
      {
        "x": 262.4329419550478,
        "y": 739.0277806483209,
        "z": 0
      },
      {
        "x": 262.4754397094947,
        "y": 739.0573234204192,
        "z": 0
      }
    ]
  },
  {
    "type": "SPLINE",
    "handle": "3FDD",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "normalVector": {
      "x": 0,
      "y": 0,
      "z": 1
    },
    "planar": true,
    "degreeOfSplineCurve": 3,
    "numberOfKnots": 14,
    "numberOfControlPoints": 10,
    "numberOfFitPoints": 0,
    "knotValues": [
      0.9221147950801091,
      0.9221147950801091,
      0.9221147950801091,
      0.9221147950801091,
      0.9338670167145838,
      0.9338670167145838,
      1.505248745831563,
      1.505248745831563,
      2.210109023906936,
      2.210109023906936,
      2.218899873798678,
      2.218899873798678,
      2.218899873798678,
      2.218899873798678
    ],
    "controlPoints": [
      {
        "x": 262.122613756567,
        "y": 738.9641903126612,
        "z": 0
      },
      {
        "x": 262.1236268666109,
        "y": 738.9637076025826,
        "z": 0
      },
      {
        "x": 262.1246408619908,
        "y": 738.9632296022016,
        "z": 0
      },
      {
        "x": 262.1749937443519,
        "y": 738.9397407481407,
        "z": 0
      },
      {
        "x": 262.2281351700648,
        "y": 738.9283849028832,
        "z": 0
      },
      {
        "x": 262.3462320008549,
        "y": 738.9238224988839,
        "z": 0
      },
      {
        "x": 262.4116545013969,
        "y": 738.9340709550341,
        "z": 0
      },
      {
        "x": 262.4739084478349,
        "y": 738.9631210090547,
        "z": 0
      },
      {
        "x": 262.4746744965671,
        "y": 738.9634815305424,
        "z": 0
      },
      {
        "x": 262.4754397094947,
        "y": 738.9638447658981,
        "z": 0
      }
    ]
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 262.1226137577319,
        "y": 739.1988565046339,
        "z": 0
      },
      {
        "x": 262.1226137577319,
        "y": 738.9641903126612,
        "z": 0
      }
    ],
    "handle": "3FDE",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 262.4754397094947,
        "y": 739.1988565046339,
        "z": 0
      },
      {
        "x": 262.4754397094947,
        "y": 738.9638447640428,
        "z": 0
      }
    ],
    "handle": "3FDF",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 262.5890267285861,
        "y": 738.7532024169348,
        "z": 0
      },
      {
        "x": 262.7365667558029,
        "y": 738.9363012462892,
        "z": 0
      }
    ],
    "handle": "3FE0",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 262.0090424198431,
        "y": 738.7532024169348,
        "z": 0
      },
      {
        "x": 261.8615023929738,
        "y": 738.9363012462892,
        "z": 0
      }
    ],
    "handle": "3FE1",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 261.8615023929738,
        "y": 738.9363012462892,
        "z": 0
      },
      {
        "x": 261.8615023929738,
        "y": 738.7437875261528,
        "z": 0
      }
    ],
    "handle": "3FE2",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 262.5890267285861,
        "y": 738.7532024169348,
        "z": 0
      },
      {
        "x": 262.5890267285861,
        "y": 738.5606887033093,
        "z": 0
      }
    ],
    "handle": "3FE3",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 262.7365667558029,
        "y": 738.9363012462892,
        "z": 0
      },
      {
        "x": 262.7365667542903,
        "y": 738.7437875373361,
        "z": 0
      }
    ],
    "handle": "3FE4",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 262.0090424198431,
        "y": 738.7532024169348,
        "z": 0
      },
      {
        "x": 262.009042418677,
        "y": 738.5606887033093,
        "z": 0
      }
    ],
    "handle": "3FE5",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 262.009042418677,
        "y": 738.5606887033093,
        "z": 0
      },
      {
        "x": 261.8615023929738,
        "y": 738.7437875373361,
        "z": 0
      }
    ],
    "handle": "3FE6",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 262.5890267285861,
        "y": 738.5606887033093,
        "z": 0
      },
      {
        "x": 262.7365667558029,
        "y": 738.7437875373361,
        "z": 0
      }
    ],
    "handle": "3FE7",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "ELLIPSE",
    "handle": "3FE8",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "center": {
      "x": 262.29902673699,
      "y": 738.9759251922334,
      "z": 0
    },
    "majorAxisEndPoint": {
      "x": 0.1764129755138129,
      "y": 2.17674e-11,
      "z": 0
    },
    "axisRatio": 0.6259016496423861,
    "startAngle": 3.252782333826853,
    "endAngle": 6.168573069506875
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 262.0090424198431,
        "y": 738.7532024169348,
        "z": 0
      },
      {
        "x": 262.5890267285861,
        "y": 738.7532024169348,
        "z": 0
      }
    ],
    "handle": "3FE9",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 262.009042418677,
        "y": 738.5606887033093,
        "z": 0
      },
      {
        "x": 262.5890267285861,
        "y": 738.5606887033093,
        "z": 0
      }
    ],
    "handle": "3FEA",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 262.0090424198431,
        "y": 739.1194000756294,
        "z": 0
      },
      {
        "x": 261.8615023929738,
        "y": 738.9363012462892,
        "z": 0
      }
    ],
    "handle": "3FEB",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 262.0090424198431,
        "y": 739.1194000756294,
        "z": 0
      },
      {
        "x": 262.1226137600609,
        "y": 739.1194000728427,
        "z": 0
      }
    ],
    "handle": "3FEC",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 262.5890267285861,
        "y": 739.1194000756294,
        "z": 0
      },
      {
        "x": 262.7365667558029,
        "y": 738.9363012462892,
        "z": 0
      }
    ],
    "handle": "3FED",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 262.4754397103679,
        "y": 739.1194000793627,
        "z": 0
      },
      {
        "x": 262.5890267285861,
        "y": 739.1194000756294,
        "z": 0
      }
    ],
    "handle": "3FEE",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "ELLIPSE",
    "handle": "3FEF",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "center": {
      "x": 258.9469522254079,
      "y": 737.3188648633612,
      "z": 0
    },
    "majorAxisEndPoint": {
      "x": -0.1764129755113634,
      "y": 0,
      "z": 0
    },
    "axisRatio": 0.6259016496518008,
    "startAngle": 0,
    "endAngle": 6.283185307179584
  },
  {
    "type": "SPLINE",
    "handle": "3FF0",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "normalVector": {
      "x": 0,
      "y": 0,
      "z": 1
    },
    "planar": true,
    "degreeOfSplineCurve": 3,
    "numberOfKnots": 12,
    "numberOfControlPoints": 8,
    "numberOfFitPoints": 0,
    "knotValues": [
      0.7387853746015494,
      0.7387853746015494,
      0.7387853746015494,
      0.7387853746015494,
      0.7844749931928205,
      0.7844749931928205,
      1.696252131471398,
      1.696252131471398,
      2.401878553014586,
      2.401878553014586,
      2.401878553014586,
      2.401878553014586
    ],
    "controlPoints": [
      {
        "x": 258.7705392451027,
        "y": 737.1775917392189,
        "z": 0
      },
      {
        "x": 258.7733088441313,
        "y": 737.1756906006402,
        "z": 0
      },
      {
        "x": 258.7761166173738,
        "y": 737.173849930984,
        "z": 0
      },
      {
        "x": 258.835655727366,
        "y": 737.136515434835,
        "z": 0
      },
      {
        "x": 258.90667465562,
        "y": 737.1229432197215,
        "z": 0
      },
      {
        "x": 259.0286149517626,
        "y": 737.1325688902206,
        "z": 0
      },
      {
        "x": 259.0808674427679,
        "y": 737.1477890079947,
        "z": 0
      },
      {
        "x": 259.1233651987859,
        "y": 737.1773317819542,
        "z": 0
      }
    ]
  },
  {
    "type": "SPLINE",
    "handle": "3FF1",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "normalVector": {
      "x": 0,
      "y": 0,
      "z": 1
    },
    "planar": true,
    "degreeOfSplineCurve": 3,
    "numberOfKnots": 14,
    "numberOfControlPoints": 10,
    "numberOfFitPoints": 0,
    "knotValues": [
      0.9221147950801091,
      0.9221147950801091,
      0.9221147950801091,
      0.9221147950801091,
      0.9338670167145838,
      0.9338670167145838,
      1.505248745831563,
      1.505248745831563,
      2.210109023906936,
      2.210109023906936,
      2.218899873798678,
      2.218899873798678,
      2.218899873798678,
      2.218899873798678
    ],
    "controlPoints": [
      {
        "x": 258.7705392451027,
        "y": 737.0841986723218,
        "z": 0
      },
      {
        "x": 258.7715523552029,
        "y": 737.083715961311,
        "z": 0
      },
      {
        "x": 258.7725663513408,
        "y": 737.0832379637213,
        "z": 0
      },
      {
        "x": 258.8229192328861,
        "y": 737.0597491068739,
        "z": 0
      },
      {
        "x": 258.8760606577279,
        "y": 737.04839326255,
        "z": 0
      },
      {
        "x": 258.9941574893889,
        "y": 737.0438308576122,
        "z": 0
      },
      {
        "x": 259.059579989872,
        "y": 737.0540793156215,
        "z": 0
      },
      {
        "x": 259.1218339370088,
        "y": 737.083129369651,
        "z": 0
      },
      {
        "x": 259.1225999851011,
        "y": 737.0834898911525,
        "z": 0
      },
      {
        "x": 259.1233651987859,
        "y": 737.0838531246452,
        "z": 0
      }
    ]
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 258.7705392466146,
        "y": 737.3188648633612,
        "z": 0
      },
      {
        "x": 258.7705392466146,
        "y": 737.0841986741806,
        "z": 0
      }
    ],
    "handle": "3FF2",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 259.1233651973299,
        "y": 737.3188648633612,
        "z": 0
      },
      {
        "x": 259.1233651973299,
        "y": 737.0838531255722,
        "z": 0
      }
    ],
    "handle": "3FF3",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 259.236952217062,
        "y": 736.8732107775348,
        "z": 0
      },
      {
        "x": 259.3844922443958,
        "y": 737.0563096087432,
        "z": 0
      }
    ],
    "handle": "3FF4",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 258.6569679087261,
        "y": 736.8732107775348,
        "z": 0
      },
      {
        "x": 258.5094278817999,
        "y": 737.0563096087432,
        "z": 0
      }
    ],
    "handle": "3FF5",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 258.5094278817999,
        "y": 737.0563096087432,
        "z": 0
      },
      {
        "x": 258.5094278817999,
        "y": 736.8637958895407,
        "z": 0
      }
    ],
    "handle": "3FF6",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 259.236952217062,
        "y": 736.8732107775348,
        "z": 0
      },
      {
        "x": 259.236952217062,
        "y": 736.6806970657753,
        "z": 0
      }
    ],
    "handle": "3FF7",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 259.3844922443958,
        "y": 737.0563096087432,
        "z": 0
      },
      {
        "x": 259.3844922428241,
        "y": 736.863795896061,
        "z": 0
      }
    ],
    "handle": "3FF8",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 258.6569679087261,
        "y": 736.8732107775348,
        "z": 0
      },
      {
        "x": 258.6569679075619,
        "y": 736.6806970657753,
        "z": 0
      }
    ],
    "handle": "3FF9",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 258.6569679075619,
        "y": 736.6806970657753,
        "z": 0
      },
      {
        "x": 258.5094278817999,
        "y": 736.863795896061,
        "z": 0
      }
    ],
    "handle": "3FFA",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 259.236952217062,
        "y": 736.6806970657753,
        "z": 0
      },
      {
        "x": 259.3844922443958,
        "y": 736.863795896061,
        "z": 0
      }
    ],
    "handle": "3FFB",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "ELLIPSE",
    "handle": "3FFC",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "center": {
      "x": 258.9469522254079,
      "y": 737.0959335537617,
      "z": 0
    },
    "majorAxisEndPoint": {
      "x": 0.1764129755138129,
      "y": 2.17674e-11,
      "z": 0
    },
    "axisRatio": 0.6259016496423861,
    "startAngle": 3.252782333826853,
    "endAngle": 6.168573069506875
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 258.6569679087261,
        "y": 736.8732107775348,
        "z": 0
      },
      {
        "x": 259.236952217062,
        "y": 736.8732107775348,
        "z": 0
      }
    ],
    "handle": "3FFD",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 258.6569679075619,
        "y": 736.6806970657753,
        "z": 0
      },
      {
        "x": 259.236952217062,
        "y": 736.6806970657753,
        "z": 0
      }
    ],
    "handle": "3FFE",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 258.6569679087261,
        "y": 737.2394084353036,
        "z": 0
      },
      {
        "x": 258.5094278817999,
        "y": 737.0563096087432,
        "z": 0
      }
    ],
    "handle": "3FFF",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 258.6569679087261,
        "y": 737.2394084353036,
        "z": 0
      },
      {
        "x": 258.7705392477787,
        "y": 737.2394084325024,
        "z": 0
      }
    ],
    "handle": "4000",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 259.236952217062,
        "y": 737.2394084353036,
        "z": 0
      },
      {
        "x": 259.3844922443958,
        "y": 737.0563096087432,
        "z": 0
      }
    ],
    "handle": "4001",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 259.1233651996579,
        "y": 737.239408439017,
        "z": 0
      },
      {
        "x": 259.236952217062,
        "y": 737.2394084353036,
        "z": 0
      }
    ],
    "handle": "4002",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 262.2881560265663,
        "y": 735.3516010725825,
        "z": 0
      },
      {
        "x": 262.401743044494,
        "y": 735.3516010716527,
        "z": 0
      }
    ],
    "handle": "4003",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 262.401743044494,
        "y": 735.3516010716527,
        "z": 0
      },
      {
        "x": 262.549283071362,
        "y": 735.1685022432318,
        "z": 0
      }
    ],
    "handle": "4004",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 261.821758736157,
        "y": 735.3516010716527,
        "z": 0
      },
      {
        "x": 261.9353300756198,
        "y": 735.3516010679303,
        "z": 0
      }
    ],
    "handle": "4005",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 261.821758736157,
        "y": 735.3516010716527,
        "z": 0
      },
      {
        "x": 261.6742187087648,
        "y": 735.1685022432318,
        "z": 0
      }
    ],
    "handle": "4006",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 261.821758734645,
        "y": 734.7928896993318,
        "z": 0
      },
      {
        "x": 262.401743044494,
        "y": 734.7928896993318,
        "z": 0
      }
    ],
    "handle": "4007",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 261.821758736157,
        "y": 734.9854034129492,
        "z": 0
      },
      {
        "x": 262.401743044494,
        "y": 734.9854034129492,
        "z": 0
      }
    ],
    "handle": "4008",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "ELLIPSE",
    "handle": "4009",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "center": {
      "x": 262.1117430536527,
      "y": 735.2081261882521,
      "z": 0
    },
    "majorAxisEndPoint": {
      "x": 0.1764129755138129,
      "y": 2.17674e-11,
      "z": 0
    },
    "axisRatio": 0.6259016496423861,
    "startAngle": 3.252782333826853,
    "endAngle": 6.168573069506875
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 262.401743044494,
        "y": 734.7928896993318,
        "z": 0
      },
      {
        "x": 262.549283071362,
        "y": 734.9759885314853,
        "z": 0
      }
    ],
    "handle": "400A",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 261.821758734645,
        "y": 734.7928896993318,
        "z": 0
      },
      {
        "x": 261.6742187087648,
        "y": 734.9759885314853,
        "z": 0
      }
    ],
    "handle": "400B",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 261.821758736157,
        "y": 734.9854034129492,
        "z": 0
      },
      {
        "x": 261.821758734645,
        "y": 734.7928896993318,
        "z": 0
      }
    ],
    "handle": "400C",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 262.549283071362,
        "y": 735.1685022432318,
        "z": 0
      },
      {
        "x": 262.5492830707227,
        "y": 734.9759885314853,
        "z": 0
      }
    ],
    "handle": "400D",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 262.401743044494,
        "y": 734.9854034129492,
        "z": 0
      },
      {
        "x": 262.401743044494,
        "y": 734.7928896993318,
        "z": 0
      }
    ],
    "handle": "400E",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 261.6742187087648,
        "y": 735.1685022432318,
        "z": 0
      },
      {
        "x": 261.6742187087648,
        "y": 734.9759885221672,
        "z": 0
      }
    ],
    "handle": "400F",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 261.821758736157,
        "y": 734.9854034129492,
        "z": 0
      },
      {
        "x": 261.6742187087648,
        "y": 735.1685022432318,
        "z": 0
      }
    ],
    "handle": "4010",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 262.401743044494,
        "y": 734.9854034129492,
        "z": 0
      },
      {
        "x": 262.549283071362,
        "y": 735.1685022432318,
        "z": 0
      }
    ],
    "handle": "4011",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 262.2881560254017,
        "y": 735.4310574987904,
        "z": 0
      },
      {
        "x": 262.2881560254017,
        "y": 735.1960457609938,
        "z": 0
      }
    ],
    "handle": "4012",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 261.9353300744549,
        "y": 735.4310574987904,
        "z": 0
      },
      {
        "x": 261.9353300744549,
        "y": 735.1963913086827,
        "z": 0
      }
    ],
    "handle": "4013",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "SPLINE",
    "handle": "4014",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "normalVector": {
      "x": 0,
      "y": 0,
      "z": 1
    },
    "planar": true,
    "degreeOfSplineCurve": 3,
    "numberOfKnots": 14,
    "numberOfControlPoints": 10,
    "numberOfFitPoints": 0,
    "knotValues": [
      0.9221147950801091,
      0.9221147950801091,
      0.9221147950801091,
      0.9221147950801091,
      0.9338670167145838,
      0.9338670167145838,
      1.505248745831563,
      1.505248745831563,
      2.210109023906936,
      2.210109023906936,
      2.218899873798678,
      2.218899873798678,
      2.218899873798678,
      2.218899873798678
    ],
    "controlPoints": [
      {
        "x": 261.935330073291,
        "y": 735.1963913086827,
        "z": 0
      },
      {
        "x": 261.936343183392,
        "y": 735.1959086004608,
        "z": 0
      },
      {
        "x": 261.9373571787727,
        "y": 735.1954305991527,
        "z": 0
      },
      {
        "x": 261.987710060319,
        "y": 735.1719417450947,
        "z": 0
      },
      {
        "x": 262.0408514860311,
        "y": 735.160585897971,
        "z": 0
      },
      {
        "x": 262.15894831682,
        "y": 735.1560234949037,
        "z": 0
      },
      {
        "x": 262.2243708173046,
        "y": 735.1662719519699,
        "z": 0
      },
      {
        "x": 262.2866247645579,
        "y": 735.1953220060022,
        "z": 0
      },
      {
        "x": 262.2873908117168,
        "y": 735.1956825256316,
        "z": 0
      },
      {
        "x": 262.2881560262178,
        "y": 735.1960457609938,
        "z": 0
      }
    ]
  },
  {
    "type": "SPLINE",
    "handle": "4015",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "normalVector": {
      "x": 0,
      "y": 0,
      "z": 1
    },
    "planar": true,
    "degreeOfSplineCurve": 3,
    "numberOfKnots": 12,
    "numberOfControlPoints": 8,
    "numberOfFitPoints": 0,
    "knotValues": [
      0.7387853746015494,
      0.7387853746015494,
      0.7387853746015494,
      0.7387853746015494,
      0.7844749931928205,
      0.7844749931928205,
      1.696252131471398,
      1.696252131471398,
      2.401878553014586,
      2.401878553014586,
      2.401878553014586,
      2.401878553014586
    ],
    "controlPoints": [
      {
        "x": 261.935330073291,
        "y": 735.2897843755698,
        "z": 0
      },
      {
        "x": 261.9380996706901,
        "y": 735.2878832360691,
        "z": 0
      },
      {
        "x": 261.9409074448049,
        "y": 735.2860425664037,
        "z": 0
      },
      {
        "x": 262.0004465546801,
        "y": 735.2487080711827,
        "z": 0
      },
      {
        "x": 262.0714654830528,
        "y": 735.2351358514204,
        "z": 0
      },
      {
        "x": 262.1934057790787,
        "y": 735.2447615247228,
        "z": 0
      },
      {
        "x": 262.2456582701988,
        "y": 735.2599816434002,
        "z": 0
      },
      {
        "x": 262.2881560262178,
        "y": 735.2895244164429,
        "z": 0
      }
    ]
  },
  {
    "type": "ELLIPSE",
    "handle": "4016",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "center": {
      "x": 262.1117430536527,
      "y": 735.4310574987904,
      "z": 0
    },
    "majorAxisEndPoint": {
      "x": -0.1764129755113634,
      "y": 0,
      "z": 0
    },
    "axisRatio": 0.6259016496518008,
    "startAngle": 0,
    "endAngle": 6.283185307179584
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 265.6402305389058,
        "y": 737.2315927129193,
        "z": 0
      },
      {
        "x": 265.7538175552039,
        "y": 737.2315927110602,
        "z": 0
      }
    ],
    "handle": "4017",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 265.7538175552039,
        "y": 737.2315927110602,
        "z": 0
      },
      {
        "x": 265.9013575825383,
        "y": 737.0484938826413,
        "z": 0
      }
    ],
    "handle": "4018",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 265.1738332472161,
        "y": 737.2315927110602,
        "z": 0
      },
      {
        "x": 265.2874045871441,
        "y": 737.2315927091914,
        "z": 0
      }
    ],
    "handle": "4019",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 265.1738332472161,
        "y": 737.2315927110602,
        "z": 0
      },
      {
        "x": 265.0262932198817,
        "y": 737.0484938826413,
        "z": 0
      }
    ],
    "handle": "401A",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 265.1738332459937,
        "y": 736.6728813387416,
        "z": 0
      },
      {
        "x": 265.7538175552039,
        "y": 736.6728813387416,
        "z": 0
      }
    ],
    "handle": "401B",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 265.1738332472161,
        "y": 736.8653950532823,
        "z": 0
      },
      {
        "x": 265.7538175552039,
        "y": 736.8653950532823,
        "z": 0
      }
    ],
    "handle": "401C",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "ELLIPSE",
    "handle": "401D",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "center": {
      "x": 265.4638175643051,
      "y": 737.0881178295239,
      "z": 0
    },
    "majorAxisEndPoint": {
      "x": 0.1764129755138129,
      "y": 2.17674e-11,
      "z": 0
    },
    "axisRatio": 0.6259016496423861,
    "startAngle": 3.252782333826853,
    "endAngle": 6.168573069506875
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 265.7538175552039,
        "y": 736.6728813387416,
        "z": 0
      },
      {
        "x": 265.9013575825383,
        "y": 736.8559801708943,
        "z": 0
      }
    ],
    "handle": "401E",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 265.1738332459937,
        "y": 736.6728813387416,
        "z": 0
      },
      {
        "x": 265.0262932198817,
        "y": 736.8559801708943,
        "z": 0
      }
    ],
    "handle": "401F",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 265.1738332472161,
        "y": 736.8653950532823,
        "z": 0
      },
      {
        "x": 265.1738332459937,
        "y": 736.6728813387416,
        "z": 0
      }
    ],
    "handle": "4020",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 265.9013575825383,
        "y": 737.0484938826413,
        "z": 0
      },
      {
        "x": 265.9013575813718,
        "y": 736.8559801708943,
        "z": 0
      }
    ],
    "handle": "4021",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 265.7538175552039,
        "y": 736.8653950532823,
        "z": 0
      },
      {
        "x": 265.7538175552039,
        "y": 736.6728813387416,
        "z": 0
      }
    ],
    "handle": "4022",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 265.0262932198817,
        "y": 737.0484938826413,
        "z": 0
      },
      {
        "x": 265.0262932198817,
        "y": 736.8559801625024,
        "z": 0
      }
    ],
    "handle": "4023",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 265.1738332472161,
        "y": 736.8653950532823,
        "z": 0
      },
      {
        "x": 265.0262932198817,
        "y": 737.0484938826413,
        "z": 0
      }
    ],
    "handle": "4024",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 265.7538175552039,
        "y": 736.8653950532823,
        "z": 0
      },
      {
        "x": 265.9013575825383,
        "y": 737.0484938826413,
        "z": 0
      }
    ],
    "handle": "4025",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 265.6402305365789,
        "y": 737.3110491382027,
        "z": 0
      },
      {
        "x": 265.6402305365789,
        "y": 737.0760373994673,
        "z": 0
      }
    ],
    "handle": "4026",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 265.2874045855118,
        "y": 737.3110491382027,
        "z": 0
      },
      {
        "x": 265.2874045855118,
        "y": 737.0763829471505,
        "z": 0
      }
    ],
    "handle": "4027",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "SPLINE",
    "handle": "4028",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "normalVector": {
      "x": 0,
      "y": 0,
      "z": 1
    },
    "planar": true,
    "degreeOfSplineCurve": 3,
    "numberOfKnots": 14,
    "numberOfControlPoints": 10,
    "numberOfFitPoints": 0,
    "knotValues": [
      0.9221147950801091,
      0.9221147950801091,
      0.9221147950801091,
      0.9221147950801091,
      0.9338670167145838,
      0.9338670167145838,
      1.505248745831563,
      1.505248745831563,
      2.210109023906936,
      2.210109023906936,
      2.218899873798678,
      2.218899873798678,
      2.218899873798678,
      2.218899873798678
    ],
    "controlPoints": [
      {
        "x": 265.2874045839999,
        "y": 737.0763829471505,
        "z": 0
      },
      {
        "x": 265.288417694042,
        "y": 737.0759002370723,
        "z": 0
      },
      {
        "x": 265.289431689424,
        "y": 737.0754222394825,
        "z": 0
      },
      {
        "x": 265.339784571785,
        "y": 737.0519333826343,
        "z": 0
      },
      {
        "x": 265.3929259974992,
        "y": 737.0405775392419,
        "z": 0
      },
      {
        "x": 265.5110228289851,
        "y": 737.0360151352388,
        "z": 0
      },
      {
        "x": 265.5764453295848,
        "y": 737.0462635904512,
        "z": 0
      },
      {
        "x": 265.6386992752089,
        "y": 737.0753136463433,
        "z": 0
      },
      {
        "x": 265.6394653241151,
        "y": 737.0756741659723,
        "z": 0
      },
      {
        "x": 265.6402305369257,
        "y": 737.0760373994673,
        "z": 0
      }
    ]
  },
  {
    "type": "SPLINE",
    "handle": "4029",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "normalVector": {
      "x": 0,
      "y": 0,
      "z": 1
    },
    "planar": true,
    "degreeOfSplineCurve": 3,
    "numberOfKnots": 12,
    "numberOfControlPoints": 8,
    "numberOfFitPoints": 0,
    "knotValues": [
      0.7387853746015494,
      0.7387853746015494,
      0.7387853746015494,
      0.7387853746015494,
      0.7844749931928205,
      0.7844749931928205,
      1.696252131471398,
      1.696252131471398,
      2.401878553014586,
      2.401878553014586,
      2.401878553014586,
      2.401878553014586
    ],
    "controlPoints": [
      {
        "x": 265.2874045839999,
        "y": 737.169776013121,
        "z": 0
      },
      {
        "x": 265.2901741822721,
        "y": 737.1678748764125,
        "z": 0
      },
      {
        "x": 265.2929819555727,
        "y": 737.1660342048852,
        "z": 0
      },
      {
        "x": 265.352521065332,
        "y": 737.1286997096566,
        "z": 0
      },
      {
        "x": 265.4235399944581,
        "y": 737.1151274926924,
        "z": 0
      },
      {
        "x": 265.5454802897876,
        "y": 737.1247531659938,
        "z": 0
      },
      {
        "x": 265.5977327832939,
        "y": 737.1399732846703,
        "z": 0
      },
      {
        "x": 265.6402305369257,
        "y": 737.1695160558389,
        "z": 0
      }
    ]
  },
  {
    "type": "ELLIPSE",
    "handle": "402A",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "center": {
      "x": 265.4638175643051,
      "y": 737.3110491354017,
      "z": 0
    },
    "majorAxisEndPoint": {
      "x": -0.1764129755113634,
      "y": 0,
      "z": 0
    },
    "axisRatio": 0.6259016496518008,
    "startAngle": 0,
    "endAngle": 6.283185307179584
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 257.7821200822947,
        "y": 736.3454019483107,
        "z": 0
      },
      {
        "x": 257.7821200814809,
        "y": 736.0327487671666,
        "z": 0
      }
    ],
    "handle": "402B",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 257.7821200829939,
        "y": 736.3454019483107,
        "z": 0
      },
      {
        "x": 258.0660508007266,
        "y": 736.5046428516422,
        "z": 0
      }
    ],
    "handle": "402C",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 266.6085877370779,
        "y": 736.3954911977015,
        "z": 0
      },
      {
        "x": 266.8966617166879,
        "y": 736.2236541947312,
        "z": 0
      }
    ],
    "handle": "402D",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 266.8966617166879,
        "y": 736.2236541947312,
        "z": 0
      },
      {
        "x": 266.8966617178508,
        "y": 735.9157962072604,
        "z": 0
      }
    ],
    "handle": "402E",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 266.8966617166879,
        "y": 736.8649138193505,
        "z": 0
      },
      {
        "x": 266.8966617178508,
        "y": 736.5570558281506,
        "z": 0
      }
    ],
    "handle": "402F",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 257.7821200822947,
        "y": 736.9866615729406,
        "z": 0
      },
      {
        "x": 257.7821200814809,
        "y": 736.6740083917938,
        "z": 0
      }
    ],
    "handle": "4030",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 257.7821200829939,
        "y": 736.9866615729406,
        "z": 0
      },
      {
        "x": 262.3746086204188,
        "y": 739.5623322566887,
        "z": 0
      }
    ],
    "handle": "4031",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 262.3746086204188,
        "y": 739.5623322566887,
        "z": 0
      },
      {
        "x": 266.8966617166879,
        "y": 736.8649138193505,
        "z": 0
      }
    ],
    "handle": "4032",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 262.3000299158738,
        "y": 733.9790614182092,
        "z": 0
      },
      {
        "x": 266.8966617178508,
        "y": 736.5570558281506,
        "z": 0
      }
    ],
    "handle": "4033",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 262.3041731769907,
        "y": 734.2892431309446,
        "z": 0
      },
      {
        "x": 266.8966617166879,
        "y": 736.8649138193505,
        "z": 0
      }
    ],
    "handle": "4034",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 262.3041731769907,
        "y": 733.6479835081842,
        "z": 0
      },
      {
        "x": 262.3000299158738,
        "y": 733.3378017945212,
        "z": 0
      }
    ],
    "handle": "4035",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 262.3041731769907,
        "y": 734.2892431309446,
        "z": 0
      },
      {
        "x": 262.3000299158738,
        "y": 733.9790614182092,
        "z": 0
      }
    ],
    "handle": "4036",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 257.78212008113,
        "y": 736.6740083917938,
        "z": 0
      },
      {
        "x": 262.3000299158738,
        "y": 733.9790614182092,
        "z": 0
      }
    ],
    "handle": "4037",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 257.7821200829939,
        "y": 736.9866615729406,
        "z": 0
      },
      {
        "x": 262.3041731769907,
        "y": 734.2892431309446,
        "z": 0
      }
    ],
    "handle": "4038",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 265.4224503558347,
        "y": 735.3968512592826,
        "z": 0
      },
      {
        "x": 266.8966617159318,
        "y": 736.2236541910021,
        "z": 0
      }
    ],
    "handle": "4039",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 262.3041731769907,
        "y": 733.6479835081842,
        "z": 0
      },
      {
        "x": 264.3253868570321,
        "y": 734.7815695302487,
        "z": 0
      }
    ],
    "handle": "403A",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "ELLIPSE",
    "handle": "403B",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "center": {
      "x": 264.8822698354487,
      "y": 735.0745282592204,
      "z": 0
    },
    "majorAxisEndPoint": {
      "x": 0.5533977571762492,
      "y": 0.299527276386044,
      "z": 0
    },
    "axisRatio": 0.8446940944687678,
    "startAngle": -0.0495734242638319,
    "endAngle": 0.4882933596806325
  },
  {
    "type": "ELLIPSE",
    "handle": "403C",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "center": {
      "x": 264.8822698354487,
      "y": 735.0745282592204,
      "z": 0
    },
    "majorAxisEndPoint": {
      "x": 0.5533977571668851,
      "y": 0.2995272764091438,
      "z": 0
    },
    "axisRatio": 0.8446940944788723,
    "startAngle": 1.937062951397157,
    "endAngle": 3.155582229527015
  },
  {
    "type": "SPLINE",
    "handle": "403D",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "normalVector": {
      "x": 0,
      "y": 0,
      "z": 1
    },
    "planar": true,
    "degreeOfSplineCurve": 3,
    "numberOfKnots": 10,
    "numberOfControlPoints": 6,
    "numberOfFitPoints": 0,
    "knotValues": [
      0.2866710058334736,
      0.2866710058334736,
      0.2866710058334736,
      0.2866710058334736,
      0.3202527597656655,
      0.3202527597656655,
      0.632600549675783,
      0.632600549675783,
      0.632600549675783,
      0.632600549675783
    ],
    "controlPoints": [
      {
        "x": 265.7496839122609,
        "y": 735.272520325143,
        "z": 0
      },
      {
        "x": 265.7512042527097,
        "y": 735.2631496433133,
        "z": 0
      },
      {
        "x": 265.752542313305,
        "y": 735.2537512211092,
        "z": 0
      },
      {
        "x": 265.7644330919721,
        "y": 735.1567269572922,
        "z": 0
      },
      {
        "x": 265.7591977483832,
        "y": 735.0677766837105,
        "z": 0
      },
      {
        "x": 265.7401310751442,
        "y": 734.9816978229206,
        "z": 0
      }
    ]
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 265.749683912611,
        "y": 735.272520325143,
        "z": 0
      },
      {
        "x": 266.8966617166879,
        "y": 735.9157962072604,
        "z": 0
      }
    ],
    "handle": "403E",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 262.3000299158738,
        "y": 733.3378017945212,
        "z": 0
      },
      {
        "x": 264.2629260257809,
        "y": 734.4386807475205,
        "z": 0
      }
    ],
    "handle": "403F",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "SPLINE",
    "handle": "4040",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "normalVector": {
      "x": 0,
      "y": 0,
      "z": 1
    },
    "planar": true,
    "degreeOfSplineCurve": 3,
    "numberOfKnots": 12,
    "numberOfControlPoints": 8,
    "numberOfFitPoints": 0,
    "knotValues": [
      1.601014487257268,
      1.601014487257268,
      1.601014487257268,
      1.601014487257268,
      2.144527230635417,
      2.144527230635417,
      2.684476675754792,
      2.684476675754792,
      2.822521534132349,
      2.822521534132349,
      2.822521534132349,
      2.822521534132349
    ],
    "controlPoints": [
      {
        "x": 265.2401102309217,
        "y": 734.3590034004311,
        "z": 0
      },
      {
        "x": 265.1017792993818,
        "y": 734.2887944709545,
        "z": 0
      },
      {
        "x": 264.9474053129087,
        "y": 734.2502901954502,
        "z": 0
      },
      {
        "x": 264.6404858127942,
        "y": 734.2513866396582,
        "z": 0
      },
      {
        "x": 264.4877398235839,
        "y": 734.2908421019017,
        "z": 0
      },
      {
        "x": 264.3243380454947,
        "y": 734.390439777631,
        "z": 0
      },
      {
        "x": 264.2926527114471,
        "y": 734.4133924199231,
        "z": 0
      },
      {
        "x": 264.2629260265968,
        "y": 734.4386807456613,
        "z": 0
      }
    ]
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 271.9742078462147,
        "y": 749.8228123309082,
        "z": 0
      },
      {
        "x": 277.5454913050058,
        "y": 746.6194204743906,
        "z": 0
      }
    ],
    "handle": "4041",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 270.3197269728397,
        "y": 749.8449121052397,
        "z": 0
      },
      {
        "x": 276.7274105605316,
        "y": 746.1606046101051,
        "z": 0
      }
    ],
    "handle": "4042",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 270.9259375232508,
        "y": 749.2567807771195,
        "z": 0
      },
      {
        "x": 270.9259375232508,
        "y": 742.906881947994,
        "z": 0
      }
    ],
    "handle": "4043",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 271.7314712868538,
        "y": 749.6917425598947,
        "z": 0
      },
      {
        "x": 271.7314712868538,
        "y": 743.358660909344,
        "z": 0
      }
    ],
    "handle": "4044",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 255.0634906458439,
        "y": 740.6915802806614,
        "z": 0
      },
      {
        "x": 255.0634906453782,
        "y": 734.0105201900012,
        "z": 0
      }
    ],
    "handle": "4045",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 222.0366063668629,
        "y": 722.8581471527039,
        "z": 0
      },
      {
        "x": 222.0366063668629,
        "y": 715.4875828083603,
        "z": 0
      }
    ],
    "handle": "4046",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 222.8421401298832,
        "y": 723.293108936393,
        "z": 0
      },
      {
        "x": 222.8421401298832,
        "y": 715.9393617687718,
        "z": 0
      }
    ],
    "handle": "4047",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 238.9528153916468,
        "y": 731.9923446113208,
        "z": 0
      },
      {
        "x": 238.9528153908318,
        "y": 724.9749409826428,
        "z": 0
      }
    ],
    "handle": "4048",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 254.6686344565239,
        "y": 741.3495342191306,
        "z": 0
      },
      {
        "x": 260.047141252784,
        "y": 738.2569856196603,
        "z": 0
      }
    ],
    "handle": "4049",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 238.9466396606289,
        "y": 731.3102846890698,
        "z": 0
      },
      {
        "x": 244.5274257186091,
        "y": 728.1014290032899,
        "z": 0
      }
    ],
    "handle": "404A",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 221.6540699494077,
        "y": 723.1558833140843,
        "z": 0
      },
      {
        "x": 228.5942501377439,
        "y": 719.1653994601182,
        "z": 0
      }
    ],
    "handle": "404B",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 220.8359892041759,
        "y": 722.6970674507311,
        "z": 0
      },
      {
        "x": 227.7761693900687,
        "y": 718.7065835958307,
        "z": 0
      }
    ],
    "handle": "404C",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 238.1132406288525,
        "y": 730.8602765752001,
        "z": 0
      },
      {
        "x": 243.709344972041,
        "y": 727.6426131399311,
        "z": 0
      }
    ],
    "handle": "404D",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 253.835235424863,
        "y": 740.8995261061935,
        "z": 0
      },
      {
        "x": 259.2290605048181,
        "y": 737.7981697563,
        "z": 0
      }
    ],
    "handle": "404E",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 254.257956882939,
        "y": 740.2566184960297,
        "z": 0
      },
      {
        "x": 254.257956882939,
        "y": 733.5587412305102,
        "z": 0
      }
    ],
    "handle": "404F",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 238.1472816276358,
        "y": 731.5573828266906,
        "z": 0
      },
      {
        "x": 238.1472816276358,
        "y": 724.5231620194528,
        "z": 0
      }
    ],
    "handle": "4050",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 303.9506957342378,
        "y": 735.3693058155438,
        "z": 0
      },
      {
        "x": 303.9506957342378,
        "y": 694.4621659349601,
        "z": 0
      }
    ],
    "handle": "4051",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 304.7562294971431,
        "y": 734.9061377998448,
        "z": 0
      },
      {
        "x": 304.7562294956289,
        "y": 694.8971277195924,
        "z": 0
      }
    ],
    "handle": "4052",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 280.7980077194517,
        "y": 744.7492796583016,
        "z": 0
      },
      {
        "x": 316.0059527086569,
        "y": 724.5053188064986,
        "z": 0
      }
    ],
    "handle": "4053",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 279.9799269725341,
        "y": 744.2904637949546,
        "z": 0
      },
      {
        "x": 316.0059527086569,
        "y": 723.5761206308307,
        "z": 0
      }
    ],
    "handle": "4054",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 157.5939053440232,
        "y": 688.9766695983715,
        "z": 0
      },
      {
        "x": 168.1468646692807,
        "y": 694.6749211438,
        "z": 0
      }
    ],
    "handle": "4055",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 161.9909238556279,
        "y": 740.3322601979488,
        "z": 0
      },
      {
        "x": 169.628312890361,
        "y": 725.0466185444928,
        "z": 0
      }
    ],
    "handle": "4056",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 190.6207896174159,
        "y": 705.8946375949333,
        "z": 0
      },
      {
        "x": 190.6207896174159,
        "y": 697.8682033475487,
        "z": 0
      }
    ],
    "handle": "4057",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 206.731464875804,
        "y": 714.5938732670627,
        "z": 0
      },
      {
        "x": 206.731464875804,
        "y": 706.9037825604829,
        "z": 0
      }
    ],
    "handle": "4058",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 174.5101143624629,
        "y": 697.1954019255945,
        "z": 0
      },
      {
        "x": 174.5101143629289,
        "y": 691.6661747545039,
        "z": 0
      }
    ],
    "handle": "4059",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 190.0957535877819,
        "y": 705.7608425160832,
        "z": 0
      },
      {
        "x": 197.169777774659,
        "y": 701.5411655502393,
        "z": 0
      }
    ],
    "handle": "405A",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 174.9257722177998,
        "y": 697.4198435191028,
        "z": 0
      },
      {
        "x": 182.1440897241698,
        "y": 693.1140951476928,
        "z": 0
      }
    ],
    "handle": "405B",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "ELLIPSE",
    "handle": "405C",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "center": {
      "x": 176.899420465518,
      "y": 691.0829985393211,
      "z": 0
    },
    "majorAxisEndPoint": {
      "x": -0.1764129755113634,
      "y": 0,
      "z": 0
    },
    "axisRatio": 0.6259016496518008,
    "startAngle": 0,
    "endAngle": 6.283185307179584
  },
  {
    "type": "SPLINE",
    "handle": "405D",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "normalVector": {
      "x": 0,
      "y": 0,
      "z": 1
    },
    "planar": true,
    "degreeOfSplineCurve": 3,
    "numberOfKnots": 12,
    "numberOfControlPoints": 8,
    "numberOfFitPoints": 0,
    "knotValues": [
      0.7387853746015494,
      0.7387853746015494,
      0.7387853746015494,
      0.7387853746015494,
      0.7844749931928205,
      0.7844749931928205,
      1.696252131471398,
      1.696252131471398,
      2.401878553014586,
      2.401878553014586,
      2.401878553014586,
      2.401878553014586
    ],
    "controlPoints": [
      {
        "x": 176.7230074852111,
        "y": 690.9417254151703,
        "z": 0
      },
      {
        "x": 176.7257770826111,
        "y": 690.9398242775387,
        "z": 0
      },
      {
        "x": 176.7285848567259,
        "y": 690.9379836050682,
        "z": 0
      },
      {
        "x": 176.7881239665442,
        "y": 690.900649109848,
        "z": 0
      },
      {
        "x": 176.8591428957878,
        "y": 690.8870768956847,
        "z": 0
      },
      {
        "x": 176.9810831902998,
        "y": 690.8967025661836,
        "z": 0
      },
      {
        "x": 177.0333356821788,
        "y": 690.9119226830043,
        "z": 0
      },
      {
        "x": 177.075833437383,
        "y": 690.9414654579014,
        "z": 0
      }
    ]
  },
  {
    "type": "SPLINE",
    "handle": "405E",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "normalVector": {
      "x": 0,
      "y": 0,
      "z": 1
    },
    "planar": true,
    "degreeOfSplineCurve": 3,
    "numberOfKnots": 14,
    "numberOfControlPoints": 10,
    "numberOfFitPoints": 0,
    "knotValues": [
      0.9221147950801091,
      0.9221147950801091,
      0.9221147950801091,
      0.9221147950801091,
      0.9338670167145838,
      0.9338670167145838,
      1.505248745831563,
      1.505248745831563,
      2.210109023906936,
      2.210109023906936,
      2.218899873798678,
      2.218899873798678,
      2.218899873798678,
      2.218899873798678
    ],
    "controlPoints": [
      {
        "x": 176.7230074852111,
        "y": 690.8483323482832,
        "z": 0
      },
      {
        "x": 176.7240205953719,
        "y": 690.8478496391316,
        "z": 0
      },
      {
        "x": 176.7250345898799,
        "y": 690.8473716396837,
        "z": 0
      },
      {
        "x": 176.775387471425,
        "y": 690.8238827837602,
        "z": 0
      },
      {
        "x": 176.8285288979518,
        "y": 690.8125269385008,
        "z": 0
      },
      {
        "x": 176.9466257302549,
        "y": 690.8079645345011,
        "z": 0
      },
      {
        "x": 177.0120482284687,
        "y": 690.8182129925107,
        "z": 0
      },
      {
        "x": 177.0743021764798,
        "y": 690.8472630456018,
        "z": 0
      },
      {
        "x": 177.075068224454,
        "y": 690.8476235670897,
        "z": 0
      },
      {
        "x": 177.075833437383,
        "y": 690.8479868005915,
        "z": 0
      }
    ]
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 176.723007486376,
        "y": 691.0829985393211,
        "z": 0
      },
      {
        "x": 176.723007486376,
        "y": 690.8483323482832,
        "z": 0
      }
    ],
    "handle": "405F",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 177.075833437383,
        "y": 691.0829985393211,
        "z": 0
      },
      {
        "x": 177.075833437383,
        "y": 690.8479868005915,
        "z": 0
      }
    ],
    "handle": "4060",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 177.189420456415,
        "y": 690.6373444525486,
        "z": 0
      },
      {
        "x": 177.3369604845058,
        "y": 690.820443284694,
        "z": 0
      }
    ],
    "handle": "4061",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 176.6094361484279,
        "y": 690.6373444525486,
        "z": 0
      },
      {
        "x": 176.4618961216168,
        "y": 690.820443284694,
        "z": 0
      }
    ],
    "handle": "4062",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 176.4618961216168,
        "y": 690.820443284694,
        "z": 0
      },
      {
        "x": 176.4618961216168,
        "y": 690.6279295627028,
        "z": 0
      }
    ],
    "handle": "4063",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 177.189420456415,
        "y": 690.6373444525486,
        "z": 0
      },
      {
        "x": 177.189420456415,
        "y": 690.4448307398712,
        "z": 0
      }
    ],
    "handle": "4064",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 177.3369604845058,
        "y": 690.820443284694,
        "z": 0
      },
      {
        "x": 177.336960482178,
        "y": 690.6279295710837,
        "z": 0
      }
    ],
    "handle": "4065",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 176.6094361484279,
        "y": 690.6373444525486,
        "z": 0
      },
      {
        "x": 176.6094361473808,
        "y": 690.4448307398712,
        "z": 0
      }
    ],
    "handle": "4066",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 176.6094361473808,
        "y": 690.4448307398712,
        "z": 0
      },
      {
        "x": 176.4618961216168,
        "y": 690.6279295710837,
        "z": 0
      }
    ],
    "handle": "4067",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 177.189420456415,
        "y": 690.4448307398712,
        "z": 0
      },
      {
        "x": 177.3369604845058,
        "y": 690.6279295710837,
        "z": 0
      }
    ],
    "handle": "4068",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "ELLIPSE",
    "handle": "4069",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "center": {
      "x": 176.899420465518,
      "y": 690.8600672287872,
      "z": 0
    },
    "majorAxisEndPoint": {
      "x": 0.1764129755138129,
      "y": 2.17674e-11,
      "z": 0
    },
    "axisRatio": 0.6259016496423861,
    "startAngle": 3.252782333826853,
    "endAngle": 6.168573069506875
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 176.6094361484279,
        "y": 690.6373444525486,
        "z": 0
      },
      {
        "x": 177.189420456415,
        "y": 690.6373444525486,
        "z": 0
      }
    ],
    "handle": "406A",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 176.6094361473808,
        "y": 690.4448307398712,
        "z": 0
      },
      {
        "x": 177.189420456415,
        "y": 690.4448307398712,
        "z": 0
      }
    ],
    "handle": "406B",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 176.6094361484279,
        "y": 691.0035421121837,
        "z": 0
      },
      {
        "x": 176.4618961216168,
        "y": 690.820443284694,
        "z": 0
      }
    ],
    "handle": "406C",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 176.6094361484279,
        "y": 691.0035421121837,
        "z": 0
      },
      {
        "x": 176.7230074879477,
        "y": 691.0035421103192,
        "z": 0
      }
    ],
    "handle": "406D",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 177.189420456415,
        "y": 691.0035421121837,
        "z": 0
      },
      {
        "x": 177.3369604845058,
        "y": 690.820443284694,
        "z": 0
      }
    ],
    "handle": "406E",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 177.075833438896,
        "y": 691.0035421159082,
        "z": 0
      },
      {
        "x": 177.189420456415,
        "y": 691.0035421121837,
        "z": 0
      }
    ],
    "handle": "406F",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "ELLIPSE",
    "handle": "4070",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "center": {
      "x": 173.5473459526549,
      "y": 689.2030068980528,
      "z": 0
    },
    "majorAxisEndPoint": {
      "x": -0.1764129755113634,
      "y": 0,
      "z": 0
    },
    "axisRatio": 0.6259016496518008,
    "startAngle": 0,
    "endAngle": 6.283185307179584
  },
  {
    "type": "SPLINE",
    "handle": "4071",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "normalVector": {
      "x": 0,
      "y": 0,
      "z": 1
    },
    "planar": true,
    "degreeOfSplineCurve": 3,
    "numberOfKnots": 12,
    "numberOfControlPoints": 8,
    "numberOfFitPoints": 0,
    "knotValues": [
      0.7387853746015494,
      0.7387853746015494,
      0.7387853746015494,
      0.7387853746015494,
      0.7844749931928205,
      0.7844749931928205,
      1.696252131471398,
      1.696252131471398,
      2.401878553014586,
      2.401878553014586,
      2.401878553014586,
      2.401878553014586
    ],
    "controlPoints": [
      {
        "x": 173.3709329729899,
        "y": 689.0617337739022,
        "z": 0
      },
      {
        "x": 173.3737025711449,
        "y": 689.0598326381222,
        "z": 0
      },
      {
        "x": 173.3765103460188,
        "y": 689.0579919666015,
        "z": 0
      },
      {
        "x": 173.4360494550766,
        "y": 689.0206574732427,
        "z": 0
      },
      {
        "x": 173.5070683826338,
        "y": 689.0070852553425,
        "z": 0
      },
      {
        "x": 173.6290086795337,
        "y": 689.0167109239837,
        "z": 0
      },
      {
        "x": 173.6812611714699,
        "y": 689.0319310445346,
        "z": 0
      },
      {
        "x": 173.723758926732,
        "y": 689.0614738175607,
        "z": 0
      }
    ]
  },
  {
    "type": "SPLINE",
    "handle": "4072",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "normalVector": {
      "x": 0,
      "y": 0,
      "z": 1
    },
    "planar": true,
    "degreeOfSplineCurve": 3,
    "numberOfKnots": 14,
    "numberOfControlPoints": 10,
    "numberOfFitPoints": 0,
    "knotValues": [
      0.9221147950801091,
      0.9221147950801091,
      0.9221147950801091,
      0.9221147950801091,
      0.9338670167145838,
      0.9338670167145838,
      1.505248745831563,
      1.505248745831563,
      2.210109023906936,
      2.210109023906936,
      2.218899873798678,
      2.218899873798678,
      2.218899873798678,
      2.218899873798678
    ],
    "controlPoints": [
      {
        "x": 173.3709329729899,
        "y": 688.9683407088633,
        "z": 0
      },
      {
        "x": 173.3719460830317,
        "y": 688.9678579987877,
        "z": 0
      },
      {
        "x": 173.3729600792289,
        "y": 688.9673799993442,
        "z": 0
      },
      {
        "x": 173.4233129607737,
        "y": 688.9438911452922,
        "z": 0
      },
      {
        "x": 173.4764543872429,
        "y": 688.9325352990917,
        "z": 0
      },
      {
        "x": 173.5945512172759,
        "y": 688.9279728950943,
        "z": 0
      },
      {
        "x": 173.6599737177588,
        "y": 688.9382213521667,
        "z": 0
      },
      {
        "x": 173.7222276650146,
        "y": 688.9672714071346,
        "z": 0
      },
      {
        "x": 173.7229937121739,
        "y": 688.9676319258214,
        "z": 0
      },
      {
        "x": 173.723758926732,
        "y": 688.9679951621208,
        "z": 0
      }
    ]
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 173.3709329752597,
        "y": 689.2030068980528,
        "z": 0
      },
      {
        "x": 173.3709329752597,
        "y": 688.9683407088633,
        "z": 0
      }
    ],
    "handle": "4073",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 173.7237589258579,
        "y": 689.2030068980528,
        "z": 0
      },
      {
        "x": 173.7237589258579,
        "y": 688.9679951621208,
        "z": 0
      }
    ],
    "handle": "4074",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 173.2573616373699,
        "y": 689.1235504727855,
        "z": 0
      },
      {
        "x": 173.10982160928,
        "y": 688.9404516434176,
        "z": 0
      }
    ],
    "handle": "4075",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 173.2573616373699,
        "y": 689.1235504727855,
        "z": 0
      },
      {
        "x": 173.3709329764817,
        "y": 689.1235504681207,
        "z": 0
      }
    ],
    "handle": "4076",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 173.8373459452998,
        "y": 689.1235504727855,
        "z": 0
      },
      {
        "x": 173.9848859723431,
        "y": 688.9404516434176,
        "z": 0
      }
    ],
    "handle": "4077",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 173.723758927488,
        "y": 689.1235504755712,
        "z": 0
      },
      {
        "x": 173.8373459452998,
        "y": 689.1235504727855,
        "z": 0
      }
    ],
    "handle": "4078",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 180.2406242664448,
        "y": 689.1157347504012,
        "z": 0
      },
      {
        "x": 180.3542112843138,
        "y": 689.1157347476181,
        "z": 0
      }
    ],
    "handle": "4079",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 180.3542112843138,
        "y": 689.1157347476181,
        "z": 0
      },
      {
        "x": 180.5017513111237,
        "y": 688.9326359182531,
        "z": 0
      }
    ],
    "handle": "407A",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 179.7742269755099,
        "y": 689.1157347476181,
        "z": 0
      },
      {
        "x": 179.8877983157291,
        "y": 689.1157347438817,
        "z": 0
      }
    ],
    "handle": "407B",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 179.7742269755099,
        "y": 689.1157347476181,
        "z": 0
      },
      {
        "x": 179.6266869485839,
        "y": 688.9326359182531,
        "z": 0
      }
    ],
    "handle": "407C",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 180.2406242656289,
        "y": 689.1951911738104,
        "z": 0
      },
      {
        "x": 180.2406242656289,
        "y": 688.9601794350855,
        "z": 0
      }
    ],
    "handle": "407D",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 179.8877983142157,
        "y": 689.1951911738104,
        "z": 0
      },
      {
        "x": 179.8877983142157,
        "y": 688.960524985564,
        "z": 0
      }
    ],
    "handle": "407E",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "SPLINE",
    "handle": "407F",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "normalVector": {
      "x": 0,
      "y": 0,
      "z": 1
    },
    "planar": true,
    "degreeOfSplineCurve": 3,
    "numberOfKnots": 14,
    "numberOfControlPoints": 10,
    "numberOfFitPoints": 0,
    "knotValues": [
      0.9221147950801091,
      0.9221147950801091,
      0.9221147950801091,
      0.9221147950801091,
      0.9338670167145838,
      0.9338670167145838,
      1.505248745831563,
      1.505248745831563,
      2.210109023906936,
      2.210109023906936,
      2.218899873798678,
      2.218899873798678,
      2.218899873798678,
      2.218899873798678
    ],
    "controlPoints": [
      {
        "x": 179.8877983126439,
        "y": 688.960524985564,
        "z": 0
      },
      {
        "x": 179.8888114227458,
        "y": 688.960042274553,
        "z": 0
      },
      {
        "x": 179.8898254181829,
        "y": 688.9595642760341,
        "z": 0
      },
      {
        "x": 179.9401782997287,
        "y": 688.9360754219922,
        "z": 0
      },
      {
        "x": 179.9933197246859,
        "y": 688.9247195748602,
        "z": 0
      },
      {
        "x": 180.1114165569299,
        "y": 688.920157171783,
        "z": 0
      },
      {
        "x": 180.1768390574137,
        "y": 688.9304056297913,
        "z": 0
      },
      {
        "x": 180.2390930038517,
        "y": 688.9594556828915,
        "z": 0
      },
      {
        "x": 180.2398590526417,
        "y": 688.9598162006514,
        "z": 0
      },
      {
        "x": 180.2406242648731,
        "y": 688.9601794378831,
        "z": 0
      }
    ]
  },
  {
    "type": "SPLINE",
    "handle": "4080",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "normalVector": {
      "x": 0,
      "y": 0,
      "z": 1
    },
    "planar": true,
    "degreeOfSplineCurve": 3,
    "numberOfKnots": 12,
    "numberOfControlPoints": 8,
    "numberOfFitPoints": 0,
    "knotValues": [
      0.7387853746015494,
      0.7387853746015494,
      0.7387853746015494,
      0.7387853746015494,
      0.7844749931928205,
      0.7844749931928205,
      1.696252131471398,
      1.696252131471398,
      2.401878553014586,
      2.401878553014586,
      2.401878553014586,
      2.401878553014586
    ],
    "controlPoints": [
      {
        "x": 179.8877983126439,
        "y": 689.053918049661,
        "z": 0
      },
      {
        "x": 179.8905679108582,
        "y": 689.0520169139024,
        "z": 0
      },
      {
        "x": 179.8933756834018,
        "y": 689.0501762432895,
        "z": 0
      },
      {
        "x": 179.9529147947906,
        "y": 689.0128417471457,
        "z": 0
      },
      {
        "x": 180.023933722405,
        "y": 688.9992695292468,
        "z": 0
      },
      {
        "x": 180.1458740176158,
        "y": 689.0088952006689,
        "z": 0
      },
      {
        "x": 180.1981265096119,
        "y": 689.0241153203024,
        "z": 0
      },
      {
        "x": 180.2406242648731,
        "y": 689.0536580933212,
        "z": 0
      }
    ]
  },
  {
    "type": "ELLIPSE",
    "handle": "4081",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "center": {
      "x": 180.064211292192,
      "y": 689.1951911756696,
      "z": 0
    },
    "majorAxisEndPoint": {
      "x": -0.1764129755113634,
      "y": 0,
      "z": 0
    },
    "axisRatio": 0.6259016496518008,
    "startAngle": 0,
    "endAngle": 6.283185307179584
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 171.3689997205499,
        "y": 721.785574049685,
        "z": 0
      },
      {
        "x": 170.831977210415,
        "y": 722.0981794502513,
        "z": 0
      }
    ],
    "handle": "4082",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 168.683887177729,
        "y": 720.2607200443698,
        "z": 0
      },
      {
        "x": 168.1468646692807,
        "y": 720.5733254440082,
        "z": 0
      }
    ],
    "handle": "4083",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 168.1468646692807,
        "y": 720.5733254440082,
        "z": 0
      },
      {
        "x": 170.831977210415,
        "y": 722.0981794502513,
        "z": 0
      }
    ],
    "handle": "4084",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 168.683887177729,
        "y": 720.2607200443698,
        "z": 0
      },
      {
        "x": 171.3689997205499,
        "y": 721.785574049685,
        "z": 0
      }
    ],
    "handle": "4085",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 168.683887177729,
        "y": 692.0150051983045,
        "z": 0
      },
      {
        "x": 171.3689997205499,
        "y": 693.5398592045523,
        "z": 0
      }
    ],
    "handle": "4086",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 168.1468646692807,
        "y": 691.7100343992934,
        "z": 0
      },
      {
        "x": 168.683887177729,
        "y": 692.0150051983045,
        "z": 0
      }
    ],
    "handle": "4087",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 171.3689997205499,
        "y": 693.5398592045523,
        "z": 0
      },
      {
        "x": 171.3689997205499,
        "y": 721.785574049685,
        "z": 0
      }
    ],
    "handle": "4088",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 168.683887177729,
        "y": 692.0150051983045,
        "z": 0
      },
      {
        "x": 168.683887177729,
        "y": 720.2607200443698,
        "z": 0
      }
    ],
    "handle": "4089",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 168.1468646692807,
        "y": 691.7100343992934,
        "z": 0
      },
      {
        "x": 168.1468646692807,
        "y": 720.5733254440082,
        "z": 0
      }
    ],
    "handle": "408A",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 168.1468646692807,
        "y": 691.7100343992934,
        "z": 0
      },
      {
        "x": 172.6526601957738,
        "y": 689.0223136488339,
        "z": 0
      }
    ],
    "handle": "408B",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 168.683887177729,
        "y": 692.0150051983045,
        "z": 0
      },
      {
        "x": 173.1929529655027,
        "y": 689.3253337303148,
        "z": 0
      }
    ],
    "handle": "408C",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 171.3689997205499,
        "y": 693.5398592045523,
        "z": 0
      },
      {
        "x": 175.8944168112349,
        "y": 690.8404341321449,
        "z": 0
      }
    ],
    "handle": "408D",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 189.2704265938945,
        "y": 705.315193037503,
        "z": 0
      },
      {
        "x": 196.3593386239957,
        "y": 701.0866354303425,
        "z": 0
      }
    ],
    "handle": "408E",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 174.1004452236219,
        "y": 696.9741940414486,
        "z": 0
      },
      {
        "x": 181.3336505723417,
        "y": 692.6595650305934,
        "z": 0
      }
    ],
    "handle": "408F",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 205.9259311121422,
        "y": 714.1589114833632,
        "z": 0
      },
      {
        "x": 205.9259311121422,
        "y": 706.4520035972807,
        "z": 0
      }
    ],
    "handle": "4090",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 189.8152558548611,
        "y": 705.4596758112303,
        "z": 0
      },
      {
        "x": 189.8152558548611,
        "y": 697.4164243880624,
        "z": 0
      }
    ],
    "handle": "4091",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 173.7045805999648,
        "y": 696.760440142817,
        "z": 0
      },
      {
        "x": 173.7045805999648,
        "y": 692.1466780975387,
        "z": 0
      }
    ],
    "handle": "4092",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "TEXT",
    "handle": "4093",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "startPoint": {
      "x": 152.4313908278708,
      "y": 742.8818349978038,
      "z": 0
    },
    "textHeight": 7.5,
    "text": "kolon baglantI filizi"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 171.3689997205499,
        "y": 695.4993031499807,
        "z": 0
      },
      {
        "x": 275.5012023972229,
        "y": 751.7272735862023,
        "z": 0
      }
    ],
    "handle": "4094",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 171.3689997205499,
        "y": 696.4147682776637,
        "z": 0
      },
      {
        "x": 274.6801205585947,
        "y": 752.1993814762717,
        "z": 0
      }
    ],
    "handle": "4095",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 161.9909238556279,
        "y": 740.3322601979488,
        "z": 0
      },
      {
        "x": 236.196725133807,
        "y": 740.3322601979488,
        "z": 0
      }
    ],
    "handle": "4096",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD",
      "customStrings": [
        "DSTYLE",
        "ARCHTICK"
      ]
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 205.1923085758448,
        "y": 713.8513351781219,
        "z": 0
      },
      {
        "x": 211.1097706682047,
        "y": 710.4488965803723,
        "z": 0
      }
    ],
    "handle": "4097",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 181.2310523219638,
        "y": 688.9077275265017,
        "z": 0
      },
      {
        "x": 212.7041294123627,
        "y": 706.559221114963,
        "z": 0
      }
    ],
    "handle": "4098",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 180.6990460751111,
        "y": 689.225070872345,
        "z": 0
      },
      {
        "x": 212.172123163473,
        "y": 706.8765644626616,
        "z": 0
      }
    ],
    "handle": "4099",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 204.3589095417419,
        "y": 713.401327064257,
        "z": 0
      },
      {
        "x": 210.291689921286,
        "y": 709.990080717951,
        "z": 0
      }
    ],
    "handle": "409A",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 178.0390148411968,
        "y": 690.8117876006332,
        "z": 0
      },
      {
        "x": 209.5120919311292,
        "y": 708.4632811928128,
        "z": 0
      }
    ],
    "handle": "409B",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 277.2023428686666,
        "y": 626.3784698564522,
        "z": 0
      },
      {
        "x": 281.794831406907,
        "y": 628.9541405383497,
        "z": 0
      }
    ],
    "handle": "409C",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 277.202342867561,
        "y": 626.0658166743624,
        "z": 0
      },
      {
        "x": 281.720252702012,
        "y": 623.3708697026412,
        "z": 0
      }
    ],
    "handle": "409D",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 277.2023428686666,
        "y": 626.3784698564522,
        "z": 0
      },
      {
        "x": 281.7243959634208,
        "y": 623.6810514153732,
        "z": 0
      }
    ],
    "handle": "409E",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 277.202342868374,
        "y": 625.7372102308827,
        "z": 0
      },
      {
        "x": 278.5001258794796,
        "y": 624.9630787027935,
        "z": 0
      }
    ],
    "handle": "409F",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 277.202342867561,
        "y": 625.4245570497443,
        "z": 0
      },
      {
        "x": 278.1467031601339,
        "y": 624.8612432647312,
        "z": 0
      }
    ],
    "handle": "40A0",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 267.5103006709246,
        "y": 636.1912804720923,
        "z": 0
      },
      {
        "x": 287.2676064477996,
        "y": 646.8595768921002,
        "z": 0
      }
    ],
    "handle": "40A1",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 266.7047669076118,
        "y": 636.6717838141992,
        "z": 0
      },
      {
        "x": 286.4620726833237,
        "y": 647.3400802351533,
        "z": 0
      }
    ],
    "handle": "40A2",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 233.7396227180727,
        "y": 653.2090608794198,
        "z": 0
      },
      {
        "x": 277.9842569480538,
        "y": 626.8170018531307,
        "z": 0
      }
    ],
    "handle": "40A3",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 236.4410865615358,
        "y": 654.7241612821863,
        "z": 0
      },
      {
        "x": 280.6857207950659,
        "y": 628.3321022549598,
        "z": 0
      }
    ],
    "handle": "40A4",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "SPLINE",
    "handle": "40A5",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "normalVector": {
      "x": 0,
      "y": 0,
      "z": 1
    },
    "planar": true,
    "degreeOfSplineCurve": 3,
    "numberOfKnots": 12,
    "numberOfControlPoints": 8,
    "numberOfFitPoints": 0,
    "knotValues": [
      1.601014487257268,
      1.601014487257268,
      1.601014487257268,
      1.601014487257268,
      2.144527230635417,
      2.144527230635417,
      2.684476675754792,
      2.684476675754792,
      2.876677566002344,
      2.876677566002344,
      2.876677566002344,
      2.876677566002344
    ],
    "controlPoints": [
      {
        "x": 229.5982909821897,
        "y": 653.115071702741,
        "z": 0
      },
      {
        "x": 229.7360051993747,
        "y": 653.0436606742431,
        "z": 0
      },
      {
        "x": 229.8900379869727,
        "y": 653.0038133747803,
        "z": 0
      },
      {
        "x": 230.1969553946998,
        "y": 653.0022367313533,
        "z": 0
      },
      {
        "x": 230.3500392199497,
        "y": 653.0403603892692,
        "z": 0
      },
      {
        "x": 230.5274230315107,
        "y": 653.1463727457449,
        "z": 0
      },
      {
        "x": 230.5709626725882,
        "y": 653.1794123984829,
        "z": 0
      },
      {
        "x": 230.6104582678531,
        "y": 653.2167580649211,
        "z": 0
      }
    ]
  },
  {
    "type": "ELLIPSE",
    "handle": "40A6",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "center": {
      "x": 229.9623495101698,
      "y": 653.8274528942918,
      "z": 0
    },
    "majorAxisEndPoint": {
      "x": -0.5507681030796265,
      "y": 0.3043356101090903,
      "z": 0
    },
    "axisRatio": 0.8446940944806286,
    "startAngle": 1.93706295137112,
    "endAngle": 3.246038118569053
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 277.202342868374,
        "y": 625.7372102308827,
        "z": 0
      },
      {
        "x": 277.202342867561,
        "y": 625.4245570497443,
        "z": 0
      }
    ],
    "handle": "40A7",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 277.2023428686666,
        "y": 625.7372102308827,
        "z": 0
      },
      {
        "x": 277.4862735860518,
        "y": 625.8964511360864,
        "z": 0
      }
    ],
    "handle": "40A8",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 277.202342868374,
        "y": 626.3784698555164,
        "z": 0
      },
      {
        "x": 277.202342867561,
        "y": 626.0658166743624,
        "z": 0
      }
    ],
    "handle": "40A9",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 251.3996254145737,
        "y": 645.8013473115832,
        "z": 0
      },
      {
        "x": 271.1569311920309,
        "y": 656.4696437343907,
        "z": 0
      }
    ],
    "handle": "40AA",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 250.5940916504469,
        "y": 646.2818506555631,
        "z": 0
      },
      {
        "x": 270.3513974269728,
        "y": 656.9501470774338,
        "z": 0
      }
    ],
    "handle": "40AB",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 222.8421401298832,
        "y": 659.084136059504,
        "z": 0
      },
      {
        "x": 222.8421401310477,
        "y": 612.1025553764601,
        "z": 0
      }
    ],
    "handle": "40AC",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 222.0366063668629,
        "y": 659.5646394016219,
        "z": 0
      },
      {
        "x": 222.0366063684922,
        "y": 612.1025553764601,
        "z": 0
      }
    ],
    "handle": "40AD",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 222.0234722171441,
        "y": 611.6298865955102,
        "z": 0
      },
      {
        "x": 264.2089926956681,
        "y": 634.4086825577496,
        "z": 0
      }
    ],
    "handle": "40AE",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 271.174165899167,
        "y": 656.4593631774158,
        "z": 0
      },
      {
        "x": 271.174165899167,
        "y": 634.0057737119532,
        "z": 0
      }
    ],
    "handle": "40AF",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 222.432470988598,
        "y": 649.384802652519,
        "z": 0
      },
      {
        "x": 230.8020973862149,
        "y": 653.7437043730096,
        "z": 0
      }
    ],
    "handle": "40B0",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "SPLINE",
    "handle": "40B1",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "normalVector": {
      "x": 0,
      "y": 0,
      "z": 1
    },
    "planar": true,
    "degreeOfSplineCurve": 3,
    "numberOfKnots": 10,
    "numberOfControlPoints": 6,
    "numberOfFitPoints": 0,
    "knotValues": [
      0.1942940721670503,
      0.1942940721670503,
      0.1942940721670503,
      0.1942940721670503,
      0.3202527597656655,
      0.3202527597656655,
      0.632600549675783,
      0.632600549675783,
      0.632600549675783,
      0.632600549675783
    ],
    "controlPoints": [
      {
        "x": 229.1140127122631,
        "y": 654.1093924026901,
        "z": 0
      },
      {
        "x": 229.1042913013961,
        "y": 654.0751089202204,
        "z": 0
      },
      {
        "x": 229.0970717834439,
        "y": 654.0401291996203,
        "z": 0
      },
      {
        "x": 229.0809356017847,
        "y": 653.9173314794932,
        "z": 0
      },
      {
        "x": 229.0853960553649,
        "y": 653.8283389834722,
        "z": 0
      },
      {
        "x": 229.1037123199789,
        "y": 653.7420973302687,
        "z": 0
      }
    ]
  },
  {
    "type": "ELLIPSE",
    "handle": "40B2",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "center": {
      "x": 229.9623495101698,
      "y": 653.8274528942918,
      "z": 0
    },
    "majorAxisEndPoint": {
      "x": -0.5507681030690998,
      "y": 0.3043356101210443,
      "z": 0
    },
    "axisRatio": 0.8446940944945511,
    "startAngle": -0.1826476037609066,
    "endAngle": 0.4882933597058834
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 233.1993299475868,
        "y": 652.9060407988687,
        "z": 0
      },
      {
        "x": 277.4439641803038,
        "y": 626.5139817707213,
        "z": 0
      }
    ],
    "handle": "40B3",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 228.169652419281,
        "y": 655.6266189953357,
        "z": 0
      },
      {
        "x": 232.6917055140949,
        "y": 652.9292005533325,
        "z": 0
      }
    ],
    "handle": "40B4",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 228.1696524174179,
        "y": 655.313965813253,
        "z": 0
      },
      {
        "x": 232.6875622526268,
        "y": 652.6190188406035,
        "z": 0
      }
    ],
    "handle": "40B5",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 232.6917055140949,
        "y": 652.9292005533325,
        "z": 0
      },
      {
        "x": 232.6875622526268,
        "y": 652.6190188406035,
        "z": 0
      }
    ],
    "handle": "40B6",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 232.6917055140949,
        "y": 652.2879409305712,
        "z": 0
      },
      {
        "x": 232.6875622526268,
        "y": 651.9777592178432,
        "z": 0
      }
    ],
    "handle": "40B7",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 232.6875622526268,
        "y": 651.9777592178432,
        "z": 0
      },
      {
        "x": 233.7819321253343,
        "y": 652.5915302457176,
        "z": 0
      }
    ],
    "handle": "40B8",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 232.6917055140949,
        "y": 652.2879409305712,
        "z": 0
      },
      {
        "x": 233.5159290011496,
        "y": 652.7502019144557,
        "z": 0
      }
    ],
    "handle": "40B9",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 230.536917274819,
        "y": 653.5732786776415,
        "z": 0
      },
      {
        "x": 232.6917055140949,
        "y": 652.2879409305712,
        "z": 0
      }
    ],
    "handle": "40BA",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 230.610458267794,
        "y": 653.2167580649211,
        "z": 0
      },
      {
        "x": 232.6875622526268,
        "y": 651.9777592178432,
        "z": 0
      }
    ],
    "handle": "40BB",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 232.6917055140949,
        "y": 652.9292005533325,
        "z": 0
      },
      {
        "x": 237.2841940533839,
        "y": 655.5048712398846,
        "z": 0
      }
    ],
    "handle": "40BC",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 232.6875622526268,
        "y": 652.6190188406035,
        "z": 0
      },
      {
        "x": 237.2841940538502,
        "y": 655.1970132524146,
        "z": 0
      }
    ],
    "handle": "40BD",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 232.762140957057,
        "y": 658.2022896790832,
        "z": 0
      },
      {
        "x": 237.2841940533839,
        "y": 655.5048712398846,
        "z": 0
      }
    ],
    "handle": "40BE",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 228.169652419281,
        "y": 655.6266189953357,
        "z": 0
      },
      {
        "x": 232.762140957057,
        "y": 658.2022896790832,
        "z": 0
      }
    ],
    "handle": "40BF",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 228.1696524189887,
        "y": 655.6266189925326,
        "z": 0
      },
      {
        "x": 228.1696524174179,
        "y": 655.313965813253,
        "z": 0
      }
    ],
    "handle": "40C0",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 237.2841940533839,
        "y": 655.5048712398846,
        "z": 0
      },
      {
        "x": 237.2841940538502,
        "y": 655.1970132524146,
        "z": 0
      }
    ],
    "handle": "40C1",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 237.2841940533839,
        "y": 654.8636116152594,
        "z": 0
      },
      {
        "x": 237.2841940538502,
        "y": 654.5557536268614,
        "z": 0
      }
    ],
    "handle": "40C2",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 237.2841940533839,
        "y": 654.8636116152594,
        "z": 0
      },
      {
        "x": 236.7576856119547,
        "y": 654.5683224005612,
        "z": 0
      }
    ],
    "handle": "40C3",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 237.2841940538502,
        "y": 654.5557536268614,
        "z": 0
      },
      {
        "x": 237.0236887377678,
        "y": 654.4096507271666,
        "z": 0
      }
    ],
    "handle": "40C4",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 236.9961200746482,
        "y": 655.0354486210197,
        "z": 0
      },
      {
        "x": 237.2841940533839,
        "y": 654.8636116152594,
        "z": 0
      }
    ],
    "handle": "40C5",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 228.169652419281,
        "y": 654.9853593707057,
        "z": 0
      },
      {
        "x": 228.4535831366671,
        "y": 655.1446002740447,
        "z": 0
      }
    ],
    "handle": "40C6",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 228.1696524189887,
        "y": 654.9853593697687,
        "z": 0
      },
      {
        "x": 228.1696524174179,
        "y": 654.6727061877027,
        "z": 0
      }
    ],
    "handle": "40C7",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 228.1696524189887,
        "y": 654.9853593707057,
        "z": 0
      },
      {
        "x": 229.4674354301518,
        "y": 654.2112278416707,
        "z": 0
      }
    ],
    "handle": "40C8",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 228.1696524174179,
        "y": 654.6727061877027,
        "z": 0
      },
      {
        "x": 229.1140127099341,
        "y": 654.1093924026901,
        "z": 0
      }
    ],
    "handle": "40C9",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "ELLIPSE",
    "handle": "40CA",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "center": {
      "x": 235.8513499003609,
      "y": 655.9510065605817,
      "z": 0
    },
    "majorAxisEndPoint": {
      "x": -0.1764129755113634,
      "y": 0,
      "z": 0
    },
    "axisRatio": 0.6259016496518008,
    "startAngle": 0,
    "endAngle": 6.283185307179584
  },
  {
    "type": "SPLINE",
    "handle": "40CB",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "normalVector": {
      "x": 0,
      "y": 0,
      "z": 1
    },
    "planar": true,
    "degreeOfSplineCurve": 3,
    "numberOfKnots": 12,
    "numberOfControlPoints": 8,
    "numberOfFitPoints": 0,
    "knotValues": [
      0.7387853746015494,
      0.7387853746015494,
      0.7387853746015494,
      0.7387853746015494,
      0.7844749931928205,
      0.7844749931928205,
      1.696252131471398,
      1.696252131471398,
      2.401878553014586,
      2.401878553014586,
      2.401878553014586,
      2.401878553014586
    ],
    "controlPoints": [
      {
        "x": 235.674936921452,
        "y": 655.8097334355061,
        "z": 0
      },
      {
        "x": 235.6777065196646,
        "y": 655.8078322997324,
        "z": 0
      },
      {
        "x": 235.68051429221,
        "y": 655.8059916282027,
        "z": 0
      },
      {
        "x": 235.740053402785,
        "y": 655.7686571320519,
        "z": 0
      },
      {
        "x": 235.8110723304557,
        "y": 655.7550849160104,
        "z": 0
      },
      {
        "x": 235.9330126264818,
        "y": 655.764710585583,
        "z": 0
      },
      {
        "x": 235.98526511842,
        "y": 655.7799307042695,
        "z": 0
      },
      {
        "x": 236.0277628735631,
        "y": 655.8094734800931,
        "z": 0
      }
    ]
  },
  {
    "type": "SPLINE",
    "handle": "40CC",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "normalVector": {
      "x": 0,
      "y": 0,
      "z": 1
    },
    "planar": true,
    "degreeOfSplineCurve": 3,
    "numberOfKnots": 14,
    "numberOfControlPoints": 10,
    "numberOfFitPoints": 0,
    "knotValues": [
      0.9221147950801091,
      0.9221147950801091,
      0.9221147950801091,
      0.9221147950801091,
      0.9338670167145838,
      0.9338670167145838,
      1.505248745831563,
      1.505248745831563,
      2.210109023906936,
      2.210109023906936,
      2.218899873798678,
      2.218899873798678,
      2.218899873798678,
      2.218899873798678
    ],
    "controlPoints": [
      {
        "x": 235.674936921452,
        "y": 655.7163403676813,
        "z": 0
      },
      {
        "x": 235.6759500316109,
        "y": 655.7158576594591,
        "z": 0
      },
      {
        "x": 235.6769640269336,
        "y": 655.7153796609417,
        "z": 0
      },
      {
        "x": 235.7273169085368,
        "y": 655.6918908059532,
        "z": 0
      },
      {
        "x": 235.780458332622,
        "y": 655.6805349616332,
        "z": 0
      },
      {
        "x": 235.8985551649238,
        "y": 655.6759725566917,
        "z": 0
      },
      {
        "x": 235.9639776655239,
        "y": 655.6862210128417,
        "z": 0
      },
      {
        "x": 236.0262316126597,
        "y": 655.7152710659437,
        "z": 0
      },
      {
        "x": 236.0269976615663,
        "y": 655.7156315892934,
        "z": 0
      },
      {
        "x": 236.0277628735631,
        "y": 655.7159948227925,
        "z": 0
      }
    ]
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 235.674936922675,
        "y": 655.9510065605817,
        "z": 0
      },
      {
        "x": 235.674936922675,
        "y": 655.7163403695392,
        "z": 0
      }
    ],
    "handle": "40CD",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 236.0277628735631,
        "y": 655.9510065605817,
        "z": 0
      },
      {
        "x": 236.0277628735631,
        "y": 655.7159948227925,
        "z": 0
      }
    ],
    "handle": "40CE",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 236.1413498926558,
        "y": 655.5053524747417,
        "z": 0
      },
      {
        "x": 236.2888899195239,
        "y": 655.688451304104,
        "z": 0
      }
    ],
    "handle": "40CF",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 235.5613655843189,
        "y": 655.5053524747417,
        "z": 0
      },
      {
        "x": 235.4138255569838,
        "y": 655.688451304104,
        "z": 0
      }
    ],
    "handle": "40D0",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 235.4138255569838,
        "y": 655.688451304104,
        "z": 0
      },
      {
        "x": 235.4138255569838,
        "y": 655.4959375830349,
        "z": 0
      }
    ],
    "handle": "40D1",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 236.1413498926558,
        "y": 655.5053524747417,
        "z": 0
      },
      {
        "x": 236.1413498926558,
        "y": 655.3128387620598,
        "z": 0
      }
    ],
    "handle": "40D2",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 236.2888899195239,
        "y": 655.688451304104,
        "z": 0
      },
      {
        "x": 236.2888899177197,
        "y": 655.4959375942087,
        "z": 0
      }
    ],
    "handle": "40D3",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 235.5613655843189,
        "y": 655.5053524747417,
        "z": 0
      },
      {
        "x": 235.5613655828631,
        "y": 655.3128387620598,
        "z": 0
      }
    ],
    "handle": "40D4",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 235.5613655828631,
        "y": 655.3128387620598,
        "z": 0
      },
      {
        "x": 235.4138255569838,
        "y": 655.4959375942087,
        "z": 0
      }
    ],
    "handle": "40D5",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 236.1413498926558,
        "y": 655.3128387620598,
        "z": 0
      },
      {
        "x": 236.2888899195239,
        "y": 655.4959375942087,
        "z": 0
      }
    ],
    "handle": "40D6",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "ELLIPSE",
    "handle": "40D7",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "center": {
      "x": 235.8513499003609,
      "y": 655.7280752509839,
      "z": 0
    },
    "majorAxisEndPoint": {
      "x": 0.1764129755138129,
      "y": 2.17674e-11,
      "z": 0
    },
    "axisRatio": 0.6259016496423861,
    "startAngle": 3.252782333826853,
    "endAngle": 6.168573069506875
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 235.5613655843189,
        "y": 655.5053524747417,
        "z": 0
      },
      {
        "x": 236.1413498926558,
        "y": 655.5053524747417,
        "z": 0
      }
    ],
    "handle": "40D8",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 235.5613655828631,
        "y": 655.3128387620598,
        "z": 0
      },
      {
        "x": 236.1413498926558,
        "y": 655.3128387620598,
        "z": 0
      }
    ],
    "handle": "40D9",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 235.5613655843189,
        "y": 655.8715501325202,
        "z": 0
      },
      {
        "x": 235.4138255569838,
        "y": 655.688451304104,
        "z": 0
      }
    ],
    "handle": "40DA",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 235.5613655843189,
        "y": 655.8715501325202,
        "z": 0
      },
      {
        "x": 235.6749369237812,
        "y": 655.8715501306513,
        "z": 0
      }
    ],
    "handle": "40DB",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 236.1413498926558,
        "y": 655.8715501325202,
        "z": 0
      },
      {
        "x": 236.2888899195239,
        "y": 655.688451304104,
        "z": 0
      }
    ],
    "handle": "40DC",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 236.0277628747852,
        "y": 655.871550136242,
        "z": 0
      },
      {
        "x": 236.1413498926558,
        "y": 655.8715501325202,
        "z": 0
      }
    ],
    "handle": "40DD",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "ELLIPSE",
    "handle": "40DE",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "center": {
      "x": 232.499275389534,
      "y": 654.0710149211844,
      "z": 0
    },
    "majorAxisEndPoint": {
      "x": -0.1764129755113634,
      "y": 0,
      "z": 0
    },
    "axisRatio": 0.6259016496518008,
    "startAngle": 0,
    "endAngle": 6.283185307179584
  },
  {
    "type": "SPLINE",
    "handle": "40DF",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "normalVector": {
      "x": 0,
      "y": 0,
      "z": 1
    },
    "planar": true,
    "degreeOfSplineCurve": 3,
    "numberOfKnots": 12,
    "numberOfControlPoints": 8,
    "numberOfFitPoints": 0,
    "knotValues": [
      0.7387853746015494,
      0.7387853746015494,
      0.7387853746015494,
      0.7387853746015494,
      0.7844749931928205,
      0.7844749931928205,
      1.696252131471398,
      1.696252131471398,
      2.401878553014586,
      2.401878553014586,
      2.401878553014586,
      2.401878553014586
    ],
    "controlPoints": [
      {
        "x": 232.3228624092879,
        "y": 653.9297417979612,
        "z": 0
      },
      {
        "x": 232.3256320066279,
        "y": 653.9278406612502,
        "z": 0
      },
      {
        "x": 232.3284397808021,
        "y": 653.9259999888009,
        "z": 0
      },
      {
        "x": 232.3879788913759,
        "y": 653.8886654926417,
        "z": 0
      },
      {
        "x": 232.4589978198046,
        "y": 653.8750932747423,
        "z": 0
      },
      {
        "x": 232.5809381143189,
        "y": 653.8847189480438,
        "z": 0
      },
      {
        "x": 232.6331906069541,
        "y": 653.8999390658028,
        "z": 0
      },
      {
        "x": 232.6756883613999,
        "y": 653.9294818388197,
        "z": 0
      }
    ]
  },
  {
    "type": "SPLINE",
    "handle": "40E0",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "normalVector": {
      "x": 0,
      "y": 0,
      "z": 1
    },
    "planar": true,
    "degreeOfSplineCurve": 3,
    "numberOfKnots": 14,
    "numberOfControlPoints": 10,
    "numberOfFitPoints": 0,
    "knotValues": [
      0.9221147950801091,
      0.9221147950801091,
      0.9221147950801091,
      0.9221147950801091,
      0.9338670167145838,
      0.9338670167145838,
      1.505248745831563,
      1.505248745831563,
      2.210109023906936,
      2.210109023906936,
      2.218899873798678,
      2.218899873798678,
      2.218899873798678,
      2.218899873798678
    ],
    "controlPoints": [
      {
        "x": 232.3228624092879,
        "y": 653.8363487301427,
        "z": 0
      },
      {
        "x": 232.3238755200287,
        "y": 653.8358660209922,
        "z": 0
      },
      {
        "x": 232.324889513897,
        "y": 653.8353880215436,
        "z": 0
      },
      {
        "x": 232.37524239777,
        "y": 653.8118991674819,
        "z": 0
      },
      {
        "x": 232.4283838219699,
        "y": 653.8005433231509,
        "z": 0
      },
      {
        "x": 232.5464806541579,
        "y": 653.7959809182166,
        "z": 0
      },
      {
        "x": 232.611903154757,
        "y": 653.8062293762302,
        "z": 0
      },
      {
        "x": 232.6741571020087,
        "y": 653.8352794293313,
        "z": 0
      },
      {
        "x": 232.6749231485297,
        "y": 653.8356399480177,
        "z": 0
      },
      {
        "x": 232.6756883613999,
        "y": 653.8360031843112,
        "z": 0
      }
    ]
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 232.3228624108019,
        "y": 654.0710149202383,
        "z": 0
      },
      {
        "x": 232.3228624108019,
        "y": 653.8363487301427,
        "z": 0
      }
    ],
    "handle": "40E1",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 232.675688362157,
        "y": 654.0710149202383,
        "z": 0
      },
      {
        "x": 232.675688362157,
        "y": 653.8360031815217,
        "z": 0
      }
    ],
    "handle": "40E2",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 232.789275380783,
        "y": 653.6253608344086,
        "z": 0
      },
      {
        "x": 232.936815407767,
        "y": 653.8084596646947,
        "z": 0
      }
    ],
    "handle": "40E3",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 232.2092910728538,
        "y": 653.6253608344086,
        "z": 0
      },
      {
        "x": 232.0617510455198,
        "y": 653.8084596646947,
        "z": 0
      }
    ],
    "handle": "40E4",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 232.0617510455198,
        "y": 653.8084596646947,
        "z": 0
      },
      {
        "x": 232.0617510455198,
        "y": 653.6159459445622,
        "z": 0
      }
    ],
    "handle": "40E5",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 232.789275380783,
        "y": 653.6253608344086,
        "z": 0
      },
      {
        "x": 232.789275380783,
        "y": 653.432847121734,
        "z": 0
      }
    ],
    "handle": "40E6",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 232.936815407767,
        "y": 653.8084596646947,
        "z": 0
      },
      {
        "x": 232.9368154065451,
        "y": 653.6159459538684,
        "z": 0
      }
    ],
    "handle": "40E7",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 232.2092910728538,
        "y": 653.6253608344086,
        "z": 0
      },
      {
        "x": 232.209291070466,
        "y": 653.432847121734,
        "z": 0
      }
    ],
    "handle": "40E8",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 232.209291070466,
        "y": 653.432847121734,
        "z": 0
      },
      {
        "x": 232.0617510455198,
        "y": 653.6159459538684,
        "z": 0
      }
    ],
    "handle": "40E9",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 232.789275380783,
        "y": 653.432847121734,
        "z": 0
      },
      {
        "x": 232.936815407767,
        "y": 653.6159459538684,
        "z": 0
      }
    ],
    "handle": "40EA",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "ELLIPSE",
    "handle": "40EB",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "center": {
      "x": 232.499275389534,
      "y": 653.8480836097114,
      "z": 0
    },
    "majorAxisEndPoint": {
      "x": 0.1764129755138129,
      "y": 2.17674e-11,
      "z": 0
    },
    "axisRatio": 0.6259016496423861,
    "startAngle": 3.252782333826853,
    "endAngle": 6.168573069506875
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 232.2092910728538,
        "y": 653.6253608344086,
        "z": 0
      },
      {
        "x": 232.789275380783,
        "y": 653.6253608344086,
        "z": 0
      }
    ],
    "handle": "40EC",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 232.209291070466,
        "y": 653.432847121734,
        "z": 0
      },
      {
        "x": 232.789275380783,
        "y": 653.432847121734,
        "z": 0
      }
    ],
    "handle": "40ED",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 232.2092910728538,
        "y": 653.9915584940419,
        "z": 0
      },
      {
        "x": 232.0617510455198,
        "y": 653.8084596646947,
        "z": 0
      }
    ],
    "handle": "40EE",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 232.2092910728538,
        "y": 653.9915584940419,
        "z": 0
      },
      {
        "x": 232.3228624126632,
        "y": 653.9915584921843,
        "z": 0
      }
    ],
    "handle": "40EF",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 232.789275380783,
        "y": 653.9915584940419,
        "z": 0
      },
      {
        "x": 232.936815407767,
        "y": 653.8084596646947,
        "z": 0
      }
    ],
    "handle": "40F0",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 232.675688363728,
        "y": 653.9915584968403,
        "z": 0
      },
      {
        "x": 232.789275380783,
        "y": 653.9915584940419,
        "z": 0
      }
    ],
    "handle": "40F1",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 229.5108975354807,
        "y": 655.8793658623442,
        "z": 0
      },
      {
        "x": 229.6244845533511,
        "y": 655.8793658576814,
        "z": 0
      }
    ],
    "handle": "40F2",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 229.6244845533511,
        "y": 655.8793658576814,
        "z": 0
      },
      {
        "x": 229.7720245803368,
        "y": 655.6962670302007,
        "z": 0
      }
    ],
    "handle": "40F3",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 229.044500245479,
        "y": 655.8793658576814,
        "z": 0
      },
      {
        "x": 229.1580715848831,
        "y": 655.8793658548936,
        "z": 0
      }
    ],
    "handle": "40F4",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 229.044500245479,
        "y": 655.8793658576814,
        "z": 0
      },
      {
        "x": 228.8969602177391,
        "y": 655.6962670302007,
        "z": 0
      }
    ],
    "handle": "40F5",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 229.0445002438501,
        "y": 655.3206544862996,
        "z": 0
      },
      {
        "x": 229.6244845533511,
        "y": 655.3206544862996,
        "z": 0
      }
    ],
    "handle": "40F6",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 229.044500245479,
        "y": 655.5131681980529,
        "z": 0
      },
      {
        "x": 229.6244845533511,
        "y": 655.5131681980529,
        "z": 0
      }
    ],
    "handle": "40F7",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "ELLIPSE",
    "handle": "40F8",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "center": {
      "x": 229.3344845621029,
      "y": 655.7358909761533,
      "z": 0
    },
    "majorAxisEndPoint": {
      "x": 0.1764129755138129,
      "y": 2.17674e-11,
      "z": 0
    },
    "axisRatio": 0.6259016496423861,
    "startAngle": 3.252782333826853,
    "endAngle": 6.168573069506875
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 229.6244845533511,
        "y": 655.3206544862996,
        "z": 0
      },
      {
        "x": 229.7720245803368,
        "y": 655.5037533203146,
        "z": 0
      }
    ],
    "handle": "40F9",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 229.0445002438501,
        "y": 655.3206544862996,
        "z": 0
      },
      {
        "x": 228.8969602177391,
        "y": 655.5037533203146,
        "z": 0
      }
    ],
    "handle": "40FA",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 229.044500245479,
        "y": 655.5131681980529,
        "z": 0
      },
      {
        "x": 229.0445002438501,
        "y": 655.3206544862996,
        "z": 0
      }
    ],
    "handle": "40FB",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 229.7720245803368,
        "y": 655.6962670302007,
        "z": 0
      },
      {
        "x": 229.7720245795198,
        "y": 655.5037533203146,
        "z": 0
      }
    ],
    "handle": "40FC",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 229.6244845533511,
        "y": 655.5131681980529,
        "z": 0
      },
      {
        "x": 229.6244845533511,
        "y": 655.3206544862996,
        "z": 0
      }
    ],
    "handle": "40FD",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 228.8969602177391,
        "y": 655.6962670302007,
        "z": 0
      },
      {
        "x": 228.8969602177391,
        "y": 655.5037533091307,
        "z": 0
      }
    ],
    "handle": "40FE",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 229.044500245479,
        "y": 655.5131681980529,
        "z": 0
      },
      {
        "x": 228.8969602177391,
        "y": 655.6962670302007,
        "z": 0
      }
    ],
    "handle": "40FF",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 229.6244845533511,
        "y": 655.5131681980529,
        "z": 0
      },
      {
        "x": 229.7720245803368,
        "y": 655.6962670302007,
        "z": 0
      }
    ],
    "handle": "4100",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 229.5108975347821,
        "y": 655.9588222866805,
        "z": 0
      },
      {
        "x": 229.5108975347821,
        "y": 655.723810547959,
        "z": 0
      }
    ],
    "handle": "4101",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 229.15807158337,
        "y": 655.9588222866805,
        "z": 0
      },
      {
        "x": 229.15807158337,
        "y": 655.7241560956389,
        "z": 0
      }
    ],
    "handle": "4102",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "SPLINE",
    "handle": "4103",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "normalVector": {
      "x": 0,
      "y": 0,
      "z": 1
    },
    "planar": true,
    "degreeOfSplineCurve": 3,
    "numberOfKnots": 14,
    "numberOfControlPoints": 10,
    "numberOfFitPoints": 0,
    "knotValues": [
      0.9221147950801091,
      0.9221147950801091,
      0.9221147950801091,
      0.9221147950801091,
      0.9338670167145838,
      0.9338670167145838,
      1.505248745831563,
      1.505248745831563,
      2.210109023906936,
      2.210109023906936,
      2.218899873798678,
      2.218899873798678,
      2.218899873798678,
      2.218899873798678
    ],
    "controlPoints": [
      {
        "x": 229.1580715825548,
        "y": 655.7241560956389,
        "z": 0
      },
      {
        "x": 229.159084691899,
        "y": 655.7236733864911,
        "z": 0
      },
      {
        "x": 229.1600986871639,
        "y": 655.7231953851806,
        "z": 0
      },
      {
        "x": 229.2104515688258,
        "y": 655.6997065311324,
        "z": 0
      },
      {
        "x": 229.2635929945377,
        "y": 655.6883506858675,
        "z": 0
      },
      {
        "x": 229.3816898260269,
        "y": 655.6837882827931,
        "z": 0
      },
      {
        "x": 229.4471123265688,
        "y": 655.6940367389421,
        "z": 0
      },
      {
        "x": 229.5093662730059,
        "y": 655.7230867939032,
        "z": 0
      },
      {
        "x": 229.510132321738,
        "y": 655.7234473116611,
        "z": 0
      },
      {
        "x": 229.5108975340269,
        "y": 655.723810547959,
        "z": 0
      }
    ]
  },
  {
    "type": "SPLINE",
    "handle": "4104",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "normalVector": {
      "x": 0,
      "y": 0,
      "z": 1
    },
    "planar": true,
    "degreeOfSplineCurve": 3,
    "numberOfKnots": 12,
    "numberOfControlPoints": 8,
    "numberOfFitPoints": 0,
    "knotValues": [
      0.7387853746015494,
      0.7387853746015494,
      0.7387853746015494,
      0.7387853746015494,
      0.7844749931928205,
      0.7844749931928205,
      1.696252131471398,
      1.696252131471398,
      2.401878553014586,
      2.401878553014586,
      2.401878553014586,
      2.401878553014586
    ],
    "controlPoints": [
      {
        "x": 229.1580715825548,
        "y": 655.8175491616139,
        "z": 0
      },
      {
        "x": 229.160841180011,
        "y": 655.8156480239594,
        "z": 0
      },
      {
        "x": 229.163648953312,
        "y": 655.8138073543013,
        "z": 0
      },
      {
        "x": 229.2231880646422,
        "y": 655.7764728572228,
        "z": 0
      },
      {
        "x": 229.2942069923166,
        "y": 655.7629006411834,
        "z": 0
      },
      {
        "x": 229.4161472868879,
        "y": 655.772526310753,
        "z": 0
      },
      {
        "x": 229.4683997803357,
        "y": 655.7877464303706,
        "z": 0
      },
      {
        "x": 229.5108975340269,
        "y": 655.8172892043319,
        "z": 0
      }
    ]
  },
  {
    "type": "ELLIPSE",
    "handle": "4105",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "center": {
      "x": 229.3344845621029,
      "y": 655.9588222866805,
      "z": 0
    },
    "majorAxisEndPoint": {
      "x": -0.1764129755113634,
      "y": 0,
      "z": 0
    },
    "axisRatio": 0.6259016496518008,
    "startAngle": 0,
    "endAngle": 6.283185307179584
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 232.8629720472962,
        "y": 657.7593575026802,
        "z": 0
      },
      {
        "x": 232.9765590651658,
        "y": 657.7593574989513,
        "z": 0
      }
    ],
    "handle": "4106",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 232.9765590651658,
        "y": 657.7593574989513,
        "z": 0
      },
      {
        "x": 233.1240990925576,
        "y": 657.5762586705341,
        "z": 0
      }
    ],
    "handle": "4107",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 232.3965747569459,
        "y": 657.7593574989513,
        "z": 0
      },
      {
        "x": 232.5101460959991,
        "y": 657.7593574952416,
        "z": 0
      }
    ],
    "handle": "4108",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 232.3965747569459,
        "y": 657.7593574989513,
        "z": 0
      },
      {
        "x": 232.2490347300188,
        "y": 657.5762586705341,
        "z": 0
      }
    ],
    "handle": "4109",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 232.3965747553741,
        "y": 657.2006461247798,
        "z": 0
      },
      {
        "x": 232.9765590651658,
        "y": 657.2006461247798,
        "z": 0
      }
    ],
    "handle": "410A",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 232.3965747569459,
        "y": 657.3931598402476,
        "z": 0
      },
      {
        "x": 232.9765590651658,
        "y": 657.3931598402476,
        "z": 0
      }
    ],
    "handle": "410B",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "ELLIPSE",
    "handle": "410C",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "center": {
      "x": 232.6865590736262,
      "y": 657.6158826155522,
      "z": 0
    },
    "majorAxisEndPoint": {
      "x": 0.1764129755138129,
      "y": 2.17674e-11,
      "z": 0
    },
    "axisRatio": 0.6259016496423861,
    "startAngle": 3.252782333826853,
    "endAngle": 6.168573069506875
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 232.9765590651658,
        "y": 657.2006461247798,
        "z": 0
      },
      {
        "x": 233.1240990925576,
        "y": 657.3837449569207,
        "z": 0
      }
    ],
    "handle": "410D",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 232.3965747553741,
        "y": 657.2006461247798,
        "z": 0
      },
      {
        "x": 232.2490347300188,
        "y": 657.3837449569207,
        "z": 0
      }
    ],
    "handle": "410E",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 232.3965747569459,
        "y": 657.3931598402476,
        "z": 0
      },
      {
        "x": 232.3965747553741,
        "y": 657.2006461247798,
        "z": 0
      }
    ],
    "handle": "410F",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 233.1240990925576,
        "y": 657.5762586705341,
        "z": 0
      },
      {
        "x": 233.1240990902298,
        "y": 657.3837449569207,
        "z": 0
      }
    ],
    "handle": "4110",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 232.9765590651658,
        "y": 657.3931598402476,
        "z": 0
      },
      {
        "x": 232.9765590651658,
        "y": 657.2006461247798,
        "z": 0
      }
    ],
    "handle": "4111",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 232.2490347300188,
        "y": 657.5762586705341,
        "z": 0
      },
      {
        "x": 232.2490347300188,
        "y": 657.3837449494674,
        "z": 0
      }
    ],
    "handle": "4112",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 232.3965747569459,
        "y": 657.3931598402476,
        "z": 0
      },
      {
        "x": 232.2490347300188,
        "y": 657.5762586705341,
        "z": 0
      }
    ],
    "handle": "4113",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 232.9765590651658,
        "y": 657.3931598402476,
        "z": 0
      },
      {
        "x": 233.1240990925576,
        "y": 657.5762586705341,
        "z": 0
      }
    ],
    "handle": "4114",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 232.8629720454919,
        "y": 657.8388139242197,
        "z": 0
      },
      {
        "x": 232.8629720454919,
        "y": 657.6038021855094,
        "z": 0
      }
    ],
    "handle": "4115",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 232.510146094894,
        "y": 657.8388139242197,
        "z": 0
      },
      {
        "x": 232.510146094894,
        "y": 657.6041477350489,
        "z": 0
      }
    ],
    "handle": "4116",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "SPLINE",
    "handle": "4117",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "normalVector": {
      "x": 0,
      "y": 0,
      "z": 1
    },
    "planar": true,
    "degreeOfSplineCurve": 3,
    "numberOfKnots": 14,
    "numberOfControlPoints": 10,
    "numberOfFitPoints": 0,
    "knotValues": [
      0.9221147950801091,
      0.9221147950801091,
      0.9221147950801091,
      0.9221147950801091,
      0.9338670167145838,
      0.9338670167145838,
      1.505248745831563,
      1.505248745831563,
      2.210109023906936,
      2.210109023906936,
      2.218899873798678,
      2.218899873798678,
      2.218899873798678,
      2.218899873798678
    ],
    "controlPoints": [
      {
        "x": 232.5101460933808,
        "y": 657.6041477350489,
        "z": 0
      },
      {
        "x": 232.5111592025502,
        "y": 657.6036650231026,
        "z": 0
      },
      {
        "x": 232.5121731979301,
        "y": 657.6031870255182,
        "z": 0
      },
      {
        "x": 232.5625260802918,
        "y": 657.5796981714602,
        "z": 0
      },
      {
        "x": 232.615667506004,
        "y": 657.5683423262006,
        "z": 0
      },
      {
        "x": 232.73376433819,
        "y": 657.5637799212715,
        "z": 0
      },
      {
        "x": 232.799186837394,
        "y": 657.5740283764862,
        "z": 0
      },
      {
        "x": 232.8614407837148,
        "y": 657.6030784342438,
        "z": 0
      },
      {
        "x": 232.8622068325051,
        "y": 657.6034389529302,
        "z": 0
      },
      {
        "x": 232.86297204625,
        "y": 657.6038021855094,
        "z": 0
      }
    ]
  },
  {
    "type": "SPLINE",
    "handle": "4118",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "normalVector": {
      "x": 0,
      "y": 0,
      "z": 1
    },
    "planar": true,
    "degreeOfSplineCurve": 3,
    "numberOfKnots": 12,
    "numberOfControlPoints": 8,
    "numberOfFitPoints": 0,
    "knotValues": [
      0.7387853746015494,
      0.7387853746015494,
      0.7387853746015494,
      0.7387853746015494,
      0.7844749931928205,
      0.7844749931928205,
      1.696252131471398,
      1.696252131471398,
      2.401878553014586,
      2.401878553014586,
      2.401878553014586,
      2.401878553014586
    ],
    "controlPoints": [
      {
        "x": 232.5101460933808,
        "y": 657.6975407991522,
        "z": 0
      },
      {
        "x": 232.512915691419,
        "y": 657.6956396643033,
        "z": 0
      },
      {
        "x": 232.5157234657087,
        "y": 657.6937989909094,
        "z": 0
      },
      {
        "x": 232.5752625753509,
        "y": 657.6564644956951,
        "z": 0
      },
      {
        "x": 232.6462815037229,
        "y": 657.6428922805932,
        "z": 0
      },
      {
        "x": 232.7682217990509,
        "y": 657.6525179510935,
        "z": 0
      },
      {
        "x": 232.8204742909883,
        "y": 657.6677380707077,
        "z": 0
      },
      {
        "x": 232.86297204625,
        "y": 657.697280841872,
        "z": 0
      }
    ]
  },
  {
    "type": "ELLIPSE",
    "handle": "4119",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "center": {
      "x": 232.6865590736262,
      "y": 657.8388139242197,
      "z": 0
    },
    "majorAxisEndPoint": {
      "x": -0.1764129755113634,
      "y": 0,
      "z": 0
    },
    "axisRatio": 0.6259016496518008,
    "startAngle": 0,
    "endAngle": 6.283185307179584
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 221.6407417425647,
        "y": 612.3386898301322,
        "z": 0
      },
      {
        "x": 263.4034589317158,
        "y": 634.8891859017339,
        "z": 0
      }
    ],
    "handle": "411A",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 270.3686321362038,
        "y": 656.9398665195332,
        "z": 0
      },
      {
        "x": 270.3686321362038,
        "y": 634.4862770512636,
        "z": 0
      }
    ],
    "handle": "411B",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 285.4737770132477,
        "y": 625.4760121432918,
        "z": 0
      },
      {
        "x": 316.0059527086569,
        "y": 607.2634763829219,
        "z": 0
      }
    ],
    "handle": "411C",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "ELLIPSE",
    "handle": "411D",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "center": {
      "x": 278.9950399587979,
      "y": 624.5793037554112,
      "z": 0
    },
    "majorAxisEndPoint": {
      "x": -0.5507681030761681,
      "y": 0.3043356101144165,
      "z": 0
    },
    "axisRatio": 0.844694094480067,
    "startAngle": 1.884008675519128,
    "endAngle": 3.246038118584126
  },
  {
    "type": "SPLINE",
    "handle": "411E",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "normalVector": {
      "x": 0,
      "y": 0,
      "z": 1
    },
    "planar": true,
    "degreeOfSplineCurve": 3,
    "numberOfKnots": 12,
    "numberOfControlPoints": 8,
    "numberOfFitPoints": 0,
    "knotValues": [
      1.580245881219742,
      1.580245881219742,
      1.580245881219742,
      1.580245881219742,
      2.144527230635417,
      2.144527230635417,
      2.684476675754792,
      2.684476675754792,
      2.876677566002344,
      2.876677566002344,
      2.876677566002344,
      2.876677566002344
    ],
    "controlPoints": [
      {
        "x": 278.6152669005098,
        "y": 623.8752466449332,
        "z": 0
      },
      {
        "x": 278.756923805572,
        "y": 623.7986138369697,
        "z": 0
      },
      {
        "x": 278.9168452168819,
        "y": 623.7556944591812,
        "z": 0
      },
      {
        "x": 279.2296458440828,
        "y": 623.7540875905913,
        "z": 0
      },
      {
        "x": 279.382729667821,
        "y": 623.7922112503801,
        "z": 0
      },
      {
        "x": 279.5601134808959,
        "y": 623.8982236077827,
        "z": 0
      },
      {
        "x": 279.6036531211581,
        "y": 623.9312632595901,
        "z": 0
      },
      {
        "x": 279.6431487179932,
        "y": 623.9686089288332,
        "z": 0
      }
    ]
  },
  {
    "type": "ELLIPSE",
    "handle": "411F",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "center": {
      "x": 281.7192495229548,
      "y": 628.5906647862904,
      "z": 0
    },
    "majorAxisEndPoint": {
      "x": -0.1764129755113634,
      "y": 0,
      "z": 0
    },
    "axisRatio": 0.6259016496518008,
    "startAngle": 0,
    "endAngle": 6.283185307179584
  },
  {
    "type": "SPLINE",
    "handle": "4120",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "normalVector": {
      "x": 0,
      "y": 0,
      "z": 1
    },
    "planar": true,
    "degreeOfSplineCurve": 3,
    "numberOfKnots": 12,
    "numberOfControlPoints": 8,
    "numberOfFitPoints": 0,
    "knotValues": [
      0.7387853746015494,
      0.7387853746015494,
      0.7387853746015494,
      0.7387853746015494,
      0.7844749931928205,
      0.7844749931928205,
      1.696252131471398,
      1.696252131471398,
      2.401878553014586,
      2.401878553014586,
      2.401878553014586,
      2.401878553014586
    ],
    "controlPoints": [
      {
        "x": 281.5428365434059,
        "y": 628.4493916612117,
        "z": 0
      },
      {
        "x": 281.5456061408609,
        "y": 628.447490525431,
        "z": 0
      },
      {
        "x": 281.5484139141619,
        "y": 628.4456498539038,
        "z": 0
      },
      {
        "x": 281.6079530256108,
        "y": 628.4083153596109,
        "z": 0
      },
      {
        "x": 281.6789719531092,
        "y": 628.3947431426429,
        "z": 0
      },
      {
        "x": 281.8009122476798,
        "y": 628.4043688131422,
        "z": 0
      },
      {
        "x": 281.8531647403729,
        "y": 628.4195889299726,
        "z": 0
      },
      {
        "x": 281.8956624948188,
        "y": 628.449131706733,
        "z": 0
      }
    ]
  },
  {
    "type": "SPLINE",
    "handle": "4121",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "normalVector": {
      "x": 0,
      "y": 0,
      "z": 1
    },
    "planar": true,
    "degreeOfSplineCurve": 3,
    "numberOfKnots": 14,
    "numberOfControlPoints": 10,
    "numberOfFitPoints": 0,
    "knotValues": [
      0.9221147950801091,
      0.9221147950801091,
      0.9221147950801091,
      0.9221147950801091,
      0.9338670167145838,
      0.9338670167145838,
      1.505248745831563,
      1.505248745831563,
      2.210109023906936,
      2.210109023906936,
      2.218899873798678,
      2.218899873798678,
      2.218899873798678,
      2.218899873798678
    ],
    "controlPoints": [
      {
        "x": 281.5428365434059,
        "y": 628.3559985943147,
        "z": 0
      },
      {
        "x": 281.5438496526912,
        "y": 628.3555158851631,
        "z": 0
      },
      {
        "x": 281.5448636480141,
        "y": 628.3550378866419,
        "z": 0
      },
      {
        "x": 281.5952165296193,
        "y": 628.3315490325947,
        "z": 0
      },
      {
        "x": 281.6483579553898,
        "y": 628.3201931864023,
        "z": 0
      },
      {
        "x": 281.7664547875767,
        "y": 628.3156307833232,
        "z": 0
      },
      {
        "x": 281.8318772866618,
        "y": 628.3258792394697,
        "z": 0
      },
      {
        "x": 281.8941312337978,
        "y": 628.3549292916432,
        "z": 0
      },
      {
        "x": 281.8948972827048,
        "y": 628.3552898159187,
        "z": 0
      },
      {
        "x": 281.8956624948188,
        "y": 628.3556530466301,
        "z": 0
      }
    ]
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 281.5428365442211,
        "y": 628.5906647881493,
        "z": 0
      },
      {
        "x": 281.5428365442211,
        "y": 628.3559985943147,
        "z": 0
      }
    ],
    "handle": "4122",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 281.8956624948188,
        "y": 628.5906647881493,
        "z": 0
      },
      {
        "x": 281.8956624948188,
        "y": 628.3556530466301,
        "z": 0
      }
    ],
    "handle": "4123",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 282.0092495146669,
        "y": 628.1450107013698,
        "z": 0
      },
      {
        "x": 282.156789541943,
        "y": 628.3281095316596,
        "z": 0
      }
    ],
    "handle": "4124",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 281.4292652062718,
        "y": 628.1450107013698,
        "z": 0
      },
      {
        "x": 281.281725179404,
        "y": 628.3281095316596,
        "z": 0
      }
    ],
    "handle": "4125",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 281.281725179404,
        "y": 628.3281095316596,
        "z": 0
      },
      {
        "x": 281.281725179404,
        "y": 628.135595809661,
        "z": 0
      }
    ],
    "handle": "4126",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 282.0092495146669,
        "y": 628.1450107013698,
        "z": 0
      },
      {
        "x": 282.0092495146669,
        "y": 627.9524969868332,
        "z": 0
      }
    ],
    "handle": "4127",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 282.156789541943,
        "y": 628.3281095316596,
        "z": 0
      },
      {
        "x": 282.156789539963,
        "y": 628.1355958199127,
        "z": 0
      }
    ],
    "handle": "4128",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 281.4292652062718,
        "y": 628.1450107013698,
        "z": 0
      },
      {
        "x": 281.4292652047009,
        "y": 627.9524969868332,
        "z": 0
      }
    ],
    "handle": "4129",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 281.4292652047009,
        "y": 627.9524969868332,
        "z": 0
      },
      {
        "x": 281.281725179404,
        "y": 628.1355958199127,
        "z": 0
      }
    ],
    "handle": "412A",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 282.0092495146669,
        "y": 627.9524969868332,
        "z": 0
      },
      {
        "x": 282.156789541943,
        "y": 628.1355958199127,
        "z": 0
      }
    ],
    "handle": "412B",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "ELLIPSE",
    "handle": "412C",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "center": {
      "x": 281.7192495229548,
      "y": 628.3677334757522,
      "z": 0
    },
    "majorAxisEndPoint": {
      "x": 0.1764129755138129,
      "y": 2.17674e-11,
      "z": 0
    },
    "axisRatio": 0.6259016496423861,
    "startAngle": 3.252782333826853,
    "endAngle": 6.168573069506875
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 281.4292652062718,
        "y": 628.1450107013698,
        "z": 0
      },
      {
        "x": 282.0092495146669,
        "y": 628.1450107013698,
        "z": 0
      }
    ],
    "handle": "412D",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 281.4292652047009,
        "y": 627.9524969868332,
        "z": 0
      },
      {
        "x": 282.0092495146669,
        "y": 627.9524969868332,
        "z": 0
      }
    ],
    "handle": "412E",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 281.4292652062718,
        "y": 628.511208359152,
        "z": 0
      },
      {
        "x": 281.281725179404,
        "y": 628.3281095316596,
        "z": 0
      }
    ],
    "handle": "412F",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 281.4292652062718,
        "y": 628.511208359152,
        "z": 0
      },
      {
        "x": 281.5428365452678,
        "y": 628.5112083582162,
        "z": 0
      }
    ],
    "handle": "4130",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 282.0092495146669,
        "y": 628.511208359152,
        "z": 0
      },
      {
        "x": 282.156789541943,
        "y": 628.3281095316596,
        "z": 0
      }
    ],
    "handle": "4131",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 281.895662496682,
        "y": 628.5112083628737,
        "z": 0
      },
      {
        "x": 282.0092495146669,
        "y": 628.511208359152,
        "z": 0
      }
    ],
    "handle": "4132",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "ELLIPSE",
    "handle": "4133",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "center": {
      "x": 278.367175010732,
      "y": 626.7106731478125,
      "z": 0
    },
    "majorAxisEndPoint": {
      "x": -0.1764129755113634,
      "y": 0,
      "z": 0
    },
    "axisRatio": 0.6259016496518008,
    "startAngle": 0,
    "endAngle": 6.283185307179584
  },
  {
    "type": "SPLINE",
    "handle": "4134",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "normalVector": {
      "x": 0,
      "y": 0,
      "z": 1
    },
    "planar": true,
    "degreeOfSplineCurve": 3,
    "numberOfKnots": 12,
    "numberOfControlPoints": 8,
    "numberOfFitPoints": 0,
    "knotValues": [
      0.7387853746015494,
      0.7387853746015494,
      0.7387853746015494,
      0.7387853746015494,
      0.7844749931928205,
      0.7844749931928205,
      1.696252131471398,
      1.696252131471398,
      2.401878553014586,
      2.401878553014586,
      2.401878553014586,
      2.401878553014586
    ],
    "controlPoints": [
      {
        "x": 278.1907620303688,
        "y": 626.5694000227338,
        "z": 0
      },
      {
        "x": 278.1935316285807,
        "y": 626.5674988878918,
        "z": 0
      },
      {
        "x": 278.1963394035117,
        "y": 626.5656582145019,
        "z": 0
      },
      {
        "x": 278.2558785125141,
        "y": 626.5283237192667,
        "z": 0
      },
      {
        "x": 278.3268974408851,
        "y": 626.514751501381,
        "z": 0
      },
      {
        "x": 278.4488377369708,
        "y": 626.5243771728127,
        "z": 0
      },
      {
        "x": 278.501090229664,
        "y": 626.539597291492,
        "z": 0
      },
      {
        "x": 278.5435879840509,
        "y": 626.5691400645215,
        "z": 0
      }
    ]
  },
  {
    "type": "SPLINE",
    "handle": "4135",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "normalVector": {
      "x": 0,
      "y": 0,
      "z": 1
    },
    "planar": true,
    "degreeOfSplineCurve": 3,
    "numberOfKnots": 14,
    "numberOfControlPoints": 10,
    "numberOfFitPoints": 0,
    "knotValues": [
      0.9221147950801091,
      0.9221147950801091,
      0.9221147950801091,
      0.9221147950801091,
      0.9338670167145838,
      0.9338670167145838,
      1.505248745831563,
      1.505248745831563,
      2.210109023906936,
      2.210109023906936,
      2.218899873798678,
      2.218899873798678,
      2.218899873798678,
      2.218899873798678
    ],
    "controlPoints": [
      {
        "x": 278.1907620303688,
        "y": 626.4760069577022,
        "z": 0
      },
      {
        "x": 278.1917751419829,
        "y": 626.4755242476167,
        "z": 0
      },
      {
        "x": 278.192789136549,
        "y": 626.4750462472439,
        "z": 0
      },
      {
        "x": 278.2431420189667,
        "y": 626.4515573931848,
        "z": 0
      },
      {
        "x": 278.2962834447391,
        "y": 626.4402015479207,
        "z": 0
      },
      {
        "x": 278.4143802754112,
        "y": 626.4356391439213,
        "z": 0
      },
      {
        "x": 278.4798027760118,
        "y": 626.4458876010029,
        "z": 0
      },
      {
        "x": 278.5420567231498,
        "y": 626.4749376550351,
        "z": 0
      },
      {
        "x": 278.542822769611,
        "y": 626.4752981746497,
        "z": 0
      },
      {
        "x": 278.5435879840509,
        "y": 626.4756614090838,
        "z": 0
      }
    ]
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 278.1907620327537,
        "y": 626.710673146881,
        "z": 0
      },
      {
        "x": 278.1907620327537,
        "y": 626.4760069577022,
        "z": 0
      }
    ],
    "handle": "4136",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 278.5435879840509,
        "y": 626.710673146881,
        "z": 0
      },
      {
        "x": 278.5435879840509,
        "y": 626.4756614081488,
        "z": 0
      }
    ],
    "handle": "4137",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 278.6571750030848,
        "y": 626.2650190610401,
        "z": 0
      },
      {
        "x": 278.8047150300106,
        "y": 626.4481178903904,
        "z": 0
      }
    ],
    "handle": "4138",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 278.0771906947491,
        "y": 626.2650190610401,
        "z": 0
      },
      {
        "x": 277.929650667124,
        "y": 626.4481178903904,
        "z": 0
      }
    ],
    "handle": "4139",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 277.929650667124,
        "y": 626.4481178903904,
        "z": 0
      },
      {
        "x": 277.929650667124,
        "y": 626.2556041711941,
        "z": 0
      }
    ],
    "handle": "413A",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 278.6571750030848,
        "y": 626.2650190610401,
        "z": 0
      },
      {
        "x": 278.6571750030848,
        "y": 626.0725053483402,
        "z": 0
      }
    ],
    "handle": "413B",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 278.8047150300106,
        "y": 626.4481178903904,
        "z": 0
      },
      {
        "x": 278.8047150288478,
        "y": 626.2556041805037,
        "z": 0
      }
    ],
    "handle": "413C",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 278.0771906947491,
        "y": 626.2650190610401,
        "z": 0
      },
      {
        "x": 278.0771906932349,
        "y": 626.0725053483402,
        "z": 0
      }
    ],
    "handle": "413D",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 278.0771906932349,
        "y": 626.0725053483402,
        "z": 0
      },
      {
        "x": 277.929650667124,
        "y": 626.2556041805037,
        "z": 0
      }
    ],
    "handle": "413E",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 278.6571750030848,
        "y": 626.0725053483402,
        "z": 0
      },
      {
        "x": 278.8047150300106,
        "y": 626.2556041805037,
        "z": 0
      }
    ],
    "handle": "413F",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "ELLIPSE",
    "handle": "4140",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "center": {
      "x": 278.367175010732,
      "y": 626.487741836343,
      "z": 0
    },
    "majorAxisEndPoint": {
      "x": 0.1764129755138129,
      "y": 2.17674e-11,
      "z": 0
    },
    "axisRatio": 0.6259016496423861,
    "startAngle": 3.252782333826853,
    "endAngle": 6.168573069506875
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 278.0771906947491,
        "y": 626.2650190610401,
        "z": 0
      },
      {
        "x": 278.6571750030848,
        "y": 626.2650190610401,
        "z": 0
      }
    ],
    "handle": "4141",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 278.0771906932349,
        "y": 626.0725053483402,
        "z": 0
      },
      {
        "x": 278.6571750030848,
        "y": 626.0725053483402,
        "z": 0
      }
    ],
    "handle": "4142",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 278.0771906947491,
        "y": 626.6312167216129,
        "z": 0
      },
      {
        "x": 277.929650667124,
        "y": 626.4481178903904,
        "z": 0
      }
    ],
    "handle": "4143",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 278.0771906947491,
        "y": 626.6312167216129,
        "z": 0
      },
      {
        "x": 278.1907620342669,
        "y": 626.6312167160212,
        "z": 0
      }
    ],
    "handle": "4144",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 278.6571750030848,
        "y": 626.6312167216129,
        "z": 0
      },
      {
        "x": 278.8047150300106,
        "y": 626.4481178903904,
        "z": 0
      }
    ],
    "handle": "4145",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 278.543587984924,
        "y": 626.6312167216129,
        "z": 0
      },
      {
        "x": 278.6571750030848,
        "y": 626.6312167216129,
        "z": 0
      }
    ],
    "handle": "4146",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 281.708378813461,
        "y": 624.7434093598092,
        "z": 0
      },
      {
        "x": 281.8219658305738,
        "y": 624.7434093551527,
        "z": 0
      }
    ],
    "handle": "4147",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 281.8219658305738,
        "y": 624.7434093551527,
        "z": 0
      },
      {
        "x": 281.9695058579089,
        "y": 624.5603105276605,
        "z": 0
      }
    ],
    "handle": "4148",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 281.2419815221811,
        "y": 624.7434093551527,
        "z": 0
      },
      {
        "x": 281.35555286205,
        "y": 624.7434093532928,
        "z": 0
      }
    ],
    "handle": "4149",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 281.2419815221811,
        "y": 624.7434093551527,
        "z": 0
      },
      {
        "x": 281.0944414949636,
        "y": 624.5603105276605,
        "z": 0
      }
    ],
    "handle": "414A",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 281.241981520317,
        "y": 624.1846979837727,
        "z": 0
      },
      {
        "x": 281.8219658305738,
        "y": 624.1846979837727,
        "z": 0
      }
    ],
    "handle": "414B",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 281.2419815221811,
        "y": 624.37721169645,
        "z": 0
      },
      {
        "x": 281.8219658305738,
        "y": 624.37721169645,
        "z": 0
      }
    ],
    "handle": "414C",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "ELLIPSE",
    "handle": "414D",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "center": {
      "x": 281.5319658374061,
      "y": 624.5999344717528,
      "z": 0
    },
    "majorAxisEndPoint": {
      "x": 0.1764129755138129,
      "y": 2.17674e-11,
      "z": 0
    },
    "axisRatio": 0.6259016496423861,
    "startAngle": 3.252782333826853,
    "endAngle": 6.168573069506875
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 281.8219658305738,
        "y": 624.1846979837727,
        "z": 0
      },
      {
        "x": 281.9695058579089,
        "y": 624.3677968149821,
        "z": 0
      }
    ],
    "handle": "414E",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 281.241981520317,
        "y": 624.1846979837727,
        "z": 0
      },
      {
        "x": 281.0944414949636,
        "y": 624.3677968149821,
        "z": 0
      }
    ],
    "handle": "414F",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 281.2419815221811,
        "y": 624.37721169645,
        "z": 0
      },
      {
        "x": 281.241981520317,
        "y": 624.1846979837727,
        "z": 0
      }
    ],
    "handle": "4150",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 281.9695058579089,
        "y": 624.5603105276605,
        "z": 0
      },
      {
        "x": 281.9695058559308,
        "y": 624.3677968149821,
        "z": 0
      }
    ],
    "handle": "4151",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 281.8219658305738,
        "y": 624.37721169645,
        "z": 0
      },
      {
        "x": 281.8219658305738,
        "y": 624.1846979837727,
        "z": 0
      }
    ],
    "handle": "4152",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 281.0944414949636,
        "y": 624.5603105276605,
        "z": 0
      },
      {
        "x": 281.0944414949636,
        "y": 624.3677968056687,
        "z": 0
      }
    ],
    "handle": "4153",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 281.2419815221811,
        "y": 624.37721169645,
        "z": 0
      },
      {
        "x": 281.0944414949636,
        "y": 624.5603105276605,
        "z": 0
      }
    ],
    "handle": "4154",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 281.8219658305738,
        "y": 624.37721169645,
        "z": 0
      },
      {
        "x": 281.9695058579089,
        "y": 624.5603105276605,
        "z": 0
      }
    ],
    "handle": "4155",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 281.7083788114839,
        "y": 624.8228657832178,
        "z": 0
      },
      {
        "x": 281.7083788114839,
        "y": 624.5878540444946,
        "z": 0
      }
    ],
    "handle": "4156",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 281.3555528601268,
        "y": 624.8228657832178,
        "z": 0
      },
      {
        "x": 281.3555528601268,
        "y": 624.5881995912496,
        "z": 0
      }
    ],
    "handle": "4157",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "SPLINE",
    "handle": "4158",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "normalVector": {
      "x": 0,
      "y": 0,
      "z": 1
    },
    "planar": true,
    "degreeOfSplineCurve": 3,
    "numberOfKnots": 14,
    "numberOfControlPoints": 10,
    "numberOfFitPoints": 0,
    "knotValues": [
      0.9221147950801091,
      0.9221147950801091,
      0.9221147950801091,
      0.9221147950801091,
      0.9338670167145838,
      0.9338670167145838,
      1.505248745831563,
      1.505248745831563,
      2.210109023906936,
      2.210109023906936,
      2.218899873798678,
      2.218899873798678,
      2.218899873798678,
      2.218899873798678
    ],
    "controlPoints": [
      {
        "x": 281.3555528586727,
        "y": 624.5881995940442,
        "z": 0
      },
      {
        "x": 281.3565659685988,
        "y": 624.5877168821023,
        "z": 0
      },
      {
        "x": 281.35757996398,
        "y": 624.5872388826547,
        "z": 0
      },
      {
        "x": 281.4079328463398,
        "y": 624.5637500267329,
        "z": 0
      },
      {
        "x": 281.4610742712968,
        "y": 624.5523941824027,
        "z": 0
      },
      {
        "x": 281.5791711028433,
        "y": 624.5478317765346,
        "z": 0
      },
      {
        "x": 281.6445936034431,
        "y": 624.558080236412,
        "z": 0
      },
      {
        "x": 281.7068475498808,
        "y": 624.5871302913692,
        "z": 0
      },
      {
        "x": 281.7076135986141,
        "y": 624.5874908100586,
        "z": 0
      },
      {
        "x": 281.7083788107837,
        "y": 624.5878540444946,
        "z": 0
      }
    ]
  },
  {
    "type": "SPLINE",
    "handle": "4159",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "normalVector": {
      "x": 0,
      "y": 0,
      "z": 1
    },
    "planar": true,
    "degreeOfSplineCurve": 3,
    "numberOfKnots": 12,
    "numberOfControlPoints": 8,
    "numberOfFitPoints": 0,
    "knotValues": [
      0.7387853746015494,
      0.7387853746015494,
      0.7387853746015494,
      0.7387853746015494,
      0.7844749931928205,
      0.7844749931928205,
      1.696252131471398,
      1.696252131471398,
      2.401878553014586,
      2.401878553014586,
      2.401878553014586,
      2.401878553014586
    ],
    "controlPoints": [
      {
        "x": 281.3555528586727,
        "y": 624.6815926581404,
        "z": 0
      },
      {
        "x": 281.3583224567707,
        "y": 624.6796915214327,
        "z": 0
      },
      {
        "x": 281.361130230187,
        "y": 624.6778508489842,
        "z": 0
      },
      {
        "x": 281.420669339888,
        "y": 624.6405163537537,
        "z": 0
      },
      {
        "x": 281.4916882675028,
        "y": 624.6269441377233,
        "z": 0
      },
      {
        "x": 281.6136285635878,
        "y": 624.6365698072914,
        "z": 0
      },
      {
        "x": 281.6658810563389,
        "y": 624.6517899278333,
        "z": 0
      },
      {
        "x": 281.7083788107837,
        "y": 624.6813326999317,
        "z": 0
      }
    ]
  },
  {
    "type": "ELLIPSE",
    "handle": "415A",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "center": {
      "x": 281.5319658374061,
      "y": 624.8228657832178,
      "z": 0
    },
    "majorAxisEndPoint": {
      "x": -0.1764129755113634,
      "y": 0,
      "z": 0
    },
    "axisRatio": 0.6259016496518008,
    "startAngle": 0,
    "endAngle": 6.283185307179584
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 285.0604533241727,
        "y": 626.6234009983027,
        "z": 0
      },
      {
        "x": 285.1740403420399,
        "y": 626.6234009936453,
        "z": 0
      }
    ],
    "handle": "415B",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 285.1740403420399,
        "y": 626.6234009936453,
        "z": 0
      },
      {
        "x": 285.3215803689666,
        "y": 626.4403021661516,
        "z": 0
      }
    ],
    "handle": "415C",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 284.5940560337037,
        "y": 626.6234009936453,
        "z": 0
      },
      {
        "x": 284.7076273738642,
        "y": 626.6234009908513,
        "z": 0
      }
    ],
    "handle": "415D",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 284.5940560337037,
        "y": 626.6234009936453,
        "z": 0
      },
      {
        "x": 284.4465160063698,
        "y": 626.4403021661516,
        "z": 0
      }
    ],
    "handle": "415E",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 284.5940560321319,
        "y": 626.0646896231701,
        "z": 0
      },
      {
        "x": 285.1740403420399,
        "y": 626.0646896231701,
        "z": 0
      }
    ],
    "handle": "415F",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 284.5940560337037,
        "y": 626.2572033368002,
        "z": 0
      },
      {
        "x": 285.1740403420399,
        "y": 626.2572033368002,
        "z": 0
      }
    ],
    "handle": "4160",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "ELLIPSE",
    "handle": "4161",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "center": {
      "x": 284.8840403503259,
      "y": 626.4799261120997,
      "z": 0
    },
    "majorAxisEndPoint": {
      "x": 0.1764129755138129,
      "y": 2.17674e-11,
      "z": 0
    },
    "axisRatio": 0.6259016496423861,
    "startAngle": 3.252782333826853,
    "endAngle": 6.168573069506875
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 285.1740403420399,
        "y": 626.0646896231701,
        "z": 0
      },
      {
        "x": 285.3215803689666,
        "y": 626.2477884562612,
        "z": 0
      }
    ],
    "handle": "4162",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 284.5940560321319,
        "y": 626.0646896231701,
        "z": 0
      },
      {
        "x": 284.4465160063698,
        "y": 626.2477884562612,
        "z": 0
      }
    ],
    "handle": "4163",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 284.5940560337037,
        "y": 626.2572033368002,
        "z": 0
      },
      {
        "x": 284.5940560321319,
        "y": 626.0646896231701,
        "z": 0
      }
    ],
    "handle": "4164",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 285.3215803689666,
        "y": 626.4403021661516,
        "z": 0
      },
      {
        "x": 285.321580367745,
        "y": 626.2477884562612,
        "z": 0
      }
    ],
    "handle": "4165",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 285.1740403420399,
        "y": 626.2572033368002,
        "z": 0
      },
      {
        "x": 285.1740403420399,
        "y": 626.0646896231701,
        "z": 0
      }
    ],
    "handle": "4166",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 284.4465160063698,
        "y": 626.4403021661516,
        "z": 0
      },
      {
        "x": 284.4465160063698,
        "y": 626.2477884460203,
        "z": 0
      }
    ],
    "handle": "4167",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 284.5940560337037,
        "y": 626.2572033368002,
        "z": 0
      },
      {
        "x": 284.4465160063698,
        "y": 626.4403021661516,
        "z": 0
      }
    ],
    "handle": "4168",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 285.1740403420399,
        "y": 626.2572033368002,
        "z": 0
      },
      {
        "x": 285.3215803689666,
        "y": 626.4403021661516,
        "z": 0
      }
    ],
    "handle": "4169",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 285.0604533234147,
        "y": 626.702857421711,
        "z": 0
      },
      {
        "x": 285.0604533234147,
        "y": 626.4678456839138,
        "z": 0
      }
    ],
    "handle": "416A",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 284.7076273720011,
        "y": 626.702857421711,
        "z": 0
      },
      {
        "x": 284.7076273720011,
        "y": 626.4681912325368,
        "z": 0
      }
    ],
    "handle": "416B",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "SPLINE",
    "handle": "416C",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "normalVector": {
      "x": 0,
      "y": 0,
      "z": 1
    },
    "planar": true,
    "degreeOfSplineCurve": 3,
    "numberOfKnots": 14,
    "numberOfControlPoints": 10,
    "numberOfFitPoints": 0,
    "knotValues": [
      0.9221147950801091,
      0.9221147950801091,
      0.9221147950801091,
      0.9221147950801091,
      0.9338670167145838,
      0.9338670167145838,
      1.505248745831563,
      1.505248745831563,
      2.210109023906936,
      2.210109023906936,
      2.218899873798678,
      2.218899873798678,
      2.218899873798678,
      2.218899873798678
    ],
    "controlPoints": [
      {
        "x": 284.7076273700218,
        "y": 626.4681912306586,
        "z": 0
      },
      {
        "x": 284.7086404808802,
        "y": 626.4677085196481,
        "z": 0
      },
      {
        "x": 284.709654475447,
        "y": 626.467230522071,
        "z": 0
      },
      {
        "x": 284.7600073570486,
        "y": 626.4437416670808,
        "z": 0
      },
      {
        "x": 284.8131487828208,
        "y": 626.4323858199602,
        "z": 0
      },
      {
        "x": 284.9312456150069,
        "y": 626.42782341782,
        "z": 0
      },
      {
        "x": 284.996668114909,
        "y": 626.4380718739702,
        "z": 0
      },
      {
        "x": 285.0589220620459,
        "y": 626.4671219289227,
        "z": 0
      },
      {
        "x": 285.0596881101368,
        "y": 626.4674824476132,
        "z": 0
      },
      {
        "x": 285.0604533229489,
        "y": 626.4678456839138,
        "z": 0
      }
    ]
  },
  {
    "type": "SPLINE",
    "handle": "416D",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "normalVector": {
      "x": 0,
      "y": 0,
      "z": 1
    },
    "planar": true,
    "degreeOfSplineCurve": 3,
    "numberOfKnots": 12,
    "numberOfControlPoints": 8,
    "numberOfFitPoints": 0,
    "knotValues": [
      0.7387853746015494,
      0.7387853746015494,
      0.7387853746015494,
      0.7387853746015494,
      0.7844749931928205,
      0.7844749931928205,
      1.696252131471398,
      1.696252131471398,
      2.401878553014586,
      2.401878553014586,
      2.401878553014586,
      2.401878553014586
    ],
    "controlPoints": [
      {
        "x": 284.7076273700218,
        "y": 626.5615842975602,
        "z": 0
      },
      {
        "x": 284.710396968294,
        "y": 626.5596831589901,
        "z": 0
      },
      {
        "x": 284.7132047415938,
        "y": 626.5578424902604,
        "z": 0
      },
      {
        "x": 284.772743852227,
        "y": 626.5205079931693,
        "z": 0
      },
      {
        "x": 284.8437627805387,
        "y": 626.5069357780737,
        "z": 0
      },
      {
        "x": 284.9657030758678,
        "y": 626.5165614467113,
        "z": 0
      },
      {
        "x": 285.0179555671058,
        "y": 626.5317815654015,
        "z": 0
      },
      {
        "x": 285.0604533229489,
        "y": 626.5613243393587,
        "z": 0
      }
    ]
  },
  {
    "type": "ELLIPSE",
    "handle": "416E",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "center": {
      "x": 284.8840403503259,
      "y": 626.702857421711,
      "z": 0
    },
    "majorAxisEndPoint": {
      "x": -0.1764129755113634,
      "y": 0,
      "z": 0
    },
    "axisRatio": 0.6259016496518008,
    "startAngle": 0,
    "endAngle": 6.283185307179584
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 286.0288105239739,
        "y": 625.7872994839893,
        "z": 0
      },
      {
        "x": 286.3168845027692,
        "y": 625.6154624782318,
        "z": 0
      }
    ],
    "handle": "416F",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 286.3168845032918,
        "y": 625.307604488902,
        "z": 0
      },
      {
        "x": 286.056379187095,
        "y": 625.1615015892094,
        "z": 0
      }
    ],
    "handle": "4170",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 286.3168845027692,
        "y": 625.6154624782318,
        "z": 0
      },
      {
        "x": 285.7903760613398,
        "y": 625.3201732616734,
        "z": 0
      }
    ],
    "handle": "4171",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 286.3168845027692,
        "y": 625.6154624782318,
        "z": 0
      },
      {
        "x": 286.3168845032918,
        "y": 625.307604488902,
        "z": 0
      }
    ],
    "handle": "4172",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 286.3168845027692,
        "y": 626.2567221028728,
        "z": 0
      },
      {
        "x": 286.3168845032918,
        "y": 625.94886411072,
        "z": 0
      }
    ],
    "handle": "4173",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 281.794831406907,
        "y": 628.9541405383497,
        "z": 0
      },
      {
        "x": 286.3168845027692,
        "y": 626.2567221028728,
        "z": 0
      }
    ],
    "handle": "4174",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 281.720252702012,
        "y": 623.3708697026412,
        "z": 0
      },
      {
        "x": 286.3168845032918,
        "y": 625.94886411072,
        "z": 0
      }
    ],
    "handle": "4175",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 281.7243959634208,
        "y": 623.6810514153732,
        "z": 0
      },
      {
        "x": 286.3168845027692,
        "y": 626.2567221028728,
        "z": 0
      }
    ],
    "handle": "4176",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 281.7243959634208,
        "y": 623.0397917926127,
        "z": 0
      },
      {
        "x": 282.548619450477,
        "y": 623.5020527737032,
        "z": 0
      }
    ],
    "handle": "4177",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 281.720252702012,
        "y": 622.7296100780177,
        "z": 0
      },
      {
        "x": 282.814622574776,
        "y": 623.3433811049727,
        "z": 0
      }
    ],
    "handle": "4178",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 281.7243959634208,
        "y": 623.0397917926127,
        "z": 0
      },
      {
        "x": 281.720252702012,
        "y": 622.7296100780177,
        "z": 0
      }
    ],
    "handle": "4179",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 281.7243959634208,
        "y": 623.6810514153732,
        "z": 0
      },
      {
        "x": 281.720252702012,
        "y": 623.3708697026412,
        "z": 0
      }
    ],
    "handle": "417A",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 279.5696077245518,
        "y": 624.3251295378323,
        "z": 0
      },
      {
        "x": 281.7243959634208,
        "y": 623.0397917926127,
        "z": 0
      }
    ],
    "handle": "417B",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 279.6431487179932,
        "y": 623.9686089269597,
        "z": 0
      },
      {
        "x": 281.720252702012,
        "y": 622.7296100780177,
        "z": 0
      }
    ],
    "handle": "417C",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "ELLIPSE",
    "handle": "417D",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "center": {
      "x": 278.9950399587979,
      "y": 624.5793037554112,
      "z": 0
    },
    "majorAxisEndPoint": {
      "x": -0.5507681030788067,
      "y": 0.3043356101076054,
      "z": 0
    },
    "axisRatio": 0.8446940944538731,
    "startAngle": -0.1826476038001776,
    "endAngle": 0.4141202800996738
  },
  {
    "type": "SPLINE",
    "handle": "417E",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "normalVector": {
      "x": 0,
      "y": 0,
      "z": 1
    },
    "planar": true,
    "degreeOfSplineCurve": 3,
    "numberOfKnots": 10,
    "numberOfControlPoints": 6,
    "numberOfFitPoints": 0,
    "knotValues": [
      0.1942940721670503,
      0.1942940721670503,
      0.1942940721670503,
      0.1942940721670503,
      0.3202527597656655,
      0.3202527597656655,
      0.5875976963365988,
      0.5875976963365988,
      0.5875976963365988,
      0.5875976963365988
    ],
    "controlPoints": [
      {
        "x": 278.1467031616479,
        "y": 624.8612432638,
        "z": 0
      },
      {
        "x": 278.1369817490938,
        "y": 624.8269597794679,
        "z": 0
      },
      {
        "x": 278.1297622320131,
        "y": 624.7919800607339,
        "z": 0
      },
      {
        "x": 278.1152828228656,
        "y": 624.6817905222813,
        "z": 0
      },
      {
        "x": 278.1171324861942,
        "y": 624.6058029951334,
        "z": 0
      },
      {
        "x": 278.1293549682,
        "y": 624.5313837500116,
        "z": 0
      }
    ]
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 315.842326434096,
        "y": 607.3610799517328,
        "z": 0
      },
      {
        "x": 316.0059527086569,
        "y": 607.4494327679131,
        "z": 0
      }
    ],
    "handle": "417F",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 315.0367926707248,
        "y": 607.8415832947826,
        "z": 0
      },
      {
        "x": 316.0059527086569,
        "y": 608.3648978937242,
        "z": 0
      }
    ],
    "handle": "4180",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 299.7316511812389,
        "y": 616.9711467921477,
        "z": 0
      },
      {
        "x": 316.0059527086569,
        "y": 625.7587352785994,
        "z": 0
      }
    ],
    "handle": "4181",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 298.9261174197876,
        "y": 617.4516501333418,
        "z": 0
      },
      {
        "x": 316.0059527086569,
        "y": 626.6742004025691,
        "z": 0
      }
    ],
    "handle": "4182",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 284.7504610005998,
        "y": 627.1910984907342,
        "z": 0
      },
      {
        "x": 303.3782816998429,
        "y": 637.249510050744,
        "z": 0
      }
    ],
    "handle": "4183",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 283.9449272374027,
        "y": 627.6716018309825,
        "z": 0
      },
      {
        "x": 302.5727479365897,
        "y": 637.7300133947327,
        "z": 0
      }
    ],
    "handle": "4184",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 303.7913810316229,
        "y": 637.0030950447516,
        "z": 0
      },
      {
        "x": 303.7913810316229,
        "y": 614.5495055764702,
        "z": 0
      }
    ],
    "handle": "4185",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 287.2848411550508,
        "y": 646.8492963360621,
        "z": 0
      },
      {
        "x": 287.2848411538877,
        "y": 624.3957068696436,
        "z": 0
      }
    ],
    "handle": "4186",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 302.9858472687199,
        "y": 637.4835983859338,
        "z": 0
      },
      {
        "x": 302.9858472687199,
        "y": 615.0300089185957,
        "z": 0
      }
    ],
    "handle": "4187",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 286.4793073922631,
        "y": 647.3297996791042,
        "z": 0
      },
      {
        "x": 286.4793073920301,
        "y": 624.8762102108302,
        "z": 0
      }
    ],
    "handle": "4188",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 222.7302810251699,
        "y": 686.7255397941917,
        "z": 0
      },
      {
        "x": 222.7307007857009,
        "y": 686.741249471899,
        "z": 0
      }
    ],
    "handle": "4189",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "TEXT",
    "handle": "418A",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "startPoint": {
      "x": 119.427855347516,
      "y": 621.0436072833626,
      "z": 0
    },
    "textHeight": 7.5,
    "text": "Radyel demir"
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 172.3825138105309,
        "y": 688.8708036057614,
        "z": 0
      },
      {
        "x": 172.3825138093671,
        "y": 688.5581504264837,
        "z": 0
      }
    ],
    "handle": "418B",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 172.3825138108808,
        "y": 688.8708036094832,
        "z": 0
      },
      {
        "x": 176.9045669056349,
        "y": 686.1733851674918,
        "z": 0
      }
    ],
    "handle": "418C",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 174.5101143640929,
        "y": 685.1383282709837,
        "z": 0
      },
      {
        "x": 174.5101143629289,
        "y": 640.9327558986841,
        "z": 0
      }
    ],
    "handle": "418D",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 173.7045805999648,
        "y": 684.9908810481394,
        "z": 0
      },
      {
        "x": 173.7045805999648,
        "y": 640.9327558986841,
        "z": 0
      }
    ],
    "handle": "418E",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 190.6207896174159,
        "y": 678.3042697422244,
        "z": 0
      },
      {
        "x": 190.6207896197436,
        "y": 631.3226890582507,
        "z": 0
      }
    ],
    "handle": "418F",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 189.8152558560249,
        "y": 678.7847730834008,
        "z": 0
      },
      {
        "x": 189.8152558568399,
        "y": 631.3226890582507,
        "z": 0
      }
    ],
    "handle": "4190",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 157.9766358185446,
        "y": 650.2839078577197,
        "z": 0
      },
      {
        "x": 199.7662916722478,
        "y": 672.8489499203814,
        "z": 0
      }
    ],
    "handle": "4191",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 157.9766358185446,
        "y": 669.0430987244442,
        "z": 0
      },
      {
        "x": 183.2597517876408,
        "y": 682.6951512163549,
        "z": 0
      }
    ],
    "handle": "4192",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 157.5939053440232,
        "y": 650.9927110942016,
        "z": 0
      },
      {
        "x": 198.9607579096919,
        "y": 673.3294532606302,
        "z": 0
      }
    ],
    "handle": "4193",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 157.5939053440232,
        "y": 669.7519019600012,
        "z": 0
      },
      {
        "x": 182.4542180240389,
        "y": 683.1756545593914,
        "z": 0
      }
    ],
    "handle": "4194",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 124.692075279891,
        "y": 617.2440324807429,
        "z": 0
      },
      {
        "x": 182.8602844406271,
        "y": 617.2440324807429,
        "z": 0
      }
    ],
    "handle": "4195",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD",
      "customStrings": [
        "DSTYLE",
        "ARCHTICK"
      ]
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 189.2173173991599,
        "y": 629.8200985454021,
        "z": 0
      },
      {
        "x": 182.8602844406271,
        "y": 617.2440324807429,
        "z": 0
      }
    ],
    "handle": "4196",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 206.731464874581,
        "y": 668.6942029008601,
        "z": 0
      },
      {
        "x": 206.7314648760941,
        "y": 621.7126222178192,
        "z": 0
      }
    ],
    "handle": "4197",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 205.9259311121422,
        "y": 669.1747062429857,
        "z": 0
      },
      {
        "x": 205.925931112899,
        "y": 621.7126222178192,
        "z": 0
      }
    ],
    "handle": "4198",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 190.6207896189291,
        "y": 668.8410707861121,
        "z": 0
      },
      {
        "x": 190.6207896197436,
        "y": 631.3226890582507,
        "z": 0
      }
    ],
    "handle": "4199",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 173.8373459452998,
        "y": 688.7573528150102,
        "z": 0
      },
      {
        "x": 173.8373459452998,
        "y": 688.5648390995347,
        "z": 0
      }
    ],
    "handle": "419A",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 173.2573616373699,
        "y": 688.7573528150102,
        "z": 0
      },
      {
        "x": 173.2573616354489,
        "y": 688.5648390995347,
        "z": 0
      }
    ],
    "handle": "419B",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 173.2573616354489,
        "y": 688.5648390995347,
        "z": 0
      },
      {
        "x": 173.10982160928,
        "y": 688.747937932614,
        "z": 0
      }
    ],
    "handle": "419C",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 173.8373459452998,
        "y": 688.5648390995347,
        "z": 0
      },
      {
        "x": 173.9848859723431,
        "y": 688.747937932614,
        "z": 0
      }
    ],
    "handle": "419D",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 173.2573616373699,
        "y": 688.7573528150102,
        "z": 0
      },
      {
        "x": 173.8373459452998,
        "y": 688.7573528150102,
        "z": 0
      }
    ],
    "handle": "419E",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 173.2573616354489,
        "y": 688.5648390995347,
        "z": 0
      },
      {
        "x": 173.8373459452998,
        "y": 688.5648390995347,
        "z": 0
      }
    ],
    "handle": "419F",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 179.7742269746959,
        "y": 688.5570233762226,
        "z": 0
      },
      {
        "x": 180.3542112843138,
        "y": 688.5570233762226,
        "z": 0
      }
    ],
    "handle": "41A0",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 179.7742269755099,
        "y": 688.7495370889008,
        "z": 0
      },
      {
        "x": 180.3542112843138,
        "y": 688.7495370889008,
        "z": 0
      }
    ],
    "handle": "41A1",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 180.3542112843138,
        "y": 688.5570233762226,
        "z": 0
      },
      {
        "x": 180.5017513111237,
        "y": 688.7401222074437,
        "z": 0
      }
    ],
    "handle": "41A2",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 179.7742269746959,
        "y": 688.5570233762226,
        "z": 0
      },
      {
        "x": 179.6266869485839,
        "y": 688.7401222074437,
        "z": 0
      }
    ],
    "handle": "41A3",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 179.7742269755099,
        "y": 688.7495370889008,
        "z": 0
      },
      {
        "x": 179.7742269746959,
        "y": 688.5570233762226,
        "z": 0
      }
    ],
    "handle": "41A4",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 180.3542112843138,
        "y": 688.7495370889008,
        "z": 0
      },
      {
        "x": 180.3542112843138,
        "y": 688.5570233762226,
        "z": 0
      }
    ],
    "handle": "41A5",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 176.8885497556758,
        "y": 687.2357431110031,
        "z": 0
      },
      {
        "x": 177.0021367727306,
        "y": 687.2357431072702,
        "z": 0
      }
    ],
    "handle": "41A6",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 177.0021367727306,
        "y": 687.2357431072702,
        "z": 0
      },
      {
        "x": 177.1496767996568,
        "y": 687.0526442788549,
        "z": 0
      }
    ],
    "handle": "41A7",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 176.4221524646858,
        "y": 687.2357431072702,
        "z": 0
      },
      {
        "x": 176.535723804204,
        "y": 687.2357431054012,
        "z": 0
      }
    ],
    "handle": "41A8",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 176.4221524646858,
        "y": 687.2357431072702,
        "z": 0
      },
      {
        "x": 176.27461243677,
        "y": 687.0526442788549,
        "z": 0
      }
    ],
    "handle": "41A9",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 176.4221524624151,
        "y": 686.6770317358859,
        "z": 0
      },
      {
        "x": 177.0021367727306,
        "y": 686.6770317358859,
        "z": 0
      }
    ],
    "handle": "41AA",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 176.4221524646858,
        "y": 686.8695454476315,
        "z": 0
      },
      {
        "x": 177.0021367727306,
        "y": 686.8695454476315,
        "z": 0
      }
    ],
    "handle": "41AB",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "ELLIPSE",
    "handle": "41AC",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "center": {
      "x": 176.7121367799126,
      "y": 687.0922682266598,
      "z": 0
    },
    "majorAxisEndPoint": {
      "x": 0.1764129755138129,
      "y": 2.17674e-11,
      "z": 0
    },
    "axisRatio": 0.6259016496423861,
    "startAngle": 3.252782333826853,
    "endAngle": 6.168573069506875
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 177.0021367727306,
        "y": 686.6770317358859,
        "z": 0
      },
      {
        "x": 177.1496767996568,
        "y": 686.8601305680357,
        "z": 0
      }
    ],
    "handle": "41AD",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 176.4221524624151,
        "y": 686.6770317358859,
        "z": 0
      },
      {
        "x": 176.27461243677,
        "y": 686.8601305680357,
        "z": 0
      }
    ],
    "handle": "41AE",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 176.4221524646858,
        "y": 686.8695454476315,
        "z": 0
      },
      {
        "x": 176.4221524624151,
        "y": 686.6770317358859,
        "z": 0
      }
    ],
    "handle": "41AF",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 177.1496767996568,
        "y": 687.0526442788549,
        "z": 0
      },
      {
        "x": 177.1496767980849,
        "y": 686.8601305680357,
        "z": 0
      }
    ],
    "handle": "41B0",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 177.0021367727306,
        "y": 686.8695454476315,
        "z": 0
      },
      {
        "x": 177.0021367727306,
        "y": 686.6770317358859,
        "z": 0
      }
    ],
    "handle": "41B1",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 176.27461243677,
        "y": 687.0526442788549,
        "z": 0
      },
      {
        "x": 176.27461243677,
        "y": 686.8601305568627,
        "z": 0
      }
    ],
    "handle": "41B2",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 176.4221524646858,
        "y": 686.8695454476315,
        "z": 0
      },
      {
        "x": 176.27461243677,
        "y": 687.0526442788549,
        "z": 0
      }
    ],
    "handle": "41B3",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 177.0021367727306,
        "y": 686.8695454476315,
        "z": 0
      },
      {
        "x": 177.1496767996568,
        "y": 687.0526442788549,
        "z": 0
      }
    ],
    "handle": "41B4",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 176.8885497538141,
        "y": 687.3151995344078,
        "z": 0
      },
      {
        "x": 176.8885497538141,
        "y": 687.0801877966112,
        "z": 0
      }
    ],
    "handle": "41B5",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 176.5357238027496,
        "y": 687.3151995344078,
        "z": 0
      },
      {
        "x": 176.5357238027496,
        "y": 687.0805333442959,
        "z": 0
      }
    ],
    "handle": "41B6",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "SPLINE",
    "handle": "41B7",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "normalVector": {
      "x": 0,
      "y": 0,
      "z": 1
    },
    "planar": true,
    "degreeOfSplineCurve": 3,
    "numberOfKnots": 14,
    "numberOfControlPoints": 10,
    "numberOfFitPoints": 0,
    "knotValues": [
      0.9221147950801091,
      0.9221147950801091,
      0.9221147950801091,
      0.9221147950801091,
      0.9338670167145838,
      0.9338670167145838,
      1.505248745831563,
      1.505248745831563,
      2.210109023906936,
      2.210109023906936,
      2.218899873798678,
      2.218899873798678,
      2.218899873798678,
      2.218899873798678
    ],
    "controlPoints": [
      {
        "x": 176.5357237996056,
        "y": 687.0805333442959,
        "z": 0
      },
      {
        "x": 176.5367369113959,
        "y": 687.0800506342082,
        "z": 0
      },
      {
        "x": 176.5377509058448,
        "y": 687.0795726366302,
        "z": 0
      },
      {
        "x": 176.5881037890798,
        "y": 687.0560837807107,
        "z": 0
      },
      {
        "x": 176.6412452139182,
        "y": 687.0447279363824,
        "z": 0
      },
      {
        "x": 176.7593420454078,
        "y": 687.0401655314417,
        "z": 0
      },
      {
        "x": 176.8247645460059,
        "y": 687.0504139866616,
        "z": 0
      },
      {
        "x": 176.8870184924458,
        "y": 687.0794640416199,
        "z": 0
      },
      {
        "x": 176.8877845412339,
        "y": 687.0798245631123,
        "z": 0
      },
      {
        "x": 176.8885497533481,
        "y": 687.0801877947522,
        "z": 0
      }
    ]
  },
  {
    "type": "SPLINE",
    "handle": "41B8",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "normalVector": {
      "x": 0,
      "y": 0,
      "z": 1
    },
    "planar": true,
    "degreeOfSplineCurve": 3,
    "numberOfKnots": 12,
    "numberOfControlPoints": 8,
    "numberOfFitPoints": 0,
    "knotValues": [
      0.7387853746015494,
      0.7387853746015494,
      0.7387853746015494,
      0.7387853746015494,
      0.7844749931928205,
      0.7844749931928205,
      1.696252131471398,
      1.696252131471398,
      2.401878553014586,
      2.401878553014586,
      2.401878553014586,
      2.401878553014586
    ],
    "controlPoints": [
      {
        "x": 176.5357237996056,
        "y": 687.1739264111937,
        "z": 0
      },
      {
        "x": 176.5384933985768,
        "y": 687.1720252754121,
        "z": 0
      },
      {
        "x": 176.5413011726917,
        "y": 687.1701846010945,
        "z": 0
      },
      {
        "x": 176.600840281694,
        "y": 687.1328501068027,
        "z": 0
      },
      {
        "x": 176.6718592102412,
        "y": 687.1192778916991,
        "z": 0
      },
      {
        "x": 176.7937995061496,
        "y": 687.1289035612716,
        "z": 0
      },
      {
        "x": 176.8460519989019,
        "y": 687.144123679951,
        "z": 0
      },
      {
        "x": 176.8885497533481,
        "y": 687.1736664539127,
        "z": 0
      }
    ]
  },
  {
    "type": "ELLIPSE",
    "handle": "41B9",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "center": {
      "x": 176.7121367799126,
      "y": 687.3151995344078,
      "z": 0
    },
    "majorAxisEndPoint": {
      "x": -0.1764129755113634,
      "y": 0,
      "z": 0
    },
    "axisRatio": 0.6259016496518008,
    "startAngle": 0,
    "endAngle": 6.283185307179584
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 172.3825138093671,
        "y": 687.9168908037207,
        "z": 0
      },
      {
        "x": 172.622302816249,
        "y": 687.7738559311183,
        "z": 0
      }
    ],
    "handle": "41BA",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 172.3825138105309,
        "y": 688.2295439839324,
        "z": 0
      },
      {
        "x": 172.892449198057,
        "y": 687.9253659704698,
        "z": 0
      }
    ],
    "handle": "41BB",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 181.4970554454478,
        "y": 687.7999382410243,
        "z": 0
      },
      {
        "x": 181.2365501293678,
        "y": 687.653835340403,
        "z": 0
      }
    ],
    "handle": "41BC",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 181.4970554450407,
        "y": 688.1077962294182,
        "z": 0
      },
      {
        "x": 180.9705470035547,
        "y": 687.8125070156492,
        "z": 0
      }
    ],
    "handle": "41BD",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 172.3825138105309,
        "y": 688.2295439839324,
        "z": 0
      },
      {
        "x": 172.3825138093671,
        "y": 687.9168908037207,
        "z": 0
      }
    ],
    "handle": "41BE",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 176.0844866799888,
        "y": 686.0213058982052,
        "z": 0
      },
      {
        "x": 176.9045669056349,
        "y": 685.5321255456629,
        "z": 0
      }
    ],
    "handle": "41BF",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 175.814340294688,
        "y": 685.8697958560614,
        "z": 0
      },
      {
        "x": 176.9004236437608,
        "y": 685.2219438301425,
        "z": 0
      }
    ],
    "handle": "41C0",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 176.9045669056349,
        "y": 685.5321255456629,
        "z": 0
      },
      {
        "x": 176.9004236437608,
        "y": 685.2219438301425,
        "z": 0
      }
    ],
    "handle": "41C1",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 176.9045669056349,
        "y": 685.5321255456629,
        "z": 0
      },
      {
        "x": 177.7287903926919,
        "y": 685.9943865286195,
        "z": 0
      }
    ],
    "handle": "41C2",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 176.9004236437608,
        "y": 685.2219438301425,
        "z": 0
      },
      {
        "x": 177.9947935165262,
        "y": 685.8357148561633,
        "z": 0
      }
    ],
    "handle": "41C3",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 181.4970554450407,
        "y": 688.1077962294182,
        "z": 0
      },
      {
        "x": 181.4970554454478,
        "y": 687.7999382410243,
        "z": 0
      }
    ],
    "handle": "41C4",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 181.2089814657807,
        "y": 688.2796332351826,
        "z": 0
      },
      {
        "x": 181.4970554450407,
        "y": 688.1077962294182,
        "z": 0
      }
    ],
    "handle": "41C5",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 172.3825138108808,
        "y": 688.2295439839324,
        "z": 0
      },
      {
        "x": 172.6664445282657,
        "y": 688.3887848900592,
        "z": 0
      }
    ],
    "handle": "41C6",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 181.4970554450407,
        "y": 688.7490558540437,
        "z": 0
      },
      {
        "x": 181.4970554454478,
        "y": 688.4411978647112,
        "z": 0
      }
    ],
    "handle": "41C7",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 176.9045669056349,
        "y": 686.1733851674918,
        "z": 0
      },
      {
        "x": 176.9004236437608,
        "y": 685.8632034538421,
        "z": 0
      }
    ],
    "handle": "41C8",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 176.9045669056349,
        "y": 686.1733851674918,
        "z": 0
      },
      {
        "x": 181.4970554450407,
        "y": 688.7490558540437,
        "z": 0
      }
    ],
    "handle": "41C9",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 176.9004236437608,
        "y": 685.8632034538421,
        "z": 0
      },
      {
        "x": 181.4970554454478,
        "y": 688.4411978647112,
        "z": 0
      }
    ],
    "handle": "41CA",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 172.3825138093671,
        "y": 688.5581504264837,
        "z": 0
      },
      {
        "x": 176.9004236437608,
        "y": 685.8632034538421,
        "z": 0
      }
    ],
    "handle": "41CB",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 173.9758234062469,
        "y": 685.4543902510702,
        "z": 0
      },
      {
        "x": 173.9758234062469,
        "y": 684.8386742742686,
        "z": 0
      }
    ],
    "handle": "41CC",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 171.315792173496,
        "y": 687.0411069774998,
        "z": 0
      },
      {
        "x": 171.315792173496,
        "y": 686.4158006170737,
        "z": 0
      }
    ],
    "handle": "41CD",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 171.315792173496,
        "y": 686.4158006170737,
        "z": 0
      },
      {
        "x": 173.9675368845339,
        "y": 684.8340268246817,
        "z": 0
      }
    ],
    "handle": "41CE",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 171.315792173496,
        "y": 687.0411069774998,
        "z": 0
      },
      {
        "x": 173.9758234062469,
        "y": 685.4543902510702,
        "z": 0
      }
    ],
    "handle": "41CF",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 171.315792173496,
        "y": 687.0411069774998,
        "z": 0
      },
      {
        "x": 173.1763799189927,
        "y": 688.0846068756626,
        "z": 0
      }
    ],
    "handle": "41D0",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 173.9758234062469,
        "y": 684.8386742742686,
        "z": 0
      },
      {
        "x": 176.3684173969079,
        "y": 686.1805467996662,
        "z": 0
      }
    ],
    "handle": "41D1",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 173.9758234062469,
        "y": 685.4543902510702,
        "z": 0
      },
      {
        "x": 175.8364111504631,
        "y": 686.4978901464538,
        "z": 0
      }
    ],
    "handle": "41D2",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 205.91279696225,
        "y": 621.2399534359438,
        "z": 0
      },
      {
        "x": 248.098317438446,
        "y": 644.0187494009733,
        "z": 0
      }
    ],
    "handle": "41D3",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 188.7550153565828,
        "y": 631.9551257426027,
        "z": 0
      },
      {
        "x": 229.9965636222038,
        "y": 654.2242077179206,
        "z": 0
      }
    ],
    "handle": "41D4",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 177.9810091832188,
        "y": 686.4692436149332,
        "z": 0
      },
      {
        "x": 228.9515664987271,
        "y": 656.0651509938699,
        "z": 0
      }
    ],
    "handle": "41D5",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 180.6824730286026,
        "y": 687.9843440186203,
        "z": 0
      },
      {
        "x": 231.6530303449829,
        "y": 657.5802513938315,
        "z": 0
      }
    ],
    "handle": "41D6",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 177.4407164135479,
        "y": 686.166223535315,
        "z": 0
      },
      {
        "x": 228.4112737289981,
        "y": 655.7621309105343,
        "z": 0
      }
    ],
    "handle": "41D7",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 205.5300664878439,
        "y": 621.9487566724238,
        "z": 0
      },
      {
        "x": 247.2927836743191,
        "y": 644.4992527430802,
        "z": 0
      }
    ],
    "handle": "41D8",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 189.4193912302138,
        "y": 631.5588235119429,
        "z": 0
      },
      {
        "x": 222.432470988598,
        "y": 649.384802652519,
        "z": 0
      }
    ],
    "handle": "41D9",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 174.9395767323439,
        "y": 641.1340364888339,
        "z": 0
      },
      {
        "x": 215.8769669272007,
        "y": 663.2388830818235,
        "z": 0
      }
    ],
    "handle": "41DA",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 173.3087159745048,
        "y": 641.1688903514223,
        "z": 0
      },
      {
        "x": 215.0714331642952,
        "y": 663.7193864239307,
        "z": 0
      }
    ],
    "handle": "41DB",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 158.0065688404719,
        "y": 651.2346272496499,
        "z": 0
      },
      {
        "x": 276.700611567474,
        "y": 580.4332693898941,
        "z": 0
      }
    ],
    "handle": "41DC",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 158.399439107626,
        "y": 688.5186606720018,
        "z": 0
      },
      {
        "x": 309.7136913236458,
        "y": 598.2592485304702,
        "z": 0
      }
    ],
    "handle": "41DD",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 158.0065688404719,
        "y": 669.9938181145125,
        "z": 0
      },
      {
        "x": 293.207151445909,
        "y": 589.3462589606415,
        "z": 0
      }
    ],
    "handle": "41DE",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 157.5939053440232,
        "y": 650.5428227391128,
        "z": 0
      },
      {
        "x": 275.8752845716648,
        "y": 579.9876199103707,
        "z": 0
      }
    ],
    "handle": "41DF",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 157.5939053440232,
        "y": 669.3020136039702,
        "z": 0
      },
      {
        "x": 292.3818244524879,
        "y": 588.9006094829928,
        "z": 0
      }
    ],
    "handle": "41E0",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 157.5939053440232,
        "y": 688.0612044706938,
        "z": 0
      },
      {
        "x": 308.8883643298759,
        "y": 597.8135990518892,
        "z": 0
      }
    ],
    "handle": "41E1",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 271.1741658980019,
        "y": 630.2539355363697,
        "z": 0
      },
      {
        "x": 271.1741658980019,
        "y": 583.2723548551803,
        "z": 0
      }
    ],
    "handle": "41E2",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 270.368632135447,
        "y": 630.7344388766222,
        "z": 0
      },
      {
        "x": 270.368632135447,
        "y": 583.2723548551803,
        "z": 0
      }
    ],
    "handle": "41E3",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 270.355497987242,
        "y": 582.7996860742458,
        "z": 0
      },
      {
        "x": 312.5410184592468,
        "y": 605.5784820383232,
        "z": 0
      }
    ],
    "handle": "41E4",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 269.9727675118467,
        "y": 583.5084893079294,
        "z": 0
      },
      {
        "x": 311.7354846970408,
        "y": 606.0589853804303,
        "z": 0
      }
    ],
    "handle": "41E5",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 254.2448227315909,
        "y": 592.4097529137325,
        "z": 0
      },
      {
        "x": 296.4303432058088,
        "y": 615.1885488787519,
        "z": 0
      }
    ],
    "handle": "41E6",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 238.1341474752409,
        "y": 602.019819754162,
        "z": 0
      },
      {
        "x": 279.7984990334358,
        "y": 624.5172016182731,
        "z": 0
      }
    ],
    "handle": "41E7",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 253.8620922570132,
        "y": 593.1185561502197,
        "z": 0
      },
      {
        "x": 295.6248094429026,
        "y": 615.6690522199324,
        "z": 0
      }
    ],
    "handle": "41E8",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 237.7514169998467,
        "y": 602.7286229915699,
        "z": 0
      },
      {
        "x": 278.992965271347,
        "y": 624.9977049594588,
        "z": 0
      }
    ],
    "handle": "41E9",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 255.0634906420009,
        "y": 639.8640023749313,
        "z": 0
      },
      {
        "x": 255.0634906420009,
        "y": 592.882421694685,
        "z": 0
      }
    ],
    "handle": "41EA",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 254.2579568809019,
        "y": 640.3445057217003,
        "z": 0
      },
      {
        "x": 254.2579568790959,
        "y": 592.882421694685,
        "z": 0
      }
    ],
    "handle": "41EB",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 238.9528153889701,
        "y": 649.4740692162848,
        "z": 0
      },
      {
        "x": 238.9528153870478,
        "y": 602.4924885378932,
        "z": 0
      }
    ],
    "handle": "41EC",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 238.1472816248431,
        "y": 649.9545725574725,
        "z": 0
      },
      {
        "x": 238.147281624201,
        "y": 602.4924885378932,
        "z": 0
      }
    ],
    "handle": "41ED",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 282.232020399358,
        "y": 623.6578916599836,
        "z": 0
      },
      {
        "x": 316.0059527074912,
        "y": 603.5116382092017,
        "z": 0
      }
    ],
    "handle": "41EE",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 282.7723131689709,
        "y": 623.9609117433208,
        "z": 0
      },
      {
        "x": 316.0059527086569,
        "y": 604.1369445733515,
        "z": 0
      }
    ],
    "handle": "41EF",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 303.7913810316229,
        "y": 610.7976674055535,
        "z": 0
      },
      {
        "x": 303.7913810316229,
        "y": 595.0613954216022,
        "z": 0
      }
    ],
    "handle": "41F0",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 302.9858472691851,
        "y": 611.2781707467328,
        "z": 0
      },
      {
        "x": 302.9858472687199,
        "y": 594.6264336388447,
        "z": 0
      }
    ],
    "handle": "41F1",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 287.2848411550508,
        "y": 620.6438686959187,
        "z": 0
      },
      {
        "x": 287.2848411550508,
        "y": 586.1484058527094,
        "z": 0
      }
    ],
    "handle": "41F2",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 286.4793073920301,
        "y": 621.1243720380442,
        "z": 0
      },
      {
        "x": 286.4793073926118,
        "y": 585.7134440699409,
        "z": 0
      }
    ],
    "handle": "41F3",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 215.1704645393179,
        "y": 707.1848694914923,
        "z": 0
      },
      {
        "x": 269.5774946803577,
        "y": 675.9017659546834,
        "z": 0
      }
    ],
    "handle": "41F4",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 215.9885452877492,
        "y": 707.6436853585692,
        "z": 0
      },
      {
        "x": 270.4108937132409,
        "y": 676.3517740676141,
        "z": 0
      }
    ],
    "handle": "41F5",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 199.5513761042379,
        "y": 699.1825753562108,
        "z": 0
      },
      {
        "x": 314.6693941979318,
        "y": 630.5143270716032,
        "z": 0
      }
    ],
    "handle": "41F6",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 200.3618152553687,
        "y": 699.6371054742459,
        "z": 0
      },
      {
        "x": 314.6693941979318,
        "y": 631.45228661504,
        "z": 0
      }
    ],
    "handle": "41F7",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 184.5256880503731,
        "y": 690.7555049518124,
        "z": 0
      },
      {
        "x": 316.0059527086569,
        "y": 612.3271267814416,
        "z": 0
      }
    ],
    "handle": "41F8",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 185.336127203655,
        "y": 691.2100350745012,
        "z": 0
      },
      {
        "x": 316.0059527074912,
        "y": 613.2650863258024,
        "z": 0
      }
    ],
    "handle": "41F9",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 219.1782749020501,
        "y": 665.0214809943028,
        "z": 0
      },
      {
        "x": 316.0059527086569,
        "y": 717.3052478302196,
        "z": 0
      }
    ],
    "handle": "41FA",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 218.3727411392017,
        "y": 665.5019843364132,
        "z": 0
      },
      {
        "x": 316.0059527086569,
        "y": 718.2207129560402,
        "z": 0
      }
    ],
    "handle": "41FB",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 203.067599647911,
        "y": 674.6315478356518,
        "z": 0
      },
      {
        "x": 309.5690633128397,
        "y": 732.1388414027095,
        "z": 0
      }
    ],
    "handle": "41FC",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 202.26206588582,
        "y": 675.1120511759007,
        "z": 0
      },
      {
        "x": 308.7479814717652,
        "y": 732.6109492937112,
        "z": 0
      }
    ],
    "handle": "41FD",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 186.5610597633048,
        "y": 684.4777491306849,
        "z": 0
      },
      {
        "x": 292.7439210513838,
        "y": 741.8130078855817,
        "z": 0
      }
    ],
    "handle": "41FE",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 185.7555260016231,
        "y": 684.9582524737315,
        "z": 0
      },
      {
        "x": 291.9228392108339,
        "y": 742.2851157756512,
        "z": 0
      }
    ],
    "handle": "41FF",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 158.399439107626,
        "y": 689.4116313801994,
        "z": 0
      },
      {
        "x": 158.3994391068108,
        "y": 650.5428227391128,
        "z": 0
      }
    ],
    "handle": "4200",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 157.5939053440232,
        "y": 688.9766695983715,
        "z": 0
      },
      {
        "x": 157.5939053440232,
        "y": 650.5428227391128,
        "z": 0
      }
    ],
    "handle": "4201",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 157.5939053443719,
        "y": 688.0612044706938,
        "z": 0
      },
      {
        "x": 168.1468646692807,
        "y": 693.7594560170515,
        "z": 0
      }
    ],
    "handle": "4202",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 205.9259311121422,
        "y": 702.7577077327367,
        "z": 0
      },
      {
        "x": 205.9259311121422,
        "y": 672.9265444148357,
        "z": 0
      }
    ],
    "handle": "4203",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 206.731464875804,
        "y": 703.2094866912848,
        "z": 0
      },
      {
        "x": 206.731464874581,
        "y": 672.4460410708516,
        "z": 0
      }
    ],
    "handle": "4204",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 190.6207896166008,
        "y": 694.1739074811337,
        "z": 0
      },
      {
        "x": 190.6207896174159,
        "y": 682.056107914068,
        "z": 0
      }
    ],
    "handle": "4205",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 189.8152558560249,
        "y": 693.7221285216401,
        "z": 0
      },
      {
        "x": 189.8152558560249,
        "y": 682.5366112561823,
        "z": 0
      }
    ],
    "handle": "4206",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 173.8373459452998,
        "y": 688.7573528150102,
        "z": 0
      },
      {
        "x": 173.9848859723431,
        "y": 688.9404516434176,
        "z": 0
      }
    ],
    "handle": "4207",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 173.2573616373699,
        "y": 688.7573528150102,
        "z": 0
      },
      {
        "x": 173.10982160928,
        "y": 688.9404516434176,
        "z": 0
      }
    ],
    "handle": "4208",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 173.10982160928,
        "y": 688.9404516434176,
        "z": 0
      },
      {
        "x": 173.10982160928,
        "y": 688.7479379232936,
        "z": 0
      }
    ],
    "handle": "4209",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 173.9848859723431,
        "y": 688.9404516434176,
        "z": 0
      },
      {
        "x": 173.984885970654,
        "y": 688.747937932614,
        "z": 0
      }
    ],
    "handle": "420A",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 180.5017513111237,
        "y": 688.9326359182531,
        "z": 0
      },
      {
        "x": 180.5017513096099,
        "y": 688.7401222074437,
        "z": 0
      }
    ],
    "handle": "420B",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 179.6266869485839,
        "y": 688.9326359182531,
        "z": 0
      },
      {
        "x": 179.6266869485839,
        "y": 688.7401221971922,
        "z": 0
      }
    ],
    "handle": "420C",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 179.7742269755099,
        "y": 688.7495370889008,
        "z": 0
      },
      {
        "x": 179.6266869485839,
        "y": 688.9326359182531,
        "z": 0
      }
    ],
    "handle": "420D",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 180.3542112843138,
        "y": 688.7495370889008,
        "z": 0
      },
      {
        "x": 180.5017513111237,
        "y": 688.9326359182531,
        "z": 0
      }
    ],
    "handle": "420E",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 176.975002349121,
        "y": 691.4464742913841,
        "z": 0
      },
      {
        "x": 181.4970554450407,
        "y": 688.7490558540437,
        "z": 0
      }
    ],
    "handle": "420F",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 255.0634906453782,
        "y": 730.3162243235954,
        "z": 0
      },
      {
        "x": 255.0634906433983,
        "y": 643.6158405514434,
        "z": 0
      }
    ],
    "handle": "4210",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 254.2579568813089,
        "y": 729.8644453631712,
        "z": 0
      },
      {
        "x": 254.2579568806689,
        "y": 644.0963438898422,
        "z": 0
      }
    ],
    "handle": "4211",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 238.9528153908318,
        "y": 721.2806451162323,
        "z": 0
      },
      {
        "x": 238.952815388154,
        "y": 653.2259073900022,
        "z": 0
      }
    ],
    "handle": "4212",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 238.1472816276358,
        "y": 720.8288661539508,
        "z": 0
      },
      {
        "x": 238.1472816248431,
        "y": 653.7064107321204,
        "z": 0
      }
    ],
    "handle": "4213",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 222.8421401298832,
        "y": 712.2450659032847,
        "z": 0
      },
      {
        "x": 222.8421401298832,
        "y": 662.8359742313622,
        "z": 0
      }
    ],
    "handle": "4214",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 222.0366063668629,
        "y": 711.7932869400817,
        "z": 0
      },
      {
        "x": 222.0366063668629,
        "y": 663.3164775725417,
        "z": 0
      }
    ],
    "handle": "4215",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 234.6800143344438,
        "y": 657.0582723682709,
        "z": 0
      },
      {
        "x": 316.0059527074912,
        "y": 700.9716088864917,
        "z": 0
      }
    ],
    "handle": "4216",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 235.4855480984537,
        "y": 656.5777690261649,
        "z": 0
      },
      {
        "x": 316.0059527092376,
        "y": 700.0561437643989,
        "z": 0
      }
    ],
    "handle": "4217",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 231.8467665460188,
        "y": 717.2952586431016,
        "z": 0
      },
      {
        "x": 287.2455305738838,
        "y": 685.4419252360202,
        "z": 0
      }
    ],
    "handle": "4218",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 231.0286858011969,
        "y": 716.8364427816124,
        "z": 0
      },
      {
        "x": 286.4121315405942,
        "y": 684.9919171221479,
        "z": 0
      }
    ],
    "handle": "4219",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 270.9259375232508,
        "y": 739.2125860806515,
        "z": 0
      },
      {
        "x": 270.9259375220879,
        "y": 676.6298808138818,
        "z": 0
      }
    ],
    "handle": "421A",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 271.7314712868538,
        "y": 739.6643650429323,
        "z": 0
      },
      {
        "x": 271.7314712848737,
        "y": 677.0648425975838,
        "z": 0
      }
    ],
    "handle": "421B",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 288.394614570891,
        "y": 744.3137840628622,
        "z": 0
      },
      {
        "x": 288.394614568621,
        "y": 686.0623928653039,
        "z": 0
      }
    ],
    "handle": "421C",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 287.5890808065899,
        "y": 744.7769520776338,
        "z": 0
      },
      {
        "x": 287.5890808057739,
        "y": 685.6274310806682,
        "z": 0
      }
    ],
    "handle": "421D",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "ELLIPSE",
    "handle": "421E",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "center": {
      "x": 173.5473459526549,
      "y": 688.9800755903124,
      "z": 0
    },
    "majorAxisEndPoint": {
      "x": 0.1764129755138129,
      "y": 2.17674e-11,
      "z": 0
    },
    "axisRatio": 0.6259016496423861,
    "startAngle": 3.252782333826853,
    "endAngle": 6.168573069506875
  },
  {
    "type": "ELLIPSE",
    "handle": "421F",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "center": {
      "x": 180.064211292192,
      "y": 688.9722598642127,
      "z": 0
    },
    "majorAxisEndPoint": {
      "x": 0.1764129755138129,
      "y": 2.17674e-11,
      "z": 0
    },
    "axisRatio": 0.6259016496423861,
    "startAngle": 3.252782333826853,
    "endAngle": 6.168573069506875
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 172.3825138108808,
        "y": 688.8708036094832,
        "z": 0
      },
      {
        "x": 176.975002349121,
        "y": 691.4464742913841,
        "z": 0
      }
    ],
    "handle": "4220",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 151.3014530752549,
        "y": 808.1786844396813,
        "z": 0
      },
      {
        "x": 580.7375409955855,
        "y": 808.1786844396813,
        "z": 0
      }
    ],
    "handle": "4221",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineTypeScale": 25,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 580.7375409955855,
        "y": 808.1786844396813,
        "z": 0
      },
      {
        "x": 580.7375409955855,
        "y": 1089.941241536444,
        "z": 0
      }
    ],
    "handle": "4222",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineTypeScale": 25,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 580.7375409955855,
        "y": 1089.941241536444,
        "z": 0
      },
      {
        "x": 151.3014530752549,
        "y": 1089.941241536444,
        "z": 0
      }
    ],
    "handle": "4223",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineTypeScale": 25,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 151.3014530752549,
        "y": 1089.941241536444,
        "z": 0
      },
      {
        "x": 151.3014530752549,
        "y": 808.1786844396813,
        "z": 0
      }
    ],
    "handle": "4224",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineTypeScale": 25,
    "lineweight": 18
  },
  {
    "type": "TEXT",
    "handle": "4225",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "startPoint": {
      "x": 151.1563714985377,
      "y": 779.7249592263104,
      "z": 0
    },
    "textHeight": 7.5,
    "text": "BAGLANTI DETAYI"
  },
  {
    "type": "TEXT",
    "handle": "4226",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "startPoint": {
      "x": 470.6836724341851,
      "y": 437.1910409955343,
      "z": 0
    },
    "textHeight": 5.392676571428575,
    "text": "GALVANİZ LAMA 30x3.5",
    "rotation": 0.0100000010572011
  },
  {
    "type": "TEXT",
    "handle": "4227",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "startPoint": {
      "x": 467.2214791298598,
      "y": 372.478515378195,
      "z": 0
    },
    "textHeight": 5.392676571428575,
    "text": "GALVANİZ LAMA 30x3.5",
    "rotation": 0.0100000010572011
  },
  {
    "type": "LWPOLYLINE",
    "vertices": [
      {
        "x": -5.68e-14,
        "y": 1162.918591290707
      },
      {
        "x": 736.2690623310042,
        "y": 1162.918591290707
      },
      {
        "x": 736.2690623310042,
        "y": 0
      },
      {
        "x": -5.68e-14,
        "y": 0
      }
    ],
    "handle": "4228",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "shape": true,
    "hasContinuousLinetypePattern": false
  },
  {
    "type": "SPLINE",
    "handle": "423D",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "normalVector": {
      "x": 0,
      "y": 0,
      "z": 1
    },
    "planar": true,
    "degreeOfSplineCurve": 3,
    "numberOfKnots": 10,
    "numberOfControlPoints": 6,
    "numberOfFitPoints": 4,
    "knotValues": [
      0,
      0,
      0,
      0,
      97.25194048395154,
      205.4173741992928,
      334.5337583385074,
      334.5337583385074,
      334.5337583385074,
      334.5337583385074
    ],
    "controlPoints": [
      {
        "x": 184.971886286278,
        "y": 509.2870756201408,
        "z": 0
      },
      {
        "x": 188.9405594330416,
        "y": 474.2592120029634,
        "z": 0
      },
      {
        "x": 197.3232653493102,
        "y": 400.2727009652851,
        "z": 0
      },
      {
        "x": 349.0678767345346,
        "y": 373.3295338989803,
        "z": 0
      },
      {
        "x": 373.2494986989799,
        "y": 461.3992750785842,
        "z": 0
      },
      {
        "x": 386.4078755982348,
        "y": 509.3222328340623,
        "z": 0
      }
    ],
    "fitPoints": [
      {
        "x": 184.971886286278,
        "y": 509.2870756201408,
        "z": 0
      },
      {
        "x": 215.8839084541505,
        "y": 417.078687642761,
        "z": 0
      },
      {
        "x": 322.2236164865608,
        "y": 397.289105878368,
        "z": 0
      },
      {
        "x": 386.4078755982348,
        "y": 509.3222328340623,
        "z": 0
      }
    ]
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 203.2,
        "y": 508,
        "z": 0
      },
      {
        "x": 209.55,
        "y": 508,
        "z": 0
      }
    ],
    "handle": "42A0",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 228.6,
        "y": 508,
        "z": 0
      },
      {
        "x": 234.95,
        "y": 508,
        "z": 0
      }
    ],
    "handle": "42A1",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 330.2,
        "y": 508,
        "z": 0
      },
      {
        "x": 336.55,
        "y": 508,
        "z": 0
      }
    ],
    "handle": "42A2",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 355.6,
        "y": 508,
        "z": 0
      },
      {
        "x": 361.95,
        "y": 508,
        "z": 0
      }
    ],
    "handle": "42A3",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 381,
        "y": 508,
        "z": 0
      },
      {
        "x": 386.0447994263605,
        "y": 508,
        "z": 0
      }
    ],
    "handle": "42A4",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 190.5,
        "y": 495.2999999999998,
        "z": 0
      },
      {
        "x": 196.8499999999999,
        "y": 495.2999999999998,
        "z": 0
      }
    ],
    "handle": "42A5",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 215.9,
        "y": 495.2999999999998,
        "z": 0
      },
      {
        "x": 222.25,
        "y": 495.2999999999998,
        "z": 0
      }
    ],
    "handle": "42A6",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 241.3,
        "y": 495.2999999999998,
        "z": 0
      },
      {
        "x": 241.5591197595573,
        "y": 495.2999999999998,
        "z": 0
      }
    ],
    "handle": "42A7",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 342.9,
        "y": 495.2999999999998,
        "z": 0
      },
      {
        "x": 349.25,
        "y": 495.2999999999998,
        "z": 0
      }
    ],
    "handle": "42A8",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 368.3,
        "y": 495.2999999999998,
        "z": 0
      },
      {
        "x": 374.6500000000001,
        "y": 495.2999999999998,
        "z": 0
      }
    ],
    "handle": "42A9",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 203.2,
        "y": 482.5999999999998,
        "z": 0
      },
      {
        "x": 209.55,
        "y": 482.5999999999998,
        "z": 0
      }
    ],
    "handle": "42AA",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 228.6,
        "y": 482.5999999999998,
        "z": 0
      },
      {
        "x": 234.95,
        "y": 482.5999999999998,
        "z": 0
      }
    ],
    "handle": "42AB",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 330.2,
        "y": 482.5999999999998,
        "z": 0
      },
      {
        "x": 336.55,
        "y": 482.5999999999998,
        "z": 0
      }
    ],
    "handle": "42AC",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 355.6,
        "y": 482.5999999999998,
        "z": 0
      },
      {
        "x": 361.95,
        "y": 482.5999999999998,
        "z": 0
      }
    ],
    "handle": "42AD",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 190.5718834996692,
        "y": 469.8999999999998,
        "z": 0
      },
      {
        "x": 196.8499999999999,
        "y": 469.8999999999998,
        "z": 0
      }
    ],
    "handle": "42AE",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 215.9,
        "y": 469.8999999999998,
        "z": 0
      },
      {
        "x": 222.25,
        "y": 469.8999999999998,
        "z": 0
      }
    ],
    "handle": "42AF",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 241.3,
        "y": 469.8999999999998,
        "z": 0
      },
      {
        "x": 241.5635528959153,
        "y": 469.8999999999998,
        "z": 0
      }
    ],
    "handle": "42B0",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 342.9,
        "y": 469.8999999999998,
        "z": 0
      },
      {
        "x": 349.25,
        "y": 469.8999999999998,
        "z": 0
      }
    ],
    "handle": "42B1",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 368.3,
        "y": 469.8999999999998,
        "z": 0
      },
      {
        "x": 374.6500000000001,
        "y": 469.8999999999998,
        "z": 0
      }
    ],
    "handle": "42B2",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 203.2,
        "y": 457.2,
        "z": 0
      },
      {
        "x": 209.55,
        "y": 457.2,
        "z": 0
      }
    ],
    "handle": "42B3",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 228.6,
        "y": 457.2,
        "z": 0
      },
      {
        "x": 231.1913958595702,
        "y": 457.2,
        "z": 0
      }
    ],
    "handle": "42B4",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 330.2,
        "y": 457.2,
        "z": 0
      },
      {
        "x": 336.55,
        "y": 457.2,
        "z": 0
      }
    ],
    "handle": "42B5",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 355.6,
        "y": 457.2,
        "z": 0
      },
      {
        "x": 361.95,
        "y": 457.2,
        "z": 0
      }
    ],
    "handle": "42B6",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 231.1913958595702,
        "y": 457.2,
        "z": 0
      },
      {
        "x": 234.95,
        "y": 457.2,
        "z": 0
      }
    ],
    "handle": "42B7",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 215.9,
        "y": 444.5,
        "z": 0
      },
      {
        "x": 221.1340503425276,
        "y": 444.5,
        "z": 0
      }
    ],
    "handle": "42B8",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 342.9,
        "y": 444.5,
        "z": 0
      },
      {
        "x": 349.25,
        "y": 444.5,
        "z": 0
      }
    ],
    "handle": "42B9",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 221.1340503425276,
        "y": 444.5,
        "z": 0
      },
      {
        "x": 222.25,
        "y": 444.5,
        "z": 0
      }
    ],
    "handle": "42BA",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 241.3,
        "y": 444.5,
        "z": 0
      },
      {
        "x": 241.5679860322501,
        "y": 444.5,
        "z": 0
      }
    ],
    "handle": "42BB",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 294.9716781756319,
        "y": 444.5,
        "z": 0
      },
      {
        "x": 298.45,
        "y": 444.5,
        "z": 0
      }
    ],
    "handle": "42BC",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 204.2351883352832,
        "y": 431.7999999999998,
        "z": 0
      },
      {
        "x": 209.5499999999999,
        "y": 431.7999999999998,
        "z": 0
      }
    ],
    "handle": "42BD",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 228.6,
        "y": 431.7999999999998,
        "z": 0
      },
      {
        "x": 234.9499999999999,
        "y": 431.7999999999998,
        "z": 0
      }
    ],
    "handle": "42BE",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 254,
        "y": 431.7999999999998,
        "z": 0
      },
      {
        "x": 259.3952802336141,
        "y": 431.7999999999998,
        "z": 0
      }
    ],
    "handle": "42BF",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 334.8109411878346,
        "y": 431.7999999999998,
        "z": 0
      },
      {
        "x": 336.5499999999999,
        "y": 431.7999999999998,
        "z": 0
      }
    ],
    "handle": "42C0",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 355.6,
        "y": 431.7999999999998,
        "z": 0
      },
      {
        "x": 358.5013532744349,
        "y": 431.7999999999998,
        "z": 0
      }
    ],
    "handle": "42C1",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 259.3952802336141,
        "y": 431.7999999999998,
        "z": 0
      },
      {
        "x": 260.35,
        "y": 431.7999999999998,
        "z": 0
      }
    ],
    "handle": "42C2",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 304.8,
        "y": 431.7999999999998,
        "z": 0
      },
      {
        "x": 311.15,
        "y": 431.7999999999998,
        "z": 0
      }
    ],
    "handle": "42C3",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 330.2,
        "y": 431.7999999999998,
        "z": 0
      },
      {
        "x": 334.8109411878346,
        "y": 431.7999999999998,
        "z": 0
      }
    ],
    "handle": "42C4",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 279.4,
        "y": 431.7999999999998,
        "z": 0
      },
      {
        "x": 285.75,
        "y": 431.7999999999998,
        "z": 0
      }
    ],
    "handle": "42C5",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 215.9,
        "y": 419.0999999999998,
        "z": 0
      },
      {
        "x": 222.25,
        "y": 419.0999999999998,
        "z": 0
      }
    ],
    "handle": "42C6",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 241.3,
        "y": 419.0999999999998,
        "z": 0
      },
      {
        "x": 247.65,
        "y": 419.0999999999998,
        "z": 0
      }
    ],
    "handle": "42C7",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 292.1,
        "y": 419.0999999999998,
        "z": 0
      },
      {
        "x": 298.45,
        "y": 419.0999999999998,
        "z": 0
      }
    ],
    "handle": "42C8",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 317.5,
        "y": 419.0999999999998,
        "z": 0
      },
      {
        "x": 323.85,
        "y": 419.0999999999998,
        "z": 0
      }
    ],
    "handle": "42C9",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 342.9,
        "y": 419.0999999999998,
        "z": 0
      },
      {
        "x": 349.2500000000002,
        "y": 419.0999999999998,
        "z": 0
      }
    ],
    "handle": "42CA",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 266.7,
        "y": 419.0999999999998,
        "z": 0
      },
      {
        "x": 273.05,
        "y": 419.0999999999998,
        "z": 0
      }
    ],
    "handle": "42CB",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 229.9555098503387,
        "y": 406.4,
        "z": 0
      },
      {
        "x": 234.95,
        "y": 406.4,
        "z": 0
      }
    ],
    "handle": "42CC",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 254,
        "y": 406.4,
        "z": 0
      },
      {
        "x": 259.3997266699677,
        "y": 406.4,
        "z": 0
      }
    ],
    "handle": "42CD",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 304.8,
        "y": 406.4,
        "z": 0
      },
      {
        "x": 311.15,
        "y": 406.4,
        "z": 0
      }
    ],
    "handle": "42CE",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 330.2,
        "y": 406.4,
        "z": 0
      },
      {
        "x": 336.55,
        "y": 406.4,
        "z": 0
      }
    ],
    "handle": "42CF",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 259.3997266699677,
        "y": 406.4,
        "z": 0
      },
      {
        "x": 260.35,
        "y": 406.4,
        "z": 0
      }
    ],
    "handle": "42D0",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 279.4,
        "y": 406.4,
        "z": 0
      },
      {
        "x": 285.7500000000001,
        "y": 406.4,
        "z": 0
      }
    ],
    "handle": "42D1",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 266.7,
        "y": 393.7,
        "z": 0
      },
      {
        "x": 273.05,
        "y": 393.7,
        "z": 0
      }
    ],
    "handle": "42D2",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 292.1,
        "y": 393.7,
        "z": 0
      },
      {
        "x": 298.45,
        "y": 393.7,
        "z": 0
      }
    ],
    "handle": "42D3",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 193.675,
        "y": 466.725,
        "z": 0
      },
      {
        "x": 193.675,
        "y": 473.0749999999998,
        "z": 0
      }
    ],
    "handle": "42D4",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 193.675,
        "y": 492.1249999999998,
        "z": 0
      },
      {
        "x": 193.675,
        "y": 498.475,
        "z": 0
      }
    ],
    "handle": "42D5",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 206.375,
        "y": 428.6249999999998,
        "z": 0
      },
      {
        "x": 206.375,
        "y": 434.9749999999998,
        "z": 0
      }
    ],
    "handle": "42D6",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 206.375,
        "y": 454.0249999999999,
        "z": 0
      },
      {
        "x": 206.375,
        "y": 460.3749999999999,
        "z": 0
      }
    ],
    "handle": "42D7",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 206.375,
        "y": 479.4249999999999,
        "z": 0
      },
      {
        "x": 206.375,
        "y": 485.7750000000002,
        "z": 0
      }
    ],
    "handle": "42D8",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 206.375,
        "y": 504.8250000000002,
        "z": 0
      },
      {
        "x": 206.375,
        "y": 509.2908111683422,
        "z": 0
      }
    ],
    "handle": "42D9",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 219.075,
        "y": 415.9249999999998,
        "z": 0
      },
      {
        "x": 219.075,
        "y": 422.2749999999998,
        "z": 0
      }
    ],
    "handle": "42DA",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 219.075,
        "y": 441.8999163789504,
        "z": 0
      },
      {
        "x": 219.075,
        "y": 447.675,
        "z": 0
      }
    ],
    "handle": "42DB",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 219.075,
        "y": 466.725,
        "z": 0
      },
      {
        "x": 219.075,
        "y": 473.0749999999999,
        "z": 0
      }
    ],
    "handle": "42DC",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 219.075,
        "y": 492.1249999999999,
        "z": 0
      },
      {
        "x": 219.075,
        "y": 498.475,
        "z": 0
      }
    ],
    "handle": "42DD",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 219.075,
        "y": 441.3249999999998,
        "z": 0
      },
      {
        "x": 219.075,
        "y": 441.8999163789504,
        "z": 0
      }
    ],
    "handle": "42DE",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 231.775,
        "y": 405.3329319097087,
        "z": 0
      },
      {
        "x": 231.775,
        "y": 409.5749999999999,
        "z": 0
      }
    ],
    "handle": "42DF",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 231.775,
        "y": 457.9369511737365,
        "z": 0
      },
      {
        "x": 231.775,
        "y": 460.3749999999998,
        "z": 0
      }
    ],
    "handle": "42E0",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 231.775,
        "y": 479.4249999999998,
        "z": 0
      },
      {
        "x": 231.775,
        "y": 485.775,
        "z": 0
      }
    ],
    "handle": "42E1",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 231.775,
        "y": 504.825,
        "z": 0
      },
      {
        "x": 231.775,
        "y": 509.2952443048276,
        "z": 0
      }
    ],
    "handle": "42E2",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 231.775,
        "y": 428.6249999999998,
        "z": 0
      },
      {
        "x": 231.775,
        "y": 434.975,
        "z": 0
      }
    ],
    "handle": "42E3",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 231.775,
        "y": 454.0249999999999,
        "z": 0
      },
      {
        "x": 231.775,
        "y": 457.9369511737366,
        "z": 0
      }
    ],
    "handle": "42E4",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 244.475,
        "y": 415.9249999999998,
        "z": 0
      },
      {
        "x": 244.475,
        "y": 422.2749999999998,
        "z": 0
      }
    ],
    "handle": "42E5",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 257.175,
        "y": 403.2249999999998,
        "z": 0
      },
      {
        "x": 257.175,
        "y": 409.5749999999998,
        "z": 0
      }
    ],
    "handle": "42E6",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 257.175,
        "y": 458.743333791086,
        "z": 0
      },
      {
        "x": 257.175,
        "y": 460.1476766477123,
        "z": 0
      }
    ],
    "handle": "42E7",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 257.175,
        "y": 428.6249999999998,
        "z": 0
      },
      {
        "x": 257.175,
        "y": 434.8695048561756,
        "z": 0
      }
    ],
    "handle": "42E8",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 269.875,
        "y": 392.3267261408188,
        "z": 0
      },
      {
        "x": 269.875,
        "y": 396.875,
        "z": 0
      }
    ],
    "handle": "42E9",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 269.875,
        "y": 415.9249999999998,
        "z": 0
      },
      {
        "x": 269.875,
        "y": 422.2749999999998,
        "z": 0
      }
    ],
    "handle": "42EA",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 282.575,
        "y": 403.2249999999998,
        "z": 0
      },
      {
        "x": 282.575,
        "y": 409.5749999999998,
        "z": 0
      }
    ],
    "handle": "42EB",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 282.575,
        "y": 428.6249999999998,
        "z": 0
      },
      {
        "x": 282.575,
        "y": 434.975,
        "z": 0
      }
    ],
    "handle": "42EC",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 295.275,
        "y": 391.1564936280603,
        "z": 0
      },
      {
        "x": 295.275,
        "y": 396.875,
        "z": 0
      }
    ],
    "handle": "42ED",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 295.275,
        "y": 415.925,
        "z": 0
      },
      {
        "x": 295.275,
        "y": 422.2749999999999,
        "z": 0
      }
    ],
    "handle": "42EE",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 295.275,
        "y": 443.3022118548055,
        "z": 0
      },
      {
        "x": 295.275,
        "y": 444.6156091072411,
        "z": 0
      }
    ],
    "handle": "42EF",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 307.975,
        "y": 403.2249999999998,
        "z": 0
      },
      {
        "x": 307.975,
        "y": 409.5749999999998,
        "z": 0
      }
    ],
    "handle": "42F0",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 307.975,
        "y": 428.6249999999998,
        "z": 0
      },
      {
        "x": 307.975,
        "y": 434.8783711291829,
        "z": 0
      }
    ],
    "handle": "42F1",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 320.675,
        "y": 396.6501945579461,
        "z": 0
      },
      {
        "x": 320.675,
        "y": 396.875,
        "z": 0
      }
    ],
    "handle": "42F2",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 320.675,
        "y": 415.9249999999998,
        "z": 0
      },
      {
        "x": 320.675,
        "y": 422.2749999999998,
        "z": 0
      }
    ],
    "handle": "42F3",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 333.375,
        "y": 403.4090364712254,
        "z": 0
      },
      {
        "x": 333.375,
        "y": 409.5749999999998,
        "z": 0
      }
    ],
    "handle": "42F4",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 333.375,
        "y": 428.6249999999998,
        "z": 0
      },
      {
        "x": 333.375,
        "y": 432.7231426857506,
        "z": 0
      }
    ],
    "handle": "42F5",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 333.375,
        "y": 432.7231426857506,
        "z": 0
      },
      {
        "x": 333.375,
        "y": 434.9750000000001,
        "z": 0
      }
    ],
    "handle": "42F6",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 333.375,
        "y": 454.0250000000001,
        "z": 0
      },
      {
        "x": 333.375,
        "y": 460.3750000000001,
        "z": 0
      }
    ],
    "handle": "42F7",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 333.375,
        "y": 479.4250000000001,
        "z": 0
      },
      {
        "x": 333.375,
        "y": 485.7750000000002,
        "z": 0
      }
    ],
    "handle": "42F8",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 333.375,
        "y": 504.8250000000002,
        "z": 0
      },
      {
        "x": 333.375,
        "y": 509.3129768506191,
        "z": 0
      }
    ],
    "handle": "42F9",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 346.075,
        "y": 415.9249999999998,
        "z": 0
      },
      {
        "x": 346.075,
        "y": 422.2749999999998,
        "z": 0
      }
    ],
    "handle": "42FA",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 346.075,
        "y": 441.3249999999998,
        "z": 0
      },
      {
        "x": 346.075,
        "y": 447.675,
        "z": 0
      }
    ],
    "handle": "42FB",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 346.075,
        "y": 466.725,
        "z": 0
      },
      {
        "x": 346.075,
        "y": 473.0749999999999,
        "z": 0
      }
    ],
    "handle": "42FC",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 346.075,
        "y": 492.1249999999999,
        "z": 0
      },
      {
        "x": 346.075,
        "y": 498.475,
        "z": 0
      }
    ],
    "handle": "42FD",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 358.775,
        "y": 432.2738019801859,
        "z": 0
      },
      {
        "x": 358.775,
        "y": 434.9750000000001,
        "z": 0
      }
    ],
    "handle": "42FE",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 358.775,
        "y": 454.0250000000001,
        "z": 0
      },
      {
        "x": 358.775,
        "y": 460.3750000000001,
        "z": 0
      }
    ],
    "handle": "42FF",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 358.775,
        "y": 479.4250000000001,
        "z": 0
      },
      {
        "x": 358.775,
        "y": 485.7750000000002,
        "z": 0
      }
    ],
    "handle": "4300",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 358.775,
        "y": 504.8250000000002,
        "z": 0
      },
      {
        "x": 358.775,
        "y": 509.3174099871745,
        "z": 0
      }
    ],
    "handle": "4301",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 371.4749999999999,
        "y": 466.725,
        "z": 0
      },
      {
        "x": 371.4749999999999,
        "y": 473.0749999999998,
        "z": 0
      }
    ],
    "handle": "4302",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 371.4749999999999,
        "y": 492.1249999999998,
        "z": 0
      },
      {
        "x": 371.4749999999999,
        "y": 498.475,
        "z": 0
      }
    ],
    "handle": "4303",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 384.1750000000001,
        "y": 504.8249999999998,
        "z": 0
      },
      {
        "x": 384.1750000000001,
        "y": 509.32184312373,
        "z": 0
      }
    ],
    "handle": "4304",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 57.95589163477615,
        "y": 246.5412701772284,
        "z": 0
      },
      {
        "x": 59.58717951829004,
        "y": 248.1725580607423,
        "z": 0
      }
    ],
    "handle": "4380",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 56.9421395350024,
        "y": 236.5472619563855,
        "z": 0
      },
      {
        "x": 69.73983680357296,
        "y": 249.344959224956,
        "z": 0
      }
    ],
    "handle": "4381",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 55.92838743522865,
        "y": 226.5532537355426,
        "z": 0
      },
      {
        "x": 75.09087515128891,
        "y": 245.7157414516029,
        "z": 0
      }
    ],
    "handle": "4382",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 54.91463533545488,
        "y": 216.5592455146997,
        "z": 0
      },
      {
        "x": 75.06488566853834,
        "y": 236.7094958477832,
        "z": 0
      }
    ],
    "handle": "4383",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 53.90088323568111,
        "y": 206.5652372938568,
        "z": 0
      },
      {
        "x": 75.03889618578778,
        "y": 227.7032502439634,
        "z": 0
      }
    ],
    "handle": "4384",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 52.88713113590735,
        "y": 196.5712290730138,
        "z": 0
      },
      {
        "x": 56.4765378933245,
        "y": 200.160635830431,
        "z": 0
      }
    ],
    "handle": "4385",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 56.4765378933245,
        "y": 200.160635830431,
        "z": 0
      },
      {
        "x": 75.0129067030372,
        "y": 218.6970046401437,
        "z": 0
      }
    ],
    "handle": "4386",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 51.87337903613356,
        "y": 186.5772208521709,
        "z": 0
      },
      {
        "x": 65.45836163867703,
        "y": 200.1622034547144,
        "z": 0
      }
    ],
    "handle": "4387",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 65.45836163867703,
        "y": 200.1622034547144,
        "z": 0
      },
      {
        "x": 74.98691722028666,
        "y": 209.690759036324,
        "z": 0
      }
    ],
    "handle": "4388",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 50.8596269363598,
        "y": 176.583212631328,
        "z": 0
      },
      {
        "x": 74.44018538402956,
        "y": 200.1637710789978,
        "z": 0
      }
    ],
    "handle": "4389",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 74.44018538402956,
        "y": 200.1637710789978,
        "z": 0
      },
      {
        "x": 74.96092773753608,
        "y": 200.6845134325042,
        "z": 0
      }
    ],
    "handle": "438A",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 49.84587483658606,
        "y": 166.589204410485,
        "z": 0
      },
      {
        "x": 74.93493825478555,
        "y": 191.6782678286845,
        "z": 0
      }
    ],
    "handle": "438B",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 48.8321227368123,
        "y": 156.5951961896421,
        "z": 0
      },
      {
        "x": 74.90894877203495,
        "y": 182.6720222248648,
        "z": 0
      }
    ],
    "handle": "438C",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 47.81837063703853,
        "y": 146.6011879687992,
        "z": 0
      },
      {
        "x": 74.88295928928441,
        "y": 173.6657766210451,
        "z": 0
      }
    ],
    "handle": "438D",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 49.80140883109572,
        "y": 139.6039700417873,
        "z": 0
      },
      {
        "x": 74.85696980653384,
        "y": 164.6595310172254,
        "z": 0
      }
    ],
    "handle": "438E",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 54.52226167555114,
        "y": 135.3445667651735,
        "z": 0
      },
      {
        "x": 74.83098032378327,
        "y": 155.6532854134057,
        "z": 0
      }
    ],
    "handle": "438F",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 60.84323915028694,
        "y": 132.6852881188401,
        "z": 0
      },
      {
        "x": 74.80499084103269,
        "y": 146.6470398095859,
        "z": 0
      }
    ],
    "handle": "4390",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 62.86179284748406,
        "y": 134.7038418160372,
        "z": 0
      },
      {
        "x": 51.63647269614763,
        "y": 145.9291619673737,
        "z": 0
      }
    ],
    "handle": "4391",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 68.92605583076326,
        "y": 137.6198349538272,
        "z": 0
      },
      {
        "x": 65.10685687775131,
        "y": 141.4390339068391,
        "z": 0
      }
    ],
    "handle": "4392",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 58.37166478694943,
        "y": 148.174225997641,
        "z": 0
      },
      {
        "x": 48.9351368411264,
        "y": 157.610753943464,
        "z": 0
      }
    ],
    "handle": "4393",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 71.8420489685532,
        "y": 143.6840979371064,
        "z": 0
      },
      {
        "x": 60.61672881721677,
        "y": 154.9094180884428,
        "z": 0
      }
    ],
    "handle": "4394",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 53.8815367264149,
        "y": 161.6446101792447,
        "z": 0
      },
      {
        "x": 49.76216733907337,
        "y": 165.7639795665863,
        "z": 0
      }
    ],
    "handle": "4395",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 74.81377953590412,
        "y": 149.6926234908246,
        "z": 0
      },
      {
        "x": 74.0871129988205,
        "y": 150.4192900279082,
        "z": 0
      }
    ],
    "handle": "4396",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 67.35192090801864,
        "y": 157.1544821187101,
        "z": 0
      },
      {
        "x": 56.12660075668221,
        "y": 168.3798022700465,
        "z": 0
      }
    ],
    "handle": "4397",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 74.83961945363404,
        "y": 158.6470396941639,
        "z": 0
      },
      {
        "x": 69.59698493828589,
        "y": 163.889674209512,
        "z": 0
      }
    ],
    "handle": "4398",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 62.86179284748405,
        "y": 170.6248663003139,
        "z": 0
      },
      {
        "x": 51.6364726961476,
        "y": 181.8501864516503,
        "z": 0
      }
    ],
    "handle": "4399",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 74.86545937136395,
        "y": 167.6014558975031,
        "z": 0
      },
      {
        "x": 65.10685687775133,
        "y": 177.3600583911157,
        "z": 0
      }
    ],
    "handle": "439A",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 58.37166478694946,
        "y": 184.0952504819176,
        "z": 0
      },
      {
        "x": 52.24325883291417,
        "y": 190.2236564359528,
        "z": 0
      }
    ],
    "handle": "439B",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 71.8420489685532,
        "y": 179.605122421383,
        "z": 0
      },
      {
        "x": 60.61672881721676,
        "y": 190.8304425727195,
        "z": 0
      }
    ],
    "handle": "439C",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 53.8815367264149,
        "y": 197.5656346635213,
        "z": 0
      },
      {
        "x": 53.07028933086109,
        "y": 198.3768820590751,
        "z": 0
      }
    ],
    "handle": "439D",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 74.91713920682378,
        "y": 185.5102883041816,
        "z": 0
      },
      {
        "x": 74.08711299882053,
        "y": 186.3403145121848,
        "z": 0
      }
    ],
    "handle": "439E",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 67.35192090801866,
        "y": 193.0755066029867,
        "z": 0
      },
      {
        "x": 60.26613027179988,
        "y": 200.1612972392055,
        "z": 0
      }
    ],
    "handle": "439F",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 60.26613027179987,
        "y": 200.1612972392055,
        "z": 0
      },
      {
        "x": 56.12660075668219,
        "y": 204.3008267543232,
        "z": 0
      }
    ],
    "handle": "43A0",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 74.94297912455367,
        "y": 194.4647045075209,
        "z": 0
      },
      {
        "x": 69.59698493828597,
        "y": 199.8106986937886,
        "z": 0
      }
    ],
    "handle": "43A1",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 62.86179284748406,
        "y": 206.5458907845905,
        "z": 0
      },
      {
        "x": 54.72435032675496,
        "y": 214.6833333053196,
        "z": 0
      }
    ],
    "handle": "43A2",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 74.96881904228358,
        "y": 203.4191207108601,
        "z": 0
      },
      {
        "x": 65.10685687775128,
        "y": 213.2810828753924,
        "z": 0
      }
    ],
    "handle": "43A3",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 58.37166478694943,
        "y": 220.0162749661942,
        "z": 0
      },
      {
        "x": 55.55138082470188,
        "y": 222.8365589284418,
        "z": 0
      }
    ],
    "handle": "43A4",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 71.8420489685532,
        "y": 215.5261469056596,
        "z": 0
      },
      {
        "x": 60.61672881721677,
        "y": 226.7514670569961,
        "z": 0
      }
    ],
    "handle": "43A5",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 75.0204988777434,
        "y": 221.3279531175386,
        "z": 0
      },
      {
        "x": 74.08711299882049,
        "y": 222.2613389964615,
        "z": 0
      }
    ],
    "handle": "43A6",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 67.35192090801864,
        "y": 228.9965310872633,
        "z": 0
      },
      {
        "x": 57.20544182059579,
        "y": 239.1430101746862,
        "z": 0
      }
    ],
    "handle": "43A7",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 75.0463387954733,
        "y": 230.2823693208778,
        "z": 0
      },
      {
        "x": 69.59698493828586,
        "y": 235.7317231780652,
        "z": 0
      }
    ],
    "handle": "43A8",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 62.86179284748399,
        "y": 242.4669152688671,
        "z": 0
      },
      {
        "x": 58.03247231854268,
        "y": 247.2962357978085,
        "z": 0
      }
    ],
    "handle": "43A9",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 75.0721787132032,
        "y": 239.236785524217,
        "z": 0
      },
      {
        "x": 65.45841224020207,
        "y": 248.8505519972182,
        "z": 0
      }
    ],
    "handle": "43AA",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineweight": 18,
    "extendedData": {
      "applicationName": "ACAD"
    }
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 483.3984166021679,
        "y": 606.6856471430424,
        "z": 0
      },
      {
        "x": 483.3988148963533,
        "y": 604.4035900579642,
        "z": 0
      }
    ],
    "handle": "43BF",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "ARC",
    "handle": "43C0",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 483.9250451627871,
      "y": 606.6857390580614,
      "z": 0
    },
    "radius": 0.5266285714285716,
    "startAngle": 1.5709708597312715,
    "endAngle": 3.141767186235127,
    "angleLength": 1.5707963265038556
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 483.9249532488162,
        "y": 607.2123676417311,
        "z": 0
      },
      {
        "x": 484.276038960552,
        "y": 607.2124289190313,
        "z": 0
      }
    ],
    "handle": "43C1",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 484.8027594379381,
        "y": 607.2125208488642,
        "z": 0
      },
      {
        "x": 484.8032453490938,
        "y": 603.7859774664065,
        "z": 0
      }
    ],
    "handle": "43C2",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 487.6113531954416,
        "y": 607.2130110397088,
        "z": 0
      },
      {
        "x": 487.6119512401206,
        "y": 603.786467678044,
        "z": 0
      }
    ],
    "handle": "43C3",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 488.137981758802,
        "y": 607.2131029535,
        "z": 0
      },
      {
        "x": 488.489067467685,
        "y": 607.2131642308002,
        "z": 0
      }
    ],
    "handle": "43C4",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 484.276038960552,
        "y": 607.2124289190313,
        "z": 0
      },
      {
        "x": 488.137981758802,
        "y": 607.2131029535,
        "z": 0
      }
    ],
    "handle": "43C5",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 489.015787942451,
        "y": 606.6866275584204,
        "z": 0
      },
      {
        "x": 489.0161862365197,
        "y": 604.4045704714832,
        "z": 0
      }
    ],
    "handle": "43C6",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 483.3988148963533,
        "y": 604.4035900579642,
        "z": 0
      },
      {
        "x": 489.0161862365197,
        "y": 604.4045704714832,
        "z": 0
      }
    ],
    "handle": "43C7",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "ARC",
    "handle": "43C8",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 488.4891593818318,
      "y": 606.6865356443363,
      "z": 0
    },
    "radius": 0.5266285714285716,
    "startAngle": 0.00017453264533675135,
    "endAngle": 1.5709708597312715,
    "angleLength": 1.5707963270859346
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 502.2557147074119,
        "y": 606.6856471430427,
        "z": 0
      },
      {
        "x": 502.2561130015973,
        "y": 604.4035900579646,
        "z": 0
      }
    ],
    "handle": "43D3",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "ARC",
    "handle": "43D4",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 502.7823432680311,
      "y": 606.6857390580617,
      "z": 0
    },
    "radius": 0.5266285714285716,
    "startAngle": 1.5709708597312715,
    "endAngle": 3.1417671862351257,
    "angleLength": 1.5707963265038543
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 502.7822513540602,
        "y": 607.2123676417312,
        "z": 0
      },
      {
        "x": 503.1333370657959,
        "y": 607.2124289190313,
        "z": 0
      }
    ],
    "handle": "43D5",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 503.6600575431821,
        "y": 607.2125208488646,
        "z": 0
      },
      {
        "x": 503.6605434543378,
        "y": 603.7859774664067,
        "z": 0
      }
    ],
    "handle": "43D6",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 506.4686513006858,
        "y": 607.213011039709,
        "z": 0
      },
      {
        "x": 506.4692493453646,
        "y": 603.7864676780442,
        "z": 0
      }
    ],
    "handle": "43D7",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 506.995279864046,
        "y": 607.2131029535003,
        "z": 0
      },
      {
        "x": 507.3463655729291,
        "y": 607.2131642308004,
        "z": 0
      }
    ],
    "handle": "43D8",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 503.1333370657959,
        "y": 607.2124289190313,
        "z": 0
      },
      {
        "x": 506.995279864046,
        "y": 607.2131029535003,
        "z": 0
      }
    ],
    "handle": "43D9",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 507.873086047695,
        "y": 606.6866275584207,
        "z": 0
      },
      {
        "x": 507.8734843417638,
        "y": 604.4045704714835,
        "z": 0
      }
    ],
    "handle": "43DA",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 502.2561130015973,
        "y": 604.4035900579646,
        "z": 0
      },
      {
        "x": 507.8734843417638,
        "y": 604.4045704714835,
        "z": 0
      }
    ],
    "handle": "43DB",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "ARC",
    "handle": "43DC",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 507.3464574870759,
      "y": 606.6865356443368,
      "z": 0
    },
    "radius": 0.5266285714285716,
    "startAngle": 0.00017453264533675135,
    "endAngle": 1.5709708597312715,
    "angleLength": 1.5707963270859346
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 540.6724811843654,
        "y": 606.6923521334305,
        "z": 0
      },
      {
        "x": 540.672879478551,
        "y": 604.4102950483524,
        "z": 0
      }
    ],
    "handle": "43DD",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "ARC",
    "handle": "43DE",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 541.1991097449848,
      "y": 606.6924440484496,
      "z": 0
    },
    "radius": 0.5266285714285716,
    "startAngle": 1.5709708597312715,
    "endAngle": 3.1417671862351257,
    "angleLength": 1.5707963265038543
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 541.1990178310137,
        "y": 607.2190726321192,
        "z": 0
      },
      {
        "x": 541.5501035427496,
        "y": 607.2191339094192,
        "z": 0
      }
    ],
    "handle": "43DF",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 542.0768240201356,
        "y": 607.2192258392524,
        "z": 0
      },
      {
        "x": 542.0773099312913,
        "y": 603.7926824567945,
        "z": 0
      }
    ],
    "handle": "43E0",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 544.8854177776394,
        "y": 607.219716030097,
        "z": 0
      },
      {
        "x": 544.8860158223181,
        "y": 603.793172668432,
        "z": 0
      }
    ],
    "handle": "43E1",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 545.4120463409997,
        "y": 607.2198079438882,
        "z": 0
      },
      {
        "x": 545.7631320498826,
        "y": 607.2198692211883,
        "z": 0
      }
    ],
    "handle": "43E2",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 541.5501035427496,
        "y": 607.2191339094192,
        "z": 0
      },
      {
        "x": 545.4120463409997,
        "y": 607.2198079438882,
        "z": 0
      }
    ],
    "handle": "43E3",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 546.2898525246487,
        "y": 606.6933325488085,
        "z": 0
      },
      {
        "x": 546.2902508187173,
        "y": 604.4112754618712,
        "z": 0
      }
    ],
    "handle": "43E4",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 540.672879478551,
        "y": 604.4102950483524,
        "z": 0
      },
      {
        "x": 546.2902508187173,
        "y": 604.4112754618712,
        "z": 0
      }
    ],
    "handle": "43E5",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "ARC",
    "handle": "43E6",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 545.7632239640295,
      "y": 606.6932406347246,
      "z": 0
    },
    "radius": 0.5266285714285716,
    "startAngle": 0.00017453264533675135,
    "endAngle": 1.5709708597312715,
    "angleLength": 1.5707963270859346
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 559.5297787123422,
        "y": 606.6956433526104,
        "z": 0
      },
      {
        "x": 559.530177006528,
        "y": 604.4135862675322,
        "z": 0
      }
    ],
    "handle": "43E7",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "ARC",
    "handle": "43E8",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 560.0564072729618,
      "y": 606.6957352676296,
      "z": 0
    },
    "radius": 0.5266285714285716,
    "startAngle": 1.5709708597312715,
    "endAngle": 3.1417671862351257,
    "angleLength": 1.5707963265038543
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 560.0563153589908,
        "y": 607.2223638512991,
        "z": 0
      },
      {
        "x": 560.4074010707265,
        "y": 607.2224251285993,
        "z": 0
      }
    ],
    "handle": "43E9",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 560.9341215481126,
        "y": 607.2225170584323,
        "z": 0
      },
      {
        "x": 560.9346074592682,
        "y": 603.7959736759746,
        "z": 0
      }
    ],
    "handle": "43EA",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 563.7427153056162,
        "y": 607.223007249277,
        "z": 0
      },
      {
        "x": 563.7433133502952,
        "y": 603.796463887612,
        "z": 0
      }
    ],
    "handle": "43EB",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 564.2693438689766,
        "y": 607.2230991630682,
        "z": 0
      },
      {
        "x": 564.6204295778597,
        "y": 607.2231604403682,
        "z": 0
      }
    ],
    "handle": "43EC",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 560.4074010707265,
        "y": 607.2224251285993,
        "z": 0
      },
      {
        "x": 564.2693438689766,
        "y": 607.2230991630682,
        "z": 0
      }
    ],
    "handle": "43ED",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 565.1471500526256,
        "y": 606.6966237679885,
        "z": 0
      },
      {
        "x": 565.1475483466944,
        "y": 604.4145666810512,
        "z": 0
      }
    ],
    "handle": "43EE",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 559.530177006528,
        "y": 604.4135862675322,
        "z": 0
      },
      {
        "x": 565.1475483466944,
        "y": 604.4145666810512,
        "z": 0
      }
    ],
    "handle": "43EF",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "ARC",
    "handle": "43F0",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 564.6205214920063,
      "y": 606.6965318539046,
      "z": 0
    },
    "radius": 0.5266285714285716,
    "startAngle": 0.00017453264533675135,
    "endAngle": 1.5709708597312715,
    "angleLength": 1.5707963270859346
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 578.4368599506673,
        "y": 606.6989432606867,
        "z": 0
      },
      {
        "x": 578.437258244853,
        "y": 604.4168861756087,
        "z": 0
      }
    ],
    "handle": "43F1",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "ARC",
    "handle": "43F2",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 578.9634885112868,
      "y": 606.699035175706,
      "z": 0
    },
    "radius": 0.5266285714285716,
    "startAngle": 1.5709708597312715,
    "endAngle": 3.1417671862351257,
    "angleLength": 1.5707963265038543
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 578.9633965973158,
        "y": 607.2256637593755,
        "z": 0
      },
      {
        "x": 579.3144823090515,
        "y": 607.2257250366757,
        "z": 0
      }
    ],
    "handle": "43F3",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 579.8412027864376,
        "y": 607.2258169665087,
        "z": 0
      },
      {
        "x": 579.8416886975932,
        "y": 603.799273584051,
        "z": 0
      }
    ],
    "handle": "43F4",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 582.6497965439413,
        "y": 607.2263071573534,
        "z": 0
      },
      {
        "x": 582.6503945886202,
        "y": 603.7997637956882,
        "z": 0
      }
    ],
    "handle": "43F5",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 583.1764251073016,
        "y": 607.2263990711446,
        "z": 0
      },
      {
        "x": 583.5275108161846,
        "y": 607.2264603484447,
        "z": 0
      }
    ],
    "handle": "43F6",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 579.3144823090515,
        "y": 607.2257250366757,
        "z": 0
      },
      {
        "x": 583.1764251073016,
        "y": 607.2263990711446,
        "z": 0
      }
    ],
    "handle": "43F7",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 584.0542312909506,
        "y": 606.6999236760649,
        "z": 0
      },
      {
        "x": 584.0546295850193,
        "y": 604.4178665891276,
        "z": 0
      }
    ],
    "handle": "43F8",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": 578.437258244853,
        "y": 604.4168861756087,
        "z": 0
      },
      {
        "x": 584.0546295850193,
        "y": 604.4178665891276,
        "z": 0
      }
    ],
    "handle": "43F9",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18
  },
  {
    "type": "ARC",
    "handle": "43FA",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "center": {
      "x": 583.5276027303312,
      "y": 606.6998317619809,
      "z": 0
    },
    "radius": 0.5266285714285716,
    "startAngle": 0.00017453264533675135,
    "endAngle": 1.5709708597312715,
    "angleLength": 1.5707963270859346
  },
  {
    "type": "LWPOLYLINE",
    "vertices": [
      {
        "x": 600.7765641753803,
        "y": 598.1980774495605
      },
      {
        "x": 600.7766867274765,
        "y": 597.4959060530927
      },
      {
        "x": 602.7904108235372,
        "y": 597.49625751466
      },
      {
        "x": 602.7899818912842,
        "y": 599.9538574553818
      },
      {
        "x": 597.1726105512344,
        "y": 599.9528770390679
      },
      {
        "x": 597.1730394831994,
        "y": 597.4952770983605
      },
      {
        "x": 599.3723438917655,
        "y": 597.4956609494839
      },
      {
        "x": 599.3722213398433,
        "y": 598.1978323450094
      }
    ],
    "handle": "43FB",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "shape": true,
    "hasContinuousLinetypePattern": false
  },
  {
    "type": "LWPOLYLINE",
    "vertices": [
      {
        "x": 466.399429214536,
        "y": 625.6841849014007
      },
      {
        "x": 466.3992453864778,
        "y": 626.7374420510484
      },
      {
        "x": 459.3775312076908,
        "y": 626.7362165301998
      },
      {
        "x": 459.377715035691,
        "y": 625.6829593814691
      },
      {
        "x": 455.8668579463851,
        "y": 625.6823466215092
      },
      {
        "x": 455.8651422178378,
        "y": 635.512746495191
      },
      {
        "x": 469.9085705754115,
        "y": 635.5151975350409
      },
      {
        "x": 469.9102863038417,
        "y": 625.6847976632199
      }
    ],
    "handle": "43FC",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "shape": true,
    "hasContinuousLinetypePattern": false
  },
  {
    "type": "LWPOLYLINE",
    "vertices": [
      {
        "x": 580.3903525061323,
        "y": 625.7040800712847
      },
      {
        "x": 580.3886367777582,
        "y": 635.5344799431003
      },
      {
        "x": 594.4320651352172,
        "y": 635.5369309848091
      },
      {
        "x": 594.4337808636474,
        "y": 625.7065311129951
      },
      {
        "x": 590.9229237743414,
        "y": 625.7059183511738
      },
      {
        "x": 590.9227399462842,
        "y": 626.7591755008325
      },
      {
        "x": 583.9010257675543,
        "y": 626.7579499808999
      },
      {
        "x": 583.9012095955553,
        "y": 625.7046928321686
      }
    ],
    "handle": "43FD",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "shape": true,
    "hasContinuousLinetypePattern": false
  },
  {
    "type": "LWPOLYLINE",
    "vertices": [
      {
        "x": 448.404786216677,
        "y": 597.4454730991127
      },
      {
        "x": 448.4043572845989,
        "y": 599.903073039819
      },
      {
        "x": 454.0217286248218,
        "y": 599.9040534570631
      },
      {
        "x": 454.0221575570166,
        "y": 597.4464535154211
      },
      {
        "x": 452.0084334610727,
        "y": 597.4461020547703
      },
      {
        "x": 452.0083109089748,
        "y": 598.1482734940827
      },
      {
        "x": 450.6039680704128,
        "y": 598.1480283914024
      },
      {
        "x": 450.6040906223931,
        "y": 597.445856950242
      }
    ],
    "handle": "43FE",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "shape": true,
    "hasContinuousLinetypePattern": false
  },
  {
    "type": "LWPOLYLINE",
    "vertices": [
      {
        "x": 604.9693776870845,
        "y": 600.2960932161546
      },
      {
        "x": 445.3373122304917,
        "y": 600.2682321648927
      },
      {
        "x": 445.336699470353,
        "y": 603.7790892552403
      },
      {
        "x": 604.9687649268882,
        "y": 603.806950305574
      }
    ],
    "handle": "43FF",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "shape": true,
    "hasContinuousLinetypePattern": false
  },
  {
    "type": "LWPOLYLINE",
    "vertices": [
      {
        "x": 446.7407359288186,
        "y": 605.5347629031021
      },
      {
        "x": 455.8689643584661,
        "y": 605.5363560793702
      },
      {
        "x": 455.8692094624851,
        "y": 604.1320132212502
      },
      {
        "x": 445.3366381943338,
        "y": 604.1301749413677
      },
      {
        "x": 445.3343479542527,
        "y": 625.3294226331417
      },
      {
        "x": 604.9664134078192,
        "y": 625.3572836825394
      },
      {
        "x": 604.9687036508104,
        "y": 604.1580359907639
      },
      {
        "x": 594.4361323827172,
        "y": 604.1561977108686
      },
      {
        "x": 594.4358872785815,
        "y": 605.5605405699316
      },
      {
        "x": 603.5641157110211,
        "y": 605.5621337462032
      },
      {
        "x": 603.5623156790392,
        "y": 623.9526957440938
      },
      {
        "x": 446.73893589119,
        "y": 623.9253249009922
      }
    ],
    "handle": "4400",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineType": "Continuous",
    "lineTypeScale": 0.05,
    "lineweight": 18,
    "shape": true,
    "hasContinuousLinetypePattern": false
  },
  {
    "type": "LINE",
    "vertices": [
      {
        "x": -5.68e-14,
        "y": 1112.918591290707,
        "z": 0
      },
      {
        "x": 736.2690623310042,
        "y": 1112.918591290707,
        "z": 0
      }
    ],
    "handle": "441C",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18
  },
  {
    "type": "TEXT",
    "handle": "441D",
    "ownerHandle": "1F",
    "layer": "Topraklama_Detay",
    "lineweight": 18,
    "startPoint": {
      "x": 300.0,
      "y": 1130.0,
      "z": 0
    },
    "textHeight": 15,
    "text": "TOPRAKLAMA DETAY"
  },
  {
    "type": "HATCH",
    "handle": "26F7",
    "layer": "Topraklama_Detay",
    "color": "#7F9FFF ",
    "colorIndex": "",
    "LineScale": 1,
    "LineType": "ByLayer",
    "Kalinlik": "18",
    "x": 0,
    "y": 0,
    "HatchPatternName": "SOLID",
    "SolidFillFlag": 1,
    "MPolygon": null,
    "AssociativityFlag": 0,
    "NumberOfBoundaryPaths": 1,
    "boundaryPath": [
      {
        "groups": [
          {
            "edgeType": "Polyline",
            "IsClosedFlag": 1,
            "NumberOfPolylineVertices": 4,
            "points": [
              339.9733919595599,
              134.6305227149241,
              335.130208079703,
              134.6296774195498,
              335.1306730335351,
              131.9656879510693,
              339.9738569134509,
              131.9665332464501
            ]
          }
        ],
        "BoundaryPathTypeFlag": 7
      }
    ],
    "pattern": {}
  },
  {
    "type": "HATCH",
    "handle": "26F8",
    "layer": "Topraklama_Detay",
    "color": "#7F9FFF ",
    "colorIndex": "",
    "LineScale": 1,
    "LineType": "ByLayer",
    "Kalinlik": "18",
    "x": 0,
    "y": 0,
    "HatchPatternName": "SOLID",
    "SolidFillFlag": 1,
    "MPolygon": null,
    "AssociativityFlag": 0,
    "NumberOfBoundaryPaths": 1,
    "boundaryPath": [
      {
        "groups": [
          {
            "edgeType": "Polyline",
            "IsClosedFlag": 1,
            "NumberOfPolylineVertices": 4,
            "points": [
              426.4770344618579,
              134.6456204494461,
              421.6338505819435,
              134.6447751531304,
              421.6343155357738,
              131.9807856855923,
              426.4774994156907,
              131.9816309800398
            ]
          }
        ],
        "BoundaryPathTypeFlag": 7
      }
    ],
    "pattern": {}
  },
  {
    "type": "HATCH",
    "handle": "26F9",
    "layer": "Topraklama_Detay",
    "color": "#7F9FFF ",
    "colorIndex": "",
    "LineScale": 1,
    "LineType": "ByLayer",
    "Kalinlik": "18",
    "x": 0,
    "y": 0,
    "HatchPatternName": "SOLID",
    "SolidFillFlag": 1,
    "MPolygon": null,
    "AssociativityFlag": 0,
    "NumberOfBoundaryPaths": 1,
    "boundaryPath": [
      {
        "groups": [
          {
            "edgeType": "Polyline",
            "IsClosedFlag": 1,
            "NumberOfPolylineVertices": 4,
            "points": [
              398.0584345945958,
              131.9766709180512,
              398.0579696408239,
              134.6406603856012,
              393.2147857635282,
              134.6398150920795,
              393.2152507174748,
              131.9758256245332
            ]
          }
        ],
        "BoundaryPathTypeFlag": 7
      }
    ],
    "pattern": {}
  },
  {
    "type": "HATCH",
    "handle": "26FA",
    "layer": "Topraklama_Detay",
    "color": "#7F9FFF ",
    "colorIndex": "",
    "LineScale": 1,
    "LineType": "ByLayer",
    "Kalinlik": "18",
    "x": 0,
    "y": 0,
    "HatchPatternName": "SOLID",
    "SolidFillFlag": 1,
    "MPolygon": null,
    "AssociativityFlag": 0,
    "NumberOfBoundaryPaths": 1,
    "boundaryPath": [
      {
        "groups": [
          {
            "edgeType": "Polyline",
            "IsClosedFlag": 1,
            "NumberOfPolylineVertices": 4,
            "points": [
              451.1567487316201,
              134.6499278722331,
              446.313564851646,
              134.6490825759101,
              446.3140298055948,
              131.9850931093133,
              451.1572136853938,
              131.9859384037509
            ]
          }
        ],
        "BoundaryPathTypeFlag": 7
      }
    ],
    "pattern": {}
  },
  {
    "type": "HATCH",
    "handle": "26FB",
    "layer": "Topraklama_Detay",
    "color": "#7F9FFF ",
    "colorIndex": "",
    "LineScale": 1,
    "LineType": "ByLayer",
    "Kalinlik": "18",
    "x": 0,
    "y": 0,
    "HatchPatternName": "SOLID",
    "SolidFillFlag": 1,
    "MPolygon": null,
    "AssociativityFlag": 0,
    "NumberOfBoundaryPaths": 1,
    "boundaryPath": [
      {
        "groups": [
          {
            "edgeType": "Polyline",
            "IsClosedFlag": 1,
            "NumberOfPolylineVertices": 4,
            "points": [
              367.146467266838,
              131.9712757626512,
              367.146002312948,
              134.6352652311316,
              362.3028184358848,
              134.6344199338918,
              362.3032833897752,
              131.9704304663419
            ]
          }
        ],
        "BoundaryPathTypeFlag": 7
      }
    ],
    "pattern": {}
  },
  {
    "type": "HATCH",
    "handle": "26FC",
    "layer": "Topraklama_Detay",
    "color": "#7F9FFF ",
    "colorIndex": "",
    "LineScale": 1,
    "LineType": "ByLayer",
    "Kalinlik": "18",
    "x": 0,
    "y": 0,
    "HatchPatternName": "SOLID",
    "SolidFillFlag": 1,
    "MPolygon": null,
    "AssociativityFlag": 0,
    "NumberOfBoundaryPaths": 1,
    "boundaryPath": [
      {
        "groups": [
          {
            "edgeType": "Polyline",
            "IsClosedFlag": 1,
            "NumberOfPolylineVertices": 4,
            "points": [
              309.5600077045377,
              134.6252145795105,
              304.7168238246801,
              134.6243692832031,
              304.7172887786299,
              131.9603798137905,
              309.560472658486,
              131.9612251101025
            ]
          }
        ],
        "BoundaryPathTypeFlag": 7
      }
    ],
    "pattern": {}
  },
  {
    "type": "HATCH",
    "handle": "26FD",
    "layer": "Topraklama_Detay",
    "color": "#7F9FFF ",
    "colorIndex": "",
    "LineScale": 1,
    "LineType": "ByLayer",
    "Kalinlik": "18",
    "x": 0,
    "y": 0,
    "HatchPatternName": "SOLID",
    "SolidFillFlag": 1,
    "MPolygon": null,
    "AssociativityFlag": 0,
    "NumberOfBoundaryPaths": 5,
    "boundaryPath": [
      {
        "groups": [
          {
            "edgeType": "Polyline",
            "IsClosedFlag": 1,
            "NumberOfPolylineVertices": 4,
            "points": [
              335.130208079703,
              134.6296774195498,
              333.057797098475,
              134.6293157162117,
              333.0635212887433,
              101.832121392712,
              335.1359322700298,
              101.8324830969686
            ]
          }
        ],
        "BoundaryPathTypeFlag": 7
      },
      {
        "groups": [
          {
            "edgeType": "Polyline",
            "IsClosedFlag": 1,
            "NumberOfPolylineVertices": 4,
            "points": [
              335.1289579772853,
              141.7922354582624,
              333.0565469961721,
              141.7918737539985,
              333.057797098475,
              134.6293157162117,
              335.130208079703,
              134.6296774195498
            ]
          }
        ],
        "BoundaryPathTypeFlag": 7
      },
      {
        "groups": [
          {
            "edgeType": "Polyline",
            "IsClosedFlag": 1,
            "NumberOfPolylineVertices": 4,
            "points": [
              335.1280368416917,
              147.0699546868018,
              333.0556258603467,
              147.0695929825197,
              333.0564811900839,
              142.1689146189028,
              335.12889217143,
              142.1692763231704
            ]
          }
        ],
        "BoundaryPathTypeFlag": 7
      },
      {
        "groups": [
          {
            "edgeType": "Polyline",
            "IsClosedFlag": 1,
            "NumberOfPolylineVertices": 4,
            "points": [
              335.122236413881,
              180.3039580853619,
              333.049825432478,
              180.3035963829597,
              333.0556258603467,
              147.0695929825197,
              335.1280368416917,
              147.0699546868018
            ]
          }
        ],
        "BoundaryPathTypeFlag": 7
      },
      {
        "groups": [
          {
            "edgeType": "Polyline",
            "IsClosedFlag": 1,
            "NumberOfPolylineVertices": 4,
            "points": [
              335.1182836900118,
              202.9513967363091,
              333.045872708666,
              202.9510350329829,
              333.049825432478,
              180.3035963829597,
              335.122236413881,
              180.3039580853619
            ]
          }
        ],
        "BoundaryPathTypeFlag": 7
      }
    ],
    "pattern": {}
  },
  {
    "type": "HATCH",
    "handle": "2702",
    "layer": "Topraklama_Detay",
    "color": "#7F9FFF ",
    "colorIndex": "",
    "LineScale": 1,
    "LineType": "ByLayer",
    "Kalinlik": "18",
    "x": 0,
    "y": 0,
    "HatchPatternName": "SOLID",
    "SolidFillFlag": 1,
    "MPolygon": null,
    "AssociativityFlag": 0,
    "NumberOfBoundaryPaths": 5,
    "boundaryPath": [
      {
        "groups": [
          {
            "edgeType": "Polyline",
            "IsClosedFlag": 1,
            "NumberOfPolylineVertices": 4,
            "points": [
              122.8435989803979,
              131.9783305963537,
              120.7711879991687,
              131.9779688911549,
              120.776912189438,
              99.18077454622014,
              122.849323170667,
              99.18113625142453
            ]
          }
        ],
        "BoundaryPathTypeFlag": 7
      },
      {
        "groups": [
          {
            "edgeType": "Polyline",
            "IsClosedFlag": 1,
            "NumberOfPolylineVertices": 4,
            "points": [
              122.8423488780957,
              139.1408886108511,
              120.7699378969258,
              139.1405269075112,
              120.7711879991687,
              131.9779688911549,
              122.8435989803979,
              131.9783305963537
            ]
          }
        ],
        "BoundaryPathTypeFlag": 7
      },
      {
        "groups": [
          {
            "edgeType": "Polyline",
            "IsClosedFlag": 1,
            "NumberOfPolylineVertices": 4,
            "points": [
              122.8414277423877,
              144.4186078403154,
              120.7690167611001,
              144.418246135111,
              120.7698720907799,
              139.51756779477,
              122.8422830720668,
              139.5179294981025
            ]
          }
        ],
        "BoundaryPathTypeFlag": 7
      },
      {
        "groups": [
          {
            "edgeType": "Polyline",
            "IsClosedFlag": 1,
            "NumberOfPolylineVertices": 4,
            "points": [
              122.8356273145759,
              177.6526112398096,
              120.7632163332321,
              177.6522495364697,
              120.7690167611001,
              144.418246135111,
              122.8414277423877,
              144.4186078403154
            ]
          }
        ],
        "BoundaryPathTypeFlag": 7
      },
      {
        "groups": [
          {
            "edgeType": "Polyline",
            "IsClosedFlag": 1,
            "NumberOfPolylineVertices": 4,
            "points": [
              122.831674590765,
              200.3000498898373,
              120.7592636094187,
              200.2996881864892,
              120.7632163332321,
              177.6522495364697,
              122.8356273145759,
              177.6526112398096
            ]
          }
        ],
        "BoundaryPathTypeFlag": 7
      }
    ],
    "pattern": {}
  },
  {
    "type": "HATCH",
    "handle": "2703",
    "layer": "Topraklama_Detay",
    "color": "#7F9FFF ",
    "colorIndex": "",
    "LineScale": 1,
    "LineType": "ByLayer",
    "Kalinlik": "18",
    "x": 0,
    "y": 0,
    "HatchPatternName": "SOLID",
    "SolidFillFlag": 1,
    "MPolygon": null,
    "AssociativityFlag": 0,
    "NumberOfBoundaryPaths": 1,
    "boundaryPath": [
      {
        "groups": [
          {
            "edgeType": "Polyline",
            "IsClosedFlag": 1,
            "NumberOfPolylineVertices": 6,
            "points": [
              122.8422830720668,
              139.5179294981025,
              122.831674590765,
              200.3000498898373,
              120.7592636094187,
              200.2996881864892,
              120.7772276537138,
              97.37329707574465,
              121.1468428724331,
              97.00381086394194,
              122.8497031337469,
              97.00410807131993
            ]
          }
        ],
        "BoundaryPathTypeFlag": 7
      }
    ],
    "pattern": {}
  },
  {
    "type": "HATCH",
    "handle": "2719",
    "layer": "Topraklama_Detay",
    "color": "#7F9FFF ",
    "colorIndex": "",
    "LineScale": 1,
    "LineType": "ByLayer",
    "Kalinlik": "18",
    "x": 0,
    "y": 0,
    "HatchPatternName": "SOLID",
    "SolidFillFlag": 1,
    "MPolygon": null,
    "AssociativityFlag": 0,
    "NumberOfBoundaryPaths": 1,
    "boundaryPath": [
      {
        "groups": [
          {
            "edgeType": "Polyline",
            "IsClosedFlag": 1,
            "NumberOfPolylineVertices": 3,
            "points": [
              135.800435840443,
              111.2873772783205,
              141.0627524808509,
              109.7967567741798,
              141.0622318355599,
              112.7798345852607
            ]
          }
        ],
        "BoundaryPathTypeFlag": 7
      }
    ],
    "pattern": {}
  },
  {
    "type": "HATCH",
    "handle": "271F",
    "layer": "Topraklama_Detay",
    "color": "#7F9FFF ",
    "colorIndex": "",
    "LineScale": 1,
    "LineType": "ByLayer",
    "Kalinlik": "18",
    "x": 0,
    "y": 0,
    "HatchPatternName": "SOLID",
    "SolidFillFlag": 1,
    "MPolygon": null,
    "AssociativityFlag": 0,
    "NumberOfBoundaryPaths": 1,
    "boundaryPath": [
      {
        "groups": [
          {
            "edgeType": "Polyline",
            "IsClosedFlag": 1,
            "NumberOfPolylineVertices": 4,
            "points": [
              131.9177464036028,
              126.0971530387105,
              131.9184213118277,
              122.2302138553932,
              256.2067769522549,
              122.2519062664323,
              256.2061020439722,
              126.1188454478906
            ]
          }
        ],
        "BoundaryPathTypeFlag": 7
      }
    ],
    "pattern": {}
  },
  {
    "type": "HATCH",
    "handle": "2720",
    "layer": "Topraklama_Detay",
    "color": "#7F9FFF ",
    "colorIndex": "",
    "LineScale": 1,
    "LineType": "ByLayer",
    "Kalinlik": "18",
    "x": 0,
    "y": 0,
    "HatchPatternName": "SOLID",
    "SolidFillFlag": 1,
    "MPolygon": null,
    "AssociativityFlag": 0,
    "NumberOfBoundaryPaths": 1,
    "boundaryPath": [
      {
        "groups": [
          {
            "edgeType": "Polyline",
            "IsClosedFlag": 1,
            "NumberOfPolylineVertices": 4,
            "points": [
              304.7220830611192,
              104.4911644291132,
              304.7225480150077,
              101.8271749597052,
              309.5657318948649,
              101.828020256944,
              309.5652669410918,
              104.4920097244949
            ]
          }
        ],
        "BoundaryPathTypeFlag": 7
      }
    ],
    "pattern": {}
  },
  {
    "type": "HATCH",
    "handle": "2725",
    "layer": "Topraklama_Detay",
    "color": "#7F9FFF ",
    "colorIndex": "",
    "LineScale": 1,
    "LineType": "ByLayer",
    "Kalinlik": "18",
    "x": 0,
    "y": 0,
    "HatchPatternName": "SOLID",
    "SolidFillFlag": 1,
    "MPolygon": null,
    "AssociativityFlag": 0,
    "NumberOfBoundaryPaths": 1,
    "boundaryPath": [
      {
        "groups": [
          {
            "edgeType": "Line",
            "x1": 113.7586977532478,
            "y1": 97.00252139009537,
            "x2": 115.3337064736979,
            "y2": 97.00279628111822
          },
          {
            "edgeType": "Line",
            "x1": 115.3337064736979,
            "y1": 97.00279628111822,
            "x2": 115.3314078722619,
            "y2": 110.1728121293599
          },
          {
            "edgeType": "Line",
            "x1": 115.3314078722619,
            "y1": 110.1728121293599,
            "x2": 113.7563991518678,
            "y2": 110.1725372392584
          },
          {
            "edgeType": "Line",
            "x1": 113.7563991518678,
            "y1": 110.1725372392584,
            "x2": 113.7586977533057,
            "y2": 97.00252139102302
          }
        ],
        "BoundaryPathTypeFlag": 1
      },
      {
        "groups": [
          {
            "edgeType": "Polyline",
            "IsClosedFlag": 1,
            "NumberOfPolylineVertices": 3,
            "points": [
              105.672944040735,
              98.62530676927143,
              107.1635645334029,
              103.8876233967021,
              104.1804867411269,
              103.8871027501336
            ]
          }
        ],
        "BoundaryPathTypeFlag": 7
      }
    ],
    "pattern": {}
  },
  {
    "type": "HATCH",
    "handle": "2728",
    "layer": "Topraklama_Detay",
    "color": "#7F9FFF ",
    "colorIndex": "",
    "LineScale": 1,
    "LineType": "ByLayer",
    "Kalinlik": "18",
    "x": 0,
    "y": 0,
    "HatchPatternName": "SOLID",
    "SolidFillFlag": 1,
    "MPolygon": null,
    "AssociativityFlag": 0,
    "NumberOfBoundaryPaths": 1,
    "boundaryPath": [
      {
        "groups": [
          {
            "edgeType": "Polyline",
            "IsClosedFlag": 1,
            "NumberOfPolylineVertices": 3,
            "points": [
              105.672944040735,
              98.62530676927143,
              107.1635645334029,
              103.8876233967021,
              104.1804867411269,
              103.8871027501336
            ]
          }
        ],
        "BoundaryPathTypeFlag": 7
      }
    ],
    "pattern": {}
  },
  {
    "type": "HATCH",
    "handle": "272E",
    "layer": "Topraklama_Detay",
    "color": "#7F9FFF ",
    "colorIndex": "",
    "LineScale": 1,
    "LineType": "ByLayer",
    "Kalinlik": "18",
    "x": 0,
    "y": 0,
    "HatchPatternName": "SOLID",
    "SolidFillFlag": 1,
    "MPolygon": null,
    "AssociativityFlag": 0,
    "NumberOfBoundaryPaths": 1,
    "boundaryPath": [
      {
        "groups": [
          {
            "edgeType": "Polyline",
            "IsClosedFlag": 1,
            "NumberOfPolylineVertices": 3,
            "points": [
              105.7559583194078,
              84.35835334099102,
              104.2653378240637,
              79.09603669214631,
              107.2484156162248,
              79.0965573359199
            ]
          }
        ],
        "BoundaryPathTypeFlag": 7
      }
    ],
    "pattern": {}
  },
  {
    "type": "HATCH",
    "handle": "2731",
    "layer": "Topraklama_Detay",
    "color": "#7F9FFF ",
    "colorIndex": "",
    "LineScale": 1,
    "LineType": "ByLayer",
    "Kalinlik": "18",
    "x": 0,
    "y": 0,
    "HatchPatternName": "SOLID",
    "SolidFillFlag": 1,
    "MPolygon": null,
    "AssociativityFlag": 0,
    "NumberOfBoundaryPaths": 1,
    "boundaryPath": [
      {
        "groups": [
          {
            "edgeType": "Line",
            "x1": 127.137380434026,
            "y1": 82.47614295406675,
            "x2": 128.7123891577347,
            "y2": 82.4764178441801
          },
          {
            "edgeType": "Line",
            "x1": 128.7123891600051,
            "y1": 82.47641784511507,
            "x2": 128.7100905586278,
            "y2": 95.6464336877625
          },
          {
            "edgeType": "Line",
            "x1": 128.7100905586278,
            "y1": 95.64643369335042,
            "x2": 127.1350818349749,
            "y2": 95.6461588023194
          },
          {
            "edgeType": "Line",
            "x1": 127.1350818326461,
            "y1": 95.6461588023194,
            "x2": 127.1373804340826,
            "y2": 82.4761429587306
          }
        ],
        "BoundaryPathTypeFlag": 1
      },
      {
        "groups": [
          {
            "edgeType": "Polyline",
            "IsClosedFlag": 1,
            "NumberOfPolylineVertices": 4,
            "points": [
              335.1354673161406,
              104.4964725663922,
              335.1359322700298,
              101.8324830969686,
              339.9791161498299,
              101.8333283932806,
              339.9786511959969,
              104.4973178608306
            ]
          }
        ],
        "BoundaryPathTypeFlag": 7
      }
    ],
    "pattern": {}
  },
  {
    "type": "HATCH",
    "handle": "273C",
    "layer": "Topraklama_Detay",
    "color": "#7F9FFF ",
    "colorIndex": "",
    "LineScale": 1,
    "LineType": "ByLayer",
    "Kalinlik": "18",
    "x": 0,
    "y": 0,
    "HatchPatternName": "SOLID",
    "SolidFillFlag": 1,
    "MPolygon": null,
    "AssociativityFlag": 0,
    "NumberOfBoundaryPaths": 1,
    "boundaryPath": [
      {
        "groups": [
          {
            "edgeType": "Polyline",
            "IsClosedFlag": 1,
            "NumberOfPolylineVertices": 4,
            "points": [
              335.1354673161406,
              104.4964725663922,
              335.1359322700298,
              101.8324830969686,
              339.9791161498299,
              101.8333283932806,
              339.9786511959969,
              104.4973178608306
            ]
          }
        ],
        "BoundaryPathTypeFlag": 7
      }
    ],
    "pattern": {}
  },
  {
    "type": "HATCH",
    "handle": "273D",
    "layer": "Topraklama_Detay",
    "color": "#7F9FFF ",
    "colorIndex": "",
    "LineScale": 1,
    "LineType": "ByLayer",
    "Kalinlik": "18",
    "x": 0,
    "y": 0,
    "HatchPatternName": "SOLID",
    "SolidFillFlag": 1,
    "MPolygon": null,
    "AssociativityFlag": 0,
    "NumberOfBoundaryPaths": 1,
    "boundaryPath": [
      {
        "groups": [
          {
            "edgeType": "Polyline",
            "IsClosedFlag": 1,
            "NumberOfPolylineVertices": 4,
            "points": [
              421.6391098183225,
              104.5115702999719,
              421.6395747722118,
              101.8475808333605,
              426.4827586521858,
              101.8484261268713,
              426.482293698237,
              104.5124155953517
            ]
          }
        ],
        "BoundaryPathTypeFlag": 7
      }
    ],
    "pattern": {}
  },
  {
    "type": "HATCH",
    "handle": "273E",
    "layer": "Topraklama_Detay",
    "color": "#7F9FFF ",
    "colorIndex": "",
    "LineScale": 1,
    "LineType": "ByLayer",
    "Kalinlik": "18",
    "x": 0,
    "y": 0,
    "HatchPatternName": "SOLID",
    "SolidFillFlag": 1,
    "MPolygon": null,
    "AssociativityFlag": 0,
    "NumberOfBoundaryPaths": 1,
    "boundaryPath": [
      {
        "groups": [
          {
            "edgeType": "Polyline",
            "IsClosedFlag": 1,
            "NumberOfPolylineVertices": 4,
            "points": [
              393.220045000082,
              104.5066102398487,
              393.2205099539141,
              101.842620769512,
              398.0636938312092,
              101.8434660648927,
              398.063228877145,
              104.5074555333703
            ]
          }
        ],
        "BoundaryPathTypeFlag": 7
      }
    ],
    "pattern": {}
  },
  {
    "type": "HATCH",
    "handle": "273F",
    "layer": "Topraklama_Detay",
    "color": "#7F9FFF ",
    "colorIndex": "",
    "LineScale": 1,
    "LineType": "ByLayer",
    "Kalinlik": "18",
    "x": 0,
    "y": 0,
    "HatchPatternName": "SOLID",
    "SolidFillFlag": 1,
    "MPolygon": null,
    "AssociativityFlag": 0,
    "NumberOfBoundaryPaths": 1,
    "boundaryPath": [
      {
        "groups": [
          {
            "edgeType": "Polyline",
            "IsClosedFlag": 1,
            "NumberOfPolylineVertices": 4,
            "points": [
              446.318824088084,
              104.5158777218303,
              446.3192890419151,
              101.8518882542848,
              451.1624729217727,
              101.8527335487306,
              451.1620079679418,
              104.5167230200013
            ]
          }
        ],
        "BoundaryPathTypeFlag": 7
      }
    ],
    "pattern": {}
  },
  {
    "type": "HATCH",
    "handle": "2740",
    "layer": "Topraklama_Detay",
    "color": "#7F9FFF ",
    "colorIndex": "",
    "LineScale": 1,
    "LineType": "ByLayer",
    "Kalinlik": "18",
    "x": 0,
    "y": 0,
    "HatchPatternName": "SOLID",
    "SolidFillFlag": 1,
    "MPolygon": null,
    "AssociativityFlag": 0,
    "NumberOfBoundaryPaths": 1,
    "boundaryPath": [
      {
        "groups": [
          {
            "edgeType": "Polyline",
            "IsClosedFlag": 1,
            "NumberOfPolylineVertices": 4,
            "points": [
              362.3080776722642,
              104.5012150807342,
              362.3085426262122,
              101.8372256131852,
              367.151726503391,
              101.8380709094917,
              367.151261549559,
              104.5020603770435
            ]
          }
        ],
        "BoundaryPathTypeFlag": 7
      }
    ],
    "pattern": {}
  },
  {
    "type": "HATCH",
    "handle": "274E",
    "layer": "Topraklama_Detay",
    "color": "#7F9FFF ",
    "colorIndex": "",
    "LineScale": 1,
    "LineType": "ByLayer",
    "Kalinlik": "18",
    "x": 0,
    "y": 0,
    "HatchPatternName": "SOLID",
    "SolidFillFlag": 1,
    "MPolygon": null,
    "AssociativityFlag": 0,
    "NumberOfBoundaryPaths": 1,
    "boundaryPath": [
      {
        "groups": [
          {
            "edgeType": "Polyline",
            "IsClosedFlag": 1,
            "NumberOfPolylineVertices": 3,
            "points": [
              123.8540856242178,
              179.1452973866799,
              129.1164022644509,
              177.6546769058304,
              129.115881619276,
              180.6377546964213
            ]
          }
        ],
        "BoundaryPathTypeFlag": 7
      }
    ],
    "pattern": {}
  },
  {
    "type": "HATCH",
    "handle": "2796",
    "layer": "Topraklama_Detay",
    "color": "#7F9FFF ",
    "colorIndex": "",
    "LineScale": 1,
    "LineType": "ByLayer",
    "Kalinlik": "18",
    "x": 0,
    "y": 0,
    "HatchPatternName": "SOLID",
    "SolidFillFlag": 1,
    "MPolygon": null,
    "AssociativityFlag": 0,
    "NumberOfBoundaryPaths": 1,
    "boundaryPath": [
      {
        "groups": [
          {
            "edgeType": "Polyline",
            "IsClosedFlag": 1,
            "NumberOfPolylineVertices": 4,
            "points": [
              134.9428992333706,
              210.1992580667102,
              132.8704882492299,
              210.1988963633703,
              120.7592636094187,
              200.2996881864892,
              122.831674590765,
              200.3000498898373
            ]
          }
        ],
        "BoundaryPathTypeFlag": 7
      }
    ],
    "pattern": {}
  },
  {
    "type": "HATCH",
    "handle": "2798",
    "layer": "Topraklama_Detay",
    "color": "#7F9FFF ",
    "colorIndex": "",
    "LineScale": 1,
    "LineType": "ByLayer",
    "Kalinlik": "18",
    "x": 0,
    "y": 0,
    "HatchPatternName": "SOLID",
    "SolidFillFlag": 1,
    "MPolygon": null,
    "AssociativityFlag": 0,
    "NumberOfBoundaryPaths": 1,
    "boundaryPath": [
      {
        "groups": [
          {
            "edgeType": "Polyline",
            "IsClosedFlag": 1,
            "NumberOfPolylineVertices": 3,
            "points": [
              336.1406947261418,
              181.7966442340903,
              341.4030113666097,
              180.3060237299622,
              341.4024907212577,
              183.2891015410423
            ]
          }
        ],
        "BoundaryPathTypeFlag": 7
      }
    ],
    "pattern": {}
  },
  {
    "type": "HATCH",
    "handle": "27A0",
    "layer": "Topraklama_Detay",
    "color": "#7F9FFF ",
    "colorIndex": "",
    "LineScale": 1,
    "LineType": "ByLayer",
    "Kalinlik": "18",
    "x": 0,
    "y": 0,
    "HatchPatternName": "SOLID",
    "SolidFillFlag": 1,
    "MPolygon": null,
    "AssociativityFlag": 0,
    "NumberOfBoundaryPaths": 1,
    "boundaryPath": [
      {
        "groups": [
          {
            "edgeType": "Polyline",
            "IsClosedFlag": 1,
            "NumberOfPolylineVertices": 4,
            "points": [
              347.229508335353,
              212.8506048899226,
              345.1570973513879,
              212.8502431884453,
              333.045872708666,
              202.9510350329829,
              335.1182836900118,
              202.9513967363091
            ]
          }
        ],
        "BoundaryPathTypeFlag": 7
      }
    ],
    "pattern": {}
  },
  {
    "type": "HATCH",
    "handle": "27B3",
    "layer": "Topraklama_Detay",
    "color": "#7F9FFF ",
    "colorIndex": "",
    "LineScale": 1,
    "LineType": "ByLayer",
    "Kalinlik": "18",
    "x": 0,
    "y": 0,
    "HatchPatternName": "SOLID",
    "SolidFillFlag": 1,
    "MPolygon": null,
    "AssociativityFlag": 0,
    "NumberOfBoundaryPaths": 1,
    "boundaryPath": [
      {
        "groups": [
          {
            "edgeType": "Polyline",
            "IsClosedFlag": 1,
            "NumberOfPolylineVertices": 4,
            "points": [
              588.1241017198172,
              100.5328924413697,
              588.1245666737664,
              97.86890301760195,
              592.9677505535655,
              97.86974831298357,
              592.967285599675,
              100.5337377358228
            ]
          }
        ],
        "BoundaryPathTypeFlag": 7
      }
    ],
    "pattern": {}
  },
  {
    "type": "HATCH",
    "handle": "27B4",
    "layer": "Topraklama_Detay",
    "color": "#7F9FFF ",
    "colorIndex": "",
    "LineScale": 1,
    "LineType": "ByLayer",
    "Kalinlik": "18",
    "x": 0,
    "y": 0,
    "HatchPatternName": "SOLID",
    "SolidFillFlag": 1,
    "MPolygon": null,
    "AssociativityFlag": 0,
    "NumberOfBoundaryPaths": 1,
    "boundaryPath": [
      {
        "groups": [
          {
            "edgeType": "Polyline",
            "IsClosedFlag": 1,
            "NumberOfPolylineVertices": 4,
            "points": [
              619.0360690475204,
              100.5382875977002,
              619.0365340014682,
              97.8742981730038,
              623.8797178813825,
              97.8751434693113,
              623.8792529274352,
              100.5391328921505
            ]
          }
        ],
        "BoundaryPathTypeFlag": 7
      }
    ],
    "pattern": {}
  },
  {
    "type": "HATCH",
    "handle": "27B5",
    "layer": "Topraklama_Detay",
    "color": "#7F9FFF ",
    "colorIndex": "",
    "LineScale": 1,
    "LineType": "ByLayer",
    "Kalinlik": "18",
    "x": 0,
    "y": 0,
    "HatchPatternName": "SOLID",
    "SolidFillFlag": 1,
    "MPolygon": null,
    "AssociativityFlag": 0,
    "NumberOfBoundaryPaths": 1,
    "boundaryPath": [
      {
        "groups": [
          {
            "edgeType": "Polyline",
            "IsClosedFlag": 1,
            "NumberOfPolylineVertices": 4,
            "points": [
              672.1348481355802,
              100.5475550824703,
              672.1353130894115,
              97.88356565963569,
              676.9784969693865,
              97.88441095406868,
              676.9780320154373,
              100.548400378786
            ]
          }
        ],
        "BoundaryPathTypeFlag": 7
      }
    ],
    "pattern": {}
  },
  {
    "type": "HATCH",
    "handle": "27B6",
    "layer": "Topraklama_Detay",
    "color": "#7F9FFF ",
    "colorIndex": "",
    "LineScale": 1,
    "LineType": "ByLayer",
    "Kalinlik": "18",
    "x": 0,
    "y": 0,
    "HatchPatternName": "SOLID",
    "SolidFillFlag": 1,
    "MPolygon": null,
    "AssociativityFlag": 0,
    "NumberOfBoundaryPaths": 1,
    "boundaryPath": [
      {
        "groups": [
          {
            "edgeType": "Polyline",
            "IsClosedFlag": 1,
            "NumberOfPolylineVertices": 4,
            "points": [
              647.4551338686124,
              100.5432476596943,
              647.4555988225032,
              97.87925823684144,
              652.2987826995675,
              97.88010353128993,
              652.2983177456765,
              100.5440929541328
            ]
          }
        ],
        "BoundaryPathTypeFlag": 7
      }
    ],
    "pattern": {}
  },
  {
    "type": "HATCH",
    "handle": "27B7",
    "layer": "Topraklama_Detay",
    "color": "#7F9FFF ",
    "colorIndex": "",
    "LineScale": 1,
    "LineType": "ByLayer",
    "Kalinlik": "18",
    "x": 0,
    "y": 0,
    "HatchPatternName": "SOLID",
    "SolidFillFlag": 1,
    "MPolygon": null,
    "AssociativityFlag": 0,
    "NumberOfBoundaryPaths": 1,
    "boundaryPath": [
      {
        "groups": [
          {
            "edgeType": "Polyline",
            "IsClosedFlag": 1,
            "NumberOfPolylineVertices": 4,
            "points": [
              560.9514913663713,
              100.5281499270313,
              560.9519563202053,
              97.8641605032635,
              565.7951401973835,
              97.86500579676797,
              565.7946752435512,
              100.5289952205421
            ]
          }
        ],
        "BoundaryPathTypeFlag": 7
      }
    ],
    "pattern": {}
  },
  {
    "type": "HATCH",
    "handle": "27B9",
    "layer": "Topraklama_Detay",
    "color": "#7F9FFF ",
    "colorIndex": "",
    "LineScale": 1,
    "LineType": "ByLayer",
    "Kalinlik": "18",
    "x": 0,
    "y": 0,
    "HatchPatternName": "SOLID",
    "SolidFillFlag": 1,
    "MPolygon": null,
    "AssociativityFlag": 0,
    "NumberOfBoundaryPaths": 1,
    "boundaryPath": [
      {
        "groups": [
          {
            "edgeType": "Polyline",
            "IsClosedFlag": 1,
            "NumberOfPolylineVertices": 3,
            "points": [
              580.6913503739632,
              64.53782325050996,
              593.8471419792032,
              60.81127201206982,
              593.8458403659732,
              68.26896647549438
            ]
          }
        ],
        "BoundaryPathTypeFlag": 7
      }
    ],
    "pattern": {}
  },
  {
    "type": "HATCH",
    "handle": "27BE",
    "layer": "Topraklama_Detay",
    "color": "#7F9FFF ",
    "colorIndex": "",
    "LineScale": 1,
    "LineType": "ByLayer",
    "Kalinlik": "18",
    "x": 0,
    "y": 0,
    "HatchPatternName": "SOLID",
    "SolidFillFlag": 1,
    "MPolygon": null,
    "AssociativityFlag": 0,
    "NumberOfBoundaryPaths": 1,
    "boundaryPath": [
      {
        "groups": [
          {
            "edgeType": "Polyline",
            "IsClosedFlag": 1,
            "NumberOfPolylineVertices": 4,
            "points": [
              530.5381071086157,
              100.5228417906946,
              530.5385720625053,
              97.85885236505057,
              535.3817559423624,
              97.85969766043122,
              535.3812909884721,
              100.5236870842018
            ]
          }
        ],
        "BoundaryPathTypeFlag": 7
      }
    ],
    "pattern": {}
  },
  {
    "type": "HATCH",
    "handle": "27C0",
    "layer": "Topraklama_Detay",
    "color": "#7F9FFF ",
    "colorIndex": "",
    "LineScale": 1,
    "LineType": "ByLayer",
    "Kalinlik": "18",
    "x": 0,
    "y": 0,
    "HatchPatternName": "SOLID",
    "SolidFillFlag": 1,
    "MPolygon": null,
    "AssociativityFlag": 0,
    "NumberOfBoundaryPaths": 1,
    "boundaryPath": [
      {
        "groups": [
          {
            "edgeType": "Polyline",
            "IsClosedFlag": 1,
            "NumberOfPolylineVertices": 4,
            "points": [
              592.9624913171872,
              128.0029531437866,
              592.9620263632394,
              130.6669426131966,
              588.1188424833252,
              130.6660973187508,
              588.1193074372713,
              128.00210784934
            ]
          }
        ],
        "BoundaryPathTypeFlag": 7
      }
    ],
    "pattern": {}
  },
  {
    "type": "HATCH",
    "handle": "27C1",
    "layer": "Topraklama_Detay",
    "color": "#7F9FFF ",
    "colorIndex": "",
    "LineScale": 1,
    "LineType": "ByLayer",
    "Kalinlik": "18",
    "x": 0,
    "y": 0,
    "HatchPatternName": "SOLID",
    "SolidFillFlag": 1,
    "MPolygon": null,
    "AssociativityFlag": 0,
    "NumberOfBoundaryPaths": 1,
    "boundaryPath": [
      {
        "groups": [
          {
            "edgeType": "Polyline",
            "IsClosedFlag": 1,
            "NumberOfPolylineVertices": 4,
            "points": [
              623.8744586448872,
              128.0083483001181,
              623.8739936911144,
              130.6723377685957,
              619.0308098110254,
              130.67149247415,
              619.0312747649144,
              128.0075030056678
            ]
          }
        ],
        "BoundaryPathTypeFlag": 7
      }
    ],
    "pattern": {}
  },
  {
    "type": "HATCH",
    "handle": "27C2",
    "layer": "Topraklama_Detay",
    "color": "#7F9FFF ",
    "colorIndex": "",
    "LineScale": 1,
    "LineType": "ByLayer",
    "Kalinlik": "18",
    "x": 0,
    "y": 0,
    "HatchPatternName": "SOLID",
    "SolidFillFlag": 1,
    "MPolygon": null,
    "AssociativityFlag": 0,
    "NumberOfBoundaryPaths": 1,
    "boundaryPath": [
      {
        "groups": [
          {
            "edgeType": "Polyline",
            "IsClosedFlag": 1,
            "NumberOfPolylineVertices": 4,
            "points": [
              676.9727727790025,
              130.6816052543035,
              672.1295888990275,
              130.6807599589219,
              672.1300538529174,
              128.0167704904406,
              676.9732377328912,
              128.0176157848836
            ]
          }
        ],
        "BoundaryPathTypeFlag": 7
      }
    ],
    "pattern": {}
  },
  {
    "type": "HATCH",
    "handle": "27C3",
    "layer": "Topraklama_Detay",
    "color": "#7F9FFF ",
    "colorIndex": "",
    "LineScale": 1,
    "LineType": "ByLayer",
    "Kalinlik": "18",
    "x": 0,
    "y": 0,
    "HatchPatternName": "SOLID",
    "SolidFillFlag": 1,
    "MPolygon": null,
    "AssociativityFlag": 0,
    "NumberOfBoundaryPaths": 1,
    "boundaryPath": [
      {
        "groups": [
          {
            "edgeType": "Polyline",
            "IsClosedFlag": 1,
            "NumberOfPolylineVertices": 4,
            "points": [
              652.2930585092392,
              130.6772978315093,
              647.4498746321764,
              130.6764525370599,
              647.4503395860082,
              128.0124630676509,
              652.2935234631875,
              128.0133083630317
            ]
          }
        ],
        "BoundaryPathTypeFlag": 7
      }
    ],
    "pattern": {}
  },
  {
    "type": "HATCH",
    "handle": "27C4",
    "layer": "Topraklama_Detay",
    "color": "#7F9FFF ",
    "colorIndex": "",
    "LineScale": 1,
    "LineType": "ByLayer",
    "Kalinlik": "18",
    "x": 0,
    "y": 0,
    "HatchPatternName": "SOLID",
    "SolidFillFlag": 1,
    "MPolygon": null,
    "AssociativityFlag": 0,
    "NumberOfBoundaryPaths": 1,
    "boundaryPath": [
      {
        "groups": [
          {
            "edgeType": "Polyline",
            "IsClosedFlag": 1,
            "NumberOfPolylineVertices": 4,
            "points": [
              565.7894160070575,
              130.6622000960597,
              560.9462321299953,
              130.6613548016139,
              560.9466970838822,
              127.9973653331317,
              565.7898809608885,
              127.998210627592
            ]
          }
        ],
        "BoundaryPathTypeFlag": 7
      }
    ],
    "pattern": {}
  },
  {
    "type": "HATCH",
    "handle": "27CC",
    "layer": "Topraklama_Detay",
    "color": "#7F9FFF ",
    "colorIndex": "",
    "LineScale": 1,
    "LineType": "ByLayer",
    "Kalinlik": "18",
    "x": 0,
    "y": 0,
    "HatchPatternName": "SOLID",
    "SolidFillFlag": 1,
    "MPolygon": null,
    "AssociativityFlag": 0,
    "NumberOfBoundaryPaths": 1,
    "boundaryPath": [
      {
        "groups": [
          {
            "edgeType": "Polyline",
            "IsClosedFlag": 1,
            "NumberOfPolylineVertices": 3,
            "points": [
              516.9812498928522,
              137.1392272561706,
              511.7189332525592,
              138.6298477156024,
              511.7194538977932,
              135.6467699483046
            ]
          }
        ],
        "BoundaryPathTypeFlag": 7
      }
    ],
    "pattern": {}
  },
  {
    "type": "HATCH",
    "handle": "27D6",
    "layer": "Topraklama_Detay",
    "color": "#7F9FFF ",
    "colorIndex": "",
    "LineScale": 1,
    "LineType": "ByLayer",
    "Kalinlik": "18",
    "x": 0,
    "y": 0,
    "HatchPatternName": "SOLID",
    "SolidFillFlag": 1,
    "MPolygon": null,
    "AssociativityFlag": 0,
    "NumberOfBoundaryPaths": 1,
    "boundaryPath": [
      {
        "groups": [
          {
            "edgeType": "Polyline",
            "IsClosedFlag": 1,
            "NumberOfPolylineVertices": 4,
            "points": [
              535.3760317520944,
              130.6568919606396,
              530.5328478722356,
              130.6560466643423,
              530.5333128261263,
              127.9920571958609,
              535.3764967060424,
              127.9929024921693
            ]
          }
        ],
        "BoundaryPathTypeFlag": 7
      }
    ],
    "pattern": {}
  },
  {
    "type": "HATCH",
    "handle": "27E7",
    "layer": "Topraklama_Detay",
    "color": "#7F9FFF ",
    "colorIndex": "",
    "LineScale": 1,
    "LineType": "ByLayer",
    "Kalinlik": "18",
    "x": 0,
    "y": 0,
    "HatchPatternName": "SOLID",
    "SolidFillFlag": 1,
    "MPolygon": null,
    "AssociativityFlag": 0,
    "NumberOfBoundaryPaths": 1,
    "boundaryPath": [
      {
        "groups": [
          {
            "edgeType": "Polyline",
            "IsClosedFlag": 1,
            "NumberOfPolylineVertices": 3,
            "points": [
              576.6919025310794,
              221.2039094306492,
              581.9542191742202,
              219.7132889274435,
              581.9536985289305,
              222.6963667161727
            ]
          }
        ],
        "BoundaryPathTypeFlag": 7
      }
    ],
    "pattern": {}
  },
  {
    "type": "HATCH",
    "handle": "43B7",
    "layer": "Topraklama_Detay",
    "color": "#7F9FFF ",
    "colorIndex": "",
    "LineScale": 1,
    "LineType": "ByLayer",
    "Kalinlik": "18",
    "x": 0,
    "y": 0,
    "HatchPatternName": "ANSI31",
    "SolidFillFlag": 0,
    "MPolygon": null,
    "AssociativityFlag": 1,
    "HatchPatternSpacing": 2,
    "HatchPatternAngle": 0,
    "NumberOfBoundaryPaths": 2,
    "boundaryPath": [
      {
        "groups": [
          {
            "edgeType": "Polyline",
            "IsClosedFlag": 1,
            "NumberOfPolylineVertices": 4,
            "points": [
              256.2038252063209,
              139.1641645804011,
              131.9154695658948,
              139.1424721693619,
              131.917746403595,
              126.0971530387105,
              256.2061020440587,
              126.1188454478906
            ]
          }
        ],
        "BoundaryPathTypeFlag": 7
      },
      {
        "groups": [
          {
            "edgeType": "Polyline",
            "IsClosedFlag": 1,
            "NumberOfPolylineVertices": 4,
            "points": [
              256.2067769522743,
              122.2519062664323,
              131.9184213117999,
              122.2302138553932,
              131.9190427451391,
              118.66966308467,
              256.2073983856238,
              118.6913554947823
            ]
          }
        ],
        "BoundaryPathTypeFlag": 7
      }
    ],
    "HatchPatternScale": 2,
    "pattern": {
      "lineCount": 1,
      "patternLine": [
        {
          "lineAngle": 45,
          "LineBasePointX": 0,
          "LineBasePointY": 0,
          "LineOffsetX": -4.490128060534575,
          "LineOffsetY": 4.490128060534575,
          "dashCount": 0
        }
      ]
    }
  }
]
  
return { result: result, width: 737* Scl, height:1162*Scl} 
  }

